var Wo = Object.defineProperty;
var on = Object.getOwnPropertySymbols;
var Ko = Object.prototype.hasOwnProperty, zo = Object.prototype.propertyIsEnumerable;
var sn = (e, t, a) => t in e ? Wo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a, ln = (e, t) => {
  for (var a in t || (t = {}))
    Ko.call(t, a) && sn(e, a, t[a]);
  if (on)
    for (var a of on(t))
      zo.call(t, a) && sn(e, a, t[a]);
  return e;
};
Number.isFinite || (Number.isFinite = (e) => typeof e == "number" && isFinite(e));
Array.prototype.find || (Array.prototype.find = function(e, t) {
  if (this === null || this === void 0)
    throw new TypeError("Array.prototype.find called on null or undefined");
  if (typeof e != "function")
    throw new TypeError("callback must be a function");
  const a = Object(this), l = a.length >>> 0;
  for (let u = 0; u < l; u++)
    if (e.call(t, a[u], u, a))
      return a[u];
});
Array.prototype.findIndex || (Array.prototype.findIndex = function(e, t) {
  if (this === null || this === void 0)
    throw new TypeError("Array.prototype.findIndex called on null or undefined");
  if (typeof e != "function")
    throw new TypeError("callback must be a function");
  const a = Object(this), l = a.length >>> 0;
  for (let u = 0; u < l; u++)
    if (u in a && e.call(t, a[u], u, a))
      return u;
  return -1;
});
Array.prototype.fill || (Array.prototype.fill = function(e, t = 0, a = this.length) {
  if (this === null || this === void 0)
    throw new TypeError("Array.prototype.fill called on null or undefined");
  const l = Object(this), u = l.length >>> 0, h = t >> 0, E = a >> 0, v = h < 0 ? Math.max(u + h, 0) : Math.min(h, u), p = E < 0 ? Math.max(u + E, 0) : Math.min(E, u);
  for (let D = v; D < p; D++)
    l[D] = e;
  return l;
});
var $o = Object.defineProperty, Yo = (e, t, a) => t in e ? $o(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a, Ut = (e, t, a) => (Yo(e, typeof t != "symbol" ? t + "" : t, a), a), Mn = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, a) {
    var l = -1;
    return t.some(function(u, h) {
      return u[0] === a ? (l = h, !0) : !1;
    }), l;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(a) {
        var l = e(this.__entries__, a), u = this.__entries__[l];
        return u && u[1];
      }, t.prototype.set = function(a, l) {
        var u = e(this.__entries__, a);
        ~u ? this.__entries__[u][1] = l : this.__entries__.push([a, l]);
      }, t.prototype.delete = function(a) {
        var l = this.__entries__, u = e(l, a);
        ~u && l.splice(u, 1);
      }, t.prototype.has = function(a) {
        return !!~e(this.__entries__, a);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(a, l) {
        l === void 0 && (l = null);
        for (var u = 0, h = this.__entries__; u < h.length; u++) {
          var E = h[u];
          a.call(l, E[1], E[0]);
        }
      }, t;
    }()
  );
}(), nr = typeof window < "u" && typeof document < "u" && window.document === document, Li = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), jo = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(Li) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), qo = 2;
function Xo(e, t) {
  var a = !1, l = !1, u = 0;
  function h() {
    a && (a = !1, e()), l && v();
  }
  function E() {
    jo(h);
  }
  function v() {
    var p = Date.now();
    if (a) {
      if (p - u < qo)
        return;
      l = !0;
    } else
      a = !0, l = !1, setTimeout(E, t);
    u = p;
  }
  return v;
}
var Qo = 20, Zo = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], Jo = typeof MutationObserver < "u", es = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = Xo(this.refresh.bind(this), Qo);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var a = this.observers_, l = a.indexOf(t);
      ~l && a.splice(l, 1), !a.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(a) {
        return a.gatherActive(), a.hasActive();
      });
      return t.forEach(function(a) {
        return a.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !nr || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Jo ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !nr || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var a = t.propertyName, l = a === void 0 ? "" : a, u = Zo.some(function(h) {
        return !!~l.indexOf(h);
      });
      u && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), Fn = function(e, t) {
  for (var a = 0, l = Object.keys(t); a < l.length; a++) {
    var u = l[a];
    Object.defineProperty(e, u, {
      value: t[u],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, jt = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || Li;
}, Bn = Oi(0, 0, 0, 0);
function wi(e) {
  return parseFloat(e) || 0;
}
function cn(e) {
  for (var t = [], a = 1; a < arguments.length; a++)
    t[a - 1] = arguments[a];
  return t.reduce(function(l, u) {
    var h = e["border-" + u + "-width"];
    return l + wi(h);
  }, 0);
}
function ts(e) {
  for (var t = ["top", "right", "bottom", "left"], a = {}, l = 0, u = t; l < u.length; l++) {
    var h = u[l], E = e["padding-" + h];
    a[h] = wi(E);
  }
  return a;
}
function is(e) {
  var t = e.getBBox();
  return Oi(0, 0, t.width, t.height);
}
function rs(e) {
  var t = e.clientWidth, a = e.clientHeight;
  if (!t && !a)
    return Bn;
  var l = jt(e).getComputedStyle(e), u = ts(l), h = u.left + u.right, E = u.top + u.bottom, v = wi(l.width), p = wi(l.height);
  if (l.boxSizing === "border-box" && (Math.round(v + h) !== t && (v -= cn(l, "left", "right") + h), Math.round(p + E) !== a && (p -= cn(l, "top", "bottom") + E)), !as(e)) {
    var D = Math.round(v + h) - t, y = Math.round(p + E) - a;
    Math.abs(D) !== 1 && (v -= D), Math.abs(y) !== 1 && (p -= y);
  }
  return Oi(u.left, u.top, v, p);
}
var ns = function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof jt(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof jt(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function as(e) {
  return e === jt(e).document.documentElement;
}
function os(e) {
  return nr ? ns(e) ? is(e) : rs(e) : Bn;
}
function ss(e) {
  var t = e.x, a = e.y, l = e.width, u = e.height, h = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, E = Object.create(h.prototype);
  return Fn(E, {
    x: t,
    y: a,
    width: l,
    height: u,
    top: a,
    right: t + l,
    bottom: u + a,
    left: t
  }), E;
}
function Oi(e, t, a, l) {
  return { x: e, y: t, width: a, height: l };
}
var ls = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Oi(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = os(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), cs = (
  /** @class */
  function() {
    function e(t, a) {
      var l = ss(a);
      Fn(this, { target: t, contentRect: l });
    }
    return e;
  }()
), us = (
  /** @class */
  function() {
    function e(t, a, l) {
      if (this.activeObservations_ = [], this.observations_ = new Mn(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = a, this.callbackCtx_ = l;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof jt(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var a = this.observations_;
        a.has(t) || (a.set(t, new ls(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof jt(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var a = this.observations_;
        a.has(t) && (a.delete(t), a.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(a) {
        a.isActive() && t.activeObservations_.push(a);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, a = this.activeObservations_.map(function(l) {
          return new cs(l.target, l.broadcastRect());
        });
        this.callback_.call(t, a, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), Hn = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new Mn(), Vn = (
  /** @class */
  function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var a = es.getInstance(), l = new us(t, a, this);
      Hn.set(this, l);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  Vn.prototype[e] = function() {
    var t;
    return (t = Hn.get(this))[e].apply(t, arguments);
  };
});
(function() {
  return typeof Li.ResizeObserver < "u" ? Li.ResizeObserver : Vn;
})();
var ar = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, ds = function(e, t) {
  if (t = t.split(":")[0], e = +e, !e)
    return !1;
  switch (t) {
    case "http":
    case "ws":
      return e !== 80;
    case "https":
    case "wss":
      return e !== 443;
    case "ftp":
      return e !== 21;
    case "gopher":
      return e !== 70;
    case "file":
      return !1;
  }
  return e !== 0;
}, dr = {}, hs = Object.prototype.hasOwnProperty, _s;
function un(e) {
  try {
    return decodeURIComponent(e.replace(/\+/g, " "));
  } catch (t) {
    return null;
  }
}
function dn(e) {
  try {
    return encodeURIComponent(e);
  } catch (t) {
    return null;
  }
}
function ps(e) {
  for (var t = /([^=?#&]+)=?([^&]*)/g, a = {}, l; l = t.exec(e); ) {
    var u = un(l[1]), h = un(l[2]);
    u === null || h === null || u in a || (a[u] = h);
  }
  return a;
}
function fs(e, t) {
  t = t || "";
  var a = [], l, u;
  typeof t != "string" && (t = "?");
  for (u in e)
    if (hs.call(e, u)) {
      if (l = e[u], !l && (l === null || l === _s || isNaN(l)) && (l = ""), u = dn(u), l = dn(l), u === null || l === null)
        continue;
      a.push(u + "=" + l);
    }
  return a.length ? t + a.join("&") : "";
}
dr.stringify = fs;
dr.parse = ps;
var Gn = ds, Pi = dr, vs = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, Wn = /[\n\r\t]/g, ms = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, Kn = /:\d+$/, ys = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, As = /^[a-zA-Z]:/;
function hr(e) {
  return (e || "").toString().replace(vs, "");
}
var or = [
  ["#", "hash"],
  // Extract from the back.
  ["?", "query"],
  // Extract from the back.
  function(e, t) {
    return Et(t.protocol) ? e.replace(/\\/g, "/") : e;
  },
  ["/", "pathname"],
  // Extract from the back.
  ["@", "auth", 1],
  // Extract from the front.
  [NaN, "host", void 0, 1, 1],
  // Set left over value.
  [/:(\d*)$/, "port", void 0, 1],
  // RegExp the back.
  [NaN, "hostname", void 0, 1, 1]
  // Set left over.
], hn = { hash: 1, query: 1 };
function zn(e) {
  var t;
  typeof window < "u" ? t = window : typeof ar < "u" ? t = ar : typeof self < "u" ? t = self : t = {};
  var a = t.location || {};
  e = e || a;
  var l = {}, u = typeof e, h;
  if (e.protocol === "blob:")
    l = new gt(unescape(e.pathname), {});
  else if (u === "string") {
    l = new gt(e, {});
    for (h in hn)
      delete l[h];
  } else if (u === "object") {
    for (h in e)
      h in hn || (l[h] = e[h]);
    l.slashes === void 0 && (l.slashes = ms.test(e.href));
  }
  return l;
}
function Et(e) {
  return e === "file:" || e === "ftp:" || e === "http:" || e === "https:" || e === "ws:" || e === "wss:";
}
function $n(e, t) {
  e = hr(e), e = e.replace(Wn, ""), t = t || {};
  var a = ys.exec(e), l = a[1] ? a[1].toLowerCase() : "", u = !!a[2], h = !!a[3], E = 0, v;
  return u ? h ? (v = a[2] + a[3] + a[4], E = a[2].length + a[3].length) : (v = a[2] + a[4], E = a[2].length) : h ? (v = a[3] + a[4], E = a[3].length) : v = a[4], l === "file:" ? E >= 2 && (v = v.slice(2)) : Et(l) ? v = a[4] : l ? u && (v = v.slice(2)) : E >= 2 && Et(t.protocol) && (v = a[4]), {
    protocol: l,
    slashes: u || Et(l),
    slashesCount: E,
    rest: v
  };
}
function Es(e, t) {
  if (e === "")
    return t;
  for (var a = (t || "/").split("/").slice(0, -1).concat(e.split("/")), l = a.length, u = a[l - 1], h = !1, E = 0; l--; )
    a[l] === "." ? a.splice(l, 1) : a[l] === ".." ? (a.splice(l, 1), E++) : E && (l === 0 && (h = !0), a.splice(l, 1), E--);
  return h && a.unshift(""), (u === "." || u === "..") && a.push(""), a.join("/");
}
function gt(e, t, a) {
  if (e = hr(e), e = e.replace(Wn, ""), !(this instanceof gt))
    return new gt(e, t, a);
  var l, u, h, E, v, p, D = or.slice(), y = typeof t, R = this, g = 0;
  for (y !== "object" && y !== "string" && (a = t, t = null), a && typeof a != "function" && (a = Pi.parse), t = zn(t), u = $n(e || "", t), l = !u.protocol && !u.slashes, R.slashes = u.slashes || l && t.slashes, R.protocol = u.protocol || t.protocol || "", e = u.rest, (u.protocol === "file:" && (u.slashesCount !== 2 || As.test(e)) || !u.slashes && (u.protocol || u.slashesCount < 2 || !Et(R.protocol))) && (D[3] = [/(.*)/, "pathname"]); g < D.length; g++) {
    if (E = D[g], typeof E == "function") {
      e = E(e, R);
      continue;
    }
    h = E[0], p = E[1], h !== h ? R[p] = e : typeof h == "string" ? (v = h === "@" ? e.lastIndexOf(h) : e.indexOf(h), ~v && (typeof E[2] == "number" ? (R[p] = e.slice(0, v), e = e.slice(v + E[2])) : (R[p] = e.slice(v), e = e.slice(0, v)))) : (v = h.exec(e)) && (R[p] = v[1], e = e.slice(0, v.index)), R[p] = R[p] || l && E[3] && t[p] || "", E[4] && (R[p] = R[p].toLowerCase());
  }
  a && (R.query = a(R.query)), l && t.slashes && R.pathname.charAt(0) !== "/" && (R.pathname !== "" || t.pathname !== "") && (R.pathname = Es(R.pathname, t.pathname)), R.pathname.charAt(0) !== "/" && Et(R.protocol) && (R.pathname = "/" + R.pathname), Gn(R.port, R.protocol) || (R.host = R.hostname, R.port = ""), R.username = R.password = "", R.auth && (v = R.auth.indexOf(":"), ~v ? (R.username = R.auth.slice(0, v), R.username = encodeURIComponent(decodeURIComponent(R.username)), R.password = R.auth.slice(v + 1), R.password = encodeURIComponent(decodeURIComponent(R.password))) : R.username = encodeURIComponent(decodeURIComponent(R.auth)), R.auth = R.password ? R.username + ":" + R.password : R.username), R.origin = R.protocol !== "file:" && Et(R.protocol) && R.host ? R.protocol + "//" + R.host : "null", R.href = R.toString();
}
function gs(e, t, a) {
  var l = this;
  switch (e) {
    case "query":
      typeof t == "string" && t.length && (t = (a || Pi.parse)(t)), l[e] = t;
      break;
    case "port":
      l[e] = t, Gn(t, l.protocol) ? t && (l.host = l.hostname + ":" + t) : (l.host = l.hostname, l[e] = "");
      break;
    case "hostname":
      l[e] = t, l.port && (t += ":" + l.port), l.host = t;
      break;
    case "host":
      l[e] = t, Kn.test(t) ? (t = t.split(":"), l.port = t.pop(), l.hostname = t.join(":")) : (l.hostname = t, l.port = "");
      break;
    case "protocol":
      l.protocol = t.toLowerCase(), l.slashes = !a;
      break;
    case "pathname":
    case "hash":
      if (t) {
        var u = e === "pathname" ? "/" : "#";
        l[e] = t.charAt(0) !== u ? u + t : t;
      } else
        l[e] = t;
      break;
    case "username":
    case "password":
      l[e] = encodeURIComponent(t);
      break;
    case "auth":
      var h = t.indexOf(":");
      ~h ? (l.username = t.slice(0, h), l.username = encodeURIComponent(decodeURIComponent(l.username)), l.password = t.slice(h + 1), l.password = encodeURIComponent(decodeURIComponent(l.password))) : l.username = encodeURIComponent(decodeURIComponent(t));
  }
  for (var E = 0; E < or.length; E++) {
    var v = or[E];
    v[4] && (l[v[1]] = l[v[1]].toLowerCase());
  }
  return l.auth = l.password ? l.username + ":" + l.password : l.username, l.origin = l.protocol !== "file:" && Et(l.protocol) && l.host ? l.protocol + "//" + l.host : "null", l.href = l.toString(), l;
}
function Ts(e) {
  (!e || typeof e != "function") && (e = Pi.stringify);
  var t, a = this, l = a.host, u = a.protocol;
  u && u.charAt(u.length - 1) !== ":" && (u += ":");
  var h = u + (a.protocol && a.slashes || Et(a.protocol) ? "//" : "");
  return a.username ? (h += a.username, a.password && (h += ":" + a.password), h += "@") : a.password ? (h += ":" + a.password, h += "@") : a.protocol !== "file:" && Et(a.protocol) && !l && a.pathname !== "/" && (h += "@"), (l[l.length - 1] === ":" || Kn.test(a.hostname) && !a.port) && (l += ":"), h += l + a.pathname, t = typeof a.query == "object" ? e(a.query) : a.query, t && (h += t.charAt(0) !== "?" ? "?" + t : t), a.hash && (h += a.hash), h;
}
gt.prototype = { set: gs, toString: Ts };
gt.extractProtocol = $n;
gt.location = zn;
gt.trimLeft = hr;
gt.qs = Pi;
var _n = gt, Ii = {}, bs = {
  get exports() {
    return Ii;
  },
  set exports(e) {
    Ii = e;
  }
}, $t = typeof Reflect == "object" ? Reflect : null, pn = $t && typeof $t.apply == "function" ? $t.apply : function(e, t, a) {
  return Function.prototype.apply.call(e, t, a);
}, yi;
$t && typeof $t.ownKeys == "function" ? yi = $t.ownKeys : Object.getOwnPropertySymbols ? yi = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : yi = function(e) {
  return Object.getOwnPropertyNames(e);
};
function Rs(e) {
  console && console.warn && console.warn(e);
}
var Yn = Number.isNaN || function(e) {
  return e !== e;
};
function pe() {
  pe.init.call(this);
}
bs.exports = pe;
Ii.once = Is;
pe.EventEmitter = pe;
pe.prototype._events = void 0;
pe.prototype._eventsCount = 0;
pe.prototype._maxListeners = void 0;
var fn = 10;
function Ui(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(pe, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return fn;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || Yn(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    fn = e;
  }
});
pe.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
pe.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || Yn(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function jn(e) {
  return e._maxListeners === void 0 ? pe.defaultMaxListeners : e._maxListeners;
}
pe.prototype.getMaxListeners = function() {
  return jn(this);
};
pe.prototype.emit = function(e) {
  for (var t = [], a = 1; a < arguments.length; a++)
    t.push(arguments[a]);
  var l = e === "error", u = this._events;
  if (u !== void 0)
    l = l && u.error === void 0;
  else if (!l)
    return !1;
  if (l) {
    var h;
    if (t.length > 0 && (h = t[0]), h instanceof Error)
      throw h;
    var E = new Error("Unhandled error." + (h ? " (" + h.message + ")" : ""));
    throw E.context = h, E;
  }
  var v = u[e];
  if (v === void 0)
    return !1;
  if (typeof v == "function")
    pn(v, this, t);
  else
    for (var p = v.length, D = Jn(v, p), a = 0; a < p; ++a)
      pn(D[a], this, t);
  return !0;
};
function qn(e, t, a, l) {
  var u, h, E;
  if (Ui(a), h = e._events, h === void 0 ? (h = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (h.newListener !== void 0 && (e.emit(
    "newListener",
    t,
    a.listener ? a.listener : a
  ), h = e._events), E = h[t]), E === void 0)
    E = h[t] = a, ++e._eventsCount;
  else if (typeof E == "function" ? E = h[t] = l ? [a, E] : [E, a] : l ? E.unshift(a) : E.push(a), u = jn(e), u > 0 && E.length > u && !E.warned) {
    E.warned = !0;
    var v = new Error("Possible EventEmitter memory leak detected. " + E.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    v.name = "MaxListenersExceededWarning", v.emitter = e, v.type = t, v.count = E.length, Rs(v);
  }
  return e;
}
pe.prototype.addListener = function(e, t) {
  return qn(this, e, t, !1);
};
pe.prototype.on = pe.prototype.addListener;
pe.prototype.prependListener = function(e, t) {
  return qn(this, e, t, !0);
};
function Ss() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function Xn(e, t, a) {
  var l = { fired: !1, wrapFn: void 0, target: e, type: t, listener: a }, u = Ss.bind(l);
  return u.listener = a, l.wrapFn = u, u;
}
pe.prototype.once = function(e, t) {
  return Ui(t), this.on(e, Xn(this, e, t)), this;
};
pe.prototype.prependOnceListener = function(e, t) {
  return Ui(t), this.prependListener(e, Xn(this, e, t)), this;
};
pe.prototype.removeListener = function(e, t) {
  var a, l, u, h, E;
  if (Ui(t), l = this._events, l === void 0)
    return this;
  if (a = l[e], a === void 0)
    return this;
  if (a === t || a.listener === t)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete l[e], l.removeListener && this.emit("removeListener", e, a.listener || t));
  else if (typeof a != "function") {
    for (u = -1, h = a.length - 1; h >= 0; h--)
      if (a[h] === t || a[h].listener === t) {
        E = a[h].listener, u = h;
        break;
      }
    if (u < 0)
      return this;
    u === 0 ? a.shift() : Ls(a, u), a.length === 1 && (l[e] = a[0]), l.removeListener !== void 0 && this.emit("removeListener", e, E || t);
  }
  return this;
};
pe.prototype.off = pe.prototype.removeListener;
pe.prototype.removeAllListeners = function(e) {
  var t, a, l;
  if (a = this._events, a === void 0)
    return this;
  if (a.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : a[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete a[e]), this;
  if (arguments.length === 0) {
    var u = Object.keys(a), h;
    for (l = 0; l < u.length; ++l)
      h = u[l], h !== "removeListener" && this.removeAllListeners(h);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (t = a[e], typeof t == "function")
    this.removeListener(e, t);
  else if (t !== void 0)
    for (l = t.length - 1; l >= 0; l--)
      this.removeListener(e, t[l]);
  return this;
};
function Qn(e, t, a) {
  var l = e._events;
  if (l === void 0)
    return [];
  var u = l[t];
  return u === void 0 ? [] : typeof u == "function" ? a ? [u.listener || u] : [u] : a ? ws(u) : Jn(u, u.length);
}
pe.prototype.listeners = function(e) {
  return Qn(this, e, !0);
};
pe.prototype.rawListeners = function(e) {
  return Qn(this, e, !1);
};
pe.listenerCount = function(e, t) {
  return typeof e.listenerCount == "function" ? e.listenerCount(t) : Zn.call(e, t);
};
pe.prototype.listenerCount = Zn;
function Zn(e) {
  var t = this._events;
  if (t !== void 0) {
    var a = t[e];
    if (typeof a == "function")
      return 1;
    if (a !== void 0)
      return a.length;
  }
  return 0;
}
pe.prototype.eventNames = function() {
  return this._eventsCount > 0 ? yi(this._events) : [];
};
function Jn(e, t) {
  for (var a = new Array(t), l = 0; l < t; ++l)
    a[l] = e[l];
  return a;
}
function Ls(e, t) {
  for (; t + 1 < e.length; t++)
    e[t] = e[t + 1];
  e.pop();
}
function ws(e) {
  for (var t = new Array(e.length), a = 0; a < t.length; ++a)
    t[a] = e[a].listener || e[a];
  return t;
}
function Is(e, t) {
  return new Promise(function(a, l) {
    function u(E) {
      e.removeListener(t, h), l(E);
    }
    function h() {
      typeof e.removeListener == "function" && e.removeListener("error", u), a([].slice.call(arguments));
    }
    ea(e, t, h, { once: !0 }), t !== "error" && Cs(e, u, { once: !0 });
  });
}
function Cs(e, t, a) {
  typeof e.on == "function" && ea(e, "error", t, a);
}
function ea(e, t, a, l) {
  if (typeof e.on == "function")
    l.once ? e.once(t, a) : e.on(t, a);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(t, function u(h) {
      l.once && e.removeEventListener(t, u), a(h);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
const Nt = class {
  constructor() {
    Ut(this, "timeout", 7 * 24 * 3600 * 1e3);
  }
  write(t, a) {
    if (Nt.available)
      try {
        localStorage.setItem(
          t,
          JSON.stringify({ value: a, time: Date.now() })
        );
      } catch (l) {
      }
  }
  read(t, a = !0) {
    if (Nt.available)
      try {
        const l = localStorage.getItem(t);
        if (l) {
          const { value: u, time: h = 0 } = JSON.parse(l);
          if (!a || Date.now() - h < this.timeout)
            return u;
        }
      } catch (l) {
      }
  }
  static get available() {
    if (typeof Nt._available > "u")
      try {
        localStorage.setItem("alg", "test"), Nt._available = !0;
      } catch (t) {
        Nt._available = !1;
      }
    return Nt._available;
  }
};
let _r = Nt;
Ut(_r, "_available");
const ks = "kwai-p";
function ti(e, t) {
  return (!t || t.length === 0) && (t = [e], e = ""), e = ks + (e ? "::" + e : ""), t.unshift("[" + e + "] > "), t;
}
const ye = class {
  /**
   * 设置日志输出等级
   * @param l 日志等级
   */
  static level(t) {
    switch (ye.ENABLE_ERROR = ye.ENABLE_WARN = ye.ENABLE_INFO = ye.ENABLE_DEBUG = ye.ENABLE_VERBOSE = !1, t) {
      case "e":
        ye.ENABLE_ERROR = !0;
        break;
      case "w":
        ye.ENABLE_ERROR = ye.ENABLE_WARN = !0;
        break;
      case "i":
        ye.ENABLE_ERROR = ye.ENABLE_WARN = ye.ENABLE_INFO = !0;
        break;
      case "d":
        ye.ENABLE_ERROR = ye.ENABLE_WARN = ye.ENABLE_INFO = ye.ENABLE_DEBUG = !0;
        break;
      case "v":
        ye.ENABLE_ERROR = ye.ENABLE_WARN = ye.ENABLE_INFO = ye.ENABLE_DEBUG = ye.ENABLE_VERBOSE = !0;
        break;
    }
  }
  /**
   * error日志
   * @param tag tag
   * @param msg 日志信息
   */
  static e(t, ...a) {
    if (!ye.ENABLE_ERROR)
      return;
    const l = ti(t, a);
    (console.error || console.warn || console.log).apply(console, l);
  }
  /**
   * warn日志
   * @param tag tag
   * @param msg 日志信息
   */
  static w(t, ...a) {
    if (!ye.ENABLE_WARN)
      return;
    const l = ti(t, a);
    (console.warn || console.log).apply(console, l);
  }
  /**
   * info日志
   * @param tag tag
   * @param msg 日志信息
   */
  static i(t, ...a) {
    if (!ye.ENABLE_INFO)
      return;
    const l = ti(t, a);
    (console.info || console.log).apply(console, l);
  }
  /**
   * debug日志
   * @param tag tag
   * @param msg 日志信息
   */
  static d(t, ...a) {
    if (!ye.ENABLE_DEBUG)
      return;
    const l = ti(t, a);
    (console.debug || console.log).apply(console, l);
  }
  /**
   * verbose日志
   * @param tag tag
   * @param msg 日志信息
   */
  static v(t, ...a) {
    if (!ye.ENABLE_VERBOSE)
      return;
    const l = ti(t, a);
    console.log.apply(console, l);
  }
};
let w = ye;
Ut(w, "ENABLE_ERROR", !0), Ut(w, "ENABLE_WARN", !1), Ut(w, "ENABLE_INFO", !1), Ut(w, "ENABLE_DEBUG", !1), Ut(w, "ENABLE_VERBOSE", !1);
var Ci = {}, Ds = {
  get exports() {
    return Ci;
  },
  set exports(e) {
    Ci = e;
  }
};
(function(e, t) {
  (function(a, l) {
    var u = "1.0.2", h = "", E = "?", v = "function", p = "undefined", D = "object", y = "string", R = "major", g = "model", _ = "name", I = "type", k = "vendor", P = "version", K = "architecture", m = "console", T = "mobile", b = "tablet", L = "smarttv", M = "wearable", U = "embedded", B = 255, H = "Amazon", q = "Apple", Ie = "ASUS", Ae = "BlackBerry", W = "Browser", C = "Chrome", st = "Edge", $e = "Firefox", Ce = "Google", He = "Huawei", Le = "LG", Oe = "Microsoft", We = "Motorola", ke = "Opera", lt = "Samsung", Q = "Sony", ct = "Xiaomi", pt = "Zebra", Tt = "Facebook", Z = function(ie, de) {
      var ee = {};
      for (var be in ie)
        de[be] && de[be].length % 2 === 0 ? ee[be] = de[be].concat(ie[be]) : ee[be] = ie[be];
      return ee;
    }, fe = function(ie) {
      for (var de = {}, ee = 0; ee < ie.length; ee++)
        de[ie[ee].toUpperCase()] = ie[ee];
      return de;
    }, Y = function(ie, de) {
      return typeof ie === y ? Ee(de).indexOf(Ee(ie)) !== -1 : !1;
    }, Ee = function(ie) {
      return ie.toLowerCase();
    }, rt = function(ie) {
      return typeof ie === y ? ie.replace(/[^\d\.]/g, h).split(".")[0] : l;
    }, Xt = function(ie, de) {
      if (typeof ie === y)
        return ie = ie.replace(/^\s\s*/, h).replace(/\s\s*$/, h), typeof de === p ? ie : ie.substring(0, B);
    }, ut = function(ie, de) {
      for (var ee = 0, be, te, Gt, me, Dt, at; ee < de.length && !Dt; ) {
        var bt = de[ee], ci = de[ee + 1];
        for (be = te = 0; be < bt.length && !Dt; )
          if (Dt = bt[be++].exec(ie), Dt)
            for (Gt = 0; Gt < ci.length; Gt++)
              at = Dt[++te], me = ci[Gt], typeof me === D && me.length > 0 ? me.length === 2 ? typeof me[1] == v ? this[me[0]] = me[1].call(this, at) : this[me[0]] = me[1] : me.length === 3 ? typeof me[1] === v && !(me[1].exec && me[1].test) ? this[me[0]] = at ? me[1].call(this, at, me[2]) : l : this[me[0]] = at ? at.replace(me[1], me[2]) : l : me.length === 4 && (this[me[0]] = at ? me[3].call(this, at.replace(me[1], me[2])) : l) : this[me] = at || l;
        ee += 2;
      }
    }, nt = function(ie, de) {
      for (var ee in de)
        if (typeof de[ee] === D && de[ee].length > 0) {
          for (var be = 0; be < de[ee].length; be++)
            if (Y(de[ee][be], ie))
              return ee === E ? l : ee;
        } else if (Y(de[ee], ie))
          return ee === E ? l : ee;
      return ie;
    }, Vt = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, ft = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      "8.1": "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, ve = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [P, [_, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [P, [_, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [_, P],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [P, [_, ke + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [P, [_, ke]],
        [
          // Mixed
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
          // Baidu Browser
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [_, P],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [P, [_, "UC" + W]],
        [
          /\bqbcore\/([\w\.]+)/i
          // WeChat Desktop for Windows Built-in Browser
        ],
        [P, [_, "WeChat(Win) Desktop"]],
        [
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [P, [_, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [P, [_, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [P, [_, "IE"]],
        [
          /yabrowser\/([\w\.]+)/i
          // Yandex
        ],
        [P, [_, "Yandex"]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[_, /(.+)/, "$1 Secure " + W], P],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [P, [_, $e + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [P, [_, ke + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [P, [_, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [P, [_, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [P, [_, ke + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [P, [_, "MIUI " + W]],
        [
          /fxios\/([-\w\.]+)/i
          // Firefox for iOS
        ],
        [P, [_, $e]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
          // 360
        ],
        [[_, "360 " + W]],
        [
          /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
        ],
        [[_, /(.+)/, "$1 " + W], P],
        [
          // Oculus/Samsung/Sailfish Browser
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[_, /_/g, " "], P],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
          // QQBrowser/Baidu App/2345 Browser
        ],
        [_, P],
        [
          /(metasr)[\/ ]?([\w\.]+)/i,
          // SouGouBrowser
          /(lbbrowser)/i
          // LieBao Browser
        ],
        [_],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[_, Tt], P],
        [
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(chromium|instagram)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram
        ],
        [_, P],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [P, [_, "GSA"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [P, [_, C + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[_, C + " WebView"], P],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [P, [_, "Android " + W]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [_, P],
        [
          /version\/([\w\.]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [P, [_, "Mobile Safari"]],
        [
          /version\/([\w\.]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [P, _],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [_, [P, nt, Vt]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [_, P],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[_, "Netscape"], P],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [P, [_, $e + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
          /(links) \(([\w\.]+)/i
          // Links
        ],
        [_, P]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
          // AMD64 (x64)
        ],
        [[K, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[K, Ee]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32 (x86)
        ],
        [[K, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
          // ARM64
        ],
        [[K, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[K, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows (ce|mobile); ppc;/i
        ],
        [[K, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
          // PowerPC
        ],
        [[K, /ower/, h, Ee]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[K, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[K, Ee]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          // Ordered by popularity
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [g, [k, lt], [I, b]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [g, [k, lt], [I, T]],
        [
          // Apple
          /\((ip(?:hone|od)[\w ]*);/i
          // iPod/iPhone
        ],
        [g, [k, q], [I, T]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [g, [k, q], [I, b]],
        [
          // Huawei
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [g, [k, He], [I, b]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
        ],
        [g, [k, He], [I, T]],
        [
          // Xiaomi
          /\b(poco[\w ]+)(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
          // Xiaomi Mi
        ],
        [[g, /_/g, " "], [k, ct], [I, T]],
        [
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
          // Mi Pad tablets
        ],
        [[g, /_/g, " "], [k, ct], [I, b]],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [g, [k, "OPPO"], [I, T]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [g, [k, "Vivo"], [I, T]],
        [
          // Realme
          /\b(rmx[12]\d{3})(?: bui|;|\))/i
        ],
        [g, [k, "Realme"], [I, T]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [g, [k, We], [I, T]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [g, [k, We], [I, b]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [g, [k, Le], [I, b]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [g, [k, Le], [I, T]],
        [
          // Lenovo
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [g, [k, "Lenovo"], [I, b]],
        [
          // Nokia
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[g, /_/g, " "], [k, "Nokia"], [I, T]],
        [
          // Google
          /(pixel c)\b/i
          // Google Pixel C
        ],
        [g, [k, Ce], [I, b]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [g, [k, Ce], [I, T]],
        [
          // Sony
          /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [g, [k, Q], [I, T]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[g, "Xperia Tablet"], [k, Q], [I, b]],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [g, [k, "OnePlus"], [I, T]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi)( bui|\))/i,
          // Kindle Fire without Silk
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [g, [k, H], [I, b]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [[g, /(.+)/g, "Fire Phone $1"], [k, H], [I, T]],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [g, k, [I, b]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [g, [k, Ae], [I, T]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [g, [k, Ie], [I, b]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [g, [k, Ie], [I, T]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [g, [k, "HTC"], [I, b]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [k, [g, /_/g, " "], [I, T]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [g, [k, "Acer"], [I, b]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [g, [k, "Meizu"], [I, T]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [g, [k, "Sharp"], [I, T]],
        [
          // MIXED
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(asus)-?(\w+)/i,
          // Asus
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w]+)/i,
          // Lenovo
          /(jolla)/i,
          // Jolla
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [k, g, [I, T]],
        [
          /(archos) (gamepad2?)/i,
          // Archos
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [k, g, [I, b]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [g, [k, Oe], [I, b]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [g, [k, "Fairphone"], [I, T]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [g, [k, "AT&T"], [I, T]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [g, [k, "Siemens"], [I, T]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [g, [k, "RCA"], [I, b]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [g, [k, "Dell"], [I, b]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [g, [k, "Verizon"], [I, b]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [g, [k, "Barnes & Noble"], [I, b]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [g, [k, "NuVision"], [I, b]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [g, [k, "ZTE"], [I, b]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [g, [k, "ZTE"], [I, T]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [g, [k, "Swiss"], [I, T]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [g, [k, "Swiss"], [I, b]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [g, [k, "Zeki"], [I, b]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[k, "Dragon Touch"], g, [I, b]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [g, [k, "Insignia"], [I, b]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [g, [k, "NextBook"], [I, b]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[k, "Voice"], g, [I, T]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[k, "LvTel"], g, [I, T]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [g, [k, "Essential"], [I, T]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [g, [k, "Envizen"], [I, b]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [g, [k, "MachSpeed"], [I, b]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [g, [k, "Rotor"], [I, b]],
        [
          /(shield[\w ]+) b/i
          // Nvidia Shield Tablets
        ],
        [g, [k, "Nvidia"], [I, b]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [k, g, [I, T]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[g, /\./g, " "], [k, Oe], [I, T]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [g, [k, pt], [I, b]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [g, [k, pt], [I, T]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [k, g, [I, m]],
        [
          /droid.+; (shield) bui/i
          // Nvidia
        ],
        [g, [k, "Nvidia"], [I, m]],
        [
          /(playstation [345portablevi]+)/i
          // Playstation
        ],
        [g, [k, Q], [I, m]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [g, [k, Oe], [I, m]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [k, [I, L]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[g, /^/, "SmartTV"], [k, lt], [I, L]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [[k, Le], [I, L]],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [k, [g, q + " TV"], [I, L]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[g, C + "cast"], [k, Ce], [I, L]],
        [
          /droid.+aft(\w)( bui|\))/i
          // Fire TV
        ],
        [g, [k, H], [I, L]],
        [
          /\(dtv[\);].+(aquos)/i
          // Sharp
        ],
        [g, [k, "Sharp"], [I, L]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[k, Xt], [g, Xt], [I, L]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          // SmartTV from Unidentified Vendors
        ],
        [[I, L]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /((pebble))app/i
          // Pebble
        ],
        [k, g, [I, M]],
        [
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [g, [k, Ce], [I, M]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [g, [k, pt], [I, M]],
        [
          /(quest( 2)?)/i
          // Oculus Quest
        ],
        [g, [k, Tt], [I, M]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [k, [I, U]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [g, [I, T]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [g, [I, b]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[I, b]],
        [
          /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[I, T]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
          // Generic Android Device
        ],
        [g, [k, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [P, [_, st + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [P, [_, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i
          // iCab
        ],
        [_, P],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [P, _]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [_, P],
        [
          /(windows) nt 6\.2; (arm)/i,
          // Windows RT
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
          // Windows Phone
          /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
        ],
        [_, [P, nt, ft]],
        [
          /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[_, "Windows"], [P, nt, ft]],
        [
          // iOS/macOS
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /cfnetwork\/.+darwin/i
        ],
        [[P, /_/g, "."], [_, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [[_, "Mac OS"], [P, /_/g, "."]],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86)/i
          // Android-x86
        ],
        [P, _],
        [
          // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          // Blackberry
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          // Tizen/KaiOS
          /\((series40);/i
          // Series 40
        ],
        [_, P],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [P, [_, Ae]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [P, [_, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [P, [_, $e + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [P, [_, "webOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [P, [_, C + "cast"]],
        [
          /(cros) [\w]+ ([\w\.]+\w)/i
          // Chromium OS
        ],
        [[_, "Chromium OS"], P],
        [
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux) ?([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [_, P],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[_, "Solaris"], P],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [_, P]
      ]
    }, Ye = function(ie, de) {
      if (typeof ie === D && (de = ie, ie = l), !(this instanceof Ye))
        return new Ye(ie, de).getResult();
      var ee = ie || (typeof a !== p && a.navigator && a.navigator.userAgent ? a.navigator.userAgent : h), be = de ? Z(ve, de) : ve;
      return this.getBrowser = function() {
        var te = {};
        return te[_] = l, te[P] = l, ut.call(te, ee, be.browser), te.major = rt(te.version), te;
      }, this.getCPU = function() {
        var te = {};
        return te[K] = l, ut.call(te, ee, be.cpu), te;
      }, this.getDevice = function() {
        var te = {};
        return te[k] = l, te[g] = l, te[I] = l, ut.call(te, ee, be.device), te;
      }, this.getEngine = function() {
        var te = {};
        return te[_] = l, te[P] = l, ut.call(te, ee, be.engine), te;
      }, this.getOS = function() {
        var te = {};
        return te[_] = l, te[P] = l, ut.call(te, ee, be.os), te;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return ee;
      }, this.setUA = function(te) {
        return ee = typeof te === y && te.length > B ? Xt(te, B) : te, this;
      }, this.setUA(ee), this;
    };
    Ye.VERSION = u, Ye.BROWSER = fe([_, P, R]), Ye.CPU = fe([K]), Ye.DEVICE = fe([g, k, I, m, T, L, b, M, U]), Ye.ENGINE = Ye.OS = fe([_, P]), e.exports && (t = e.exports = Ye), t.UAParser = Ye;
    var Je = typeof a !== p && (a.jQuery || a.Zepto);
    if (Je && !Je.ua) {
      var kt = new Ye();
      Je.ua = kt.getResult(), Je.ua.get = function() {
        return kt.getUA();
      }, Je.ua.set = function(ie) {
        kt.setUA(ie);
        var de = kt.getResult();
        for (var ee in de)
          Je.ua[ee] = de[ee];
      };
    }
  })(typeof window == "object" ? window : ar);
})(Ds, Ci);
const xs = Ci;
function Ns() {
  const e = new _r();
  w.level(e.read("kwai-player-log"));
}
Ns();
let fi = 0;
function Os() {
  return fi = fi ? fi + 1 : Date.now(), `c-${fi}`;
}
const Be = xs(), ki = Be.os.name, Ps = ki && ki.toLowerCase().indexOf("android") >= 0, Us = ki && ki.toLowerCase().indexOf("ios") >= 0, Ht = Be.device.type === "mobile" || Ps || Us, Mi = Ii.EventEmitter;
(function() {
  try {
    if (typeof document != "undefined") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._kwai-player_uxc1a_2{position:relative;margin:0;padding:0}._kwai-player_uxc1a_2 *{margin:0;padding:0}._kwai-player-video-interactive_uxc1a_11{display:block;width:100%;height:100%;position:absolute;top:0;left:0}._kwai-player-poster_uxc1a_19{width:100%;height:100%;position:absolute;left:0;top:0;background-color:#333;background-size:contain;background-position:center;background-repeat:no-repeat}._kwai-player-video_uxc1a_11{display:block;width:100%;height:100%;position:absolute;top:0;left:0}._kwai-player-video_uxc1a_11 video{display:block;width:100%;height:100%}._kwai-player-video_uxc1a_11 canvas{display:block;margin:0 auto;max-width:100%;max-height:100%;position:relative}._kwai-player-disable-scroll_uxc1a_50{overflow:hidden;height:100%}")), document.head.appendChild(e);
    }
  } catch (t) {
    console.error("vite-plugin-css-injected-by-js", t);
  }
})();
var Ms = Object.defineProperty, Fs = (e, t, a) => t in e ? Ms(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a, F = (e, t, a) => (Fs(e, typeof t != "symbol" ? t + "" : t, a), a), At = /* @__PURE__ */ ((e) => (e.SYSTEM = "system", e.WINDOW = "window", e))(At || {}), Ai = /* @__PURE__ */ ((e) => (e.VIDEO = "video", e.VIDEO_INTERACTIVE = "videoInteractive", e.DEFAULT = "default", e))(Ai || {}), Bs = /* @__PURE__ */ ((e) => (e.NONE = "none", e.KWAI = "kwai", e.GENERAL = "general", e))(Bs || {}), N = /* @__PURE__ */ ((e) => (e.ERROR = "error", e.MANIFEST_PARSED = "manifestparsed", e.LEVEL_SWITCHING = "levelswitching", e.LEVEL_SWITCHED = "levelswitched", e.LEVEL_SWITCH_PLAYING = "levelswitchplaying", e.LEVEL_SWITCH_FAILED = "levelswitchfailed", e.LEVEL_UPDATED = "levelupdated", e.AUDIO_TRACKS_SWITCHING = "audiotrackswitching", e.AUDIO_TRACKS_SWITCHED = "audiotrackswitched", e.LOADSTART = "loadstart", e.PROGRESS = "progress", e.SUSPEND = "suspend", e.ABORT = "abort", e.EMPTIED = "emptied", e.STALLED = "stalled", e.LOADEDMETADATA = "loadedmetadata", e.LOADEDDATA = "loadeddata", e.CANPLAY = "canplay", e.CANPLAYTHROUGH = "canplaythrough", e.PLAYING = "playing", e.WAITING = "waiting", e.SEEKING = "seeking", e.SEEKED = "seeked", e.ENDED = "ended", e.DURATIONCHANGE = "durationchange", e.TIMEUPDATE = "timeupdate", e.PLAY = "play", e.PAUSE = "pause", e.RATECHANGE = "ratechange", e.RESIZE = "resize", e.VOLUMECHANGE = "volumechange", e.ENTER_PICTURE_IN_PICTURE = "enterpictureinpicture", e.LEAVE_PICTURE_IN_PICTURE = "leavepictureinpicture", e.REPORT = "report", e.VIDEO_RENDERER_CHANGE = "videorendererchange", e.FULLSCREEN_CHANGE = "fullscreenchange", e.LIVE_SHIFT_CHANGE = "liveshiftchange", e.LIVE_SHIFT_TYPE_CHANGE = "liveshifttypechange", e.ATTRIBUTE_CHANGE_CONFIG = "attribute:change:config", e.ATTRIBUTE_CHANGE_SRC = "attribute:change:src", e.ATTRIBUTE_CHANGE_VIDEO_ID = "attribute:change:videoid", e.ATTRIBUTE_CHANGE_PREVIEW_URL = "attribute:change:previewurl", e.ATTRIBUTE_CHANGE_MASK_URL = "attribute:change:maskurl", e.ATTRIBUTE_CHANGE_CROSS_ORIGIN = "attribute:change:crossorigin", e.ATTRIBUTE_CHANGE_PRELOAD = "attribute:change:preload", e.ATTRIBUTE_CHANGE_CURRENT_TIME = "attribute:change:currenttime", e.ATTRIBUTE_CHANGE_DEFAULT_PLAYBACK_RATE = "attribute:change:defaultplaybackrate", e.ATTRIBUTE_CHANGE_PLAYBACK_RATE = "attribute:change:playbackrate", e.ATTRIBUTE_CHANGE_AUTOPLAY = "attribute:change:autoplay", e.ATTRIBUTE_CHANGE_LOOP = "attribute:change:loop", e.ATTRIBUTE_CHANGE_CONTROLS = "attribute:change:controls", e.ATTRIBUTE_CHANGE_VOLUME = "attribute:change:volume", e.ATTRIBUTE_CHANGE_MUTED = "attribute:change:muted", e.ATTRIBUTE_CHANGE_DEFAULT_MUTED = "attribute:change:defaultmuted", e.ATTRIBUTE_CHANGE_POSTER = "attribute:change:poster", e.ATTRIBUTE_CHANGE_DISABLE_PICTURE_IN_PICTURE = "attribute:change:disablepictureinpicture", e.ATTRIBUTE_CHANGE_PLAYSINLINE = "attribute:change:playsinline", e.ATTRIBUTE_CHANGE_DISABLE_ADAPTIVE = "attribute:change:disableadaptive", e.ATTRIBUTE_CHANGE_DISABLE_DOWNLOAD = "attribute:change:disabledownload", e.ATTRIBUTE_CHANGE_DISABLE_MASK = "attribute:change:disablemask", e.ATTRIBUTE_CHANGE_DISABLE_HOTKEY = "attribute:change:disablehotkey", e.ATTRIBUTE_CHANGE_DISABLE_DANMAKU = "attribute:change:disabledanmaku", e.ATTRIBUTE_CHANGE_DANMAKU_RENDERING = "attribute:change:danmakurendering", e.ATTRIBUTE_CHANGE_DANMAKU_CONTROLS_POS = "attribute:change:danmakucontrolspos", e.ATTRIBUTE_CHANGE_DANMAKU_CONTROLS_POS_FULLSCREEN = "attribute:change:danmakucontrolsposfullscreen", e.ATTRIBUTE_CHANGE_CURRENT_LEVEL = "attribute:change:currentlevel", e.ATTRIBUTE_CHANGE_NEXT_LEVEL = "attribute:change:nextlevel", e.ATTRIBUTE_CHANGE_CURRENT_FRAME = "attribute:change:currentframe", e.ATTRIBUTE_CHANGE_AUDIO_TRACK = "attribute:change:audiotrack", e.ATTRIBUTE_CHANGE_PREFETCH = "attribute:change:prefetch", e.ATTRIBUTE_CHANGE_SHOW_PROGRESS = "attribute:change:showprogress", e.ATTRIBUTE_CHANGE_SHOW_TIME = "attribute:change:showtime", e.ATTRIBUTE_CHANGE_SHOW_NEXT = "attribute:change:shownext", e.ATTRIBUTE_CHANGE_SHOW_PREV = "attribute:change:showprev", e.ATTRIBUTE_CHANGE_BIZ_DATA = "attribute:change:bizdata", e.ATTRIBUTE_CHANGE_LIVE_TIME = "attribute:change:livetime", e.ATTRIBUTE_CHANGE_SHOW_INFO_PANEL = "attribute:change:showinfopanel", e.CLICK_NEXT = "clicknext", e.CLICK_PREV = "clickprev", e.CLICK_LOGIN = "clicklogin", e.CLICK_REGISTER = "clickregister", e.CLICK_SEND_DANMAKU = "clicksenddanmaku", e.CLICK_VIP = "clickvip", e))(N || {}), xe = function(e) {
  var t = {};
  function a(l) {
    if (t[l])
      return t[l].exports;
    var u = t[l] = { i: l, l: !1, exports: {} };
    return e[l].call(u.exports, u, u.exports, a), u.l = !0, u.exports;
  }
  return a.m = e, a.c = t, a.d = function(l, u, h) {
    a.o(l, u) || Object.defineProperty(l, u, { enumerable: !0, get: h });
  }, a.r = function(l) {
    typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(l, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(l, "__esModule", { value: !0 });
  }, a.t = function(l, u) {
    if (1 & u && (l = a(l)), 8 & u || 4 & u && typeof l == "object" && l && l.__esModule)
      return l;
    var h = /* @__PURE__ */ Object.create(null);
    if (a.r(h), Object.defineProperty(h, "default", { enumerable: !0, value: l }), 2 & u && typeof l != "string")
      for (var E in l)
        a.d(h, E, function(v) {
          return l[v];
        }.bind(null, E));
    return h;
  }, a.n = function(l) {
    var u = l && l.__esModule ? function() {
      return l.default;
    } : function() {
      return l;
    };
    return a.d(u, "a", u), u;
  }, a.o = function(l, u) {
    return Object.prototype.hasOwnProperty.call(l, u);
  }, a.p = "", a(a.s = 17);
}([function(e, t, a) {
  var l = a(8);
  function u(h, E) {
    for (var v = 0; v < E.length; v++) {
      var p = E[v];
      p.enumerable = p.enumerable || !1, p.configurable = !0, "value" in p && (p.writable = !0), Object.defineProperty(h, l(p.key), p);
    }
  }
  e.exports = function(h, E, v) {
    return E && u(h.prototype, E), v && u(h, v), Object.defineProperty(h, "prototype", { writable: !1 }), h;
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, t) {
  function a() {
    return e.exports = a = Object.assign ? Object.assign.bind() : function(l) {
      for (var u = 1; u < arguments.length; u++) {
        var h = arguments[u];
        for (var E in h)
          Object.prototype.hasOwnProperty.call(h, E) && (l[E] = h[E]);
      }
      return l;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, a.apply(this, arguments);
  }
  e.exports = a, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, t) {
  e.exports = function(a) {
    if (a === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a;
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, t) {
  e.exports = void 0;
}, function(e, t, a) {
  var l = a(14), u = a(15), h = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, E = /[\n\r\t]/g, v = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, p = /:\d+$/, D = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, y = /^[a-zA-Z]:/;
  function R(m) {
    return (m || "").toString().replace(h, "");
  }
  var g = [["#", "hash"], ["?", "query"], function(m, T) {
    return k(T.protocol) ? m.replace(/\\/g, "/") : m;
  }, ["/", "pathname"], ["@", "auth", 1], [NaN, "host", void 0, 1, 1], [/:(\d*)$/, "port", void 0, 1], [NaN, "hostname", void 0, 1, 1]], _ = { hash: 1, query: 1 };
  function I(m) {
    var T, b = (typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}).location || {}, L = {}, M = typeof (m = m || b);
    if (m.protocol === "blob:")
      L = new K(unescape(m.pathname), {});
    else if (M === "string")
      for (T in L = new K(m, {}), _)
        delete L[T];
    else if (M === "object") {
      for (T in m)
        T in _ || (L[T] = m[T]);
      L.slashes === void 0 && (L.slashes = v.test(m.href));
    }
    return L;
  }
  function k(m) {
    return m === "file:" || m === "ftp:" || m === "http:" || m === "https:" || m === "ws:" || m === "wss:";
  }
  function P(m, T) {
    m = (m = R(m)).replace(E, ""), T = T || {};
    var b, L = D.exec(m), M = L[1] ? L[1].toLowerCase() : "", U = !!L[2], B = !!L[3], H = 0;
    return U ? B ? (b = L[2] + L[3] + L[4], H = L[2].length + L[3].length) : (b = L[2] + L[4], H = L[2].length) : B ? (b = L[3] + L[4], H = L[3].length) : b = L[4], M === "file:" ? H >= 2 && (b = b.slice(2)) : k(M) ? b = L[4] : M ? U && (b = b.slice(2)) : H >= 2 && k(T.protocol) && (b = L[4]), { protocol: M, slashes: U || k(M), slashesCount: H, rest: b };
  }
  function K(m, T, b) {
    if (m = (m = R(m)).replace(E, ""), !(this instanceof K))
      return new K(m, T, b);
    var L, M, U, B, H, q, Ie = g.slice(), Ae = typeof T, W = this, C = 0;
    for (Ae !== "object" && Ae !== "string" && (b = T, T = null), b && typeof b != "function" && (b = u.parse), L = !(M = P(m || "", T = I(T))).protocol && !M.slashes, W.slashes = M.slashes || L && T.slashes, W.protocol = M.protocol || T.protocol || "", m = M.rest, (M.protocol === "file:" && (M.slashesCount !== 2 || y.test(m)) || !M.slashes && (M.protocol || M.slashesCount < 2 || !k(W.protocol))) && (Ie[3] = [/(.*)/, "pathname"]); C < Ie.length; C++)
      typeof (B = Ie[C]) != "function" ? (U = B[0], q = B[1], U != U ? W[q] = m : typeof U == "string" ? ~(H = U === "@" ? m.lastIndexOf(U) : m.indexOf(U)) && (typeof B[2] == "number" ? (W[q] = m.slice(0, H), m = m.slice(H + B[2])) : (W[q] = m.slice(H), m = m.slice(0, H))) : (H = U.exec(m)) && (W[q] = H[1], m = m.slice(0, H.index)), W[q] = W[q] || L && B[3] && T[q] || "", B[4] && (W[q] = W[q].toLowerCase())) : m = B(m, W);
    b && (W.query = b(W.query)), L && T.slashes && W.pathname.charAt(0) !== "/" && (W.pathname !== "" || T.pathname !== "") && (W.pathname = function(st, $e) {
      if (st === "")
        return $e;
      for (var Ce = ($e || "/").split("/").slice(0, -1).concat(st.split("/")), He = Ce.length, Le = Ce[He - 1], Oe = !1, We = 0; He--; )
        Ce[He] === "." ? Ce.splice(He, 1) : Ce[He] === ".." ? (Ce.splice(He, 1), We++) : We && (He === 0 && (Oe = !0), Ce.splice(He, 1), We--);
      return Oe && Ce.unshift(""), Le !== "." && Le !== ".." || Ce.push(""), Ce.join("/");
    }(W.pathname, T.pathname)), W.pathname.charAt(0) !== "/" && k(W.protocol) && (W.pathname = "/" + W.pathname), l(W.port, W.protocol) || (W.host = W.hostname, W.port = ""), W.username = W.password = "", W.auth && (~(H = W.auth.indexOf(":")) ? (W.username = W.auth.slice(0, H), W.username = encodeURIComponent(decodeURIComponent(W.username)), W.password = W.auth.slice(H + 1), W.password = encodeURIComponent(decodeURIComponent(W.password))) : W.username = encodeURIComponent(decodeURIComponent(W.auth)), W.auth = W.password ? W.username + ":" + W.password : W.username), W.origin = W.protocol !== "file:" && k(W.protocol) && W.host ? W.protocol + "//" + W.host : "null", W.href = W.toString();
  }
  K.prototype = { set: function(m, T, b) {
    var L = this;
    switch (m) {
      case "query":
        typeof T == "string" && T.length && (T = (b || u.parse)(T)), L[m] = T;
        break;
      case "port":
        L[m] = T, l(T, L.protocol) ? T && (L.host = L.hostname + ":" + T) : (L.host = L.hostname, L[m] = "");
        break;
      case "hostname":
        L[m] = T, L.port && (T += ":" + L.port), L.host = T;
        break;
      case "host":
        L[m] = T, p.test(T) ? (T = T.split(":"), L.port = T.pop(), L.hostname = T.join(":")) : (L.hostname = T, L.port = "");
        break;
      case "protocol":
        L.protocol = T.toLowerCase(), L.slashes = !b;
        break;
      case "pathname":
      case "hash":
        if (T) {
          var M = m === "pathname" ? "/" : "#";
          L[m] = T.charAt(0) !== M ? M + T : T;
        } else
          L[m] = T;
        break;
      case "username":
      case "password":
        L[m] = encodeURIComponent(T);
        break;
      case "auth":
        var U = T.indexOf(":");
        ~U ? (L.username = T.slice(0, U), L.username = encodeURIComponent(decodeURIComponent(L.username)), L.password = T.slice(U + 1), L.password = encodeURIComponent(decodeURIComponent(L.password))) : L.username = encodeURIComponent(decodeURIComponent(T));
    }
    for (var B = 0; B < g.length; B++) {
      var H = g[B];
      H[4] && (L[H[1]] = L[H[1]].toLowerCase());
    }
    return L.auth = L.password ? L.username + ":" + L.password : L.username, L.origin = L.protocol !== "file:" && k(L.protocol) && L.host ? L.protocol + "//" + L.host : "null", L.href = L.toString(), L;
  }, toString: function(m) {
    m && typeof m == "function" || (m = u.stringify);
    var T, b = this, L = b.host, M = b.protocol;
    M && M.charAt(M.length - 1) !== ":" && (M += ":");
    var U = M + (b.protocol && b.slashes || k(b.protocol) ? "//" : "");
    return b.username ? (U += b.username, b.password && (U += ":" + b.password), U += "@") : b.password ? (U += ":" + b.password, U += "@") : b.protocol !== "file:" && k(b.protocol) && !L && b.pathname !== "/" && (U += "@"), (L[L.length - 1] === ":" || p.test(b.hostname) && !b.port) && (L += ":"), U += L + b.pathname, (T = typeof b.query == "object" ? m(b.query) : b.query) && (U += T.charAt(0) !== "?" ? "?" + T : T), b.hash && (U += b.hash), U;
  } }, K.extractProtocol = P, K.location = I, K.trimLeft = R, K.qs = u, e.exports = K;
}, function(e, t, a) {
  var l = a(16);
  e.exports = function(u, h) {
    u.prototype = Object.create(h.prototype), u.prototype.constructor = u, l(u, h);
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, t, a) {
  var l, u, h, E, v;
  l = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, u = /^(?=([^\/?#]*))\1([^]*)$/, h = /(?:\/|^)\.(?=\/)/g, E = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, v = { buildAbsoluteURL: function(p, D, y) {
    if (y = y || {}, p = p.trim(), !(D = D.trim())) {
      if (!y.alwaysNormalize)
        return p;
      var R = v.parseURL(p);
      if (!R)
        throw new Error("Error trying to parse base URL.");
      return R.path = v.normalizePath(R.path), v.buildURLFromParts(R);
    }
    var g = v.parseURL(D);
    if (!g)
      throw new Error("Error trying to parse relative URL.");
    if (g.scheme)
      return y.alwaysNormalize ? (g.path = v.normalizePath(g.path), v.buildURLFromParts(g)) : D;
    var _ = v.parseURL(p);
    if (!_)
      throw new Error("Error trying to parse base URL.");
    if (!_.netLoc && _.path && _.path[0] !== "/") {
      var I = u.exec(_.path);
      _.netLoc = I[1], _.path = I[2];
    }
    _.netLoc && !_.path && (_.path = "/");
    var k = { scheme: _.scheme, netLoc: g.netLoc, path: null, params: g.params, query: g.query, fragment: g.fragment };
    if (!g.netLoc && (k.netLoc = _.netLoc, g.path[0] !== "/"))
      if (g.path) {
        var P = _.path, K = P.substring(0, P.lastIndexOf("/") + 1) + g.path;
        k.path = v.normalizePath(K);
      } else
        k.path = _.path, g.params || (k.params = _.params, g.query || (k.query = _.query));
    return k.path === null && (k.path = y.alwaysNormalize ? v.normalizePath(g.path) : g.path), v.buildURLFromParts(k);
  }, parseURL: function(p) {
    var D = l.exec(p);
    return D ? { scheme: D[1] || "", netLoc: D[2] || "", path: D[3] || "", params: D[4] || "", query: D[5] || "", fragment: D[6] || "" } : null;
  }, normalizePath: function(p) {
    for (p = p.split("").reverse().join("").replace(h, ""); p.length !== (p = p.replace(E, "")).length; )
      ;
    return p.split("").reverse().join("");
  }, buildURLFromParts: function(p) {
    return p.scheme + p.netLoc + p.path + p.params + p.query + p.fragment;
  } }, e.exports = v;
}, function(e, t, a) {
  var l, u = typeof Reflect == "object" ? Reflect : null, h = u && typeof u.apply == "function" ? u.apply : function(m, T, b) {
    return Function.prototype.apply.call(m, T, b);
  };
  l = u && typeof u.ownKeys == "function" ? u.ownKeys : Object.getOwnPropertySymbols ? function(m) {
    return Object.getOwnPropertyNames(m).concat(Object.getOwnPropertySymbols(m));
  } : function(m) {
    return Object.getOwnPropertyNames(m);
  };
  var E = Number.isNaN || function(m) {
    return m != m;
  };
  function v() {
    v.init.call(this);
  }
  e.exports = v, e.exports.once = function(m, T) {
    return new Promise(function(b, L) {
      function M(B) {
        m.removeListener(T, U), L(B);
      }
      function U() {
        typeof m.removeListener == "function" && m.removeListener("error", M), b([].slice.call(arguments));
      }
      K(m, T, U, { once: !0 }), T !== "error" && function(B, H, q) {
        typeof B.on == "function" && K(B, "error", H, q);
      }(m, M, { once: !0 });
    });
  }, v.EventEmitter = v, v.prototype._events = void 0, v.prototype._eventsCount = 0, v.prototype._maxListeners = void 0;
  var p = 10;
  function D(m) {
    if (typeof m != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof m);
  }
  function y(m) {
    return m._maxListeners === void 0 ? v.defaultMaxListeners : m._maxListeners;
  }
  function R(m, T, b, L) {
    var M, U, B, H;
    if (D(b), (U = m._events) === void 0 ? (U = m._events = /* @__PURE__ */ Object.create(null), m._eventsCount = 0) : (U.newListener !== void 0 && (m.emit("newListener", T, b.listener ? b.listener : b), U = m._events), B = U[T]), B === void 0)
      B = U[T] = b, ++m._eventsCount;
    else if (typeof B == "function" ? B = U[T] = L ? [b, B] : [B, b] : L ? B.unshift(b) : B.push(b), (M = y(m)) > 0 && B.length > M && !B.warned) {
      B.warned = !0;
      var q = new Error("Possible EventEmitter memory leak detected. " + B.length + " " + String(T) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      q.name = "MaxListenersExceededWarning", q.emitter = m, q.type = T, q.count = B.length, H = q, console && console.warn && console.warn(H);
    }
    return m;
  }
  function g() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function _(m, T, b) {
    var L = { fired: !1, wrapFn: void 0, target: m, type: T, listener: b }, M = g.bind(L);
    return M.listener = b, L.wrapFn = M, M;
  }
  function I(m, T, b) {
    var L = m._events;
    if (L === void 0)
      return [];
    var M = L[T];
    return M === void 0 ? [] : typeof M == "function" ? b ? [M.listener || M] : [M] : b ? function(U) {
      for (var B = new Array(U.length), H = 0; H < B.length; ++H)
        B[H] = U[H].listener || U[H];
      return B;
    }(M) : P(M, M.length);
  }
  function k(m) {
    var T = this._events;
    if (T !== void 0) {
      var b = T[m];
      if (typeof b == "function")
        return 1;
      if (b !== void 0)
        return b.length;
    }
    return 0;
  }
  function P(m, T) {
    for (var b = new Array(T), L = 0; L < T; ++L)
      b[L] = m[L];
    return b;
  }
  function K(m, T, b, L) {
    if (typeof m.on == "function")
      L.once ? m.once(T, b) : m.on(T, b);
    else {
      if (typeof m.addEventListener != "function")
        throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof m);
      m.addEventListener(T, function M(U) {
        L.once && m.removeEventListener(T, M), b(U);
      });
    }
  }
  Object.defineProperty(v, "defaultMaxListeners", { enumerable: !0, get: function() {
    return p;
  }, set: function(m) {
    if (typeof m != "number" || m < 0 || E(m))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + m + ".");
    p = m;
  } }), v.init = function() {
    this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, v.prototype.setMaxListeners = function(m) {
    if (typeof m != "number" || m < 0 || E(m))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + m + ".");
    return this._maxListeners = m, this;
  }, v.prototype.getMaxListeners = function() {
    return y(this);
  }, v.prototype.emit = function(m) {
    for (var T = [], b = 1; b < arguments.length; b++)
      T.push(arguments[b]);
    var L = m === "error", M = this._events;
    if (M !== void 0)
      L = L && M.error === void 0;
    else if (!L)
      return !1;
    if (L) {
      var U;
      if (T.length > 0 && (U = T[0]), U instanceof Error)
        throw U;
      var B = new Error("Unhandled error." + (U ? " (" + U.message + ")" : ""));
      throw B.context = U, B;
    }
    var H = M[m];
    if (H === void 0)
      return !1;
    if (typeof H == "function")
      h(H, this, T);
    else {
      var q = H.length, Ie = P(H, q);
      for (b = 0; b < q; ++b)
        h(Ie[b], this, T);
    }
    return !0;
  }, v.prototype.addListener = function(m, T) {
    return R(this, m, T, !1);
  }, v.prototype.on = v.prototype.addListener, v.prototype.prependListener = function(m, T) {
    return R(this, m, T, !0);
  }, v.prototype.once = function(m, T) {
    return D(T), this.on(m, _(this, m, T)), this;
  }, v.prototype.prependOnceListener = function(m, T) {
    return D(T), this.prependListener(m, _(this, m, T)), this;
  }, v.prototype.removeListener = function(m, T) {
    var b, L, M, U, B;
    if (D(T), (L = this._events) === void 0)
      return this;
    if ((b = L[m]) === void 0)
      return this;
    if (b === T || b.listener === T)
      --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete L[m], L.removeListener && this.emit("removeListener", m, b.listener || T));
    else if (typeof b != "function") {
      for (M = -1, U = b.length - 1; U >= 0; U--)
        if (b[U] === T || b[U].listener === T) {
          B = b[U].listener, M = U;
          break;
        }
      if (M < 0)
        return this;
      M === 0 ? b.shift() : function(H, q) {
        for (; q + 1 < H.length; q++)
          H[q] = H[q + 1];
        H.pop();
      }(b, M), b.length === 1 && (L[m] = b[0]), L.removeListener !== void 0 && this.emit("removeListener", m, B || T);
    }
    return this;
  }, v.prototype.off = v.prototype.removeListener, v.prototype.removeAllListeners = function(m) {
    var T, b, L;
    if ((b = this._events) === void 0)
      return this;
    if (b.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : b[m] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete b[m]), this;
    if (arguments.length === 0) {
      var M, U = Object.keys(b);
      for (L = 0; L < U.length; ++L)
        (M = U[L]) !== "removeListener" && this.removeAllListeners(M);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (typeof (T = b[m]) == "function")
      this.removeListener(m, T);
    else if (T !== void 0)
      for (L = T.length - 1; L >= 0; L--)
        this.removeListener(m, T[L]);
    return this;
  }, v.prototype.listeners = function(m) {
    return I(this, m, !0);
  }, v.prototype.rawListeners = function(m) {
    return I(this, m, !1);
  }, v.listenerCount = function(m, T) {
    return typeof m.listenerCount == "function" ? m.listenerCount(T) : k.call(m, T);
  }, v.prototype.listenerCount = k, v.prototype.eventNames = function() {
    return this._eventsCount > 0 ? l(this._events) : [];
  };
}, function(e, t, a) {
  var l = a(9).default, u = a(12);
  e.exports = function(h) {
    var E = u(h, "string");
    return l(E) === "symbol" ? E : String(E);
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, t) {
  function a(l) {
    return e.exports = a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
      return typeof u;
    } : function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, a(l);
  }
  e.exports = a, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, t, a) {
  function l(v) {
    var p = {};
    function D(R) {
      if (p[R])
        return p[R].exports;
      var g = p[R] = { i: R, l: !1, exports: {} };
      return v[R].call(g.exports, g, g.exports, D), g.l = !0, g.exports;
    }
    D.m = v, D.c = p, D.i = function(R) {
      return R;
    }, D.d = function(R, g, _) {
      D.o(R, g) || Object.defineProperty(R, g, { configurable: !1, enumerable: !0, get: _ });
    }, D.r = function(R) {
      Object.defineProperty(R, "__esModule", { value: !0 });
    }, D.n = function(R) {
      var g = R && R.__esModule ? function() {
        return R.default;
      } : function() {
        return R;
      };
      return D.d(g, "a", g), g;
    }, D.o = function(R, g) {
      return Object.prototype.hasOwnProperty.call(R, g);
    }, D.p = "/", D.oe = function(R) {
      throw console.error(R), R;
    };
    var y = D(D.s = ENTRY_MODULE);
    return y.default || y;
  }
  function u(v) {
    return (v + "").replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
  }
  function h(v, p, D) {
    var y = {};
    y[D] = [];
    var R = p.toString(), g = R.match(/^function\s?\w*\(\w+,\s*\w+,\s*(\w+)\)/);
    if (!g)
      return y;
    for (var _, I = g[1], k = new RegExp("(\\\\n|\\W)" + u(I) + "\\(\\s*(/\\*.*?\\*/)?\\s*.*?([\\.|\\-|\\+|\\w|/|@]+).*?\\)", "g"); _ = k.exec(R); )
      _[3] !== "dll-reference" && y[D].push(_[3]);
    for (k = new RegExp("\\(" + u(I) + '\\("(dll-reference\\s([\\.|\\-|\\+|\\w|/|@]+))"\\)\\)\\(\\s*(/\\*.*?\\*/)?\\s*.*?([\\.|\\-|\\+|\\w|/|@]+).*?\\)', "g"); _ = k.exec(R); )
      v[_[2]] || (y[D].push(_[1]), v[_[2]] = a(_[1]).m), y[_[2]] = y[_[2]] || [], y[_[2]].push(_[4]);
    for (var P, K = Object.keys(y), m = 0; m < K.length; m++)
      for (var T = 0; T < y[K[m]].length; T++)
        P = y[K[m]][T], isNaN(1 * P) || (y[K[m]][T] = 1 * y[K[m]][T]);
    return y;
  }
  function E(v) {
    return Object.keys(v).reduce(function(p, D) {
      return p || v[D].length > 0;
    }, !1);
  }
  e.exports = function(v, p) {
    p = p || {};
    var D = { main: a.m }, y = p.all ? { main: Object.keys(D.main) } : function(k, P) {
      for (var K = { main: [P] }, m = { main: [] }, T = { main: {} }; E(K); )
        for (var b = Object.keys(K), L = 0; L < b.length; L++) {
          var M = b[L], U = K[M].pop();
          if (T[M] = T[M] || {}, !T[M][U] && k[M][U]) {
            T[M][U] = !0, m[M] = m[M] || [], m[M].push(U);
            for (var B = h(k, k[M][U], M), H = Object.keys(B), q = 0; q < H.length; q++)
              K[H[q]] = K[H[q]] || [], K[H[q]] = K[H[q]].concat(B[H[q]]);
          }
        }
      return m;
    }(D, v), R = "";
    Object.keys(y).filter(function(k) {
      return k !== "main";
    }).forEach(function(k) {
      for (var P = 0; y[k][P]; )
        P++;
      y[k].push(P), D[k][P] = "(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })", R = R + "var " + k + " = (" + l.toString().replace("ENTRY_MODULE", JSON.stringify(P)) + ")({" + y[k].map(function(K) {
        return JSON.stringify(K) + ": " + D[k][K].toString();
      }).join(",") + `});
`;
    }), R = R + "new ((" + l.toString().replace("ENTRY_MODULE", JSON.stringify(v)) + ")({" + y.main.map(function(k) {
      return JSON.stringify(k) + ": " + D.main[k].toString();
    }).join(",") + "}))(self);";
    var g = new window.Blob([R], { type: "text/javascript" });
    if (p.bare)
      return g;
    var _ = (window.URL || window.webkitURL || window.mozURL || window.msURL).createObjectURL(g), I = new window.Worker(_);
    return I.objectURL = _, I;
  };
}, function(e, t, a) {
  var l = a(8);
  e.exports = function(u, h, E) {
    return (h = l(h)) in u ? Object.defineProperty(u, h, { value: E, enumerable: !0, configurable: !0, writable: !0 }) : u[h] = E, u;
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, t, a) {
  var l = a(9).default;
  e.exports = function(u, h) {
    if (l(u) !== "object" || u === null)
      return u;
    var E = u[Symbol.toPrimitive];
    if (E !== void 0) {
      var v = E.call(u, h || "default");
      if (l(v) !== "object")
        return v;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (h === "string" ? String : Number)(u);
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, t) {
  Number.isFinite || (Number.isFinite = function(a) {
    return typeof a == "number" && isFinite(a);
  }), Number.MAX_SAFE_INTEGER || (Number.MAX_SAFE_INTEGER = Math.pow(2, 53) - 1), Object.values || (Object.values = function(a) {
    if (a == null)
      throw new TypeError("Cannot convert undefined or null to object");
    var l = [];
    for (var u in a)
      Object.prototype.hasOwnProperty.call(a, u) && l.push(a[u]);
    return l;
  });
}, function(e, t, a) {
  e.exports = function(l, u) {
    if (u = u.split(":")[0], !(l = +l))
      return !1;
    switch (u) {
      case "http":
      case "ws":
        return l !== 80;
      case "https":
      case "wss":
        return l !== 443;
      case "ftp":
        return l !== 21;
      case "gopher":
        return l !== 70;
      case "file":
        return !1;
    }
    return l !== 0;
  };
}, function(e, t, a) {
  var l = Object.prototype.hasOwnProperty;
  function u(E) {
    try {
      return decodeURIComponent(E.replace(/\+/g, " "));
    } catch (v) {
      return null;
    }
  }
  function h(E) {
    try {
      return encodeURIComponent(E);
    } catch (v) {
      return null;
    }
  }
  t.stringify = function(E, v) {
    v = v || "";
    var p, D, y = [];
    for (D in typeof v != "string" && (v = "?"), E)
      if (l.call(E, D)) {
        if ((p = E[D]) || p != null && !isNaN(p) || (p = ""), D = h(D), p = h(p), D === null || p === null)
          continue;
        y.push(D + "=" + p);
      }
    return y.length ? v + y.join("&") : "";
  }, t.parse = function(E) {
    for (var v, p = /([^=?#&]+)=?([^&]*)/g, D = {}; v = p.exec(E); ) {
      var y = u(v[1]), R = u(v[2]);
      y === null || R === null || y in D || (D[y] = R);
    }
    return D;
  };
}, function(e, t) {
  function a(l, u) {
    return e.exports = a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(h, E) {
      return h.__proto__ = E, h;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, a(l, u);
  }
  e.exports = a, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, t, a) {
  a.r(t), a.d(t, "default", function() {
    return an;
  }), a.d(t, "createKernel", function() {
    return Bo;
  }), a.d(t, "CodecType", function() {
    return p;
  }), a.d(t, "Decoder", function() {
    return R;
  }), a.d(t, "DemuxerType", function() {
    return nt;
  }), a.d(t, "DownloadStatus", function() {
    return no;
  }), a.d(t, "HttpRangeType", function() {
    return K;
  }), a.d(t, "KEvents", function() {
    return S;
  }), a.d(t, "LogLevel", function() {
    return Ae;
  }), a.d(t, "LiveShiftType", function() {
    return U;
  }), a.d(t, "MediaBox", function() {
    return _;
  }), a.d(t, "ReportTypes", function() {
    return je;
  }), a.d(t, "StereoType", function() {
    return L;
  }), a.d(t, "VideoDecBlockPolicy", function() {
    return P;
  }), a.d(t, "VideoDropFramePolicy", function() {
    return k;
  }), a.d(t, "VideoRendererType", function() {
    return y;
  }), a.d(t, "WasmDecoder", function() {
    return D;
  }), a.d(t, "EventReportTypes", function() {
    return ge;
  });
  var l = a(1), u = a.n(l), h = a(0), E = a.n(h), v = (a(13), a(7)), p = function(r) {
    return r.unknown = "unknown", r.h264 = "h264", r.hevc = "hevc", r.av1 = "av1", r.kvc3 = "kvc3", r.kvc4 = "kvc4", r.kvc5 = "kvc5", r.kvc6 = "kvc6", r.aac = "aac", r.mp3 = "mp3", r.opus = "opus", r.yuv = "yuv", r.rawvideo = "rawvideo", r.vvc = "vvc", r.bvc2 = "bvc2", r.kvc30 = "kvc30", r;
  }({}), D = function(r) {
    return r.kvc3 = "kvc3", r.kvc4 = "kvc4", r.kvc5 = "kvc5", r.kvc6 = "kvc6", r.h265 = "h265", r.kw265 = "kw265", r.kvc30 = "kvc30", r;
  }({}), y = function(r) {
    return r.video = "video", r.canvas = "canvas", r;
  }({}), R = function(r) {
    return r.buildin = "buildin", r.wasm = "wasm", r.none = "none", r.unsupported = "unsupported", r;
  }({}), g = function(r) {
    return r.KWAI_FLV_ABR = "kwaiFlvAbr", r.KWAI_FLV_MP = "kwaiFlvMultipart", r.KWAI = "kwai", r.FILE = "file", r.OTHERS = "others", r;
  }({}), _ = function(r) {
    return r.flv = "flv", r.hls = "hls", r.hls_ts = "hls_ts", r.hls_fmp4 = "hls_fmp4", r.webrtc = "webrtc", r.mp4 = "mp4", r.raw = "raw", r.mp3 = "mp3", r.wav = "wav", r.aac = "aac", r.matroska = "matroska", r.ts = "ts", r.ivf = "ivf", r.yuv = "yuv", r.unknown = "unknown", r;
  }({}), I = function(r) {
    return r.LIVE = "live_retry", r.RTC = "rtc_retry", r.CODEC_AUDIO = "codec_audio", r.CODEC_REMUX_TYPE = "codec_remux_type", r.NATIVE = "native", r.MSE = "mse", r.REMUX = "remux", r.HEVC_DEC = "hevc_dec", r.FALLBACK_H264 = "fallback_h264", r.BACKUP = "backup", r.NEXT_MEDIA_DESC = "next_media_desc", r.LOADER = "loader", r;
  }({}), k = function(r) {
    return r.AUTO = "auto", r.ALL_NON_REF = "allNonRef", r.MIN = "min", r;
  }({}), P = function(r) {
    return r.NONE = "none", r.WAITING = "waiting", r;
  }({}), K = function(r) {
    return r.STANDARD = "standard", r.QUERY_START_END = "queryStartEnd", r;
  }({}), m = function(r) {
    return r.MAIN = "main", r.AUDIO = "audio", r.SUBTITLE = "subtitle", r;
  }({}), T = function(r) {
    return r.VIDEO = "video", r.AUDIO = "audio", r;
  }({}), b = function(r) {
    return r.unknown = "unknown", r.native = "native", r.mse = "mse", r.rtc = "rtc", r;
  }({}), L = function(r) {
    return r[r.Normal = 0] = "Normal", r[r.V360 = 1] = "V360", r[r.V180 = 2] = "V180", r;
  }({}), M = function(r) {
    return r[r.normal = 0] = "normal", r[r.internal = 1] = "internal", r[r.retry = 2] = "retry", r;
  }({}), U = function(r) {
    return r.NONE = "none", r.KWAI = "kwai", r.GENERAL = "general", r;
  }({}), B = function(r) {
    return r.UNKNOWN = "", r.PROBABLY = "probably", r;
  }({}), H = function() {
    function r() {
      this.timeout = 6048e5;
    }
    var s = r.prototype;
    return s.write = function(i, n) {
      if (r.available)
        try {
          localStorage.setItem(i, JSON.stringify({ value: n, time: Date.now() }));
        } catch (o) {
        }
    }, s.read = function(i, n) {
      if (n === void 0 && (n = !0), r.available)
        try {
          var o = localStorage.getItem(i);
          if (o) {
            var c = JSON.parse(o), d = c.value, A = c.time, f = A === void 0 ? 0 : A;
            if (!n || Date.now() - f < (typeof n == "number" ? n : this.timeout))
              return d;
          }
        } catch (x) {
        }
    }, E()(r, null, [{ key: "available", get: function() {
      if (r._available === void 0)
        try {
          localStorage.setItem("alg", "test"), r._available = !0;
        } catch (i) {
          r._available = !1;
        }
      return r._available;
    } }]), r;
  }();
  H._available = void 0;
  var q, Ie = H, Ae = function(r) {
    return r.NONE = "none", r.ERROR = "e", r.WARN = "w", r.INFO = "i", r.DEBUG = "d", r.VERBOSE = "v", r;
  }({}), W = ((q = {})[Ae.NONE] = 1, q[Ae.ERROR] = 100, q[Ae.WARN] = 200, q[Ae.INFO] = 300, q[Ae.DEBUG] = 400, q[Ae.VERBOSE] = 500, q), C = function() {
    function r() {
    }
    return r.loadLogLevel = function() {
      if (location.href) {
        var s = location.href.match(/kwaiKernelLog=([a-z]{1})/);
        if (s && s.length > 1)
          return void (this.level = s[1]);
      }
      var i = new Ie();
      this.level = i.read("kwai-kernel-log") || Ae.ERROR;
    }, r.e = function(s) {
      var i, n;
      if (!(this._logVal < W[Ae.ERROR])) {
        for (var o = arguments.length, c = new Array(o > 1 ? o - 1 : 0), d = 1; d < o; d++)
          c[d - 1] = arguments[d];
        console.error ? (i = console).error.apply(i, this._formatter(s, c)) : (n = console).log.apply(n, this._formatter(s, c));
      }
    }, r.w = function(s) {
      var i, n;
      if (!(this._logVal < W[Ae.WARN])) {
        for (var o = arguments.length, c = new Array(o > 1 ? o - 1 : 0), d = 1; d < o; d++)
          c[d - 1] = arguments[d];
        console.warn ? (i = console).warn.apply(i, this._formatter(s, c)) : (n = console).log.apply(n, this._formatter(s, c));
      }
    }, r.i = function(s) {
      var i, n;
      if (!(this._logVal < W[Ae.INFO])) {
        for (var o = arguments.length, c = new Array(o > 1 ? o - 1 : 0), d = 1; d < o; d++)
          c[d - 1] = arguments[d];
        console.info ? (i = console).info.apply(i, this._formatter(s, c)) : (n = console).log.apply(n, this._formatter(s, c));
      }
    }, r.d = function(s) {
      var i, n;
      if (!(this._logVal < W[Ae.DEBUG])) {
        for (var o = arguments.length, c = new Array(o > 1 ? o - 1 : 0), d = 1; d < o; d++)
          c[d - 1] = arguments[d];
        console.debug ? (i = console).debug.apply(i, this._formatter(s, c)) : (n = console).log.apply(n, this._formatter(s, c));
      }
    }, r.v = function(s) {
      var i;
      if (!(this._logVal < W[Ae.VERBOSE])) {
        for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), c = 1; c < n; c++)
          o[c - 1] = arguments[c];
        (i = console).log.apply(i, this._formatter(s, o));
      }
    }, E()(r, null, [{ key: "level", get: function() {
      return this._level;
    }, set: function(s) {
      W[s] && (this._level = s, this._logVal = W[s] || 0);
    } }]), r;
  }();
  C._level = Ae.NONE, C._logVal = 0, C._formatter = function(r, s) {
    return s && s.length !== 0 ? (s.unshift("[kwai-k::" + (r || "") + "] > "), s) : ["[kwai-k]", r];
  };
  function st(r, s, i) {
    if (r[s] === void 0)
      r[s] = i;
    else {
      var n = r[s];
      Array.isArray(n) ? n.push(i) : typeof n == "string" && (r[s] = [n, i]);
    }
  }
  function $e(r) {
    var s = {};
    return typeof r == "string" ? r.trim().split(/[\r\n]+/).forEach(function(i) {
      var n = i.split(": "), o = n.shift(), c = n.join(":");
      o && st(s, o, c);
    }) : r && r.forEach(function(i, n) {
      i.split(",").forEach(function(o) {
        st(s, n, o);
      });
    }), s;
  }
  function Ce(r) {
    var s = [];
    if (r)
      for (var i in r) {
        var n = r[i];
        n && s.push(i + ": " + (Array.isArray(n) ? n.join(",") : n).slice(0, 255));
      }
    if (s.length)
      return s.length > 20 ? (s.sort(function(o, c) {
        return He(c) - He(o);
      }), s.slice(0, 20)) : s;
  }
  var He = function(r) {
    return r.toLowerCase().indexOf("kwaisign") === 0 || r.toLowerCase().indexOf("x-ks-") === 0 ? 1 : 0;
  }, Le = function(r) {
    return r.MOZ_CHUNK = "moz-chunked-arraybuffer", r.UNKNOW = "unknow", r.UNSUPPORT = "", r;
  }({}), Oe = function() {
    function r() {
      var i = this;
      this.tag = "xhr", this._xhr = null, this._context = void 0, this._callbacks = null, this._progress = Le.UNKNOW, this._onReadyStateChange = function() {
        if (i._xhr) {
          var n = i._xhr;
          n.readyState === 2 && (i._context.responseUrl = n.responseURL, i._context.responseHeader = $e(n.getAllResponseHeaders()), i._callbacks && i._callbacks.onConnect && i._callbacks.onConnect(i._context, n.status), (n.status < 200 || n.status > 299) && i._onError());
        }
      }, this._onProgress = function() {
        if (i._xhr) {
          var n = i._xhr.response;
          i._callbacks && i._callbacks.onProgress && n && i._callbacks.onProgress(i._context, n);
        }
      }, this._onLoadEnd = function() {
        var n = null, o = i._xhr;
        !i._progress && o && (n = o.response), i._callbacks && i._callbacks.onEnd(i._context, n);
      }, this._onError = function() {
        var n;
        i._callbacks && i._callbacks.onError && i._callbacks.onError(new Error("xhr load error.")), (n = i._xhr) == null || n.abort();
      }, this._xhr = null;
    }
    r.isSupportChunk = function() {
      if (r._supportChunk !== Le.UNKNOW)
        return r._supportChunk;
      try {
        var i = new XMLHttpRequest();
        if (i.open("GET", "https://example.com", !0), i.responseType = Le.MOZ_CHUNK, i.responseType === Le.MOZ_CHUNK)
          return r._supportChunk = Le.MOZ_CHUNK, r._supportChunk;
      } catch (n) {
        r._supportChunk = Le.UNSUPPORT;
      }
      return Le.UNSUPPORT;
    };
    var s = r.prototype;
    return s.load = function(i, n) {
      this._callbacks = n, this._context = i, this._progress = Le.UNSUPPORT, i.progress && i.responseType === "arraybuffer" && (this._progress = r.isSupportChunk());
      var o = this._xhr = new XMLHttpRequest();
      o.open(i.requestMethod ? i.requestMethod : "GET", this._context.url, !0), this._progress === Le.MOZ_CHUNK ? (o.responseType = Le.MOZ_CHUNK, o.onprogress = this._onProgress, o.onload = this._onLoadEnd) : (o.responseType = i.responseType || "arraybuffer", o.onload = this._onLoadEnd), o.onreadystatechange = this._onReadyStateChange, o.onerror = this._onError, o.withCredentials = !!i.credentials, i.range && o.setRequestHeader("Range", i.range), i.headers && i.headers.forEach(function(c) {
        o.setRequestHeader(c.header, c.value);
      }), o.send(i.requestBody);
    }, s.abort = function() {
      this._xhr && (this._xhr.onreadystatechange = null, this._xhr.onprogress = null, this._xhr.onload = null, this._xhr.onerror = null, this._xhr.abort(), this._xhr = null);
    }, s.destroy = function() {
      this._callbacks = null, this.abort();
    }, r;
  }();
  Oe._supportChunk = Le.UNKNOW;
  var We = [_.hls, _.hls_ts, _.hls_fmp4];
  function ke(r) {
    return !!r && We.indexOf(r) !== -1;
  }
  var lt = {};
  (function(r) {
    if (typeof navigator < "u") {
      r = r ? r.toLowerCase() : navigator.userAgent.toLowerCase();
      var s = /(edge)\/([\w.]+)/.exec(r) || /(edg)\/([\w.]+)/.exec(r) || /(opr)[\/]([\w.]+)/.exec(r) || /(chrome)[ \/]([\w.]+)/.exec(r) || /(iemobile)[\/]([\w.]+)/.exec(r) || /(version)(applewebkit)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(r) || /(webkit)[ \/]([\w.]+).*(version)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(r) || /(webkit)[ \/]([\w.]+)/.exec(r) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(r) || /(msie) ([\w.]+)/.exec(r) || r.indexOf("trident") >= 0 && /(rv)(?::| )([\w.]+)/.exec(r) || r.indexOf("compatible") < 0 && /(firefox)[ \/]([\w.]+)/.exec(r) || [], i = /(ipad)/.exec(r) || /(ipod)/.exec(r) || /(windows phone)/.exec(r) || /(iphone)/.exec(r) || /(kindle)/.exec(r) || /(android)/.exec(r) || /(windows)/.exec(r) || /(mac)/.exec(r) || /(linux)/.exec(r) || /(cros)/.exec(r) || [], n = /(?:iphone|ipad|cpu) os (\d+)[._]\d+/.exec(r) || /android ([\d\.]+)/.exec(r) || [], o = { browser: s[5] || s[3] || s[1] || "", version: s[2] || s[4] || "0", majorVersion: s[4] || s[2] || "0", platform: i[0] || "", platformVersion: n[1] || "" }, c = { x5: / tbs\//.test(r), xweb: / xweb\//.test(r) };
      if (o.browser) {
        c[o.browser] = !0;
        var d = o.majorVersion.split(".");
        c.version = { major: parseInt(o.majorVersion, 10), string: o.version }, d.length > 1 && (c.version.minor = parseInt(d[1], 10)), d.length > 2 && (c.version.build = parseInt(d[2], 10));
      }
      o.platform && (c[o.platform] = !0), (c.chrome || c.opr || c.safari) && (c.webkit = !0), (c.rv || c.iemobile) && (c.rv && delete c.rv, o.browser = "msie", c.msie = !0), (c.edg || c.edge) && (delete c.edg, delete c.edge, o.browser = "msedge", c.msedge = !0), c.opr && (o.browser = "opera", c.opera = !0), c.safari && c.android && (o.browser = "android", c.android = !0);
      for (var A in (c.android || c.iphone || c.ipad) && (c.mobile = !0), c.ios = c.iphone || c.ipad, c.name = o.browser, c.platform = o.platform, c.platformVersion = o.platformVersion, lt)
        lt.hasOwnProperty(A) && delete lt[A];
      u()(lt, c);
    }
  })();
  var Q = lt, ct = function(r) {
    return r.LOADER_CONNECT_TIMEOUT = "connectTimeout", r.LOADER_TRANS_TIMEOUT = "transTimeout", r;
  }({}), pt = function(r) {
    return r.FETCH_READ_ERROR_NAME = "ReadError", r.SLICE_UNPACK_ERROR_NAME = "SliceUnpackError", r;
  }({}), Tt = function(r) {
    return r.UNKNOWN = "unknown", r.FETCH = "fetch", r.XHR = "xhr", r;
  }({});
  function Z(r, s) {
    var i = r.toString();
    return i.toLowerCase().includes("[native code]") && i.includes(s) ? B.UNKNOWN : B.PROBABLY;
  }
  var fe = function() {
    function r() {
      this.tag = "fetch", this._context = void 0, this._callbacks = null, this._controller = null, this._reader = null, this._abort = !1;
    }
    r.isSupported = function() {
      return typeof fetch < "u" && typeof ReadableStream < "u";
    };
    var s = r.prototype;
    return s.load = function(i, n) {
      var o = this;
      this._context = i, this._callbacks = n;
      var c = new Headers();
      i.headers && i.headers.forEach(function(x) {
        c.append(x.header, x.value);
      }), i.range && c.append("Range", i.range);
      var d = { method: i.requestMethod ? i.requestMethod : "GET", headers: c, mode: "cors", cache: "default", referrerPolicy: "no-referrer-when-downgrade", signal: this._getAbortSignal() };
      i.requestBody && (d.body = i.requestBody), i.credentials && (d.credentials = "include");
      var A = fetch;
      if (i.preferNative === !0) {
        var f = this._getNativeFetch();
        A = f.func, i.monkeyPatched = f.patched, i.useResetNativeFetch = f == null ? void 0 : f.resetNativeFetch;
      } else
        i.monkeyPatched = Z(A, "fetch");
      A(i.url, d).then(function(x) {
        if (i.responseUrl = x.url, i.redirected = x.redirected, i.responseHeader = $e(x.headers), o._callbacks && o._callbacks.onConnect && o._callbacks.onConnect(i, x.status), x.ok)
          return o._abort ? void (x.body && x.body.getReader().cancel()) : i.responseType === "arraybuffer" ? i.progress ? void (x.body && (o._reader = x.body.getReader(), o._pump(o._reader))) : void x.arrayBuffer().then(function(V) {
            o._onEnd(i, V);
          }).catch(function(V) {
            if (!o._abort) {
              var G = new Error(x.status + " " + V);
              o._onError(G);
            }
          }) : void x.text().then(function(V) {
            o._onEnd(i, V);
          }).catch(function(V) {
            if (!o._abort) {
              var G = new Error(x.status + " " + V);
              o._onError(G);
            }
          });
        var O = new Error(x.status + " " + x.statusText);
        o._onError(O);
      }).catch(function(x) {
        x.name !== "AbortError" && o._onError(x);
      });
    }, s.abort = function() {
      this._controller && (this._controller.abort(), this._controller = null), this._reader && (this._reader.cancel().catch(function() {
      }), this._reader = null), this._abort = !0;
    }, s.destroy = function() {
      this._callbacks = null, this.abort();
    }, s._onProgress = function(i, n) {
      this._callbacks && this._callbacks.onProgress && this._callbacks.onProgress(i, n);
    }, s._onEnd = function(i, n) {
      this._callbacks && this._callbacks.onEnd && (this._reader = null, this._controller = null, this._callbacks.onEnd(i, n));
    }, s._onError = function(i) {
      this._callbacks && this._callbacks.onError && this._callbacks.onError(i);
    }, s._pump = function(i) {
      var n = this;
      i.read().then(function(o) {
        if (n._abort)
          return i.cancel(), null;
        if (o.done)
          return n._onEnd(n._context, null), null;
        var c = o.value.buffer;
        return n._context.useResetNativeFetch && Q.safari && (c = new Uint8Array(new Uint8Array(c).subarray()).buffer), n._onProgress(n._context, c), n._pump(i);
      }).catch(function(o) {
        o.name !== "AbortError" && (o.name = pt.FETCH_READ_ERROR_NAME, n._onError(o));
      });
    }, s._getAbortSignal = function() {
      try {
        if (AbortController)
          return this._controller = new AbortController(), this._controller.signal;
      } catch (i) {
        return null;
      }
      return null;
    }, s._getNativeFetch = function() {
      if (r._nativeFetch !== void 0)
        return r._nativeFetch;
      if (Z(fetch, "fetch") === B.PROBABLY) {
        var i = function(n) {
          var o, c, d = document.createElement("iframe");
          document.body.appendChild(d);
          var A = (o = ((c = d.contentWindow) == null ? void 0 : c.fetch) || null) == null ? void 0 : o.bind(n);
          return document.body.removeChild(d), C.i("native-fetch", "detected io monkey patched. get native io, fetch: " + !!A), A;
        }(window);
        r._nativeFetch = i ? { func: i, patched: B.PROBABLY, resetNativeFetch: !0 } : { func: fetch, patched: B.PROBABLY, resetNativeFetch: !1 };
      } else
        r._nativeFetch = { func: fetch, patched: B.UNKNOWN, resetNativeFetch: !1 };
      return r._nativeFetch;
    }, r;
  }();
  fe._nativeFetch = void 0;
  var Y = a(3), Ee = a.n(Y), rt = { alwaysSeekKeyframe: !1, lazyLoadMaxDuration: -1, lazyLoadRecoverDuration: 20, webWorker: !0, appendErrorMaxRetry: 3, credentials: !1, streamingMux: !0, autoPlaybackRate: !0, autoPlaybackRateConf: void 0, enableSoftwareAES: !0, startPlayBufferSec: 0, startFromSec: 0, startFromKeyframe: !0, defaultSpts: -5e3, kwaiKernelLog: Ae.ERROR, retryWithBackup: !0, resourceBuffer: !0, resourceBufferSize: 500, ntp: !0, ensureVideo: !1, adaptive: !0, abrSpeedTest: !0, httpRangeType: K.STANDARD, enableAacPriv: !1, maxAudioFramesDrift: 5, forceKeyFrameOnDiscontinuity: !1, videoDropFramePolicy: k.AUTO, videoDecBlockPolicy: P.WAITING, videoFrameBufferSize: 536870912, maxVideoDecThreads: 8, mainThreadRendering: !1, wasmDecoderEnabled: !Q.mobile, maxRetry: 3, connectionTimeout: 1e4, transmissionTimeout: 3e4, retryDelay: 100, maxFragFailSec: 11, flvLoadEndError: !0, catchUpPausedLive: !0, breakpointContinuation: !0, manifestLoadingMaxRetry: 3, manifestConnectionTimeout: 1e4, manifestTransmissionTimeout: 1e4, manifestLoadingRetryDelay: 1, levelLoadingMaxRetry: 3, levelConnectionTimeout: 1e4, levelTransmissionTimeout: 1e4, levelLoadingRetryDelay: 100, emeEnabled: !0, widevineLicenseUrl: "", playreadyLicenseUrl: "", fairplayLicenseUrl: "", keyLoadingMaxRetry: 3, keyConnectionTimeout: 1e4, keyTransmissionTimeout: 5e3, keyLoadingRetryDelay: 300, sdpConnectionTimeout: 1e4, peerConnectionTimeout: 1e4, peerConnectionMaxRetry: 5, peerConnectionRetryDelay: 3e3, decLibLoadingMaxRetry: 2, decLibConnectionTimeout: 5e3, liveDelayFragNum: 3, liveShiftType: U.NONE, preferNativeLoader: void 0, playbackAbilityCacheTimeout: 864e5 }, Xt = { maxRetry: 1, retryDelay: 100, connectionTimeout: 1e4, levelConnectionTimeout: 1e4, manifestConnectionTimeout: 1e4 }, ut = function() {
    function r() {
    }
    return r.isStreamingSupported = function() {
      return r._streamingSupported === void 0 && (r._streamingSupported = fe.isSupported() || !!Oe.isSupportChunk()), r._streamingSupported;
    }, r.processConfig = function(s) {
      if (s) {
        var i = s.src, n = s.preprocessUrl;
        (s = JSON.parse(JSON.stringify(s))).src = i, s.preprocessUrl = n, n && C.i("config", "set preprocessUrl");
      }
      s.isLive ? rt.videoFrameBufferSize = 104857600 : rt.videoFrameBufferSize = 536870912;
      var o = ke(s.box) ? u()({}, rt, Xt) : u()({}, rt);
      return u()(o, s), o.wasmDecoderEnabled = o.wasmDecoderEnabled && !!Ee.a, o.startPlayBufferSec = Math.min(5, Math.max(0, o.startPlayBufferSec)), this._initPlayBackRateRule(o), Worker || (o.webWorker = !1), o;
    }, r._initPlayBackRateRule = function(s) {
      var i = s.autoPlaybackRateConf;
      if (i) {
        var n = i.rule;
        if (n && Array.isArray(n) && ((n = n.filter(function(o) {
          return o.upper > o.lower && o.rate > 0;
        })).sort(function(o, c) {
          return c.rate - o.rate;
        }), n.length > 1))
          return i.rule = n, void (s.autoPlaybackRateConf = i);
      }
    }, r;
  }();
  ut._streamingSupported = void 0;
  var nt = function(r) {
    return r.UNKNOWN = "unknown", r.FLV = "flv", r.FMP4 = "fmp4", r.TS = "ts", r.MP4 = "mp4", r.RAW = "raw", r.IVF = "ivf", r.YUV = "yuv", r;
  }({}), Vt = function(r) {
    return r.MANIFEST = "manifest", r.LEVEL = "level", r.AUDIO_TRACK = "audioTrack", r.SUBTITLE_TRACK = "subtitleTrack", r;
  }({}), ft = function(r) {
    return r.NETWORK_ERROR = "networkError", r.MEDIA_ERROR = "mediaError", r.KEY_SYSTEM_ERROR = "keySystemError", r.MUX_ERROR = "muxError", r.OTHER_ERROR = "otherError", r.MSE_ERROR = "mseError", r.DECODER_ERROR = "decoderError", r.RENDERER_ERROR = "rendererError", r;
  }({}), ve = function(r) {
    return r[r.LOAD_ERROR = 10] = "LOAD_ERROR", r[r.MANIFEST_LOAD_ERROR = 11] = "MANIFEST_LOAD_ERROR", r[r.LEVEL_LOAD_ERROR = 12] = "LEVEL_LOAD_ERROR", r[r.AUDIO_TRACK_LOAD_ERROR = 13] = "AUDIO_TRACK_LOAD_ERROR", r[r.KEY_LOAD_ERROR = 14] = "KEY_LOAD_ERROR", r[r.KEY_SYSTEM_LICENSE_REQUEST_FAILED = 15] = "KEY_SYSTEM_LICENSE_REQUEST_FAILED", r[r.DEC_LIB_LOAD_ERROR = 16] = "DEC_LIB_LOAD_ERROR", r[r.RTC_SDP_LOAD_ERROR = 17] = "RTC_SDP_LOAD_ERROR", r[r.SUBTITLE_TRACK_LOAD_ERROR = 18] = "SUBTITLE_TRACK_LOAD_ERROR", r[r.CANNOT_SEEK = 100] = "CANNOT_SEEK", r[r.VIDEO_ERROR = 101] = "VIDEO_ERROR", r[r.UNSUPPORTED = 102] = "UNSUPPORTED", r[r.CONFIG_ERROR = 103] = "CONFIG_ERROR", r[r.OTHER = 104] = "OTHER", r[r.UNKNOWN = 105] = "UNKNOWN", r[r.CANNOT_SEEK_BY_FRAME_INDEX = 106] = "CANNOT_SEEK_BY_FRAME_INDEX", r[r.SRC_EMPTY = 107] = "SRC_EMPTY", r[r.VIDEO_ERROR_1 = 111] = "VIDEO_ERROR_1", r[r.VIDEO_ERROR_2 = 112] = "VIDEO_ERROR_2", r[r.VIDEO_ERROR_3 = 113] = "VIDEO_ERROR_3", r[r.VIDEO_ERROR_4 = 114] = "VIDEO_ERROR_4", r[r.MEDIASOURCE_ERROR = 200] = "MEDIASOURCE_ERROR", r[r.ADDSOURCEBUFFER_ERROR = 201] = "ADDSOURCEBUFFER_ERROR", r[r.SOURCEBUFFER_ERROR = 202] = "SOURCEBUFFER_ERROR", r[r.ENDOFSTREAM_ERROR = 203] = "ENDOFSTREAM_ERROR", r[r.APPENDBUFFER_ERROR = 204] = "APPENDBUFFER_ERROR", r[r.CHANGETYPE_ERROR = 205] = "CHANGETYPE_ERROR", r[r.MSE_CAPABILITY_ERROR = 206] = "MSE_CAPABILITY_ERROR", r[r.PARSING_ERROR = 301] = "PARSING_ERROR", r[r.REMUX_ERROR = 302] = "REMUX_ERROR", r[r.REMUX_ALLOC_ERROR = 303] = "REMUX_ALLOC_ERROR", r[r.REMUX_WORKER_ERROR = 304] = "REMUX_WORKER_ERROR", r[r.DEMUX_NOT_FOUND = 305] = "DEMUX_NOT_FOUND", r[r.MANIFEST_PARSING_ERROR = 400] = "MANIFEST_PARSING_ERROR", r[r.KEY_SYSTEM_NO_ACCESS = 500] = "KEY_SYSTEM_NO_ACCESS", r[r.KEY_SYSTEM_NO_SESSION = 501] = "KEY_SYSTEM_NO_SESSION", r[r.KEY_SYSTEM_URL_ERROR = 502] = "KEY_SYSTEM_URL_ERROR", r[r.KEY_SYSTEM_NO_KEYS = 505] = "KEY_SYSTEM_NO_KEYS", r[r.FRAG_DECRYPT_ERROR = 506] = "FRAG_DECRYPT_ERROR", r[r.KEY_SYSTEM_NO_INIT_DATA = 507] = "KEY_SYSTEM_NO_INIT_DATA", r[r.KEY_SYSTEM_UNSUPPORTED = 508] = "KEY_SYSTEM_UNSUPPORTED", r[r.DECODER_LOAD_ERROR = 600] = "DECODER_LOAD_ERROR", r[r.DECODER_INIT_ERROR = 601] = "DECODER_INIT_ERROR", r[r.DECODER_DRAW_ERROR = 602] = "DECODER_DRAW_ERROR", r[r.DECODER_WEBGL_ERROR = 603] = "DECODER_WEBGL_ERROR", r[r.DECODER_UNSUPPORTED = 604] = "DECODER_UNSUPPORTED", r[r.DECODER_COPY_YUV_ERROR = 605] = "DECODER_COPY_YUV_ERROR", r[r.PRELOAD_ERROR = 700] = "PRELOAD_ERROR", r[r.LIVE_DISCONNECTED_ERROR = 1009] = "LIVE_DISCONNECTED_ERROR", r[r.WEBRTC_DISCONNECTED_ERROR = 1010] = "WEBRTC_DISCONNECTED_ERROR", r[r.WEBRTC_FAILED_ERROR = 1011] = "WEBRTC_FAILED_ERROR", r[r.WEBRTC_CLOSED_ERROR = 1012] = "WEBRTC_CLOSED_ERROR", r[r.WEBRTC_ICE_CANDIDATE_ERROR = 1013] = "WEBRTC_ICE_CANDIDATE_ERROR", r[r.WEBRTC_ICE_CONNECTION_ERROR = 1014] = "WEBRTC_ICE_CONNECTION_ERROR", r[r.WEBRTC_OFFER_ERROR = 1015] = "WEBRTC_OFFER_ERROR", r[r.WEBRTC_ANSWER_ERROR = 1016] = "WEBRTC_ANSWER_ERROR", r[r.WEBRTC_TRANSMISSION_DATA_NULL = 1017] = "WEBRTC_TRANSMISSION_DATA_NULL", r[r.WEBRTC_CONNECT_TIMEOUT = 1018] = "WEBRTC_CONNECT_TIMEOUT", r[r.WEBRTC_CONNECT_FAILED = 1019] = "WEBRTC_CONNECT_FAILED", r;
  }({}), Ye = [ve.VIDEO_ERROR, ve.VIDEO_ERROR_1, ve.VIDEO_ERROR_2, ve.VIDEO_ERROR_3, ve.VIDEO_ERROR_4], Je = { 400: "01", 401: "02", 403: "03", 404: "04", other4xx: "05", serverError: "06", timeoutOpen: "07", timeoutIO: "08", 200: "09", 206: "09" };
  function kt(r, s, i) {
    if (i === void 0 && (i = 0), r >= 100)
      return r;
    var n = "00";
    return s === ct.LOADER_CONNECT_TIMEOUT ? n = Je.timeoutOpen || n : s === ct.LOADER_TRANS_TIMEOUT ? n = Je.timeoutIO || n : Object.prototype.hasOwnProperty.call(Je, i) ? n = Je[i] || n : /^4\d{2}$/.test(i.toString()) ? n = Je.other4xx || n : /^5\d{2}$/.test(i.toString()) && (n = Je.serverError || n), parseInt(r + n, 10);
  }
  var ie = /\.[^./\\?#]+(?=$|[?#])/i, de = { ".mp4": _.mp4, ".m4s": _.mp4, ".mov": _.mp4, ".m4a": _.mp4, ".flv": _.flv, ".m3u8": _.hls, ".sdp": _.webrtc, ".webm": _.matroska, ".mkv": _.matroska, ".mka": _.matroska, ".mp3": _.mp3, ".wav": _.wav, ".aac": _.aac, ".ts": _.ts, ".yuv": _.yuv, ".slice": _.flv };
  function ee(r) {
    var s = function(i) {
      var n = i.toLocaleLowerCase().match(ie);
      return n ? n[0] : "";
    }(r);
    return s && de[s] || _.unknown;
  }
  var be = a(4), te = a.n(be), Gt = /^[^_][A-Za-z0-9_-]*$/, me = /_([A-Za-z0-9]+)_/;
  function Dt(r) {
    var s = new te.a(r).pathname, i = ee(r), n = i === _.flv || ke(i) || i === _.ts, o = "", c = "", d = s.split("/"), A = d[d.length - 1] || "";
    if (n) {
      try {
        var f = s.lastIndexOf("/");
        f >= 0 && (s = s.slice(f + 1));
        var x = s.split(".")[0].split("_");
        x.length === 1 ? (o = bt(x[0]), c = at(r)) : x.length === 2 ? (o = bt(x[0]), c = bt(x[1])) : x.length > 2 && (o = bt(x.slice(0, x.length - 1).join("_")), c = bt(x[x.length - 1]));
      } catch (O) {
      }
      return { streamID: o, transcodingTpl: c, filename: A };
    }
    return { streamID: "", transcodingTpl: at(r), filename: A };
  }
  var at = function(r) {
    var s = r.match(me), i = "";
    return s != null && s.length && s.length > 1 && (i = s[1]), bt(i);
  }, bt = function(r) {
    return Gt.test(r) ? r : "";
  };
  function ci(r) {
    var s;
    performance.addEventListener && (s = r, performance && (typeof performance.setResourceTimingBufferSize == "function" ? performance.setResourceTimingBufferSize(s) : typeof performance.webkitSetResourceTimingBufferSize == "function" && performance.webkitSetResourceTimingBufferSize(s)), performance.addEventListener("resourcetimingbufferfull", vr));
  }
  var ui, vr = function() {
    performance && (typeof performance.clearResourceTimings == "function" ? performance.clearResourceTimings() : typeof performance.webkitClearResourceTimings == "function" && performance.webkitClearResourceTimings());
  }, no = function(r) {
    return r.FAIL = "FAIL", r.ABORT = "ABORT", r.SUCCESS = "SUCCESS", r.CONNECTED = "CONNECTED", r;
  }({});
  (ui = {})[Vt.MANIFEST] = ve.MANIFEST_LOAD_ERROR, ui[Vt.LEVEL] = ve.LEVEL_LOAD_ERROR, ui[Vt.AUDIO_TRACK] = ve.AUDIO_TRACK_LOAD_ERROR, ui[Vt.SUBTITLE_TRACK] = ve.SUBTITLE_TRACK_LOAD_ERROR;
  var ge = function(r) {
    return r.PLAY = "PLAY", r.END = "END", r.PAUSE = "PAUSE", r.LOAD = "LOAD", r.BLOCK_START = "BLOCK_START", r.BLOCK_END = "BLOCK_END", r.SEEK_START = "SEEK_START", r.SEEK_END = "SEEK_END", r.LIVE_STOP = "LIVE_STOP", r.ERROR = "ERROR", r.DESTORY = "DESTORY", r.QUALITY_CHANGE = "QUALITY_CHANGE", r.QUALITY_CHANGE_DATA = "QUALITY_CHANGE_DATA", r.QUALITY_CHANGE_RENDER = "QUALITY_CHANGE_RENDER", r.SPEED_CHANGE = "SPEED_CHANGE", r.RETRY = "RETRY", r.NETWORK_CHANGE = "NETWORK_CHANGE", r.FIRST_SCREEN_RENDER = "FIRST_SCREEN_RENDER", r.METADATA_LOAD = "METADATA_LOAD", r.LIVE_SHIFT = "LIVE_SHIFT", r.AUDIO_CHANGE = "AUDIO_CHANGE", r;
  }({}), je = function(r) {
    return r.METADATA = "metadata", r.MEDIA_INFO = "mediaInfo", r.HEARTBEAT = "heartbeat", r.DOWNLOAD = "download", r.REALTIME_BEACON = "realtimeBeacon", r.DISCONTINUITY = "discontinuity", r.KEY_FRAME = "keyFrame", r.PRIV_NAL = "privNal", r.SEI = "sei", r.AAC_PRIV = "aacPriv", r.EVENT = "event", r;
  }({}), ao = a(5), Qt = a.n(ao), oo = function() {
    function r() {
      var i = this;
      this._timer = void 0, this._xhr = void 0, this._callbackFunc = void 0, this._onEnd = function() {
        i._detectEnd();
      }, this._onReadystatechange = function() {
        i._xhr && i._xhr.readyState >= 2 && i._detectEnd();
      }, this._detectEnd = function() {
        i._xhr && i._callbackFunc && i._callbackFunc(i._xhr.status), i.stop();
      };
    }
    var s = r.prototype;
    return s.start = function(i, n) {
      this._callbackFunc = n, this._xhr && this.stop();
      var o = this._xhr = new XMLHttpRequest();
      o.open("GET", i, !0), o.onreadystatechange = this._onReadystatechange, o.onerror = this._onEnd, o.onload = this._onEnd, o.send(), this._timer = setTimeout(this._detectEnd, 1e3);
    }, s.stop = function() {
      this._timer && (clearTimeout(this._timer), this._timer = void 0), this._xhr && (this._xhr.onreadystatechange = null, this._xhr.onload = null, this._xhr.onerror = null, this._xhr.abort(), this._xhr = void 0), this._callbackFunc = void 0;
    }, r;
  }();
  function Rt() {
    return typeof window != "object" || typeof document != "object" || typeof document.createElement != "function";
  }
  function Vi() {
    var r, s;
    if (!Rt())
      return ((r = window) == null ? void 0 : r.MediaSource) || ((s = window) == null ? void 0 : s.WebKitMediaSource);
  }
  function mr() {
    var r, s;
    if (!Rt())
      return ((r = window) == null ? void 0 : r.SourceBuffer) || ((s = window) == null ? void 0 : s.WebKitSourceBuffer);
  }
  var so = { audio: { a3ds: !0, "ac-3": !0, "ac-4": !0, alac: !0, alaw: !0, dra1: !0, "dts+": !0, "dts-": !0, dtsc: !0, dtse: !0, dtsh: !0, "ec-3": !0, enca: !0, g719: !0, g726: !0, m4ae: !0, mha1: !0, mha2: !0, mhm1: !0, mhm2: !0, mlpa: !0, mp4a: !0, "raw ": !0, Opus: !0, samr: !0, sawb: !0, sawp: !0, sevc: !0, sqcp: !0, ssmv: !0, twos: !0, ulaw: !0 }, video: { avc1: !0, avc2: !0, avc3: !0, avc4: !0, avcp: !0, drac: !0, dvav: !0, dvhe: !0, encv: !0, hev1: !0, hvc1: !0, mjp2: !0, mp4v: !0, mvc1: !0, mvc2: !0, mvc3: !0, mvc4: !0, resv: !0, rv60: !0, s263: !0, svc1: !0, svc2: !0, "vc-1": !0, vp08: !0, vp09: !0 } };
  function yr(r) {
    var s = {};
    return (r || "").split(/[ ,]+/).forEach(function(i) {
      i.indexOf("avc1") !== 0 && i.indexOf("hev1") !== 0 && i.indexOf("av01") !== 0 && i.indexOf("kvc") !== 0 || (s.video = i), i.indexOf("mp4a") === 0 && (s.audio = i);
    }), s;
  }
  function lo(r, s) {
    var i = [].concat(r.split(/[ ,]+/));
    ["video", "audio"].forEach(function(n) {
      var o = i.filter(function(d) {
        return function(A, f) {
          var x = so[f];
          return !!x && x[A.slice(0, 4)] === !0;
        }(d, n);
      });
      if (o.length) {
        var c = o.filter(function(d) {
          return d.lastIndexOf("avc1", 0) === 0 || d.lastIndexOf("av01", 0) === 0 || d.lastIndexOf("hev1", 0) === 0 || d.lastIndexOf("hvc1", 0) === 0 || d.lastIndexOf("mp4a", 0) === 0;
        });
        s[n + "Codec"] = c.length > 0 ? c[0] : o[0], i = i.filter(function(d) {
          return o.indexOf(d) === -1;
        });
      }
    }), s.codec = i.join(",");
  }
  function Ar(r) {
    return r.indexOf("avc1") === 0 ? p.h264 : r.indexOf("hev1") === 0 || r.indexOf("hvc1") === 0 ? p.hevc : r.indexOf("av01") === 0 ? p.av1 : p.unknown;
  }
  var co = a(2), Pe = a.n(co), Er = function() {
    function r() {
      this._$evt = new v.EventEmitter();
    }
    var s = r.prototype;
    return s.on = function(i, n) {
      this._$evt.on(i, n);
    }, s.prependListener = function(i, n) {
      this._$evt.prependListener(i, n);
    }, s.removeAllListeners = function(i) {
      this._$evt.removeAllListeners(i);
    }, s.off = function(i, n) {
      this._$evt.off(i, n);
    }, s.listeners = function(i) {
      return this._$evt.listeners(i);
    }, s.emit = function(i, n) {
      return this._$evt.emit(i, n);
    }, s.listenerCount = function(i) {
      return this._$evt.listenerCount(i);
    }, r;
  }(), gr = function(r) {
    return r.METADATA = "metadata", r.MEDIA_INFO = "mediaInfo", r.PARSING_INIT_SEGMENT = "parsingInitSegment", r.PARSING_DATA = "parsingData", r.PARSED_DATA = "parsedData", r.SCRIPT_PARSED = "scriptParsed", r.KEY_FRAME_INDEXS = "keyFrameIndexs", r.VIDEO_FRAME_INFO = "videoFrameInfo", r.DISCONTINUITY = "discontinuity", r.REPORT = "report", r.LOAD_END = "loadEnd", r.ERROR = "error", r.MANIFEST_PARSED = "manifestParsed", r.LEVEL_SWITCHING = "levelSwitching", r.LEVEL_SWITCHED = "levelSwitched", r.LEVEL_SWITCH_PLAYING = "levelSwitchPlaying", r.LEVEL_SWITCH_FAILED = "levelSwitchFailed", r.LEVEL_LOADED = "levelLoaded", r.LEVEL_UPDATED = "levelUpdated", r.AUDIO_TRACK_SWITCHING = "audioTrackSwitching", r.AUDIO_TRACK_SWITCHED = "audioTrackSwitched", r.AUDIO_TRACK_UPDATED = "audioTrackUpdated", r.HLS_MANIFEST_PARSED = "hlsManifestParsed", r.HLS_KEY_LOADED = "hlsKeyLoaded", r.AUDIO_TRACK_LOADED = "audioLoaded", r.SUBTITLE_TRACK_LOADED = "subtitleTrackLoaded", r.SUBTITLE_LOADED = "subtitleLoaded", r.SUBTITLE_TRACK_SWITCHED = "subtitleTrackSwitched", r.SUBTITLE_TRACK_UPDATED = "subtitleTrackUpdated", r.BUFFER_CLEANING = "bufferCleaning", r.VIDEO_SEEK = "vdeoSeek", r.PRELOAD_COMPLETE = "preloadComplete", r.ABR_NEXT = "abrNext", r.PRIV_NAL = "privNal", r.SEI = "sei", r.AAC_PRIV = "aacPriv", r.RAW_DATA = "rawData", r.MP4_NOT_FASTSTART = "mp4NotFaststart", r.VIDEO_CODEC_DETECTED = "videoCodecChange", r.H265_DETECTED = "h265Detected", r.VIDEO_RENDERER_CHANGE = "videoRendererChange", r.DEC_LIB_LOADED = "decLibLoaded", r.DEC_INIT_COMPLETE = "decoderInitComplete", r.DEC_VIDEO_READY = "decVideoReady", r.STEP = "step", r.RENDERER_BUF_EXPIRED = "rendererBufExpired", r.RENDERER_SEEK = "rendererSeek", r.RENDERER_BUF_UPDATE = "rendererBufUpdate", r.RENDERER_DRAW = "rendererDraw", r.DECODER_FRAME = "decoderFrame", r.DECODER_IMG = "decoderImg", r.DECODER_SEEK = "decoderSeek", r.DECODER_SEEK_ABORT = "decoderSeekAbort", r.DECODER_WAITING = "decoderWaiting", r.DECODER_DATA_END = "decoderDataEnd", r.DECODER_BUF_LOW = "decoderDataEmpty", r.DECODER_DROP_FRAME = "decocerDropFrame", r.DECODER_MEDIA_INFO = "decoderMediaInfo", r.MEDIA_CONNECTED = "mediaConnected", r.LOADER_CHUNK_ARRIVAL = "loaderChunkArrival", r.DEMUXER_DETECTED = "demuxerDetected", r.MEDIA_DEMUX = "mediaDemux", r.KEY_FRAME = "keyFrame", r.USE_BACKUP = "useBackup", r.NEW_SOURCE = "newSource", r.DOWNLOAD = "download", r.STOP_LOAD = "stopLoad", r.LOAD = "load", r.WAITING = "waiting", r.LOADEDMETADATA = "loadedmetadata", r.LOADEDDATA = "loadeddata", r.CANPLAY = "canplay", r.SEEKING = "seeking", r.SEEK_WITH_LOAD = "seekWithLoad", r.SEEKED = "seeked", r.PLAYING = "playing", r.PAUSE = "pause", r.PLAY = "play", r.ENDED = "ended", r.TIMEUPDATE = "timeupdate", r.PROGRESS = "progress", r.RATE_CHANGE = "ratechange", r.DURATION_CHANGE = "durationchange", r.HEARTBEAT = "heartbeat", r.MSE_UPDATE = "mseUpdate", r.MSE_BUFFER_FULL = "mseBufferFull", r.RETRY = "retry", r.FALLBACK_H264 = "fallbackH264", r;
  }(gr || {}), S = gr, St = function(r) {
    return r[r.NONE = 0] = "NONE", r[r.WAITING = 1] = "WAITING", r[r.SEEK = 2] = "SEEK", r[r.SELECT_BITRATE = 3] = "SELECT_BITRATE", r[r.INIT = 4] = "INIT", r[r.LOADING = 5] = "LOADING", r;
  }({}), Ke = "kernel-base", uo = function(r) {
    function s(n) {
      var o;
      return (o = r.call(this, n.video) || this)._ctx = void 0, o._httpStatusDetector = void 0, o._setStartFromOnTimeupdate = !1, o._ctx = n, o;
    }
    Qt()(s, r);
    var i = s.prototype;
    return i.load = function(n) {
      var o;
      C.i("kernel-native", "load", this._ctx.stat.startFromSec);
      var c = this._ctx.lctx.levels;
      c.length || this._onError({ type: ft.OTHER_ERROR, details: ve.MANIFEST_PARSING_ERROR, fatal: !0, reason: "manifest parse error. core: native" });
      var d = 0, A = this._ctx.lctx.startIdx;
      typeof A == "number" && A >= 0 && A < c.length && (d = A, C.i("kernel-native", "set level from level startIdx.")), C.i("kernel-native", "level: " + d + " " + ((o = c[d]) == null ? void 0 : o.qualityType)), this._ctx.lctx.currentIdx = this._ctx.lctx.nextIdx = d, this._ctx.lctx.abr = !1, this.emit(S.MANIFEST_PARSED), this._load(n);
    }, i.onAbrLevelsUpdated = function() {
    }, i.refresh = function() {
      var n;
      this._ctx.stat.startFromSec = this._video.currentTime, this._load(M.retry), (n = this._video.play()) == null || n.catch(function(o) {
        return C.i("kernel-native", "refresh. call play() fail.", o);
      });
    }, i.stopLoad = function() {
      this.emit(S.STOP_LOAD), this._stopHeartbeat();
    }, i.setCurrentLevel = function(n) {
      C.i("kernel-native", "set current level: " + n + " @ " + this._video.currentTime);
      var o = this._ctx;
      if (o.lctx.levels.length) {
        if (n >= 0 && n < o.lctx.levels.length && o.lctx.currentIdx !== n) {
          o.lctx.currentIdx = o.lctx.nextIdx = n;
          var c = o.lctx.current;
          if (c)
            return this._stat = St.SELECT_BITRATE, o.stat.startFromSec = this._video.currentTime, this._levelSwitchId++, this.emit(S.LEVEL_SWITCHING, { time: o.currentTime, bitrate: c.bitrate, level: n, smooth: !1, auto: !1, id: this._levelSwitchId }), this._startLoadLevel(o.lctx.currentIdx), this._video.paused || this._video.play(), void this.emit(S.LEVEL_SWITCHED, { time: o.currentTime, bitrate: c.bitrate, level: n, smooth: !1, auto: !1, id: this._levelSwitchId });
        }
        this.emit(S.LEVEL_SWITCH_FAILED);
      } else
        o.lctx.currentIdx = o.lctx.nextIdx = n;
    }, i.setNextLevel = function(n) {
      this.setCurrentLevel(n);
    }, i.liveEnd = function() {
    }, i.jumpToLiveTime = function(n) {
      return C.i("kernel-native", "jump to live time. isLive: " + this._ctx.stat.isLive + " type: " + this._ctx.stat.liveShiftType, n), this._ctx.stat.liveShiftType === U.GENERAL && (this._ctx.stat.liveShiftParams = n, this.refresh(), !0);
    }, i.destroy = function() {
      C.i("kernel-native", "destroy"), this._httpStatusDetector && (this._httpStatusDetector.stop(), this._httpStatusDetector = void 0), r.prototype.destroy.call(this);
    }, i._onVideoPlay = function() {
      this._error || this._video.src || this.load(), r.prototype._onVideoPlay.call(this);
    }, i._onVideoCanplay = function() {
      var n = this._ctx, o = n.lctx.current;
      o && this._stat === St.SELECT_BITRATE && this.emit(S.LEVEL_SWITCH_PLAYING, { time: n.currentTime, bitrate: o.bitrate, level: n.lctx.currentIdx, smooth: !1, auto: !1, id: this._levelSwitchId }), this._stat !== St.NONE && (this._stat = St.NONE), r.prototype._onVideoCanplay.call(this);
    }, i._onVideoTimeupdate = function() {
      var n = this._ctx;
      r.prototype._onVideoTimeupdate.call(this), this._setStartFromOnTimeupdate && (C.i("kernel-native", "timeupdate start from: " + n.stat.startFromSec), this._applyStartFrom(), this._setStartFromOnTimeupdate = !1);
    }, i._onVideoWaiting = function() {
      C.i("kernel-native", "video waiting"), this._stat = this._stat || St.WAITING;
      var n = this._ctx.bufferedSec, o = !this._video.ended && !this._video.seeking && this._stat === St.WAITING;
      this.emit(S.WAITING, { block: o, bufferedSec: n });
    }, i._onVideoDurationchange = function() {
      (Q.android || this._ctx.stat.isLive === void 0) && this._mediaInfo && this._video.duration > 0 && (this._ctx.stat.isLive = !isFinite(this._video.duration), this.emit(S.MEDIA_INFO, this._mediaInfo)), r.prototype._onVideoDurationchange.call(this);
    }, i._onVideoLoadeddata = function() {
      if (C.i("kernel-native", "video loadeddata. duration: " + this._video.duration), this._video.videoWidth || !this._ctx.canCodecFallback) {
        this._ctx.stat.isLive === void 0 && this._video.duration > 0 && (this._ctx.stat.isLive = !isFinite(this._video.duration)), this._mediaInfo = { width: this._video.videoWidth, height: this._video.videoHeight, videoDecoder: R.buildin };
        var n = this._ctx, o = n.lctx.current;
        if (n.cOutput.updateRendererType(y.video), n.cOutput.rendererType === y.canvas && this.emit(S.VIDEO_RENDERER_CHANGE, { enabled: !0, canvas: n.cOutput.canvas, type: y.canvas }), o && o.codec) {
          var c = yr(o.codec);
          this._mediaInfo.audioCodec = c.audio, this._mediaInfo.videoCodec = c.video, c.video && (n.stat.codecType = Ar(c.video));
        }
        this._mediaInfo.videoCodecType = n.stat.codecType, Q.android ? n.stat.startFromSec && (this._setStartFromOnTimeupdate = !0) : this._applyStartFrom(), this.emit(S.MEDIA_INFO, this._mediaInfo);
      } else
        this.emit(S.FALLBACK_H264, { type: I.FALLBACK_H264, message: "buildin " + this._ctx.stat.codecType + " dec no width.", code: 0 });
    }, i._onVideoSeeking = function() {
      C.i("kernel-native", "seeking " + this._video.currentTime);
      var n = this._video.currentTime;
      this.emit(S.SEEKING), this._ctx.isTimeinBuffered(n) || this.emit(S.SEEK_WITH_LOAD);
    }, i._onVideoError = function() {
      var n, o = this, c = ((n = this._video.error) == null ? void 0 : n.code) || 0, d = kt(Ye[c], "video error");
      if (c === 4 && this._ctx.canCodecFallback)
        this.emit(S.FALLBACK_H264, { type: I.FALLBACK_H264, message: "buildin " + this._ctx.stat.codecType + " dec error. video error: " + c, code: d });
      else {
        var A = this._ctx.lctx.current;
        if (A && A.urlId < A.url.length - 1)
          return A.urlId++, this.emit(S.RETRY, { type: I.BACKUP, message: "video error: " + c + ". use backup url.", code: d }), void this._load(M.retry);
        var f = "video error";
        this._video && this._video.error && (f += " code:" + c + " message:" + this._video.error.message);
        var x = { type: ft.MEDIA_ERROR, details: (c ? Ye[c] : ve.VIDEO_ERROR) || ve.VIDEO_ERROR, fatal: !0, url: this._video.src, reason: f };
        c === 2 || c === 4 ? (this._httpStatusDetector || (this._httpStatusDetector = new oo()), this._httpStatusDetector.start(this._video.src, function(O) {
          C.i("kernel-native", "video error check http status code:", O), (c === 2 || c === 4 && O > 0) && (O < 200 || O > 299) ? o._onError({ type: ft.NETWORK_ERROR, details: ve.LOAD_ERROR, fatal: !0, url: o._video.src, statusCode: O, reason: f }) : (O === 0 && (x.statusCode = 0), o._onError(x));
        })) : this._onError(x);
      }
    }, i._load = function(n) {
      C.i("kernel-native", "_load"), this._mediaInfo = void 0, this._error = void 0, this._stat = St.LOADING, this.emit(S.LOAD, { type: n }), this._startLoadLevel(this._ctx.lctx.currentIdx), this._startHeartbeat();
    }, i._startLoadLevel = function(n) {
      var o = this._ctx, c = o.lctx.current;
      if (c) {
        var d, A;
        C.i("kernel-native", "level", n);
        var f, x = c.currentUrl;
        this.emit(S.NEW_SOURCE, { sync: o.stat.startFromSec || 0 }), (d = this._ctx.config.preprocessUrl) != null && d.stream && (C.d("kernel-native", "preprocessUrl stream"), x = (f = this._ctx.config.preprocessUrl) == null ? void 0 : f.stream(x)), o.stat.liveShiftType === U.GENERAL && (A = o.stat.liveShiftParams) != null && A.urlParams && (x = o.getGeneralLiveShiftUrl(x)), this._video.src = x;
      }
    }, i._applyStartFrom = function() {
      var n = this._ctx;
      n.stat.startFromSec > 0 && (C.i("kernel-native", "start from: " + n.stat.startFromSec), this._video.currentTime = n.stat.startFromSec, n.stat.startFromSec = 0);
    }, E()(s, [{ key: "type", get: function() {
      return b.native;
    } }]), s;
  }(function(r) {
    function s(n) {
      var o;
      if ((o = r.call(this) || this)._video = void 0, o._error = void 0, o._hbTimer = void 0, o._stat = St.INIT, o._mediaInfo = void 0, o._levelSwitchId = 0, o._nextLevel = [], o._nextAudio = void 0, o._eventHandlers = void 0, !n)
        throw new Error("video is null");
      return o._video = n, o._eventHandlers = { loadedmetadata: o._onVideoLoadedmetadata.bind(Pe()(o)), loadeddata: o._onVideoLoadeddata.bind(Pe()(o)), canplay: o._onVideoCanplay.bind(Pe()(o)), seeking: o._onVideoSeeking.bind(Pe()(o)), seeked: o._onVideoSeeked.bind(Pe()(o)), waiting: o._onVideoWaiting.bind(Pe()(o)), playing: o._onVideoPlaying.bind(Pe()(o)), pause: o._onVideoPause.bind(Pe()(o)), play: o._onVideoPlay.bind(Pe()(o)), error: o._onVideoError.bind(Pe()(o)), ended: o._onVideoEnded.bind(Pe()(o)), ratechange: o._onVideoRatechange.bind(Pe()(o)), durationchange: o._onVideoDurationchange.bind(Pe()(o)), timeupdate: o._onVideoTimeupdate.bind(Pe()(o)), progress: o._onVideoProgress.bind(Pe()(o)), emptied: o._onVideoEmptied.bind(Pe()(o)), resize: o._onVideoResize.bind(Pe()(o)) }, o._bindVideoEvents(), o;
    }
    Qt()(s, r);
    var i = s.prototype;
    return i.destroy = function() {
      this._stopHeartbeat(), this._unbindVideoEvents(), this.removeAllListeners();
    }, i.getError = function() {
      return this._error;
    }, i.getTrackBufInfo = function() {
    }, i.load = function() {
      this._video.load();
    }, i.resume = function() {
      this._video.paused && this._video.play();
    }, i.refresh = function() {
    }, i.stopLoad = function() {
    }, i._getNextFrameTime = function() {
      var n = this._mediaInfo && this._mediaInfo.fps ? this._mediaInfo.fps : 30;
      return this._video.duration && !this._video.ended ? this._video.currentTime + 1 / n : -1;
    }, i._getPrevFrameTime = function() {
      var n = this._mediaInfo && this._mediaInfo.fps ? this._mediaInfo.fps : 30;
      return this._video.duration && this._video.currentTime - 1 / n >= 0 ? this._video.currentTime - 1 / n : -1;
    }, i._bindVideoEvents = function() {
      if (this._video)
        for (var n in this._eventHandlers)
          this._video.addEventListener(n, this._eventHandlers[n]);
    }, i._unbindVideoEvents = function() {
      if (this._video)
        for (var n in this._eventHandlers)
          this._video.removeEventListener(n, this._eventHandlers[n]);
    }, i._onVideoLoadedmetadata = function() {
      C.i(Ke, "loadedmetadata"), this.emit(S.LOADEDMETADATA);
    }, i._onVideoLoadeddata = function() {
      C.i(Ke, "loadeddata"), this.emit(S.LOADEDDATA);
    }, i._onVideoCanplay = function() {
      C.i(Ke, "canplay " + !!this._stat), this.emit(S.CANPLAY);
    }, i._onVideoSeeking = function() {
      C.i(Ke, "seeking " + this._video.currentTime), this.emit(S.SEEKING);
    }, i._onVideoSeeked = function() {
      C.i(Ke, "seeked"), this.emit(S.SEEKED);
    }, i._onVideoWaiting = function() {
    }, i._onVideoPlaying = function() {
      C.i(Ke, "playing"), this._error || (this._stat = St.NONE, this._startHeartbeat(), this.emit(S.PLAYING));
    }, i._onVideoPause = function() {
      C.i(Ke, "pause. seeking: " + this._video.seeking), this._video.ended || this.emit(S.PAUSE);
    }, i._onVideoPlay = function() {
      C.i(Ke, "play", this._error), this.emit(S.PLAY);
    }, i._onVideoError = function(n) {
      C.i(Ke, "error", n);
    }, i._onVideoEnded = function() {
      C.i(Ke, "ended"), this.emit(S.ENDED), this._stopHeartbeat();
    }, i._onVideoRatechange = function() {
      C.i(Ke, "ratechange " + this._video.playbackRate), this.emit(S.RATE_CHANGE);
    }, i._onVideoDurationchange = function() {
      C.i(Ke, "durationchange " + this._video.duration), this.emit(S.DURATION_CHANGE);
    }, i._onVideoTimeupdate = function() {
      this.emit(S.TIMEUPDATE);
    }, i._onVideoProgress = function() {
      this.emit(S.PROGRESS);
    }, i._onVideoEmptied = function() {
      C.i(Ke, "video emptied");
    }, i._onVideoResize = function() {
      C.i(Ke, "video resize");
    }, i._onError = function(n) {
      n.fatal && (this._error = n.details || ve.UNKNOWN), C.i(Ke, "error", this._error, n), this.emit(S.ERROR, n);
    }, i._heartbeat = function() {
      this.emit(S.HEARTBEAT);
    }, i._startHeartbeat = function() {
      this._hbTimer || (this._hbTimer = setInterval(this._heartbeat.bind(this), 1e3));
    }, i._stopHeartbeat = function() {
      this._hbTimer && (clearInterval(this._hbTimer), this._hbTimer = void 0);
    }, E()(s, [{ key: "type", get: function() {
      return b.unknown;
    } }]), s;
  }(Er));
  function Tr(r, s, i) {
    s === void 0 && (s = 3), r = Math.round(r), !i || i.startDelay === r || r <= 0 || (i.startDelay = r, i.rule = [{ rate: 1.5, lower: r + 2 * s + 1, upper: Number.MAX_SAFE_INTEGER }, { rate: 1.25, lower: r + s + 1, upper: r + 2 * s }, { rate: 1.1, lower: r + 1, upper: r + s }, { rate: 1, lower: 0, upper: r }], C.i("playback-rate", "update by delay: " + r + ".", i));
  }
  var Zt = function(r) {
    return r[r.AV_PIX_FMT_MONO = 0] = "AV_PIX_FMT_MONO", r[r.AV_PIX_FMT_YUV420P = 1] = "AV_PIX_FMT_YUV420P", r[r.AV_PIX_FMT_YUV422P = 2] = "AV_PIX_FMT_YUV422P", r[r.AV_PIX_FMT_YUV444P = 3] = "AV_PIX_FMT_YUV444P", r;
  }({}), Gi = function(r) {
    return r[r.normal = 0] = "normal", r[r.fill = 1] = "fill", r;
  }({}), ho = new RegExp("_([0-9]+)x([0-9]+)(_([0-9]+))?(_([0-9]+))?(_(420|422|444|mono))?"), _o = ["mono", "420", "422", "444"], di, br = function() {
    function r() {
      this._list = [];
    }
    var s = r.prototype;
    return s.append = function(i) {
      this._list.push(i);
    }, s.clear = function() {
      this._list = [];
    }, E()(r, [{ key: "hasData", get: function() {
      return !!this._list.length;
    } }, { key: "retryCount", get: function() {
      return this._list.reduce(function(i, n) {
        return (typeof n.count == "number" && n.count > 0 ? n.count : 1) + i;
      }, 0);
    } }, { key: "hasChangeCore", get: function() {
      return this._list.reduce(function(i, n) {
        return n.change || i;
      }, !1);
    } }, { key: "mergedBeacon", get: function() {
      var i = [];
      return this._list.forEach(function(n) {
        var o;
        if (i.length && n.type === I.LOADER && ((o = i[i.length - 1]) == null ? void 0 : o.type) === I.LOADER) {
          var c = i[i.length - 1].count;
          i[i.length - 1].count = c ? c + 1 : 2;
        } else
          i.push(u()({}, n));
      }), i.slice(-10);
    } }, { key: "beacon", get: function() {
      return this._list.slice(-10);
    } }]), r;
  }(), po = function() {
    function r() {
      this.coreType = b.unknown, this.native = !1, this.codecType = p.unknown, this.gopRemux = !1, this.audioCodec = "", this.recoverSwapRemux = !1, this.box = void 0, this.isLive = void 0, this.autoLazyLoad = !0, this.lazyLoadRecoverDuration = 12.8, this.lazyLoadMaxDuration = 16, this.firstFrameLoaded = !1, this.startFromSec = -1, this.webWorker = !0, this.muxWorker = void 0, this.isNetworkInUse = !1, this.srcType = g.OTHERS, this.isPreload = void 0, this.videoPlaybackQuality = void 0, this.drm = void 0, this.hasVideo = void 0, this.hasAudio = void 0, this.multipartLiveDelay = void 0, this.mixContainerInput = void 0, this.mixCodecInput = void 0, this.mixCodecAvailable = void 0, this.mixQualityList = void 0, this.srcMeta = void 0, this.multipart = void 0, this.demuxerType = void 0, this.retryInfo = new br(), this.mainThreadRendering = void 0, this.stereoType = void 0, this.decoder = R.buildin, this.wasmDecoder = void 0, this.wasmSimd = void 0, this.wasmThreads = void 0, this.fallback264 = void 0, this.isKwaiSlice = void 0, this.autoPlaybackRateConf = void 0, this.preferNativeLoader = void 0, this._liveShift = !1, this._liveShiftType = U.NONE, this._liveShiftParams = void 0;
    }
    return r.prototype.reset = function() {
      this.coreType = b.unknown, this.codecType = p.unknown, this.audioCodec = "", this.recoverSwapRemux = !1, this.box = _.unknown, this.autoLazyLoad = !0, this.firstFrameLoaded = !1, this.isNetworkInUse = !1, this.srcType = g.OTHERS, this.retryInfo.clear(), this.decoder = R.buildin, this.lazyLoadMaxDuration = 16, this.lazyLoadRecoverDuration = 0.8 * this.lazyLoadMaxDuration, this.drm = this.hasVideo = this.hasAudio = this.isPreload = this.videoPlaybackQuality = this.mixContainerInput = this.mixCodecInput = this.mixCodecAvailable = this.mixQualityList = this.multipart = this.stereoType = this.mainThreadRendering = this.wasmDecoder = this.wasmSimd = this.wasmThreads = this.fallback264 = void 0;
    }, E()(r, [{ key: "liveShift", get: function() {
      return this.liveShiftType !== U.NONE && this._liveShift;
    }, set: function(s) {
      this._liveShift = s;
    } }, { key: "liveShiftType", get: function() {
      return !this.isLive || this._liveShiftType === U.KWAI && Q.mobile || !ke(this.box) ? U.NONE : this._liveShiftType;
    }, set: function(s) {
      this._liveShiftType = s;
    } }, { key: "liveShiftParams", get: function() {
      return this._liveShiftParams;
    }, set: function(s) {
      this._liveShiftParams = s;
    } }]), r;
  }(), Rr = { preferLowPowerToHighPerformance: !0, preserveDrawingBuffer: !0 };
  function Sr(r) {
    return r.getContext("webgl", Rr);
  }
  function Wi() {
    if (!di) {
      var r = typeof HTMLCanvasElement > "u" ? new OffscreenCanvas(1, 1) : document.createElement("canvas");
      Lr(r, di = { webGL: !1, performance: !1 }, !0) || Lr(r, di, !1);
    }
    return di;
  }
  function Lr(r, s, i) {
    i === void 0 && (i = !1);
    var n = !1, o = u()({ failIfMajorPerformanceCaveat: i }, Rr);
    try {
      var c = r.getContext("webgl", o);
      if (c) {
        var d = c.getExtension("WEBGL_debug_renderer_info");
        s.webGL = !0, s.performance = i, d != null && d.UNMASKED_VENDOR_WEBGL && (s.vendor = c.getParameter(d == null ? void 0 : d.UNMASKED_VENDOR_WEBGL)), d != null && d.UNMASKED_RENDERER_WEBGL && (s.renderer = c.getParameter(d == null ? void 0 : d.UNMASKED_RENDERER_WEBGL)), n = !0;
        var A = c.getExtension("WEBGL_lose_context");
        A && A.loseContext();
      }
    } catch (f) {
    }
    return n;
  }
  var fo = function(r) {
    function s() {
      for (var n, o = arguments.length, c = new Array(o), d = 0; d < o; d++)
        c[d] = arguments[d];
      return (n = r.call.apply(r, [this].concat(c)) || this)._vppList = [], n._originSizeCanvas = void 0, n._originSizeGL = null, n._video = void 0, n._webGLFrameSink = void 0, n._inputRendererType = y.video, n._draw = function() {
        n._vppList.forEach(function(A) {
          return A.vpp.draw();
        });
      }, n;
    }
    Qt()(s, r);
    var i = s.prototype;
    return i.reset = function() {
      r.prototype.reset.call(this), this._destroyOriginSizeCanvas(), this._webGLFrameSink = void 0, this._inputRendererType = y.video;
    }, i.updateFormatSize = function(n, o, c) {
      var d = !1, A = c % 180 == 90 || c % 180 == -90, f = A ? o : n, x = A ? n : o;
      return f === this._fSize.w && x === this._fSize.h || (d = !0, this._fSize.w = f, this._fSize.h = x, this._calculateUpperSize(), this._originSizeCanvas && (C.i("canvas-output-vpp", "updateFormatSize. w:" + n + " h:" + o + " rotation:" + c), this._originSizeCanvas.width = n, this._originSizeCanvas.height = o, this._originSizeGL && (this._originSizeGL.canvas.width = n, this._originSizeGL.canvas.height = o)), this._calculateDisplaySize()), d;
    }, i.setVideo = function(n) {
      C.i("canvas-output-vpp", "setVideo", n), this._video = n, this._applayVPP();
    }, i.setWebGLFrameSink = function(n) {
      C.i("canvas-output-vpp", "setWebGLFrameSink"), this._webGLFrameSink = n, this._applayVPP(), n.afterDraw(this._draw);
    }, i.updateRendererType = function(n) {
      C.i("canvas-output-vpp", "updateRendererType: " + n);
      var o = this.rendererType;
      return n !== y.canvas && !this.hasVPP || this._canvas || this._createOutputCanvas(), this._inputRendererType = n, this._applayVPP(), o !== this.rendererType;
    }, i.bindVPP = function(n) {
      C.i("canvas-output-vpp", "bind vpp");
      for (var o = this.rendererType, c = 0; c < this._vppList.length; c++)
        if (this._vppList[c].vpp === n)
          return C.i("canvas-output-vpp", "vpp has been bound."), !1;
      return this._vppList.push({ vpp: n, originSize: n.originalSizeInput }), this._canvas || this._createOutputCanvas(), this._applayVPP(), o !== this.rendererType;
    }, i.unbindVPP = function(n) {
      C.i("canvas-output-vpp", "unbind vpp");
      var o = this.rendererType;
      if (!this.hasVPP)
        return !1;
      if (n) {
        for (var c = 0; c < this._vppList.length; c++)
          if (n === this._vppList[c].vpp) {
            var d = this._vppList.splice(c, 1);
            d.length && (d[0].vpp.detachSource(), d[0].vpp.detachOutputCanvas());
            break;
          }
      } else
        this._vppList.forEach(function(A) {
          A.vpp.detachSource(), A.vpp.detachOutputCanvas();
        }), this._vppList.splice(0);
      return this.hasVPP ? this._applayVPP() : (C.i("canvas-output-vpp", "unbind all vpp"), this._inputRendererType === y.video && this._canvas && this._destroyCanvas(), this._inputRendererType === y.canvas && this._webGLFrameSink && (this.webgl && this._webGLFrameSink.setWebGLCtx(this.webgl, Gi.normal), this._webGLFrameSink.drawToCanvas(), this._webGLFrameSink.reDraw())), o !== this.rendererType;
    }, i.destroy = function() {
      r.prototype.destroy.call(this), this._destroyOriginSizeCanvas();
    }, i._calculateUpperSize = function() {
      r.prototype._calculateUpperSize.call(this), this._draw();
    }, i._applayVPP = function() {
      var n = this;
      if (this._canvas && this.hasVPP) {
        var o, c = this.webgl;
        if (this._inputRendererType === y.canvas) {
          if (!this._webGLFrameSink)
            return;
          o = this._canvas;
        } else
          this._inputRendererType === y.video && (o = this._video);
        if (o && c) {
          if (this._inputRendererType === y.canvas)
            if (this._vppList[0].originSize) {
              var d, A;
              this._originSizeGL || this._createOriginSizeCanvas(), this._originSizeGL && (C.i("canvas-output-vpp", "webgl set origin size", this._originSizeGL), (d = this._webGLFrameSink) == null || d.setWebGLCtx(this._originSizeGL, Gi.fill), (A = this._webGLFrameSink) == null || A.drawToCanvas()), o = this._originSizeCanvas;
            } else {
              var f, x;
              (f = this._webGLFrameSink) == null || f.setWebGLCtx(c, Gi.normal), (x = this._webGLFrameSink) == null || x.drawToFBO();
            }
          C.i("canvas-output-vpp", "apply vpp", o, c, JSON.stringify(this._fSize)), this._vppList.forEach(function(O, V) {
            o && (O.vpp.attachOutputCanvas(c), O.vpp.attachSource(o), V < n._vppList.length - 1 && (o = O.vpp.drawToFBO())), O.vpp.draw();
          });
        }
      }
    }, i._createOriginSizeCanvas = function() {
      this._originSizeCanvas = this._createCanvas(this._fSize), !this._originSizeGL && this._originSizeCanvas && (this._originSizeGL = Sr(this._originSizeCanvas));
    }, i._destroyOriginSizeCanvas = function() {
      if (C.i("canvas-output-vpp", "destroy origin size canvas"), this._originSizeGL) {
        C.i("canvas-output-vpp", "origin size lose ctx");
        var n = this._originSizeGL.getExtension("WEBGL_lose_context");
        n && n.loseContext(), this._originSizeGL = null;
      }
      this._originSizeCanvas && (this._originSizeCanvas = void 0);
    }, E()(s, [{ key: "rendererType", get: function() {
      return this._inputRendererType === y.video ? this.hasVPP ? y.canvas : y.video : y.canvas;
    } }, { key: "output", get: function() {
      return this.rendererType === y.video ? this._video : this._canvas;
    } }, { key: "hasVPP", get: function() {
      return this._vppList.length > 0;
    } }]), s;
  }(function() {
    function r(i) {
      this._canvas = void 0, this._gl = null, this._cSize = { w: 0, h: 0 }, this._fSize = { w: 0, h: 0 }, this._dSize = { w: 0, h: 0 }, C.i("canvas-output", "constructor"), this._canvas = i;
    }
    var s = r.prototype;
    return s.reset = function() {
      C.i("canvas-output", "reset"), this._destroyCanvas();
    }, s.updateCanvasSize = function(i, n) {
      var o = !1;
      return i === this._cSize.w && n === this._cSize.h || (o = !0, this._cSize.w = i, this._cSize.h = n, this._calculateUpperSize()), this._calculateDisplaySize(), o;
    }, s.updateFormatSize = function(i, n, o) {
      var c = !1, d = o % 180 == 90 || o % 180 == -90, A = d ? n : i, f = d ? i : n;
      return A === this._fSize.w && f === this._fSize.h || (c = !0, this._fSize.w = A, this._fSize.h = f, this._calculateUpperSize(), this._calculateDisplaySize()), c;
    }, s.destroy = function() {
      C.i("canvas-output", "destroy"), this._destroyCanvas();
    }, s._calculateUpperSize = function() {
      if (this._canvas && this._cSize.h) {
        var i = this._cSize, n = i.w, o = i.h, c = this._fSize, d = c.w, A = c.h;
        if (A) {
          var f = n / o;
          f > d / A ? o > A && (n = (o = A) * f) : n > d && (o = (n = d) / f);
        }
        this._canvas.width = n, this._canvas.height = o, C.i("canvas-output", "update canvas size", n, o);
      }
    }, s._calculateDisplaySize = function() {
      var i, n, o = ((i = this._canvas) == null ? void 0 : i.width) || this._cSize.w, c = ((n = this._canvas) == null ? void 0 : n.height) || this._cSize.h, d = this._fSize, A = d.w / d.h;
      A > o / c ? (this._dSize.w = o, this._dSize.h = Math.round(o / A)) : (this._dSize.w = Math.round(c * A), this._dSize.h = c);
    }, s._createCanvas = function(i) {
      C.i("canvas-output", "create canvas");
      var n = document.createElement("canvas");
      return i.w ? (n.width = i.w, n.height = i.h) : (i.w = n.width, i.h = n.height), n;
    }, s._createOutputCanvas = function() {
      this._canvas || (this._canvas = this._createCanvas(this._cSize));
    }, s._destroyCanvas = function() {
      if (C.i("canvas-output", "destroy canvas"), this._gl) {
        var i = this._gl.getExtension("WEBGL_lose_context");
        i && i.loseContext();
      }
      this._gl = null, this._canvas && (typeof HTMLCanvasElement < "u" && this._canvas instanceof HTMLCanvasElement && this._canvas.remove(), this._canvas = void 0);
    }, E()(r, [{ key: "canvas", get: function() {
      return this._canvas;
    } }, { key: "webgl", get: function() {
      return !this._gl && this._canvas && (this._gl = Sr(this._canvas)), this._gl;
    } }, { key: "canvasSize", get: function() {
      return this._cSize;
    } }, { key: "formatSize", get: function() {
      return this._fSize;
    } }, { key: "displaySize", get: function() {
      return this._dSize;
    } }]), r;
  }()), vo = function() {
    function r() {
      this._lastDroppedFrames = 0, this._lastDecodedFrames = 0, this._lastTime = 0, this._decoded = 0, this._dropped = 0;
    }
    var s = r.prototype;
    return s.reset = function() {
      this._lastTime = performance.now(), this._lastDroppedFrames = this._lastDecodedFrames = this._decoded = this._dropped = 0;
    }, s.getFPS = function(i) {
      if (i) {
        var n, o = performance.now(), c = i.totalVideoFrames, d = i.droppedVideoFrames;
        if (c) {
          c < this._lastDecodedFrames && (this._lastDecodedFrames = 0, this._lastDroppedFrames = 0);
          var A = o - this._lastTime, f = d - this._lastDroppedFrames, x = c - this._lastDecodedFrames, O = 0, V = 0;
          this._lastTime && (O = parseFloat((1e3 * f / A).toFixed(2)), V = parseFloat((1e3 * x / A).toFixed(2))), this._decoded = this._decoded += x, this._dropped = this._dropped += f, this._lastTime = o, this._lastDroppedFrames = d, this._lastDecodedFrames = c, n = { decoded: this._decoded, dropped: this._dropped, decodedFPS: V, droppedFPS: O };
        }
        return this._lastTime = o, n;
      }
    }, r;
  }(), wr = function() {
    function r(i) {
      this._abr = !1, this._startIdx = -1, this._currentIdx = 0, this._nextIdx = 0, this._levels = [], this._audioIdx = 0, this._audioTracks = [], this._subtitleIdx = 0, this._subtitleTracks = [], this._abrLevels = [], this._default = void 0, this._availableList = void 0, C.i("level-ctx", "constructor abr:" + i), this._abr = i;
    }
    var s = r.prototype;
    return s.getLevel = function(i) {
      return i === void 0 && (i = m.MAIN), i === m.MAIN ? this._levels[this._currentIdx] : i === m.AUDIO ? this._audioTracks[this._audioIdx] : i === m.SUBTITLE ? this._subtitleTracks[this._subtitleIdx] : void 0;
    }, s.setLevelIdx = function(i, n) {
      n === void 0 && (n = m.MAIN), n === m.MAIN ? this.currentIdx = i : n === m.AUDIO ? this.audioIdx = i : n === m.SUBTITLE && (this.subtitleIdx = i);
    }, s.getLevelIdx = function(i) {
      return i === void 0 && (i = m.MAIN), i === m.MAIN ? this._currentIdx : i === m.AUDIO ? this._audioIdx : i === m.SUBTITLE ? this._subtitleIdx : -1;
    }, s.setNextIdx = function(i, n) {
      n === void 0 && (n = m.MAIN), n === m.MAIN && (this.nextIdx = i);
    }, s.getNextIdx = function(i) {
      return i === void 0 && (i = m.MAIN), i === m.MAIN ? this._nextIdx : -1;
    }, s.clearFrag = function() {
      C.i("level-ctx", "clear"), [this._levels, this._audioTracks, this._subtitleTracks].forEach(function(i) {
        i.forEach(function(n) {
          var o = n;
          o.fragments && o.clear();
        });
      });
    }, s.abrIndexToOrign = function(i) {
      var n = this._abrLevels[i];
      return n ? n.index : 0;
    }, s.orignIndexToAbr = function(i) {
      var n = 0;
      return this._abrLevels.forEach(function(o, c) {
        o.index !== i || (n = c);
      }), n;
    }, s._generateAbrList = function() {
      var i = this, n = this._availableList;
      this._default = 0, this._abrLevels = [], this._levels.forEach(function(o, c) {
        o.default && !n && (i._default = c), o.enableAdaptive && (!n || n && n.indexOf(c) !== -1) && i._abrLevels.push(o);
      }), this._abrLevels.sort(function(o, c) {
        return o.bitrate - c.bitrate;
      });
    }, E()(r, [{ key: "abr", get: function() {
      return this._abr;
    }, set: function(i) {
      this._abr = i;
    } }, { key: "startIdx", get: function() {
      return this._startIdx;
    }, set: function(i) {
      this._startIdx = i;
    } }, { key: "currentIdx", get: function() {
      return this._currentIdx;
    }, set: function(i) {
      i >= 0 && (this._currentIdx = i);
    } }, { key: "nextIdx", get: function() {
      return this._nextIdx;
    }, set: function(i) {
      i >= 0 && (this._nextIdx = i);
    } }, { key: "levels", get: function() {
      return this._levels;
    }, set: function(i) {
      this._levels = i, this._generateAbrList();
    } }, { key: "current", get: function() {
      return this._levels[this._currentIdx];
    } }, { key: "currentUrl", get: function() {
      var i = this._levels[this._currentIdx];
      return i ? i.url[i.urlId] : "";
    } }, { key: "audioIdx", get: function() {
      return this._audioIdx;
    }, set: function(i) {
      i >= 0 && (this._audioIdx = i);
    } }, { key: "audioTracks", get: function() {
      return this._audioTracks;
    }, set: function(i) {
      this._audioTracks = i;
    } }, { key: "audio", get: function() {
      return this._audioTracks[this._audioIdx];
    } }, { key: "subtitleIdx", get: function() {
      return this._subtitleIdx;
    }, set: function(i) {
      i >= 0 && (this._subtitleIdx = i);
    } }, { key: "subtitleTracks", get: function() {
      return this._subtitleTracks;
    }, set: function(i) {
      this._subtitleTracks = i;
    } }, { key: "subtitle", get: function() {
      return this._subtitleTracks[this._subtitleIdx];
    } }, { key: "abrLevels", get: function() {
      return this._abrLevels;
    } }, { key: "availableList", set: function(i) {
      this._availableList = i, this._generateAbrList();
    } }, { key: "default", get: function() {
      return this._default || 0;
    }, set: function(i) {
      this._default = i;
    } }, { key: "abrDefault", get: function() {
      var i = 0;
      return this._abrLevels.forEach(function(n, o) {
        n.default && (i = o);
      }), i;
    } }]), r;
  }(), Ir = 0, Cr = function() {
    var r = s.prototype;
    function s() {
      var i = this;
      this._context = void 0, this._loader = void 0, this._callbacks = null, this._config = void 0, this._loaderCallback = void 0, this._stats = void 0, this._retryDelay = 0, this._loading = !1, this._aborted = !1, this._connectTimer = void 0, this._transTimer = void 0, this._retryTimer = void 0, this._rangeStart = void 0, this._progressTime = 0, this._loadInternal = function() {
        var n;
        i._loading = !0, i._aborted = !1;
        var o = i._stats;
        (n = i._callbacks) != null && n.onLoad && i._callbacks.onLoad(i._context, o), o.code = 0, o.tfirst = 0, o.loaded = 0, i._stopRetryTimer(), i._loader = new (i._getInternalLoader())(), o.type = i._loader instanceof fe ? Tt.FETCH : Tt.XHR, i._loader && (o.id = i._loader.tag + "-" + Ir, i._config.connectionTimeout && (i._connectTimer = setTimeout(function() {
          return i._onTimeout(ct.LOADER_CONNECT_TIMEOUT);
        }, i._config.connectionTimeout)), i._httpRange(i._context), o.tsload = Date.now(), o.tstart = performance.now(), i._loader.load(i._context, i._loaderCallback));
      }, this._onConnect = function(n, o) {
        i._stopConnectTimer();
        var c = i._stats;
        i._getContentLen(n, c), i._startTransmissionTimer(), c.code = o, c.tfirst = Math.max(c.trequest, performance.now()), i._callbacks && i._callbacks.onConnect && i._callbacks.onConnect(n, c), typeof n.rangeStart == "number" && n.rangeStart > 0 && c.code !== 206 && i._callbacks && i._callbacks.onError && setTimeout(function() {
          i._onError(new Error("range error. " + n.range + " statu code:" + c.code));
        }, 0);
      }, this._onProgress = function(n, o) {
        var c = i._stats;
        if (i._progressTime = performance.now(), !n.breakpointContinuation && c.output > c.loaded) {
          if (c.loaded + o.byteLength - c.output > 0) {
            var d = o.slice(c.output - c.loaded);
            i._callProgress(i._context, d, c);
          }
          c.loaded += o.byteLength;
        } else
          c.loaded += o.byteLength, i._callProgress(i._context, o, c);
      }, this._onError = function(n) {
        i._stopTimer(), i._destroyLoader();
        var o, c = i._stats, d = i._config, A = i._context, f = c.type === Tt.FETCH && A.monkeyPatched && A.preferNative === void 0;
        i._loading = !1, C.i("loader", n.name, n == null ? void 0 : n.message, i._config.maxRetry, i._context.url, f ? "monkeyPatchedFetch" : ""), i._context.breakpointContinuation && c.code === 416 || f && i._stats.output === c.loaded ? (o = i._callbacks) != null && o.onEnd && i._callbacks.onEnd(i._context, null, c) : (c.fatal = !d.maxRetry || c.retry >= d.maxRetry || !d.maxRetry, c.errName = n.name, c.errMessage = n.message || "load error", f && (n.name === pt.FETCH_READ_ERROR_NAME && !i._stats.loaded || n.message === ct.LOADER_TRANS_TIMEOUT && !i._stats.loaded || n.message === ct.LOADER_CONNECT_TIMEOUT || !i._stats.code) && (i._context.preferNative = !0, C.i("loader", "monkey patched fetch error. switch to native fetch.")), i._callbacks && i._callbacks.onError && i._callbacks.onError(i._context, c), c.fatal || (d.breakpointContinuation && i._stats.contentTotalLength && (C.i("loader", "breakpointContinuation. " + i._stats.loaded + " / " + i._stats.contentTotalLength), i._stats.output && i._stats.loaded > 0 ? (i._rangeStart ? i._context.rangeStart = i._rangeStart + i._stats.output : i._context.rangeStart = i._stats.output, i._context.breakpointContinuation = !0) : (i._context.rangeStart = i._rangeStart, i._context.breakpointContinuation = !1)), c.retry++, i._callbacks && (i._retryDelay ? (i._retryTimer = setTimeout(i._loadInternal, i._retryDelay), i._retryDelay = 2 * i._retryDelay) : i._loadInternal())));
      }, this._onTimeout = function(n) {
        i._loading = !1, i._abortInternal();
        var o = new Error(n);
        i._onError(o);
      }, Ir++, this._loader = null, this._config = { connectionTimeout: 0, transmissionTimeout: 0, maxRetry: 0, retryDelay: 0 }, this._loaderCallback = { onConnect: this._onConnect, onProgress: this._onProgress, onEnd: this._onEnd.bind(this), onError: this._onError };
    }
    return r._getInternalLoader = function() {
      return s._chunkLoaderDef !== void 0 || (s._chunkLoaderDef = Oe, Q.msie || Q.msedge ? Oe.isSupportChunk() ? s._chunkLoaderDef = Oe : fe.isSupported() && (s._chunkLoaderDef = fe) : fe.isSupported() ? s._chunkLoaderDef = fe : Oe.isSupportChunk() && (s._chunkLoaderDef = Oe)), s._chunkLoaderDef;
    }, r.load = function(i, n, o) {
      this._init(i, n, o), this._loadInternal();
    }, r.destroy = function() {
      this._stopTimer(), this._abortInternal(!1), this._destroyLoader(), this._callbacks = null;
    }, r.abort = function() {
      this._stopTimer(), this._abortInternal();
    }, r._init = function(i, n, o) {
      this._context = i, this._rangeStart = i.rangeStart, this._callbacks = n, this._config = o || this._config, this._stats = { id: "", type: Tt.UNKNOWN, trequest: performance.now(), retry: 0, loaded: 0, code: 0, output: 0, tfirst: 0, tload: 0, total: 0, tsload: 0, tstart: 0, fatal: !1, errName: "", errMessage: "" }, this._config.retryDelay && (this._retryDelay = this._config.retryDelay);
    }, r._destroyLoader = function() {
      this._loader && (this._loader.destroy(), this._loader = null);
    }, r._abortInternal = function(i) {
      i === void 0 && (i = !0), i && this._callbacks && this._callbacks.onAbort && !this._aborted && this._loading && this._callbacks.onAbort(this._context, this._stats), this._aborted = !0, this._loader && this._loader.abort();
    }, r._stopTimer = function() {
      this._stopConnectTimer(), this._stopRetryTimer(), this._stopTransmissionTimer();
    }, r._callProgress = function(i, n, o) {
      this._stats.output += n.byteLength, this._callbacks && this._callbacks.onProgress && this._callbacks.onProgress(i, n, o);
    }, r._onEnd = function(i, n) {
      this._stopTimer();
      var o = this._stats;
      this._getContentLen(i, o), o.total = n ? o.loaded = typeof n == "string" ? n.length || 0 : n.byteLength || 0 : o.loaded, o.tload = Math.max(o.tfirst, performance.now()), this._loading = !1, o.output = 0, this._callbacks && this._callbacks.onEnd(i, n, o);
    }, r._startTransmissionTimer = function() {
      var i = this;
      this._stopTransmissionTimer(), this._progressTime = performance.now();
      var n = this._config.transmissionTimeout || 0;
      n && (this._transTimer = setInterval(function() {
        performance.now() - i._progressTime > n && i._onTimeout(ct.LOADER_TRANS_TIMEOUT);
      }, 1e3));
    }, r._stopTransmissionTimer = function() {
      this._transTimer && (clearInterval(this._transTimer), this._transTimer = void 0);
    }, r._stopConnectTimer = function() {
      this._connectTimer && (clearTimeout(this._connectTimer), this._connectTimer = void 0);
    }, r._stopRetryTimer = function() {
      this._retryTimer && (clearTimeout(this._retryTimer), this._retryTimer = void 0);
    }, r._httpRange = function(i) {
      if (i.rangeEnd || i.rangeStart)
        if (i.rangeType && i.rangeType !== K.STANDARD && typeof i.url == "string") {
          var n = new te.a(i.url, !0);
          i.rangeEnd ? (n.query.start = (i.rangeStart || 0).toString(), n.query.end = (i.rangeEnd - 1).toString()) : i.rangeStart && (n.query.start = i.rangeStart.toString()), i.url = n.toString();
        } else
          i.rangeEnd ? i.range = "bytes=" + (i.rangeStart || 0) + "-" + (i.rangeEnd - 1) : i.rangeStart && (i.range = "bytes=" + i.rangeStart + "-");
    }, r._getContentLen = function(i, n) {
      if (!n.contentTotalLength || !n.contentLength) {
        var o = i.responseHeader;
        if (o) {
          if (i.range || typeof i.rangeStart == "number") {
            var c = o["content-range"];
            c && (n.contentTotalLength = parseInt((Array.isArray(c) ? c[0] : c).split("/")[1]) || 0);
          }
          var d = o["content-length"];
          d && (n.contentLength = parseInt(Array.isArray(d) ? d[0] : d) || 0);
        }
      }
    }, E()(s, [{ key: "context", get: function() {
      return this._context;
    } }, { key: "config", get: function() {
      return this._config;
    } }]), s;
  }();
  Cr._chunkLoaderDef = void 0;
  var dt = { local: 0, server: 0 }, Wt = function() {
    function r() {
      var i = this;
      this._loader = void 0, this._callback = void 0, this._loaderConfig = void 0, this._onLoaderError = function() {
        i._disposeLoader();
      }, this._onLoaderEnd = function(n, o) {
        if (i._disposeLoader(), typeof o == "string") {
          dt.local = performance.now();
          var c = o.split(",");
          dt.server = 1e3 * parseFloat(c[0]) + parseInt(c[1], 10) / 1e3 / 2;
        }
      }, this._callback = { onError: this._onLoaderError, onEnd: this._onLoaderEnd }, this._loaderConfig = { connectionTimeout: 5e3 };
    }
    r.serverMs = function(i) {
      return dt.server ? i - dt.local + dt.server : null;
    }, r.clear = function() {
      dt.local = 0, dt.server = 0;
    };
    var s = r.prototype;
    return s.load = function(i) {
      this._disposeLoader();
      var n = { url: "https://ntp.nc.gifshow.com/", responseType: "text", progress: !1, preferNative: i };
      (this._loader = new Cr()).load(n, this._callback, this._loaderConfig);
    }, s.destroy = function() {
      this._disposeLoader();
    }, s._disposeLoader = function() {
      this._loader && this._loader.destroy();
    }, E()(r, [{ key: "time", get: function() {
      return u()({}, dt);
    } }], [{ key: "serverNowMs", get: function() {
      return dt.server ? performance.now() - dt.local + dt.server : null;
    } }]), r;
  }(), kr = function() {
    function r() {
      this._ntp = void 0, this._priv = { abst: 0, originDTS: 0 }, this._vLastExtraInfo = void 0, this._aLastExtraInfo = void 0, this._ntp = new Wt();
    }
    var s = r.prototype;
    return s.init = function(i) {
      !Wt.serverNowMs && this._ntp && this._ntp.load(i);
    }, s.onPrivNal = function(i) {
      i.abst && (this._priv.abst = i.abst, this._priv.originDTS = i.originDTS);
    }, s.onParsing = function(i) {
      var n = this;
      i.segments.forEach(function(o) {
        o.type === T.VIDEO ? n._vLastExtraInfo = { dts: o.startDTS, originDTS: o.originFirstDTS, parseTime: o.firstParseTime } : o.type === T.AUDIO && (n._aLastExtraInfo = { dts: o.startDTS, originDTS: o.originFirstDTS, parseTime: o.firstParseTime });
      });
    }, s.destroy = function() {
      this._ntp && (this._ntp.destroy(), this._ntp = void 0);
    }, s.getDisplayDelay = function(i) {
      return this._renderDelay(i, this._vLastExtraInfo);
    }, s.getAudioRenderDelay = function(i) {
      return this._renderDelay(i, this._aLastExtraInfo);
    }, s.getRecDelay = function() {
      var i = this._vLastExtraInfo;
      if (Wt.serverNowMs && i != null && i.parseTime) {
        var n = this._priv, o = Wt.serverMs(1e3 * i.parseTime + r._workerStartMs);
        if (o && n.originDTS && n.abst)
          return Math.round(o - 1e3 * (i.originDTS - n.originDTS + n.abst));
      }
      return 0;
    }, s._renderDelay = function(i, n) {
      var o = Wt.serverNowMs, c = this._priv;
      return o && n && c.abst && c.originDTS ? Math.round(1e3 * (n.dts - i - (n.originDTS - c.originDTS + c.abst)) + o) : 0;
    }, E()(r, null, [{ key: "workerTimeOffset", set: function(i) {
      r._workerStartMs = i;
    } }]), r;
  }();
  kr._workerStartMs = 0;
  var Dr = kr, xr = function() {
    function r() {
      this._traffic = 0, this._streams = [], this._download = [], this._trafficGroupedByVCodecType = {}, this._trafficGroupedByLevel = {}, this._currentLoad = void 0, this._contentLen = 0, this._fillA = 0, this._fillV = 0;
    }
    var s = r.prototype;
    return s.onStreamOpen = function(i, n, o, c) {
      if (this._streams.length > 10) {
        var d = this._streams.shift();
        if (d) {
          this._trafficGroupedByVCodecType[d.vCodecType] = (this._trafficGroupedByVCodecType[d.vCodecType] || 0) + d.traffic;
          var A = d.qualityType || "unknown";
          this._trafficGroupedByLevel[A] = (this._trafficGroupedByLevel[A] || 0) + d.traffic;
        }
      }
      var f = this._currentLoad ? this._currentLoad.index + 1 : 0;
      this._currentLoad = { index: f, startPos: i, url: n, bitrate: o, qualityType: c, traffic: 0, loadTimeCost: 0, keyFrame: 0, videoDataRate: 0, audioDataRate: 0, speed: 0, vCodecType: p.unknown, segments: [] }, this._streams.push(this._currentLoad);
    }, s.onMediaInfo = function(i) {
      var n = this._streams[this._streams.length - 1];
      n && (i.videoCodecType && (n.vCodecType = i.videoCodecType), n.mediaInfo = u()({}, i));
    }, s.setRTCStats = function(i) {
      var n = this._currentLoad;
      n && (n.traffic = i.totalReceive, n.audioDataRate = i.audioDataRate, n.videoDataRate = i.videoDataRate, n.speed = i.speed, n.keyFrame = i.key, this._traffic = n.traffic);
    }, s.onDataReceive = function(i) {
      this._traffic += i.byteLength;
      var n = this._download;
      n.length > 200 && n.pop(), n.unshift(i);
      var o = this._currentLoad;
      o && (o.traffic += i.byteLength, o.loadTimeCost += i.timeCost, o.speed = Math.round(o.traffic / o.loadTimeCost * 1e3) || 0);
    }, s.onParsing = function(i) {
      var n = this;
      i.segments.forEach(function(o) {
        n._calculateDataRate(o.type, 1e3 * (o.endDTS - o.startDTS), o.payload.byteLength), o.type === T.VIDEO && o.fillDuration && (n._fillV += Math.round(1e3 * o.fillDuration)), o.type === T.AUDIO && o.fillDuration && (n._fillA += Math.round(1e3 * o.fillDuration));
      });
    }, s.onRaw = function(i) {
      if (i.samples.length) {
        var n = i.samples.reduce(function(c, d) {
          return d.yuv ? c + d.yuv.y.bytes.length + d.yuv.u.bytes.length + d.yuv.v.bytes.length : c + d.units.reduce(function(A, f) {
            return A + f.data.byteLength;
          }, 0);
        }, 0), o = i.samples[i.samples.length - 1].dts - i.samples[0].dts + (i.samples[i.samples.length - 1].duration || 0);
        this._calculateDataRate(T.VIDEO, o / 90, n);
      }
    }, s.downloadInfoByRange = function(i) {
      i === void 0 && (i = 1e3);
      var n = { size: 0, timeCost: 0 };
      if (this._download.length)
        for (var o = performance.now(), c = 0; c < this._download.length && this._download[c].ts > o - i; c++)
          n.size += this._download[c].byteLength, n.timeCost += this._download[c].timeCost;
      return n;
    }, s._calculateDataRate = function(i, n, o) {
      var c = this._streams[this._streams.length - 1], d = c.segments;
      d.push({ type: i, duration: n, byteLength: o }), d.length > 200 && d.shift();
      for (var A = 0, f = 0, x = 0; x < d.length; x++)
        d[x].type === i && (f += d[x].byteLength, A += d[x].duration);
      A > 0 && (i === T.VIDEO ? c.videoDataRate = Math.round(8 * f / A) : i === T.AUDIO && (c.audioDataRate = Math.round(8 * f / A)));
    }, E()(r, [{ key: "smoothedDownloadSpeed", get: function() {
      var i = this._download, n = i[0];
      return n && !n.progress ? n.byteLength / n.timeCost * 1e3 : 1e3 * i.reduceRight(function(o, c) {
        var d = c.byteLength / c.timeCost;
        return o > 0 ? d * (1 - 0.9) + 0.9 * o : d;
      }, 0);
    } }, { key: "trafficGroupedByVCodecType", get: function() {
      var i = u()({}, this._trafficGroupedByVCodecType);
      return i.total = this._traffic, this._streams.forEach(function(n) {
        i[n.vCodecType] = (i[n.vCodecType] || 0) + n.traffic;
      }), i;
    } }, { key: "trafficGroupedByLevel", get: function() {
      var i = u()({}, this._trafficGroupedByLevel);
      return i.total = this._traffic, this._streams.forEach(function(n) {
        var o = n.qualityType || "unknown";
        i[o] = (i[o] || 0) + n.traffic;
      }), i;
    } }, { key: "traffic", get: function() {
      return this._traffic;
    } }, { key: "speed", get: function() {
      var i = this._currentLoad, n = this.downloadInfoByRange();
      return this._download.length ? n.timeCost ? Math.round(n.size / n.timeCost * 1e3) : 0 : (i == null ? void 0 : i.speed) || 0;
    } }, { key: "currentLoad", get: function() {
      return this._currentLoad;
    } }, { key: "streams", get: function() {
      return this._streams;
    } }, { key: "contentLen", get: function() {
      return this._contentLen;
    }, set: function(i) {
      this._contentLen = i;
    } }, { key: "fillA", get: function() {
      return this._fillA;
    } }, { key: "fillV", get: function() {
      return this._fillV;
    } }]), r;
  }(), hi = a(6), mo = function() {
    function r(s, i) {
      this._uri = null, this.baseuri = void 0, this.reluri = void 0, this.method = null, this.key = null, this.iv = void 0, this.baseuri = s, this.reluri = i;
    }
    return E()(r, [{ key: "uri", get: function() {
      return !this._uri && this.reluri && (this._uri = Object(hi.buildAbsoluteURL)(this.baseuri, this.reluri, { alwaysNormalize: !0 })), this._uri;
    } }]), r;
  }(), Nr = function(r) {
    return r.AUDIO = "audio", r.VIDEO = "video", r;
  }({}), Or = function() {
    function r() {
      var i;
      this._url = "", this._byteRange = null, this._decryptdata = null, this._elementaryStreams = ((i = {})[Nr.AUDIO] = !1, i[Nr.VIDEO] = !1, i), this.rawProgramDateTime = null, this.programDateTime = null, this.tagList = [], this.relurl = void 0, this.baseurl = void 0, this.duration = void 0, this.sn = 0, this.levelkey = void 0, this.level = 0, this.start = 0, this.cc = 0, this.maxStartPTS = 0, this.startPTS = void 0, this.endPTS = void 0, this.startDTS = void 0, this.endDTS = void 0, this.deltaPTS = void 0, this.dropped = 0, this.type = void 0, this.loader = void 0, this.title = null, this.urlId = 0, this.data = void 0;
    }
    var s = r.prototype;
    return s.setByteRange = function(i, n) {
      var o = i.split("@", 2), c = [];
      o.length === 1 ? c[0] = n ? n.byteRangeEndOffset : 0 : c[0] = parseInt(o[1], 10), c[1] = parseInt(o[0], 10) + c[0], this._byteRange = c;
    }, s.addElementaryStream = function(i) {
      this._elementaryStreams[i] = !0;
    }, s.hasElementaryStream = function(i) {
      return this._elementaryStreams[i] === !0;
    }, s.createInitializationVector = function(i) {
      for (var n = new Uint8Array(16), o = 12; o < 16; o++)
        n[o] = i >> 8 * (15 - o) & 255;
      return n;
    }, s.setDecryptDataFromLevelKey = function(i, n) {
      var o = i;
      return i && i.method && i.uri && !i.iv && ((o = new mo(i.baseuri, i.reluri)).method = i.method, o.iv = this.createInitializationVector(n)), o;
    }, E()(r, [{ key: "url", get: function() {
      return !this._url && this.relurl && (this._url = Object(hi.buildAbsoluteURL)(this.baseurl, this.relurl, { alwaysNormalize: !0 })), this._url;
    }, set: function(i) {
      this._url = i;
    } }, { key: "byteRange", get: function() {
      return this._byteRange ? this._byteRange : [];
    } }, { key: "byteRangeStartOffset", get: function() {
      return this.byteRange[0];
    } }, { key: "byteRangeEndOffset", get: function() {
      return this.byteRange[1];
    } }, { key: "decryptdata", get: function() {
      if (!this.levelkey && !this._decryptdata)
        return null;
      if (!this._decryptdata && this.levelkey) {
        var i = this.sn;
        typeof i != "number" && (i = 0), this._decryptdata = this.setDecryptDataFromLevelKey(this.levelkey, i);
      }
      return this._decryptdata;
    } }, { key: "endProgramDateTime", get: function() {
      if (this.programDateTime === null || !Number.isFinite(this.programDateTime))
        return null;
      var i = Number.isFinite(this.duration) ? this.duration : 0;
      return this.programDateTime + 1e3 * i;
    } }, { key: "encrypted", get: function() {
      return !(!this.decryptdata || this.decryptdata.uri === null || this.decryptdata.key !== null);
    } }]), r;
  }(), Jt = function() {
    function r(s) {
      this.url = [], this.urlId = 0, this.bitrate = 0, this.maxBitrate = 0, this.qualityType = "", this.qualityLabel = "", this.id = 0, this.codec = "", this.audioCodec = "", this.videoCodec = "", this.hidden = !1, this.enableAdaptive = !0, this.default = !1, this.width = void 0, this.height = void 0, this.index = 0, this.drmSchemaId = "", this.drmToken = "", this.hdr = void 0, this.vCodecType = p.unknown, this.meta = void 0, this.fileName = void 0, this.url = [s], this.urlId = 0;
    }
    return r.prototype.getKLevel = function() {
      return { width: this.width, height: this.height, qualityLabel: this.qualityLabel, qualityType: this.qualityType, bitrate: this.bitrate, maxBitrate: this.maxBitrate };
    }, E()(r, [{ key: "currentUrl", get: function() {
      return this.url[this.urlId] || "";
    } }]), r;
  }(), Ki = function(r) {
    function s(n) {
      var o;
      return (o = r.call(this, n) || this).startSN = 0, o.endSN = 0, o.fragments = [], o.initSegment = null, o.live = !0, o.needSidxRanges = !1, o.startTimeOffset = null, o.targetduration = 0, o.totalduration = 0, o.type = null, o.version = null, o.ptsKnown = !1, o.m3u8Slice = void 0, o.audioGroupIds = void 0, o.attrs = void 0, o.averagetargetduration = void 0, o.name = void 0, o.lang = void 0, o.groupId = "", o.instreamId = "", o.autoselect = void 0, o.forced = void 0, o.size = 0, o.partOfData = !1, o.http416 = 0, o;
    }
    Qt()(s, r);
    var i = s.prototype;
    return i.clear = function() {
      this.fragments = [], this.startSN = 0, this.endSN = 0, this.initSegment = null, this.m3u8Slice = void 0, this.live = !0, this.needSidxRanges = !1, this.startTimeOffset = 0;
    }, i.mergeFrom = function(n, o) {
      if (o === void 0 && (o = !1), n.fragments.length) {
        var c = this.endSN;
        if (this.endSN = n.endSN, n.partOfData || (n.initSegment && !this.initSegment && (this.initSegment = n.initSegment), this.live = n.live, this.needSidxRanges = n.needSidxRanges, this.targetduration = n.targetduration, this.ptsKnown = n.ptsKnown, this.averagetargetduration = n.averagetargetduration, this.hasFrag || (this.m3u8Slice = n.m3u8Slice, this.audioGroupIds = n.audioGroupIds, this.attrs = n.attrs, this.name = n.name, this.lang = n.lang, this.groupId = n.groupId, this.instreamId = n.instreamId, this.autoselect = n.autoselect, this.forced = n.forced)), o && this.fragments.length) {
          for (var d, A = n.fragments.length, f = 0; f < n.fragments.length; f++) {
            var x = n.fragments[f].sn;
            if (typeof x == "number" && x > c) {
              A = f;
              break;
            }
          }
          if (this.fragments.length && n.fragments.splice(0, A), n.partOfData) {
            var O = this.fragments[this.fragments.length - 1].endPTS;
            O && n.fragments.forEach(function(V) {
              V.start = V.startPTS = O, V.endPTS = V.startPTS + V.duration, O = V.endPTS;
            });
          }
          (d = this.fragments).push.apply(d, n.fragments), this.totalduration = this.fragments.reduce(function(V, G) {
            return V + G.duration;
          }, 0), n.partOfData ? this.size += n.size : this.size = n.size;
        } else
          this.startSN = n.startSN, this.fragments = n.fragments, this.totalduration = n.totalduration, this.size = n.size;
      }
    }, E()(s, [{ key: "timeInfo", get: function() {
      var n = [], o = [];
      return this.fragments.forEach(function(c) {
        n.push(c.start), typeof c.programDateTime == "number" && o.push(c.programDateTime);
      }), { duration: this.totalduration, times: n, utcs: o, targetduration: this.targetduration };
    } }, { key: "hasProgramDateTime", get: function() {
      return !(!this.fragments[0] || typeof this.fragments[0].programDateTime != "number" || !Number.isFinite(this.fragments[0].programDateTime));
    } }, { key: "hasFrag", get: function() {
      return this.fragments.length > 0;
    } }]), s;
  }(Jt), yo = function(r) {
    return r[r.LongVideo = 1] = "LongVideo", r[r.ShortVideo = 2] = "ShortVideo", r[r.LiveGame = 3] = "LiveGame", r[r.LiveShow = 4] = "LiveShow", r[r.LivePlayBack = 5] = "LivePlayBack", r;
  }({}), Ao = { 1: _.hls_ts, 2: _.mp4, 3: _.flv, 4: _.hls_fmp4 }, Pr = { avc: p.h264, hevc: p.hevc, av1: p.av1, kvc3: p.kvc3, kvc4: p.kvc4, kvc5: p.kvc5, kvc6: p.kvc6, kvc30: p.kvc30 }, Lt = function() {
    function r() {
    }
    return r.verify = function(s) {
      return !!(s && s.adaptationSet && s.adaptationSet.length) && s.adaptationSet.reduce(function(i, n) {
        return !!(i && n.representation && n.representation.length);
      }, !0);
    }, r.parse = function(s, i) {
      i === void 0 && (i = !1);
      var n, o, c, d, A, f, x, O, V, G = [], j = !1, $ = 0, _e = [], oe = {};
      if (r.verify(s)) {
        var se = s;
        f = Ao[se.mediaType], x = se.stereoType === 1 ? L.V360 : L.Normal, se.businessType !== void 0 && (O = se.businessType >= 3 && se.businessType <= 5), se.businessType === yo.LivePlayBack && (V = !0), se.version && (oe.version = se.version), se.videoId && (oe.videoId = se.videoId), se.videoBaseFeature && (oe.videoBaseFeature = se.videoBaseFeature), se.videoAestheticFeature && (oe.videoAestheticFeature = se.videoAestheticFeature), se.videoFeature && (oe.videoFeature = se.videoFeature), se.adaptationSet.forEach(function(ae) {
          var it = ae.duration / 1e3;
          O === void 0 && it && (O = !1), !$ && it && ($ = it);
          var Ho = ae.drmSchemaId, Vo = ae.drmToken;
          ae.drmSchemaId && (j = !0);
          var yt = m.MAIN;
          if (ae.mimeType && (ae.mimeType.indexOf("video") !== -1 ? oe.videoMimeType = ae.mimeType : ae.mimeType.indexOf("audio") !== -1 ? (oe.audioMimeType = ae.mimeType, yt = m.AUDIO) : ae.mimeType === "text/vtt" ? (oe.subtitleMimeType = ae.mimeType, yt = m.SUBTITLE) : yt = void 0), yt) {
            var Zi = ae.representation.map(function(ce, ei) {
              var ne;
              if (!f && ce.m3u8Slice && (f = _.hls), f || (f = ee(ce.url)), ke(f) ? ((ne = new Ki(ce.url)).lang = ae.language || "", ne.default = !!ce.defaultSelect, ne.id = ce.id || ei, ne.m3u8Slice = ce.m3u8Slice, ne.totalduration = it || $) : ne = new Jt(ce.url), ne.vCodecType = p.unknown, ne.hdr = ce.hdrType || 0, ne.maxBitrate = ce.maxBitrate || 0, ne.bitrate = ce.avgBitrate || ne.maxBitrate, ne.qualityType = ce.qualityType || "", ne.qualityLabel = ce.qualityLabel || "", ne.codec = ce.codecs || "", ne.codec) {
                var Go = yr(ne.codec);
                ne.videoCodec = Go.video || "", ne.vCodecType = Ar(ne.videoCodec);
              }
              return ce.videoCodec && Pr[ce.videoCodec] && (ne.vCodecType = Pr[ce.videoCodec] || p.unknown), _e.push(ne.vCodecType), se.adaptationSet.length === 1 && (ne.audioCodec = ""), ce.width && ce.height && (ne.width = ce.width, ne.height = ce.height), ne.hidden = ce.hidden || !1, ne.enableAdaptive = ce.disableAdaptive === void 0 || !ce.disableAdaptive, ne.default = ce.defaultSelect || !1, ne.index = ei, ne.drmSchemaId = ce.drmSchemaId || Ho, ne.drmToken = ce.drmToken || Vo, ne.drmSchemaId && (j = !0), ce.backupUrl && ce.backupUrl.length && (ne.url = ne.url.concat(ce.backupUrl)), ne.urlId = 0, ne.default && c === void 0 && (yt === m.MAIN ? c = ei : yt === m.AUDIO ? d = ei : yt === m.SUBTITLE && (A = ei)), (ce.comment || ce.kvqScore) && (ne.meta = { comment: ce.comment, kvqScore: ce.kvqScore }), ne;
            });
            yt === m.MAIN ? G = G.concat(Zi) : yt === m.AUDIO ? (n || (n = []), n = n.concat(Zi)) : yt === m.SUBTITLE && (o || (o = []), o = o.concat(Zi));
          }
        });
      }
      if (o && r.processingSubtitleType(o, $), i)
        return [{ codecType: _e.length === 1 ? _e[0] : p.unknown, mediaLevels: { levels: G, def: c || 0, audioTracks: n, defAudio: d || 0, subtitleTracks: o, defSubtitle: A || 0, drm: j, box: f, stereoType: x, isLive: O, meta: oe } }];
      var we = {};
      G.forEach(function(ae) {
        var it = we[ae.vCodecType];
        it || (we[ae.vCodecType] = it = { def: 0, levels: [] }), ae.default && (it.def = it.levels.length), it.levels.push(ae);
      });
      var Re = [];
      for (var Ne in we) {
        var tt = we[Ne];
        tt && Re.push({ codecType: Ne, mediaLevels: { levels: tt.levels, def: tt.def, audioTracks: n, defAudio: d || 0, subtitleTracks: o, defSubtitle: A || 0, drm: j, box: f, stereoType: x, isLive: O, isLiveShift: V, meta: oe } });
      }
      return Re;
    }, r.processingSubtitleType = function(s, i) {
      s.forEach(function(n, o) {
        if (ee(n.currentUrl) === _.hls) {
          n.live = !1, n.index = o, n.totalduration = i, n.targetduration = i, n.endSN = 1;
          var c = new Or();
          c.type = m.SUBTITLE, c.start = 0, c.sn = 1, c.level = o, c.cc = 0, c.url = n.currentUrl, c.duration = i, n.fragments = [c];
        }
      });
    }, r.getAdaptationIdxByType = function(s, i) {
      for (var n = 0; n < s.adaptationSet.length; n++) {
        var o;
        if (s.adaptationSet[n].mimeType === void 0)
          return i === "video" ? 0 : -1;
        if (((o = s.adaptationSet[n].mimeType) == null ? void 0 : o.indexOf(i)) === 0)
          return n;
      }
      return -1;
    }, r;
  }();
  function Ur(r, s, i) {
    var n = Math.min(r, s);
    return n > 1080 || n === 1080 && i > 35;
  }
  var Eo = new RegExp('codecs="((/w|.)+)"'), zi = [{ k: "video/mp4", v: _.mp4 }, { k: "video/quicktime", v: _.mp4 }, { k: "video/x-flv", v: _.flv }, { k: "video/webm", v: _.matroska }, { k: "video/x-matroska", v: _.matroska }, { k: "video/mp2t", v: _.ts }, { k: "audio/x-matroska", v: _.matroska }, { k: "audio/mp4", v: _.mp4 }, { k: "audio/mpeg", v: _.mp3 }, { k: "audio/aac", v: _.aac }, { k: "application/vnd.apple.mpegurl", v: _.hls }, { k: "application/x-mpegurl", v: _.hls }, { k: "audio/wave", v: _.wav }, { k: "audio/wav", v: _.wav }, { k: "audio/x-wav", v: _.wav }, { k: "audio/x-pn-wav", v: _.wav }], It, $i, _i = function() {
    function r() {
    }
    return r.verify = function(s) {
      return !!(s && Object.prototype.hasOwnProperty.call(s, "version") && Object.prototype.hasOwnProperty.call(s, "adaptationSet") && Object.prototype.hasOwnProperty.call(s.adaptationSet, "representation") && Array.isArray(s.adaptationSet.representation) && s.adaptationSet.representation.length > 0) && s.adaptationSet.representation.reduce(function(i, n) {
        return !!(i && n.url && n.bitrate && n.qualityType);
      }, !0);
    }, r.parse = function(s) {
      var i, n = [];
      return r.verify(s) && s.adaptationSet.representation.forEach(function(o, c) {
        var d = new Jt(o.url);
        d.id = o.id || c, d.maxBitrate = o.bitrate || 0, d.bitrate = o.averageBitrate || d.maxBitrate, d.qualityType = o.qualityType || "", d.qualityLabel = o.name || "", d.codec = o.codec || "", d.hidden = o.hidden || !1, d.enableAdaptive = o.enableAdaptive === void 0 || !!o.enableAdaptive, d.default = o.defaultSelect || !1, d.index = c, n.push(d), d.default && i === void 0 && (i = c);
      }), { levels: n, def: i || 0, srcType: g.KWAI_FLV_ABR };
    }, r;
  }(), Mr = function() {
    function r() {
    }
    return r.verify = function(s) {
      return !!(s && Object.prototype.hasOwnProperty.call(s, "segments") && Array.isArray(s.segments) && s.segments.length > 0) && (s.segments.forEach(function(i) {
        if (!i.url || !i.duration || !i.time)
          return !1;
      }), !0);
    }, r.parse = function(s, i) {
      i === void 0 && (i = "");
      var n = [], o = { levels: n, withCredentials: !1, hasVideo: !0, hasAudio: !0 };
      if (r.verify(s)) {
        var c = new Ki("");
        n.push(c);
        var d = s;
        o.withCredentials = !!d.withCredentials, d.hasAudio !== void 0 && (o.hasAudio = !!d.hasAudio), d.hasVideo !== void 0 && (o.hasVideo = !!d.hasVideo);
        var A = 0, f = 0, x = 0, O = 0, V = 0;
        d.segments.forEach(function(G, j) {
          var $ = new Or();
          $.sn = j, typeof G.startUtcTime == "string" ? $.programDateTime = parseInt(G.startUtcTime) : typeof G.startUtcTime == "number" && ($.programDateTime = G.startUtcTime), typeof G.duration == "string" ? $.duration = (parseFloat(G.duration) || 0) / 1e3 : $.duration = (G.duration || 0) / 1e3, $.start = A, $.baseurl = i, $.relurl = G.url, G.filesize && (V += G.filesize), $.duration > O && (O = $.duration), A += $.duration, j > 0 && x !== G.periodId && ($.tagList.push(["DIS"]), f++), $.cc = f, x = G.periodId, c.fragments.push($);
        }), c.bitrate = 8 * V / 1024 / c.totalduration, c.live = !1, c.type = m.MAIN, c.startSN = 0, c.endSN = c.fragments.length - 1, c.totalduration = A, c.targetduration = O, c.averagetargetduration = A / c.fragments.length;
      }
      return o;
    }, r;
  }(), Fr = function() {
    function r() {
    }
    return r.verify = function(s) {
      return !!(s && s.adaptationSet && s.adaptationSet.representation && s.adaptationSet.representation.length) && s.adaptationSet.representation.reduce(function(i, n) {
        return !!(n.url && n.bandwidth && i);
      }, !0);
    }, r.parse = function(s) {
      var i = [];
      return r.verify(s) && s.adaptationSet.representation.forEach(function(n) {
        if (n && (n.url || n.m3u8)) {
          var o = new Ki(n.baseUrl ? Object(hi.buildAbsoluteURL)(n.baseUrl, n.url, { alwaysNormalize: !0 }) : n.url);
          o.bitrate = Math.floor(n.bandwidth / 1e3), o.maxBitrate = Math.floor(n.bandwidth / 1e3), o.qualityType = n.qualityType || "", o.qualityLabel = n.qualityLabel || "", n.width && n.height && (o.width = n.width, o.height = n.height), lo(n.codecs || "", o), o.audioCodec = "", o.m3u8Slice = n.m3u8 || n.m3u8Slice, o.totalduration = n.duration, n.backupUrl && n.backupUrl.length && (o.url = o.url.concat(n.backupUrl)), o.default = n.defaultSelect || !1, o.urlId = 0, i.push(o);
        }
      }), { levels: i, def: 0 };
    }, r;
  }();
  function pi() {
    return typeof navigator > "u" ? 0 : navigator.hardwareConcurrency || 0;
  }
  var Br = { av1: ['video/mp4; codecs="av01.0.05M.08,mp4a.40.2"'], hevc: ['video/mp4; codecs="hev1.1.6.L150.90,mp4a.40.2"', 'video/mp4; codecs="hvc1.1.6.L150.90,mp4a.40.2"'], h264: ['video/mp4; codecs="avc1.42E01E,mp4a.40.2"'], opus: ['video/mp4; codecs="opus"'], mp3: ['video/mp4; codecs="mp3"'], aac: ['video/mp4; codecs="mp4a.40.2"'] }, Hr = { av1: ['video/mp4; codecs="av01.0.13T.10"'], hevc: ['video/mp4; codecs="hev1.2.2.L150.90"', 'video/mp4; codecs="hvc1.2.2.L150.90"'], h264: ['video/mp4; codecs="avc1.6e0028"'] }, go = { mp4: ["video/mp4", "video/quicktime"], flv: ["video/x-flv"], ts: ["video/mp2t"], matroska: ["video/x-matroska", "video/webm"], hls: ["application/vnd.apple.mpegURL", "application/x-mpegURL"], hls_ts: ["application/vnd.apple.mpegURL", "application/x-mpegURL"], hls_fmp4: ["application/vnd.apple.mpegURL", "application/x-mpegURL"], aac: ["audio/aac"], mp3: ["audio/mpeg", "audio/mp3"] }, vt = function() {
    function r() {
    }
    return r.isMSEAvailable = function() {
      if (r._mseAvailable !== void 0)
        return r._mseAvailable;
      if (!Ee.a)
        return r._mseAvailable = !1, !1;
      var s = Vi(), i = mr();
      if (r._mseApiAvailable = !!(s && i && i.prototype && typeof i.prototype.appendBuffer == "function" && typeof i.prototype.remove == "function"), s && Q.mobile && r._mseApiAvailable)
        try {
          var n = new s(), o = document.createElement("video");
          o.src = URL.createObjectURL(n), URL.revokeObjectURL(o.src), r._mseAvailable = !0;
        } catch (c) {
          r._mseAvailable = !1;
        }
      else
        r._mseAvailable = r._mseApiAvailable;
      return r._mseAvailable;
    }, r.isMSECodecCapabilityNormal = function() {
      return r.isMSEAvailable() && r.TYPE_SUPPORTED.h264;
    }, r.isSupported = function(s) {
      return s === void 0 && (s = p.h264), r.isMSECodecSupported(s) && r.isMSEAvailable();
    }, r.isMSECodecSupported = function(s, i) {
      if (s === void 0 && (s = p.h264), i === void 0 && (i = !1), Q.msedge || Q.msie)
        return r.isMSEAvailable() && s === p.h264;
      if (s === p.hevc && r.playHEVCTest === !1)
        return !1;
      var n = i && Hr[s] || Br[s];
      return !!n && n.reduce(function(o, c) {
        return o || r.isMSECodecStrSupported(c);
      }, !1);
    }, r.isVideoCodecSupported = function(s, i) {
      var n = this;
      if (s === void 0 && (s = p.h264), i === void 0 && (i = !1), Q.msedge || Q.msie)
        return s === p.h264;
      if (s === p.hevc && r.playHEVCTest === !1)
        return !1;
      var o = i && Hr[s] || Br[s];
      return !!o && o.reduce(function(c, d) {
        return c || !(!n._testVideo || !n._testVideo.canPlayType(d));
      }, !0);
    }, r.isVideoBoxSupported = function(s) {
      var i = this;
      if (s === void 0 && (s = _.mp4), s === _.unknown)
        return !0;
      var n = go[s];
      return !!n && n.reduce(function(o, c) {
        return o || !(!i._testVideo || !i._testVideo.canPlayType(c));
      }, !1);
    }, r.isVideoCodecStrSupportedInMp4 = function(s, i) {
      i === void 0 && (i = "");
      try {
        return !(!this._testVideo || !this._testVideo.canPlayType((i || "video") + '/mp4;codecs="' + s + '"'));
      } catch (n) {
      }
      return !1;
    }, r.isWebRTCSupported = function() {
      return "RTCPeerConnection" in window && "RTCRtpTransceiver" in window;
    }, r.isMSECodecStrSupportedInMp4 = function(s, i) {
      var n;
      return i === void 0 && (i = ""), !((n = Vi()) == null || !n.isTypeSupported((i || "video") + '/mp4;codecs="' + s + '"'));
    }, r.isMSECodecStrSupported = function(s) {
      var i = Vi();
      return !(!i || typeof i.isTypeSupported != "function" || !i.isTypeSupported(s));
    }, r.isChangeTypeSupported = function() {
      if (r._changeTypeSupported === void 0) {
        var s = mr();
        r._changeTypeSupported = !(!s || s.prototype.changeType === void 0);
      }
      return r._changeTypeSupported;
    }, r.getVideoCodecCompatibilityByCodec = function(s) {
      var i = R.unsupported, n = !0;
      s === p.h264 ? i = r.TYPE_SUPPORTED.h264 ? R.buildin : R.unsupported : s === p.av1 ? (i = r.TYPE_SUPPORTED.av1 ? R.buildin : R.unsupported, n = pi() >= 2) : s === p.hevc ? (i = r.TYPE_SUPPORTED.hevc ? R.buildin : R.unsupported) === R.buildin ? (Q.msedge && (i = R.unsupported), n = pi() >= 2 || Q.safari) : n = r.wasmSmooth : s !== p.kvc3 && s !== p.kvc4 && s !== p.kvc5 && s !== p.kvc6 && s !== p.vvc && s !== p.kvc30 && s !== p.bvc2 || (i = typeof WebAssembly < "u" ? R.wasm : R.unsupported, n = r.wasmSmooth);
      var o = !1;
      return i === R.buildin && (o = r.isChangeTypeSupported(), s === p.hevc && this.playHEVCTest === !1 && (i = R.wasm)), { decoder: i, smooth: i !== R.unsupported && n, mix: o };
    }, r._threads = function() {
      try {
        return typeof WebAssembly < "u" && typeof MessageChannel < "u" && new MessageChannel().port1.postMessage(new SharedArrayBuffer(1)), WebAssembly.validate(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 5, 4, 1, 3, 1, 1, 10, 11, 1, 9, 0, 65, 0, 254, 16, 2, 0, 26, 11]));
      } catch (s) {
        return !1;
      }
    }, r._simd = function() {
      return typeof WebAssembly < "u" && WebAssembly.validate(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 5, 1, 96, 0, 1, 123, 3, 2, 1, 0, 10, 10, 1, 8, 0, 65, 0, 253, 15, 253, 98, 11]));
    }, E()(r, null, [{ key: "isSupportSimd", get: function() {
      return r._isSupportSimd === void 0 && (r._isSupportSimd = r._simd()), r._isSupportSimd;
    } }, { key: "isSupportThreads", get: function() {
      return r._isSupportThreads === void 0 && (r._isSupportThreads = r._threads()), r._isSupportThreads;
    } }, { key: "wasmSmooth", get: function() {
      if (r._wasmSmooth === void 0) {
        var s = pi();
        r._wasmSmooth = !!(r.isSupportHW && r.isSupportThreads && s && s >= 6);
      }
      return r._wasmSmooth;
    } }, { key: "isSupportHW", get: function() {
      return !!Wi().performance;
    } }, { key: "playHEVCTest", get: function() {
      return this._playHEVCTest;
    }, set: function(s) {
      this._playHEVCTest = s;
    } }, { key: "_testVideo", get: function() {
      return $i || Rt() || ($i = document.createElement("video")), $i;
    } }]), r;
  }();
  It = vt, vt._changeTypeSupported = void 0, vt._mseAvailable = void 0, vt._mseApiAvailable = void 0, vt._isSupportSimd = void 0, vt._isSupportThreads = void 0, vt._wasmSmooth = void 0, vt._playHEVCTest = void 0, vt.TYPE_SUPPORTED = { mpeg: It.isMSECodecStrSupported("audio/mpeg"), mp3: It.isMSECodecSupported(p.mp3), opus: It.isMSECodecSupported(p.opus), hevc: It.isMSECodecSupported(p.hevc), av1: It.isMSECodecSupported(p.av1), h264: It.isMSECodecSupported(p.h264), aac: It.isMSECodecSupported(p.aac) };
  var De, X = vt, Vr = new RegExp("^((http|https)://)|blob:"), To = [_.matroska, _.mp3, _.aac], bo = [_.flv, _.raw, _.webrtc, _.ivf], Ro = [_.mp4, _.flv, _.hls, _.raw, _.hls_fmp4, _.hls_ts, _.ts, _.ivf], Gr = Object.values(p), Wr = function() {
    function r() {
    }
    return r.verifyMix = function(s) {
      var i = 0;
      for (var n in s)
        Gr.indexOf(n) !== -1 && i++;
      return i > 0;
    }, r.isSrcEmpty = function(s) {
      if (!s)
        return !1;
      try {
        if (typeof s == "string") {
          if (!(s = s.trim()))
            return !0;
          if (!Vr.test(s))
            return Object.keys(JSON.parse(s)).length === 0;
        } else if (!(s instanceof Blob))
          return Object.keys(s).length === 0;
      } catch (i) {
      }
      return !1;
    }, r.filterLevels = function(s) {
      var i = Q.chrome || Q.firefox;
      s.levels.forEach(function(d) {
        i && d.audioCodec && d.audioCodec.indexOf("mp4a.40.34") !== -1 && (d.audioCodec = "");
      });
      var n = X.isMSEAvailable() ? X.isMSECodecStrSupportedInMp4 : X.isVideoCodecStrSupportedInMp4, o = X.isMSEAvailable() ? X.isMSECodecSupported : X.isVideoCodecSupported;
      s.levels = s.levels.filter(function(d) {
        var A = d.audioCodec, f = d.videoCodec, x = d.hdr, O = d.vCodecType, V = !A || n(A, "audio"), G = !f || n(f);
        return x && !f && O !== p.unknown && (G = o(O, !!x)), V && G;
      });
      var c = !1;
      return s.levels.forEach(function(d, A) {
        d.index = A, d.default && (s.def = A, c = !0);
      }), c || (C.i("media-src", "no default main level, select the one with the lowest bit rate."), s.def = s.levels.reduce(function(d, A, f) {
        return A.bitrate < s.levels[d].bitrate ? f : d;
      }, 0)), s.audioTracks && (s.audioTracks = s.audioTracks.filter(function(d) {
        return !d.audioCodec || n(d.audioCodec, "audio");
      }), s.defAudio = void 0, s.audioTracks.forEach(function(d, A) {
        d.index = A, d.default && (s.defAudio = A);
      }), s.defAudio === void 0 && (s.defAudio = 0)), s.subtitleTracks && s.subtitleTracks.length && s.subtitleTracks.forEach(function(d, A) {
        d.index = A, d.default && (s.defSubtitle = A);
      }), s;
    }, r.preParse = function(s, i, n, o, c) {
      if (i === void 0 && (i = !1), c === void 0 && (c = ""), typeof s == "string") {
        var d = this._formatStrData(s);
        if (!d)
          return [{ src: s, box: _.unknown, srcType: g.OTHERS }];
        s = d;
      } else
        s instanceof Blob || (s = JSON.parse(JSON.stringify(s)));
      if (Array.isArray(s)) {
        var A = [], f = [];
        s.forEach(function(V) {
          if (V != null && V.src) {
            var G = { info: r._preParseMd(V.src, i, n, o, c), priority: 0, mime: void 0 };
            A.push(G.info.box), V.type && (G.mime = function(j) {
              for (var $ = { type: j, box: _.unknown, vCodec: p.unknown }, _e = 0; _e < zi.length; _e++)
                if (j.toLocaleLowerCase().indexOf(zi[_e].k) === 0) {
                  $.box = zi[_e].v;
                  var oe = j.match(Eo);
                  oe && oe.length > 2 && oe[1].split(",").forEach(function(se) {
                    se.indexOf("avc1") === 0 ? $.vCodec = p.h264 : se.indexOf("av01") === 0 ? $.vCodec = p.av1 : se.indexOf("hev1") !== 0 && se.indexOf("hvc1") !== 0 || ($.vCodec = p.hevc);
                  });
                  break;
                }
              return $;
            }(V.type)), f.push(G);
          }
        });
        for (var x = 0; x < f.length; x++) {
          var O = f[x];
          if (O.info && O.info.src) {
            if (O.mime && (O.mime.box !== _.unknown && (O.info.box = O.mime.box), O.mime.vCodec !== p.unknown && (O.info.codecType = O.mime.vCodec)), n !== void 0 && n !== O.info.nativeFirst || O.priority++, O.info.nativeFirst)
              O.priority += O.info.box === _.unknown ? 1 : X.isVideoBoxSupported(O.info.box) ? 2 : -100, O.priority += O.info.codecType === p.unknown ? 1 : o && o === O.info.codecType || X.isVideoCodecSupported(O.info.codecType) ? 2 : -100;
            else {
              if (!X.isMSEAvailable())
                continue;
              O.priority += O.info.box === _.unknown ? 1 : Ro.indexOf(O.info.box) >= 0 ? 2 : -100, O.priority += O.info.codecType === p.unknown ? 1 : o && o === O.info.codecType || X.isMSECodecSupported(O.info.codecType) ? 2 : -100;
            }
            C.i("media-src", "media desc " + x + ". box: " + O.info.box + " codec: " + O.info.codecType + " priority: " + O.priority);
          }
        }
        return f.sort(function(V, G) {
          return G.priority - V.priority;
        }).filter(function(V) {
          return V.priority > 0;
        }).map(function(V) {
          return V.info;
        });
      }
      return [r._preParseMd(s, i, n, o, c)];
    }, r._preParseMd = function(s, i, n, o, c) {
      if (i === void 0 && (i = !1), c === void 0 && (c = ""), typeof s == "string") {
        var d = this._formatStrData(s);
        if (!d)
          return { src: s, box: _.unknown, srcType: g.OTHERS };
        s = d;
      }
      var A, f = X.isMSEAvailable();
      if (r.verifyMix(s)) {
        var x = s, O = [];
        for (var V in x) {
          var G = V;
          if (Gr.indexOf(G) !== -1) {
            var j = x[G];
            if (typeof j == "string" && (j = j.trim()), !j)
              continue;
            var $ = this._getMediaSrcInfoBySrc(j, c), _e = Array.isArray($) ? this._getMediaSrcInfoFromArr($, G) || $[0] : $;
            if (!_e)
              continue;
            _e.codecType = G, O.push(_e);
          }
        }
        A = this._getMediaSrcInfoByCompatibility(O, i, n, o);
      } else {
        var oe = this._getMediaSrcInfoBySrc(s, c);
        Array.isArray(oe) ? oe.length > 1 ? A = this._getMediaSrcInfoByCompatibility(oe, i, n, o) : (A = oe[0]).nativeFirst = this._getNativeFirstByBox(A.box, f, n) : (A = oe).nativeFirst = this._getNativeFirstByBox(A.box, f, n);
      }
      return A || (A = { src: s, box: _.unknown, srcType: g.OTHERS }), A;
    }, r._getMediaSrcInfoByCompatibility = function(s, i, n, o) {
      var c, d, A = this;
      i === void 0 && (i = !1);
      var f = {}, x = {}, O = [], V = X.isMSEAvailable();
      s.forEach(function(Re) {
        var Ne = Re.codecType;
        if (Ne)
          if (Re.nativeFirst = A._getNativeFirstByBox(Re.box, V, n), O.push(Ne), V && !Re.nativeFirst) {
            var tt = X.getVideoCodecCompatibilityByCodec(Ne);
            x[Ne] = tt.decoder, Ne === p.h264 && (tt.decoder = R.buildin, tt.smooth = !0), tt.smooth && tt.decoder === R.buildin && Re.mediaLevels && (Re.compatibility = tt, f[Ne] = Re);
          } else {
            var ae = X.isVideoCodecSupported(Ne);
            x[Ne] = ae ? R.buildin : R.unsupported, Ne !== p.h264 && (!ae || Q.ios && Ne === p.hevc && (Re.box === _.hls_ts || Re.box === _.hls_fmp4 && parseInt(Q.platformVersion) <= 12)) || (Re.compatibility = { decoder: R.buildin, smooth: !0, mix: !1 }, f[Ne] = Re);
          }
      });
      var G, j, $ = (c = f[p.hevc]) != null && c.mediaLevels && f[p.hevc].mediaLevels.levels.length ? f[p.hevc] : void 0, _e = (d = f[p.av1]) != null && d.mediaLevels && f[p.av1].mediaLevels.levels.length ? f[p.av1] : void 0, oe = f[p.h264];
      if (o && f[o])
        G = f[o], C.i("media-src", "selected the specified codec: " + o);
      else {
        var se = _e || $;
        if (i) {
          var we = this._mixManifest(se, oe);
          we && (G = we), C.i("media-src", "mixed codec used");
        }
      }
      return G || ((G = _e || $ || oe) && (G.nativeFirst = this._getNativeFirstByBox(G.box, V, n)), C.i("media-src", "selected src: " + ((j = G) == null ? void 0 : j.codecType))), G && (O.length && (G.mixCodecInput = O), G.mixCodecAvailable = x), G;
    }, r._getMediaSrcInfoFromArr = function(s, i) {
      for (var n = 0; n < s.length; n++)
        if (s[n].codecType === i)
          return s[n];
    }, r._mixManifest = function(s, i) {
      var n;
      if (!Q.mobile && s && s.compatibility && s.compatibility.mix && i && (Lt.verify(s.src) && Lt.verify(i.src) && s.box === i.box ? n = function(d, A, f) {
        if (f === void 0 && (f = p.hevc), d.mediaType === A.mediaType) {
          var x = Lt.getAdaptationIdxByType(d, "audio"), O = Lt.getAdaptationIdxByType(A, "audio");
          if (x >= 0 && O >= 0 || x === -1 && O === -1) {
            var V = Lt.getAdaptationIdxByType(d, "video"), G = Lt.getAdaptationIdxByType(A, "video");
            if (V === -1 || G === -1)
              return;
            var j = d.adaptationSet[V].representation, $ = A.adaptationSet[G].representation;
            if (j.length === 0 || $.length === 0 || j.length === 1 && $.length === 1)
              return;
            var _e = [], oe = [], se = {}, we = j.length > 1 ? j : $, Re = we[0].width < we[we.length - 1].width;
            if ($.forEach(function(ae) {
              Ur(ae.height, ae.width, ae.frameRate) || (se[ae.qualityType] = f, oe.push(ae));
            }), j.forEach(function(ae) {
              (Ur(ae.height, ae.width, ae.frameRate) || oe.length === 0) && (se[ae.qualityType] = p.h264, _e.push(ae));
            }), _e.length === 0 && oe.length === 0)
              return;
            var Ne = _e.concat(oe);
            if (oe.length && Ne.sort(function(ae, it) {
              return Re ? ae.width - it.width : it.width - ae.width;
            }), Ne.length) {
              var tt = u()({}, A);
              return tt.adaptationSet[G].representation = Ne, { manifest: tt, qualityList: se };
            }
          }
        }
      }(i.src, s.src, s.codecType) : _i.verify(s.src) && _i.verify(i.src) && (i.src, s.src, n = void (s.codecType === void 0 && p.hevc)), n)) {
        var o;
        C.i("media-src", "mix kwai manifest"), s.src = n.manifest;
        var c = (o = Lt.parse(s.src, !0)[0]) == null ? void 0 : o.mediaLevels;
        return c && (s.mediaLevels = r.filterLevels(c)), s.codecType = p.unknown, s.mixQualityList = n.qualityList, s;
      }
    }, r._getNativeFirstByBox = function(s, i, n) {
      return !i || To.indexOf(s) !== -1 || !(bo.indexOf(s) !== -1 || !X.isVideoBoxSupported(s)) && (Q.mobile ? s === _.mp4 || s === _.hls || s === _.hls_ts || s === _.ts ? !(n !== void 0 && !n) && !!X.isVideoBoxSupported(s) : s === _.hls_fmp4 ? !(n !== void 0 && !n) && !(!X.isVideoBoxSupported(s) || !Q.x5 && !Q.xweb) : void 0 : n ? !!X.isVideoBoxSupported(s) : n === void 0 && !X.isMSEAvailable());
    }, r._getMediaSrcInfoBySrc = function(s, i) {
      var n = this;
      i === void 0 && (i = "");
      var o = { src: s, box: _.unknown, srcType: g.OTHERS };
      if (typeof s == "string")
        o.box = ee(s), o.mediaLevels = { levels: [new Jt(s)], def: 0 }, o.isLive = this._getIsLiveByBox(o.box);
      else if (s instanceof Blob) {
        var c = new Jt(URL.createObjectURL(s));
        o.mediaLevels = { levels: [c], def: 0 }, s instanceof File ? (o.box = ee(s.name), c.fileName = s.name) : (o.box = _.unknown, c.fileName = "unknow"), o.srcType = g.FILE, o.isLive = !1;
      } else {
        if (Lt.verify(s)) {
          var d = Lt.parse(s).map(function(f) {
            var x, O, V = { mediaLevels: r.filterLevels(f.mediaLevels), src: s, box: f.mediaLevels.box || ee(((x = f.mediaLevels.levels[0]) == null ? void 0 : x.url[0]) || ""), srcType: g.KWAI, isLive: n._getIsLiveByBox(o.box), isLiveShift: f.mediaLevels.isLiveShift, codecType: f.codecType };
            return typeof ((O = V.mediaLevels) == null ? void 0 : O.isLive) == "boolean" && (V.isLive = V.mediaLevels.isLive), ke(V.box) && (V.multipart = !0), V;
          });
          return d.length ? d : d[0];
        }
        if (_i.verify(s))
          o.mediaLevels = r.filterLevels(_i.parse(s)), o.box = _.flv, o.isLive = !0, o.srcType = g.KWAI_FLV_ABR;
        else if (Mr.verify(s)) {
          var A = Mr.parse(s, i);
          o.mediaLevels = u()({ def: 0 }, A), o.box = _.flv, o.isLive = !1, o.multipart = !0, o.srcType = g.KWAI_FLV_MP;
        } else
          Fr.verify(s) && (o.mediaLevels = r.filterLevels(Fr.parse(s)), o.box = _.hls, o.srcType = g.KWAI);
      }
      return ke(o.box) && (o.multipart = !0), o;
    }, r._getIsLiveByBox = function(s) {
      var i;
      return [_.flv, _.hls, _.unknown, _.ivf, _.yuv].indexOf(s) === -1 && (i = !1), s === _.webrtc && (i = !0), i;
    }, r._formatStrData = function(s) {
      var i = s.trim();
      if (i) {
        if (!Vr.test(i)) {
          try {
            i = JSON.parse(i);
          } catch (n) {
            C.i("media-src", "formatStrData error", n);
          }
          typeof i == "string" && (i = Object(hi.buildAbsoluteURL)(location.href, i, { alwaysNormalize: !0 }));
        }
        return i;
      }
    }, r;
  }(), So = function() {
    function r() {
      var i = this;
      this._ls = new Ie(), this._timeout = void 0, this._onVideoEvent = function() {
        var n, o;
        C.i("play-hevc-test", "on video event. " + ((n = De) == null ? void 0 : n.videoWidth) + " " + ((o = De) == null ? void 0 : o.error)), i._onComplete(!!De && De.videoWidth > 0 && !De.error);
      };
    }
    var s = r.prototype;
    return s.init = function(i) {
      if (i > 0) {
        var n = this._ls.read("kwai-kernel-hevc", i);
        C.i("play-hevc-test", "init", n), n !== void 0 && (X.playHEVCTest = !!n);
      }
    }, s.start = function() {
      var i;
      X.playHEVCTest === void 0 && ((i = De) != null && i.src || this._startVideoTest());
    }, s.destroy = function() {
      this._stopTimer(), this._clearTestVideo();
    }, s._onComplete = function(i) {
      C.i("play-hevc-test", "complete result: " + i + " " + performance.now()), this._stopTimer(), this._clearTestVideo(), X.playHEVCTest = i, this._ls.write("kwai-kernel-hevc", i);
    }, s._startVideoTest = function() {
      C.i("play-hevc-test", "start video test"), Rt() ? this._onComplete(!1) : (De || (De = document.createElement("video")), De.preload = "metadata", De.addEventListener("error", this._onVideoEvent), De.addEventListener("loadeddata", this._onVideoEvent), De.addEventListener("loadedmetadata", this._onVideoEvent), this._startTimer(), De.src = "data:video/mp4;base64,AAAAHGZ0eXBpc29tAAACAGlzb21pc28ybXA0MQAAA01tb292AAAAbG12aGQAAAAAAAAAAAAAAAAAAAPoAAAD6AABAAABAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAACd3RyYWsAAABcdGtoZAAAAAMAAAAAAAAAAAAAAAEAAAAAAAAD6AAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAFAAAAAtAAAAAAACRlZHRzAAAAHGVsc3QAAAAAAAAAAQAAA+gAAAAAAAEAAAAAAe9tZGlhAAAAIG1kaGQAAAAAAAAAAAAAAAAAEk+AABJPgFXEAAAAAAAhaGRscgAAAAAAAAAAdmlkZQAAAAAAAAAAAAAAAAAAAAGmbWluZgAAABR2bWhkAAAAAQAAAAAAAAAAAAAAJGRpbmYAAAAcZHJlZgAAAAAAAAABAAAADHVybCAAAAABAAABZnN0YmwAAAECc3RzZAAAAAAAAAABAAAA8mh2YzEAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAFAALQAEgAAABIAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAY//8AAAB4aHZjQwEBYAAAAJAAAAAAAF3wAPz9+PgAAA8DoAABABhAAQwB//8BYAAAAwCQAAADAAADAF2VmAmhAAEAK0IBAQFgAAADAJAAAAMAAAMAXaACgIAtFllZpJMrwFoCAAADAAIAAAMAAhCiAAEAB0QBwXK0YkAAAAAQcGFzcAAAAAEAAAABAAAAFGJ0cnQAAAAAAAALyAAAC8gAAAAYc3R0cwAAAAAAAAABAAAAAQAST4AAAAAcc3RzYwAAAAAAAAABAAAAAQAAAAEAAAABAAAAFHN0c3oAAAAAAAABeQAAAAEAAAAUc3RjbwAAAAAAAAABAAADeQAAAGJ1ZHRhAAAAWm1ldGEAAAAAAAAAIWhkbHIAAAAAAAAAAG1kaXJhcHBsAAAAAAAAAAAAAAAALWlsc3QAAAAlqXRvbwAAAB1kYXRhAAAAAQAAAABMYXZmNTkuMjcuMTAwAAAACGZyZWUAAAGBbWRhdAAAABhAAQwB//8BYAAAAwCQAAADAAADAF2VmAkAAAArQgEBAWAAAAMAkAAAAwAAAwBdoAKAgC0WWVmkkyvAWgIAAAMAAgAAAwACEAAAAAdEAcFytGJAAAABHygBrxMYaRpdZVRRRNJK5mjj//0Xz8f2QC1YmO2u+AJADNDyAAADAAADAAADAAADAAAMqKXvcrgFwB8iYAAAAwAAAwAAAwAAAwAAAwAHnJMChCpAAAADAAADAAADAAADAAADAAAgIIcAAAMAAAMAAAMAAAMAAAMAAAMAABEwAAADAAADAAADAAADAAADAAADAAAYsAAAAwAAAwAAAwAAAwAAAwAAAwAEpAAAAwAAAwAAAwAAAwAAAwAAAwAwYAAAAwAAAwAAAwAAAwAAAwAAAwDggAAAAwAAAwAAAwAAAwAAAwAAAwKyAAADAAADAAADAAADAAADAAAEZAAAAwAAAwAAAwAAAwAAAwAAB8QAAAMAAAMAAAMAAAMAAAMAACeg", De.play().catch(function() {
      }));
    }, s._clearTestVideo = function() {
      De && (De.removeEventListener("error", this._onVideoEvent), De.removeEventListener("loadeddata", this._onVideoEvent), De.removeEventListener("loadedmetadata", this._onVideoEvent), De.src = "");
    }, s._startTimer = function() {
      var i = this;
      this._stopTimer(), this._timeout = setTimeout(function() {
        C.i("play-hevc-test", "timeout"), i._onComplete(!1);
      }, 1e3);
    }, s._stopTimer = function() {
      this._timeout && (clearTimeout(this._timeout), this._timeout = void 0);
    }, r;
  }(), Lo = a(10), wo = a.n(Lo), Kr = function() {
    function r(i, n) {
      this.video = void 0, this.mse = void 0, this.stat = new po(), this.loadRec = void 0, this.lctx = void 0, this.localTimeOffset = void 0, this._mediaDescList = [], this._mediaDescIdx = 0, this._srcUpdateTime = 0, this._originSrc = void 0, this._config = void 0, this._streamingMuxEnabled = !1, this._streamingMux = !1, this._cOutput = void 0, this._liveDelay = new Dr(), this._fps = new vo(), this._yuvParams = void 0, this._hevcTest = new So(), this.video = n, this.lctx = new wr(!0), this._setConfig(ut.processConfig(i));
    }
    var s = r.prototype;
    return s.destroy = function() {
      var i;
      C.i("av-ctx", "destroy"), (i = this.stat.muxWorker) == null || i.terminate(), this._destroyLevels(), this._destroyCanvasOutput(), this._liveDelay.destroy(), this._hevcTest.destroy();
    }, s.getNewCtx = function() {
      return new r(this._config);
    }, s.updateVideoPlaybackQuality = function(i, n) {
      this.stat.videoPlaybackQuality ? (this.stat.videoPlaybackQuality.droppedVideoFrames = n, this.stat.videoPlaybackQuality.totalVideoFrames = i) : this.stat.videoPlaybackQuality = { corruptedVideoFrames: 0, creationTime: 0, droppedVideoFrames: n, totalVideoFrames: i };
    }, s.isTimeinBuffered = function(i) {
      if (this.video) {
        for (var n = this.video.buffered, o = 0; o < n.length; o++)
          if (i >= n.start(o) && i < n.end(o))
            return !0;
      }
      return !1;
    }, s.currentBuffer = function(i) {
      if (this.video)
        for (var n = this.video.buffered, o = 0; o < n.length; o++) {
          var c = n.start(o), d = n.end(o);
          if (c <= i && i < d)
            return { start: c, end: d };
        }
    }, s.nextBuffer = function(i) {
      if (this.video)
        for (var n = this.video.buffered, o = 0; o < n.length; o++) {
          var c = n.start(o), d = n.end(o);
          if (c > i)
            return { start: c, end: d };
        }
    }, s.getLocalTime = function(i) {
      return typeof this.localTimeOffset == "number" ? i - this.localTimeOffset : void 0;
    }, s.getStreamTime = function(i) {
      return typeof this.localTimeOffset == "number" ? i + this.localTimeOffset : void 0;
    }, s.getGeneralLiveShiftUrl = function(i) {
      var n, o = this.stat;
      if ((n = o.liveShiftParams) != null && n.urlParams) {
        var c = te()(i, !0);
        for (var d in o.liveShiftParams.urlParams)
          c.query[d] = o.liveShiftParams.urlParams[d];
        return c.toString();
      }
      return i;
    }, s.getRemuxConfig = function() {
      var i = this._config;
      return { isLive: this.stat.isLive, kwaiKernelLog: C.level || i.kwaiKernelLog, enableSoftwareAES: i.enableSoftwareAES, gopRemux: this.stat.gopRemux, preferDecoder: i.preferDecoder, streamingMux: this.streamingMux, ensureVideo: i.ensureVideo, maxAudioFramesDrift: i.maxAudioFramesDrift, forceKeyFrameOnDiscontinuity: i.forceKeyFrameOnDiscontinuity, wasmDecoderEnabled: i.wasmDecoderEnabled, enableAacPriv: i.enableAacPriv };
    }, s.getDecConfig = function() {
      var i = this._config;
      return { kwaiKernelLog: C.level || i.kwaiKernelLog, videoDropFramePolicy: i.videoDropFramePolicy, videoFrameBufferSize: i.videoFrameBufferSize, videoDecBlockPolicy: i.videoDecBlockPolicy, maxVideoDecThreads: i.maxVideoDecThreads, mainThreadRendering: i.mainThreadRendering };
    }, s.setSrc = function(i, n) {
      i && (this._resetStat(), this.resetStreamingEnabled(), this._yuvParams = void 0, this.loadRec = new xr()), this._setSrc(i, n);
    }, s.reProcessSrc = function(i) {
      this._originSrc && this._processSrc(this._originSrc, i);
    }, s.updateLiveShiftStatuByTime = function(i) {
      var n;
      if (this.stat.liveShiftType && (i === void 0 && (i = (n = this.video) == null ? void 0 : n.currentTime), this.lctx.current && typeof i == "number")) {
        var o = this.liveLocalTime;
        this.stat.liveShift = !!(o && i < o - 0.1);
      }
    }, s.resetStreamingEnabled = function() {
      var i = this._config;
      this._streamingMuxEnabled = this._streamingMux = !(!i.streamingMux || !ut.isStreamingSupported() || Q.msie || Q.safari && this.stat.isLive === !1 || Q.msedge && this.stat.isLive === !1), C.i("av-ctx", "resetStreamingEnabled: " + this._streamingMuxEnabled);
    }, s.resetGopRemux = function() {
      this.stat.gopRemux = !!(Q.safari || Q.opera && Q.version.major < 37), C.i("av-ctx", "resetGopRemux: " + this.stat.gopRemux);
    }, s.hasNextMediaDesc = function() {
      return this._mediaDescIdx + 1 < this._mediaDescList.length;
    }, s.nextMediaDesc = function() {
      if (this.hasNextMediaDesc()) {
        this._mediaDescIdx++;
        var i = this._mediaDescList[this._mediaDescIdx];
        if (i)
          return this._useMediaDesc(i), !0;
      }
      return !1;
    }, s._setConfig = function(i) {
      this._config = i, this._hevcTest.init(this._config.playbackAbilityCacheTimeout), this.resetStreamingEnabled(), this._resetStat(), this._yuvParams = void 0, this.stat.startFromSec = i.startFromSec || (i.startFrom || -1e3) / 1e3, this.stat.webWorker = i.webWorker && !!Ee.a, typeof i.preferNativeLoader == "boolean" && (this.stat.preferNativeLoader = i.preferNativeLoader), this._config.autoPlaybackRateConf ? (C.i("av-ctx", "use config.autoPlaybackRateConf", this._config.autoPlaybackRateConf), this.stat.autoPlaybackRateConf = this._config.autoPlaybackRateConf) : this.stat.autoPlaybackRateConf = function(n, o) {
        o === void 0 && (o = 3), C.i("playback-rate", "get by delay: " + n);
        var c = { startDelay: 0, interval: 0.6, rule: [] };
        return Tr(n, o, c), c;
      }(-Math.floor(this._config.defaultSpts / 1e3));
      try {
        this.stat.webWorker && (this.stat.muxWorker = wo()(3)), Dr.workerTimeOffset = performance.now(), C.i("av-ctx", "init mux worker");
      } catch (n) {
      }
      i.lazyLoadMaxDuration > 0 && i.lazyLoadRecoverDuration > 0 && i.lazyLoadMaxDuration >= i.lazyLoadRecoverDuration && (this.stat.lazyLoadMaxDuration = i.lazyLoadMaxDuration, this.stat.lazyLoadRecoverDuration = i.lazyLoadRecoverDuration), this.loadRec = new xr(), i.src && this._setSrc(i.src);
    }, s._resetStat = function() {
      C.i("av-ctx", "reset stat");
      var i = this._config, n = this.stat;
      this._streamingMux = this._streamingMuxEnabled;
      var o = n.preferNativeLoader;
      n.reset(), this.resetGopRemux(), n.isLive = i.isLive, n.native = i.nativeFirst, n.liveShiftType = this._config.liveShiftType, n.preferNativeLoader = o, this.stat = n;
    }, s._setSrc = function(i, n) {
      this._mediaDescIdx = 0, this._srcUpdateTime = Date.now(), this._processSrc(i, n);
    }, s._processSrc = function(i, n) {
      i && (this._originSrc = i);
      var o = this.config;
      this._mediaDescList = Wr.preParse(i, o.mixManifestEnabled, o.nativeFirst, n, o.baseURL);
      var c = this._mediaDescList[this._mediaDescIdx];
      c && this._useMediaDesc(c);
    }, s._useMediaDesc = function(i) {
      var n, o, c, d, A = this.config, f = this.stat;
      this._cOutput && this._cOutput.reset(), this.stat.srcType === g.FILE && this._destroyLevels(), this.lctx = new wr(A.adaptive), f.codecType = i.codecType ? i.codecType : p.unknown, f.box = A.box || i.box || _.unknown, f.srcType = i.srcType, f.mixContainerInput = i.mixContainerInput, f.mixCodecInput = i.mixCodecInput, f.mixCodecAvailable = i.mixCodecAvailable, f.mixQualityList = i.mixQualityList, f.multipart = i.multipart, f.stereoType = (n = i.mediaLevels) == null ? void 0 : n.stereoType, (o = i.mediaLevels) != null && o.meta && (f.srcMeta = (c = i.mediaLevels) == null ? void 0 : c.meta), A.liveDelayFragNum && A.liveDelayFragNum > 0 && f.multipart && (f.multipartLiveDelay = -1e4 * A.liveDelayFragNum, A.autoPlaybackRateConf || Tr(10 * A.liveDelayFragNum, 10, f.autoPlaybackRateConf)), i.nativeFirst !== void 0 && (f.native = i.nativeFirst), typeof i.isLive == "boolean" && (f.isLive = i.isLive), i.isLiveShift === !0 && (f.liveShiftType = U.KWAI), typeof ((d = i.mediaLevels) == null ? void 0 : d.isLive) == "boolean" && (f.isLive = i.mediaLevels.isLive), !i.mediaLevels || i.srcType === g.OTHERS && ke(f.box) && !f.native || (f.hasAudio = i.mediaLevels.hasAudio, f.hasVideo = i.mediaLevels.hasVideo, f.drm = i.mediaLevels.drm, this.lctx.levels = i.mediaLevels.levels, this.lctx.default = this.lctx.currentIdx = i.mediaLevels.def, i.mediaLevels.audioTracks && (this.lctx.audioTracks = i.mediaLevels.audioTracks, this.lctx.audioIdx = i.mediaLevels.defAudio || 0), i.mediaLevels.subtitleTracks && (this.lctx.subtitleTracks = i.mediaLevels.subtitleTracks, this.lctx.subtitleIdx = i.mediaLevels.defSubtitle || 0)), i.box === _.yuv && (this._yuvParams = function(x) {
        if (x) {
          var O = x.match(ho);
          if (O && O.length > 2) {
            var V = parseInt(O[1]), G = parseInt(O[2]), j = O[4] ? parseInt(O[4]) : 1e3, $ = O[6] ? parseInt(O[6]) : 8, _e = Zt.AV_PIX_FMT_YUV420P;
            if (O[8]) {
              var oe = _o.indexOf(O[8]);
              oe !== -1 && (_e = oe);
            }
            var se = [Zt.AV_PIX_FMT_YUV420P, Zt.AV_PIX_FMT_YUV422P].indexOf(_e) === -1 ? V : V / 2, we = _e === Zt.AV_PIX_FMT_YUV420P ? G / 2 : G;
            return { width: V, height: G, chroma: Zt.AV_PIX_FMT_YUV420P, chromaWidth: se, chromaHeight: we, cropLeft: 0, cropTop: 0, cropWidth: V, cropHeight: G, displayWidth: V, displayHeight: G, pts: 0, fps: j, bpp: $, dataSize: (V * G + se * we * 2) * ($ > 8 ? 2 : 1) };
          }
        }
      }(i.src instanceof File ? i.src.name : this.lctx.currentUrl)), this.resetStreamingEnabled(), C.i("av-ctx", "set src:" + f.box + " live: " + f.isLive + " mobile: " + !!Q.mobile + " gopRemux: " + f.gopRemux + " streamingMux " + this.streamingMux);
    }, s._destroyLevels = function() {
      this.lctx && this.lctx.levels.forEach(function(i) {
        i.url.forEach(function(n) {
          n.indexOf("blob:") === 0 && URL.revokeObjectURL(n);
        });
      });
    }, s._destroyCanvasOutput = function() {
      this._cOutput && (this._cOutput.destroy(), this._cOutput = void 0);
    }, E()(r, [{ key: "live", get: function() {
      return !(!this.stat.isLive || this.stat.liveShift);
    } }, { key: "liveLocalTime", get: function() {
      var i = this.lctx.current;
      return i && i.totalduration && this.stat.multipartLiveDelay ? i.totalduration + this.stat.multipartLiveDelay / 1e3 + 0.1 : 0;
    } }, { key: "yuvParams", get: function() {
      return this._yuvParams;
    } }, { key: "canCodecFallback", get: function() {
      return !(!this.stat.mixCodecInput || this.stat.codecType === p.h264 || this.stat.mixCodecInput.indexOf(p.h264) === -1 || this.stat.decoder !== R.buildin);
    } }, { key: "fps", get: function() {
      return this._fps;
    } }, { key: "liveDelay", get: function() {
      return this._liveDelay;
    } }, { key: "cOutput", get: function() {
      return this._cOutput || (this._cOutput = new fo()), this._cOutput;
    } }, { key: "isAbrAvailable", get: function() {
      return this._config.adaptive && this.lctx.levels.length > 1 && !this.stat.isPreload && !this.isSwitchLevelByReload;
    } }, { key: "isSwitchLevelByReload", get: function() {
      return this.stat.box !== _.flv && !ke(this.stat.box);
    } }, { key: "mediaBufferedSec", get: function() {
      return this.video && this.video.buffered && this.video.buffered.length ? { start: this.video.buffered.start(0), end: this.video.buffered.end(this.video.buffered.length - 1) } : { start: 0, end: 0 };
    } }, { key: "bufferedEnd", get: function() {
      return this.video && this.video.buffered.length ? this.video.buffered.end(this.video.buffered.length - 1) : 0;
    } }, { key: "bufferedSec", get: function() {
      return this.video && this.video.buffered.length > 0 ? Math.max(0, this.video.buffered.end(this.video.buffered.length - 1) - this.video.currentTime) : 0;
    } }, { key: "bufferSliceNum", get: function() {
      return this.video ? this.video.buffered.length : 0;
    } }, { key: "currentTime", get: function() {
      return this.video ? this.video.currentTime : 0;
    } }, { key: "playbackRate", get: function() {
      return this.video ? this.video.playbackRate : 1;
    } }, { key: "config", get: function() {
      return this._config;
    } }, { key: "src", get: function() {
      var i;
      return ((i = this._mediaDescList[this._mediaDescIdx]) == null ? void 0 : i.src) || "";
    } }, { key: "srcUpdateTime", get: function() {
      return this._srcUpdateTime;
    } }, { key: "originSrc", get: function() {
      return this._originSrc;
    } }, { key: "videoPlaybackQuality", get: function() {
      return this.stat.videoPlaybackQuality ? this.stat.videoPlaybackQuality : this.video ? this.video.getVideoPlaybackQuality !== void 0 ? this.video.getVideoPlaybackQuality() : { corruptedVideoFrames: 0, creationTime: 0, droppedVideoFrames: this.video.webkitDecodedFrameCount || 0, totalVideoFrames: this.video.webkitDroppedFrameCount || 0 } : void 0;
    } }, { key: "demuxerType", get: function() {
      return this.stat.demuxerType;
    }, set: function(i) {
      var n = this.stat;
      if (i !== n.demuxerType) {
        var o = n.box === void 0 || n.box === _.unknown;
        i === nt.RAW ? (n.box = _.raw, n.isLive = !1) : i === nt.FLV ? (n.box = _.flv, n.multipart && (n.isLive = !1)) : i === nt.MP4 || i === nt.FMP4 ? (o && (n.box = _.mp4), n.multipart || (n.isLive = !1)) : i === nt.TS ? o && (n.box = _.ts) : i === nt.IVF && (n.box = _.ivf, n.isLive = !1), n.demuxerType = i, this.resetGopRemux();
      }
    } }, { key: "streamingMuxEnabled", get: function() {
      return this._streamingMuxEnabled && !(this.src instanceof Blob);
    }, set: function(i) {
      this._streamingMuxEnabled = i;
    } }, { key: "streamingMux", get: function() {
      return this.stat.box === _.flv && this.stat.isLive !== !1 || this.streamingMuxEnabled && this._streamingMux;
    }, set: function(i) {
      this._streamingMux = i;
    } }, { key: "hevcTest", get: function() {
      return this._hevcTest;
    } }], [{ key: "packName", get: function() {
      return "mini_es";
    } }, { key: "version", get: function() {
      return "3.3.22";
    } }, { key: "buildTime", get: function() {
      return "Fri Jan 19 2024 19:37:02 GMT+0800 (中国标准时间)";
    } }]), r;
  }();
  Kr.instanceCount = 0;
  var Yi, et = Kr, Io = a(11), Co = a.n(Io), ht = function(r) {
    return r.NORMEL = "normal", r.SEEK = "seek", r.END = "end", r.LEVEL_SWITCH = "levelSwitch", r.FIRST_FRAME = "firstFrame", r.LOAD = "load", r.BACKUP = "backup", r;
  }({}), Te = function(r) {
    return r.START = "start", r.MANIFEST = "manifest", r.LEVEL = "level", r.STREAM_CONNECTED = "streamConnected", r.DATA = "data", r.DEMUX = "demux", r.SEGMENT = "segment", r.CANPLAY = "canplay", r.LOADEDMETADATA = "loadedmetadata", r.LOADEDDATA = "loadeddata", r.SEEKED = "seeked", r;
  }(Te || {}), zr = [{ event: Te.START, detailName: "first-loader-open" }, { event: Te.MANIFEST, detailName: "manifest-duration" }, { event: Te.LEVEL, detailName: "level-duration" }, { event: Te.STREAM_CONNECTED, detailName: "stream-connected-duration" }, { event: Te.DATA, detailName: "first-package-duration" }, { event: Te.DEMUX, detailName: "first-remux-duration" }, { event: Te.SEGMENT, detailName: "first-segment-duration" }, { event: Te.LOADEDMETADATA, detailName: "first-meta-duration" }, { event: [Te.LOADEDDATA, Te.CANPLAY, Te.SEEKED], detailName: "first-frame-duration" }], ko = function() {
    function r(i) {
      this._complete = 0, this._duration = 0, this._events = void 0, this._start = 0, this._lastEventTime = 0, this._details = {}, this._ctx = void 0, this._events = zr.slice(0), this._ctx = i;
    }
    var s = r.prototype;
    return s.start = function() {
      C.i("first-frame", "start"), this._complete = 0, this._start = performance.now(), this._duration = 0, this._events = zr.slice(0), this._lastEventTime = 0, this._details = {}, this.process(Te.START, this._start);
    }, s.process = function(i, n) {
      var o;
      if (n === void 0 && (n = 0), C.i("first-frame", "process type: " + i + " " + n + " complete: " + this._complete), this._complete)
        return !1;
      var c = this._events, d = -1;
      n = n || performance.now();
      for (var A = 0; A < c.length; A++) {
        var f = c[A];
        if (Array.isArray(f.event)) {
          if (f.event.indexOf(i) !== -1) {
            d = A;
            break;
          }
        } else if (f.event === i) {
          d = A;
          break;
        }
      }
      if (d === -1)
        return !1;
      var x = c.splice(0, d + 1).pop(), O = ((o = this._ctx.mse) == null ? void 0 : o.readyState) === "closed";
      if ((c.length === 0 || O && i === Te.SEGMENT) && (this._duration = n - this._start, this._complete = Date.now(), C.i("first-frame", "complete " + this._duration + " " + this._complete)), x) {
        var V = Math.round(n - this._lastEventTime);
        this._lastEventTime === 0 && (V = Date.now()), this._lastEventTime = n, this._details[x.detailName] = V;
      }
      return !!this._complete;
    }, s.onDownloadError = function() {
      this._details.download_retry ? this._details.download_retry++ : this._details.download_retry = 1;
    }, s.onRetry = function() {
      this._details.retry ? this._details.retry++ : this._details.retry = 1;
    }, E()(r, [{ key: "complete", get: function() {
      return this._complete;
    } }, { key: "duration", get: function() {
      return this._duration;
    } }, { key: "details", get: function() {
      return this._details;
    } }]), r;
  }(), $r = [/headless/, /spider/, /[a-z0-9]+bot[^a-z0-9]/], mt = function(r) {
    return r.none = "", r.probably = "probably", r.maybe = "maybe", r;
  }(mt || {}), Yr = function() {
    if (Rt())
      return mt.none;
    if (navigator.webdriver)
      return mt.probably;
    for (var r = navigator.userAgent.toLowerCase(), s = 0; s < $r.length; s++)
      if ($r[s].test(r))
        return mt.probably;
    if (window.innerWidth <= 0 && window.innerHeight <= 0)
      return mt.probably;
    if (X.isMSEAvailable() && !X.isMSECodecCapabilityNormal())
      return mt.maybe;
    try {
      var i = document.createElement("canvas");
      i.width = 4, i.width = 4;
      var n = i.getContext("2d");
      if (n) {
        n.fillStyle = "#FFFFFF", n == null || n.fillRect(0, 0, i.width, i.height);
        for (var o = n.getImageData(0, 0, i.width, i.height).data, c = 0; c < o.length; c++)
          if (o[c] !== 0)
            return mt.none;
        return mt.maybe;
      }
    } catch (d) {
      return mt.probably;
    }
    return mt.none;
  }(), Do = new Uint8Array(16);
  function xo() {
    if (!Yi && !(Yi = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto)))
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return Yi(Do);
  }
  for (var No = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, Oo = function(r) {
    return typeof r == "string" && No.test(r);
  }, Ue = [], ji = 0; ji < 256; ++ji)
    Ue.push((ji + 256).toString(16).substr(1));
  var Po = function(r) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = (Ue[r[s + 0]] + Ue[r[s + 1]] + Ue[r[s + 2]] + Ue[r[s + 3]] + "-" + Ue[r[s + 4]] + Ue[r[s + 5]] + "-" + Ue[r[s + 6]] + Ue[r[s + 7]] + "-" + Ue[r[s + 8]] + Ue[r[s + 9]] + "-" + Ue[r[s + 10]] + Ue[r[s + 11]] + Ue[r[s + 12]] + Ue[r[s + 13]] + Ue[r[s + 14]] + Ue[r[s + 15]]).toLowerCase();
    if (!Oo(i))
      throw TypeError("Stringified UUID is invalid");
    return i;
  }, qi, Uo = function(r, s, i) {
    var n = (r = r || {}).random || (r.rng || xo)();
    if (n[6] = 15 & n[6] | 64, n[8] = 63 & n[8] | 128, s) {
      i = i || 0;
      for (var o = 0; o < 16; ++o)
        s[i + o] = n[o];
      return s;
    }
    return Po(n);
  };
  function Xi() {
    return qi || (qi = { support_mse: X.isMSEAvailable() ? 1 : 0, support_aac_mse: X.TYPE_SUPPORTED.aac ? 1 : 0, support_aac: X.isVideoCodecSupported(p.aac) ? 1 : 0, support_h264_mse: X.TYPE_SUPPORTED.h264 ? 1 : 0, support_h264: X.isVideoCodecSupported(p.h264) ? 1 : 0, support_h265_mse: X.TYPE_SUPPORTED.hevc ? 1 : 0, support_h265: X.isVideoCodecSupported(p.hevc) ? 1 : 0, support_av1_mse: X.TYPE_SUPPORTED.av1 ? 1 : 0, support_simd: X.isSupportSimd ? 1 : 0, support_thread: X.isSupportThreads ? 1 : 0, support_hw: X.isSupportHW ? 1 : 0, support_change_type: X.isChangeTypeSupported() ? 1 : 0, support_streaming: ut.isStreamingSupported() ? 1 : 0, hardware_concurrency: pi() || 0, wasm_dec_smooth: X.wasmSmooth ? 1 : 0 }), qi;
  }
  function Qi(r, s) {
    var i, n;
    return typeof navigator < "u" && (navigator.webdriver && (i = navigator.webdriver ? 1 : 0), navigator.onLine !== void 0 && (n = navigator.onLine ? 1 : 0)), { session_id: s.sessionId, kernel_version: et.version, pack_name: et.packName, creation_time: s.creationTime, src_update_time: r.srcUpdateTime, load_start_time: s.loadStartTime, instance_count: et.instanceCount, webdriver: i, on_line: n };
  }
  function jr() {
    var r = {};
    if (typeof navigator < "u") {
      navigator.onLine !== void 0 && (r.network_on_line = navigator.onLine ? 1 : 0);
      var s = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      (s == null ? void 0 : s.rtt) !== void 0 && (r.network_rtt = s.rtt), (s == null ? void 0 : s.rtt) !== void 0 && (r.network_downlink = s.downlink), (s == null ? void 0 : s.effectiveType) !== void 0 && (r.network_effective_type = s.effectiveType), (s == null ? void 0 : s.saveData) !== void 0 && (r.network_save_data = s.saveData ? 1 : 0);
    }
    return r;
  }
  function qr(r, s) {
    var i, n, o, c = (i = r.video) == null ? void 0 : i.duration, d = r.lctx.current, A = (d == null ? void 0 : d.currentUrl) || "", f = u()({ play_url: (d == null ? void 0 : d.fileName) || A, url_id: (d == null ? void 0 : d.urlId) || 0, stream_host: A ? new te.a(A).host : "", reuse: s.reuse, metadata_time: s.metadataTime, play_start_time: s.playStartTime, playing_start_time: s.playingStartTime, stream_duration: Math.round(1e3 * (c && Number.isFinite(c) ? c : 0)), max_bitrate: (d == null ? void 0 : d.maxBitrate) || 0, codec: s.codecs, play_pos: s.playPos || 0, v_data_rate: Math.round(((n = r.loadRec.currentLoad) == null ? void 0 : n.audioDataRate) || 0), a_data_rate: Math.round(((o = r.loadRec.currentLoad) == null ? void 0 : o.videoDataRate) || 0), drm: r.stat.drm ? 1 : 0, adaptive_multi_rate: r.lctx.abr ? 1 : 0, use_backup: s.useBackup, play_to_end: s.playToEnd, v_decoder: r.stat.decoder, video_codec_type: r.stat.codecType || p.unknown, start_codec: s.startCodec, demuxer: r.stat.demuxerType || nt.UNKNOWN, core_type: r.stat.coreType, box: r.stat.box, kwai_slice: r.stat.isKwaiSlice ? 1 : 0, monkey_patched_fetch: s.monkeyPatchedFetch }, Qi(r, s), jr(), function(V) {
      var G = V.video;
      return G ? { elem_crossorigin: G.crossOrigin, elem_autoplay: G.autoplay ? 1 : 0, elem_loop: G.loop ? 1 : 0, elem_volume: G.volume, elem_muted: G.muted ? 1 : 0, elem_preload: G.preload, elem_controls: G.controls ? 1 : 0, elem_ready_state: G.readyState, elem_network_state: G.networkState } : {};
    }(r));
    typeof X.playHEVCTest == "boolean" && (f.play_hevc_test = X.playHEVCTest ? 1 : 0), r.stat.isLive !== void 0 && (f.live = r.stat.isLive ? 1 : 0), f.live_shift_type = r.stat.liveShiftType;
    var x = Dt((d == null ? void 0 : d.fileName) || A);
    r.stat.box === _.flv && r.stat.isLive !== !1 && (f.stream_id = x.streamID, s.cdnIP && (f.cdn_ip = s.cdnIP)), s.httpHeader && (f.response_header = Ce(s.httpHeader)), d != null && d.bitrate && (f.bitrate = Math.round(d.bitrate)), d != null && d.qualityType && (f.quality_type = d.qualityType), d != null && d.qualityLabel && (f.quality_label = d.qualityLabel), s.startQualityType && (f.start_quality_type = s.startQualityType), x.transcodingTpl && (f.transcoding_template = x.transcodingTpl), x.filename && (f.filename = x.filename), typeof navigator < "u" && navigator.deviceMemory && (f.device_memory = navigator.deviceMemory);
    var O = Wi();
    return O.renderer && (f.gpu_renderer = O.renderer), Yr && (f.bot = Yr), r.stat.wasmDecoder && (f.wasm_dec = r.stat.wasmDecoder, f.wasm_dec_simd = r.stat.wasmSimd ? 1 : 0, f.wasm_dec_threads = r.stat.wasmThreads || 0), f;
  }
  function Xr() {
    var r = {};
    return Rt() || (window.screen.width && (r.screen_w = window.screen.width), window.screen.height && (r.screen_h = window.screen.height), window.screen.colorDepth && (r.screen_color_depth = window.screen.colorDepth)), r;
  }
  function Qr(r) {
    var s = {};
    return r && (r.fps && (s.fps = Math.round(1e3 * r.fps) / 1e3), r.width && (s.width = r.width), r.height && (s.height = r.height), r.codedWidth && (s.coded_width = r.codedWidth), r.codedHeight && (s.coded_height = r.codedHeight), r.sar && r.sar.width !== r.sar.height && (s.sar = r.sar), r.enhancedFlv && (s.enhanced_flv = r.enhancedFlv ? 1 : 0)), s;
  }
  function Zr(r) {
    var s = { src_type: r.stat.srcType };
    return r.stat.stereoType && (s.stereo_type = r.stat.stereoType), r.stat.mixCodecInput && r.stat.mixCodecInput.length && (s.mix_codec_input = r.stat.mixCodecInput), r.stat.mixContainerInput && r.stat.mixContainerInput.length && (s.mix_container_input = r.stat.mixContainerInput), r.stat.mixCodecAvailable && (s.mix_codec_available = r.stat.mixCodecAvailable), r.stat.mixQualityList && (s.mix_quality_list = r.stat.mixQualityList), r.stat.fallback264 && (s.fallback_264 = 1), s;
  }
  function Jr(r) {
    var s, i = {};
    return r.stat.srcMeta && (i.src_meta = r.stat.srcMeta), (s = r.lctx.current) != null && s.meta && (i.current_level_meta = r.lctx.current.meta), i;
  }
  function en(r) {
    var s = performance.now();
    return { play: Math.round(r.playDuration + (r.playStartMS ? s - r.playStartMS : 0)), actualPlay: Math.round(r.actualPlayDuration + (r.actualPlayStartMS ? s - r.actualPlayStartMS : 0)), pause: Math.round(r.pauseDuration + (r.pauseStartMS ? s - r.pauseStartMS : 0)), buffer: Math.round(r.bufferTime + (r.bufferingStartMS ? s - r.bufferingStartMS : 0)) };
  }
  function tn() {
    return document.hidden || document.webkitHidden || document.mozHidden || !0;
  }
  var Mo = function() {
    function r(i, n) {
      this._data = void 0, this._ctx = void 0, this._snapshot = void 0, this._tickIndex = 1, this._statTimestampMillis = 0, this._statTimestampMillisUTC = 0, this._firstScreen = !0, this._firstScreenDetails = void 0, this._firstScreenDuration = void 0, this._clickToFirstFrame = 0, this._errorCode = 0, this._errorMessage = "", this._retryInfo = new br(), this._data = i, this._ctx = n, this._tickIndex = 1, this._snapshot = { play: 0, actualPlay: 0, pause: 0, buffer: 0, blockCount: 0, pauseCnt: 0, renderBlockCount: 0, seekCnt: 0, seekLoadCnt: 0, decodedFrames: 0, droppedFrames: 0, traffic: 0, download: 0, mseUpdate: 0, mseRemove: 0, segment: 0, preloadCount: 0, fillA: 0, fillV: 0, keyFrame: 0, onLineChange: 0, visibilityChange: 0, heartbeatTimeout: 0, loadCnt: 0, refreshCnt: 0 }, this._resetForNewInterval();
    }
    var s = r.prototype;
    return s._updateSnapshot = function(i, n) {
      var o = {};
      for (var c in n) {
        var d = i[c];
        typeof d == "number" && (o[c] = d - n[c], n[c] = d);
      }
      return o;
    }, s._resetForNewInterval = function() {
      this._statTimestampMillis = performance.now(), this._statTimestampMillisUTC = Date.now(), this._firstScreenDuration = void 0, this._firstScreenDetails = void 0, this._errorCode = 0, this._errorMessage = "";
    }, s.setFirstScreenDuration = function(i, n, o) {
      this._firstScreenDuration = Math.round(i), this._firstScreenDetails = n, this._firstScreen = !0, this._clickToFirstFrame = o;
    }, s.setError = function(i, n) {
      this._errorCode = i, this._errorMessage = n;
    }, s.setRetry = function(i) {
      this._retryInfo.append(u()({}, i));
    }, s.build = function() {
      var i = this._data, n = this._ctx, o = this._ctx.stat, c = performance.now(), d = Math.round(c - this._statTimestampMillis), A = this._updateSnapshot(i, this._snapshot), f = this._updateSnapshot(en(this._data), this._snapshot), x = this._updateSnapshot(this._ctx.loadRec, this._snapshot), O = this._updateSnapshot({ fillA: this._ctx.loadRec.fillA, fillV: this._ctx.loadRec.fillV }, this._snapshot), V = this._ctx.loadRec.downloadInfoByRange(d), G = V.timeCost ? Math.round(V.size / V.timeCost * 1e3) : 0, j = { tick_index: this._tickIndex, tick_start: this._statTimestampMillisUTC, tick_duration: d, error_code: this._errorCode, error_message: this._errorMessage, block_cnt: A.blockCount || 0, render_block_cnt: A.renderBlockCount || 0, decoded_video_frames: A.decodedFrames || 0, dropped_video_frames: A.droppedFrames || 0, segment_cnt: A.segment || 0, play_duration: f.play || 0, buffer_time: f.buffer || 0, actual_play_duration: f.actualPlay || 0, played_video_duration: f.play || 0, traffic: ((x == null ? void 0 : x.traffic) || 0) >> 10, hidden: tn() ? 1 : 0, download: A.download, download_speed: G, seek_cnt: A.seekCnt, seek_load_cnt: A.seekLoadCnt, pause_duration: f.pause, pause_cnt: A.pauseCnt, preload_cnt: A.preloadCount, on_line_change: A.onLineChange, visibility_change: A.visibilityChange, heartbeat_timeout: A.heartbeatTimeout, load_cnt: A.loadCnt, refresh_cnt: A.refreshCnt };
      return u()(j, Xi(), qr(n, i), function($) {
        var _e, oe, se, we, Re;
        return $.mse ? (we = $.mse.bufferedByType(T.VIDEO), Re = $.mse.bufferedByType(T.AUDIO)) : we = Re = $.mediaBufferedSec, { a_buf_start: Math.round(1e3 * Re.start) || 0, a_buf_end: Math.round(1e3 * Re.end) || 0, a_buf_len: Math.round(1e3 * Math.max(0, Re.end - $.currentTime)) || 0, a_buf_slices: ((_e = $.mse) == null ? void 0 : _e.bufferSliceNumByType(T.AUDIO)) || $.bufferSliceNum || 0, v_buf_start: Math.round(1e3 * we.start) || 0, v_buf_end: Math.round(1e3 * we.end) || 0, v_buf_len: Math.round(1e3 * Math.max(0, we.end - $.currentTime)) || 0, v_buf_slices: ((oe = $.mse) == null ? void 0 : oe.bufferSliceNumByType(T.VIDEO)) || $.bufferSliceNum || 0, buffer_queue_cnt: ((se = $.mse) == null ? void 0 : se.pendingNum()) || 0 };
      }(n), function($) {
        if ($.stat.isLive && $.stat.box === _.flv) {
          var _e = $.liveDelay.getDisplayDelay($.currentTime);
          if (_e)
            return { v_rec_delay: $.liveDelay.getRecDelay(), v_render_delay: _e || 0, a_render_delay: $.liveDelay.getAudioRenderDelay($.currentTime) || 0 };
        }
        return {};
      }(n)), this._retryInfo.hasData && (j.retry_record = this._retryInfo.beacon, j.retry_cnt = this._retryInfo.retryCount, this._retryInfo.clear()), O.fillA && (j.fill_a = O.fillA), O.fillV && (j.fill_v = O.fillV), o.coreType === b.mse && (j.mse_update_cnt = A.mseUpdate || 0, j.mse_remove_cnt = A.mseRemove || 0, j.key_frame_cnt = A.keyFrame, o.isLive ? (j.live_shift_type = n.stat.liveShiftType, n.stat.liveShiftType !== U.NONE && (j.live_shift = n.stat.liveShift ? 1 : 0)) : (j.lazyload_min = Math.floor(o.lazyLoadRecoverDuration), j.lazyload_max = Math.floor(o.lazyLoadMaxDuration))), this._firstScreen && (this._firstScreenDuration === void 0 ? j.first_screen_total_duration = 0 : (j.first_screen_total_duration = this._firstScreenDuration, j.first_screen_details = this._firstScreenDetails, o.coreType === b.mse && o.box === _.mp4 && (j.mp4_moov_size = i.mp4MoovSize, i.mp4FastStart !== void 0 && (j.mp4_fast_start = i.mp4FastStart ? 0 : 1)), this._firstScreenDetails = void 0, this._firstScreenDuration = void 0, this._firstScreen = !1)), typeof this._clickToFirstFrame == "number" && i.playStartTime && (j.click_to_first_frame = this._clickToFirstFrame, this._clickToFirstFrame > 0 && (this._clickToFirstFrame = void 0)), this._tickIndex === 1 && u()(j, Xi(), Zr(this._ctx), Xr()), this._resetForNewInterval(), this._tickIndex++, j;
    }, r;
  }();
  function rn(r, s) {
    var i = Object.keys(r);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(r);
      s && (n = n.filter(function(o) {
        return Object.getOwnPropertyDescriptor(r, o).enumerable;
      })), i.push.apply(i, n);
    }
    return i;
  }
  function nn(r) {
    for (var s = 1; s < arguments.length; s++) {
      var i = arguments[s] != null ? arguments[s] : {};
      s % 2 ? rn(Object(i), !0).forEach(function(n) {
        Co()(r, n, i[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(i)) : rn(Object(i)).forEach(function(n) {
        Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(i, n));
      });
    }
    return r;
  }
  S.MANIFEST_PARSED, S.LEVEL_SWITCHING, S.LEVEL_SWITCHED, S.LEVEL_SWITCH_PLAYING, S.AUDIO_TRACK_SWITCHING, S.AUDIO_TRACK_SWITCHED, S.STOP_LOAD, S.LEVEL_UPDATED, S.AUDIO_TRACK_UPDATED, S.PRELOAD_COMPLETE, S.DEC_LIB_LOADED, S.LOAD, S.PRIV_NAL, S.SEI, S.AAC_PRIV, S.PARSING_DATA, S.WAITING, S.LOADEDMETADATA, S.LOADEDDATA, S.CANPLAY, S.SEEKING, S.SEEKED, S.SEEK_WITH_LOAD, S.PLAYING, S.PAUSE, S.PLAY, S.ENDED, S.RATE_CHANGE, S.MEDIA_INFO, S.TIMEUPDATE, S.PROGRESS, S.HEARTBEAT, S.LOADER_CHUNK_ARRIVAL, S.MEDIA_DEMUX, S.MEDIA_CONNECTED, S.KEY_FRAME, S.NEW_SOURCE, S.DISCONTINUITY, S.METADATA, S.DOWNLOAD;
  var Fo = function(r) {
    function s(n) {
      var o;
      return (o = r.call(this) || this)._beaconTimer = void 0, o._creationTime = void 0, o._runningStartTime = void 0, o._ctx = void 0, o._firstFrame = void 0, o._data = void 0, o._realtimeBeacon = void 0, o._hiddenStart = !1, o._playing = !1, o._seeking = !1, o._seekLoadFlag = !1, o._mediaInfoUpdated = !1, o._seekingThrottle = null, o._seekedDebounce = null, o._onOnlineChange = function() {
        o._data.onLineChange++, o._triggerEventReport(ge.NETWORK_CHANGE, { online: navigator.onLine !== void 0 ? navigator.onLine ? 1 : 0 : void 0 });
      }, o._onVisibilityChange = function() {
        o._data.visibilityChange++;
      }, o._sendRealtimeBeacon = function(c) {
        var d;
        c === void 0 && (c = ht.NORMEL);
        var A = (d = o._realtimeBeacon) == null ? void 0 : d.build();
        if (A) {
          var f;
          c === ht.NORMEL && A.first_screen_total_duration > 0 ? A.type = ht.FIRST_FRAME : (c === ht.LOAD && u()(A, Jr(o._ctx)), A.type = c), o._mediaInfoUpdated && (u()(A, Qr((f = o._ctx.loadRec.currentLoad) == null ? void 0 : f.mediaInfo)), o._mediaInfoUpdated = !1), o._ctx.stat.isLive || (A.seek_record = o._data.seekRecord.slice(0), o._data.seekRecord = []), C.i("monitor", "realtime beacon", A), o.emit(S.REPORT, { type: je.REALTIME_BEACON, value: A });
        }
      }, o._runningStartTime = performance.now(), o._creationTime = Date.now(), o._firstFrame = new ko(n), o._ctx = n, o._reset(), Rt || (window.addEventListener("online", o._onOnlineChange), window.addEventListener("offline", o._onOnlineChange), document.addEventListener("visibilitychange", o._onVisibilityChange)), o;
    }
    Qt()(s, r);
    var i = s.prototype;
    return i._reset = function() {
      var n;
      this._playing = !1, this._seeking = !1, this._seekLoadFlag = !1, this._mediaInfoUpdated = !1, this._seekedDebounce && clearTimeout(this._seekedDebounce), this._seekingThrottle && clearTimeout(this._seekingThrottle), this._data = (n = { decodedFrames: 0, droppedFrames: 0, sessionId: Uo(), creationTime: 0, startTime: 0, loadStartTime: 0, playStartTime: 0, metadataTime: 0, playingStartTime: 0, playDuration: 0, actualPlayDuration: 0, pauseDuration: 0, pauseCnt: 0, bufferTime: 0, blockCount: 0, renderBlockCount: 0, seekCnt: 0, seekDuration: 0, seekLoadCnt: 0, seekLoadDuration: 0, seekStartTime: 0, unknownTSPacketCount: 0, audioNonMonotonous: 0, startBitrate: 0, smoothBitrate: -1, useBackup: 0, aacOverhead: 0, errorCode: 0, errorMessage: "", download: 0, preloadCount: 0, reuse: 0, playPos: 0, seekRecord: [], codecs: "", firstScreenTotalDuration: 0, clickToFirstFrame: 0, playToEnd: 0, fillA: 0, fillV: 0, keyFrame: 0, onLineChange: 0, visibilityChange: 0, lastHeartbeatTime: 0, heartbeatTimeout: 0, loadCnt: 0, refreshCnt: 0, monkeyPatchedFetch: "" }, fe.isSupported() && (n.monkeyPatchedFetch = Z(fetch, "fetch")), n), this._data.creationTime = this._creationTime, C.i("monitor", "reset", this._data.sessionId), this._ctx.fps.reset(), this._ctx.fps.getFPS(this._ctx.videoPlaybackQuality);
    }, i.onLoaderChunkArrival = function(n) {
      this._ctx.loadRec.onDataReceive(n), this._processFirstFrame(Te.DATA);
    }, i.onMediaConnected = function(n) {
      n.headers && (this._data.httpHeader = n.headers), this._processFirstFrame(Te.STREAM_CONNECTED);
    }, i.onMediaDemux = function() {
      this._processFirstFrame(Te.DEMUX, performance.now());
    }, i.onKeyFrame = function(n) {
      this._ctx.loadRec.currentLoad && this._ctx.loadRec.currentLoad.keyFrame++, this.data.keyFrame++, n && this.emit(S.REPORT, { type: je.KEY_FRAME, value: n });
    }, i.onDecLibLoaded = function(n) {
      this._data.decLibLoadDuration = n.duration, this._data.decLibCacheHit = n.hitCache;
    }, i.onNewSource = function(n) {
      var o = this._data, c = this._ctx.lctx.current;
      c ? (this._ctx.loadRec.onStreamOpen(n.sync, c.currentUrl, c.bitrate, c.qualityType), o.level = this._ctx.lctx.currentIdx, o.startQualityType || (o.startQualityType = c.qualityType)) : this._ctx.loadRec.onStreamOpen(n.sync, "", 0, "unknown");
    }, i.onDiscontinuity = function(n) {
      this.emit(S.REPORT, { type: je.DISCONTINUITY, value: n });
    }, i.onDownload = function(n) {
      var o = this, c = this._data;
      n.error_code && !this._firstFrame.complete && this._firstFrame.onDownloadError(), c.download++;
      var d = u()({ use_backup: c.useBackup, first_screen: c.firstScreenTotalDuration ? 1 : 0 }, Qi(this._ctx, c), jr(), n);
      n.error_code === 1009 ? setTimeout(function() {
        o.emit(S.REPORT, { type: je.DOWNLOAD, value: d });
      }, 0) : this.emit(S.REPORT, { type: je.DOWNLOAD, value: d });
    }, i.onHeartbeat = function() {
      var n, o, c = this._data, d = this._ctx, A = d.fps.getFPS(this._ctx.videoPlaybackQuality), f = {}, x = d.loadRec, O = performance.now();
      c.lastHeartbeatTime && O - c.lastHeartbeatTime > 1500 && c.heartbeatTimeout++, c.lastHeartbeatTime = performance.now(), (d.stat.coreType === b.mse || d.stat.coreType === b.rtc) && (f.totalReceive = x.traffic, f.speed = x.speed, f.videoDataRate = ((n = x.currentLoad) == null ? void 0 : n.videoDataRate) || 0, f.audioDataRate = ((o = x.currentLoad) == null ? void 0 : o.audioDataRate) || 0), d.mse && (f.videoBuffered = Math.round(Math.max(0, 1e3 * (d.mse.bufferedEndByType(T.VIDEO) - d.currentTime))), f.audioBuffered = Math.round(Math.max(0, 1e3 * (d.mse.bufferedEndByType(T.AUDIO) - d.currentTime))), f.fillAudio = c.fillA, f.fillVideo = c.fillV, f.keyFrame = c.keyFrame, d.stat.isLive ? (f.isLive = d.stat.isLive, d.stat.liveShiftType && (f.liveShift = d.stat.liveShift)) : (f.lazyloadMin = d.stat.lazyLoadRecoverDuration, f.lazyloadMax = d.stat.lazyLoadMaxDuration)), f.buffered = Math.round(1e3 * d.bufferedSec), f.decodedFPS = (A == null ? void 0 : A.decodedFPS) || 0, f.droppedFPS = (A == null ? void 0 : A.droppedFPS) || 0, c.decodedFrames = f.decodedFrames = (A == null ? void 0 : A.decoded) || 0, c.droppedFrames = f.droppedFrames = (A == null ? void 0 : A.dropped) || 0, d.stat.isLive && d.stat.box === _.flv && (f.audioRenderDelay = d.liveDelay.getAudioRenderDelay(d.currentTime), f.displayDelay = d.liveDelay.getDisplayDelay(d.currentTime), f.recDelay = d.liveDelay.getRecDelay()), this.emit(S.REPORT, { type: je.HEARTBEAT, value: f });
    }, i.destroy = function() {
      C.i("monitor", "destroy"), this._triggerEventReport(ge.DESTORY), this._sendRealtimeBeacon(ht.END), this._stopBeaconTimer(), Rt() || (window.removeEventListener("online", this._onOnlineChange), window.removeEventListener("offline", this._onOnlineChange), document.removeEventListener("visibilitychange", this._onVisibilityChange)), this._seekedDebounce && clearTimeout(this._seekedDebounce), this._seekingThrottle && clearTimeout(this._seekingThrottle), this.removeAllListeners();
    }, i.onPreloadComplete = function() {
      this._data.preloadCount++;
    }, i.onLoad = function(n) {
      if (C.i("monitor", "on load: " + n.type), this._data.loadCnt++, n.type)
        n.type !== M.internal && n.type !== M.retry || this._firstFrame.complete || this._firstFrame.start(), this._data.errorCode = 0, this._data.errorMessage = "";
      else {
        var o, c = ((o = this._ctx.lctx.current) == null ? void 0 : o.currentUrl) || "";
        if (this._data.startTime) {
          var d = this._data.reuse;
          this._reset(), this._data.reuse = d + 1;
        }
        this._triggerEventReport(ge.LOAD, { url: c, protocol: this._ctx.stat.box, initial_speed: String(this._ctx.video && this._ctx.video.playbackRate) }), this._data.startTime = performance.now(), this._data.loadStartTime = Date.now(), this._firstFrame.start(), this._hiddenStart = tn(), this._stopBeaconTimer(), this._realtimeBeacon = new Mo(this._data, this._ctx), this._sendRealtimeBeacon(ht.LOAD);
      }
    }, i.onStopLoad = function() {
      this._sendRealtimeBeacon(ht.END), this._stopBeaconTimer(), this._waitingEnd(), this._ctx.stat.isLive && this._triggerEventReport(ge.LIVE_STOP);
    }, i.onManifestParsed = function(n) {
      C.i("monitor", "on manifest: " + n);
      var o = this._ctx.lctx.current;
      o && (this._data.startBitrate || (this._data.startBitrate = o.bitrate)), this._processFirstFrame(Te.MANIFEST);
    }, i.onLevelUpdated = function(n) {
      this._processFirstFrame(Te.LEVEL);
    }, i.onAudioTrackUpdated = function() {
    }, i.onMediaInfo = function(n) {
      var o, c, d = this._ctx;
      (n = n || {}).box = d.stat.box, d.stat.srcMeta && (n.srcMeta = d.stat.srcMeta), (o = d.lctx.current) != null && o.meta && (n.currentLevelMeta = (c = d.lctx.current) == null ? void 0 : c.meta), typeof d.stat.isLive == "boolean" && (n.isLive = d.stat.isLive), n.liveShiftEnabled = d.stat.liveShiftType !== U.NONE, n.liveShiftType = d.stat.liveShiftType, n.packName = et.packName, d.loadRec.onMediaInfo(n);
      var A = [];
      n.videoCodec && A.push(n.videoCodec), n.audioCodec && A.push(n.audioCodec), this._data.codecs = A.join(","), this._data.startCodec || (this._data.startCodec = this._data.codecs), n.sid = this._data.sessionId, n.hardwareAccelerated = X.isSupportHW, n.coreType = d.stat.coreType, !n.streamHost && d.lctx.currentUrl && (n.streamHost = new te.a(d.lctx.currentUrl).host);
      var f = Wi();
      f.renderer && (n.gpu = f.renderer), d.loadRec.currentLoad && (d.loadRec.currentLoad.mediaInfo = n), d.stat.isLive && d.stat.box === _.flv && d.config.ntp && d.liveDelay.init(d.stat.preferNativeLoader), d.stat.isKwaiSlice && (n.isKwaiSlice = d.stat.isKwaiSlice);
      var x = JSON.stringify(n);
      C.i("monitor", "mediainfo", x), this._mediaInfoUpdated = !0, this.emit(S.REPORT, { type: je.MEDIA_INFO, value: JSON.parse(x) });
    }, i.onParsingData = function(n) {
      if (n.extra && n.extra.stat) {
        var o = this._data;
        o.unknownTSPacketCount = o.unknownTSPacketCount || n.extra.stat.unknownTSPacketCount || 0, o.audioNonMonotonous = o.audioNonMonotonous || n.extra.stat.audioNonMonotonous || 0, o.aacOverhead = o.aacOverhead || n.extra.stat.aacOverhead || 0;
      }
      this._processFirstFrame(Te.SEGMENT);
    }, i.onPrivNal = function(n) {
      this._ctx.liveDelay.onPrivNal(n), this.emit(S.REPORT, { type: je.PRIV_NAL, value: { info: n.info } });
    }, i.onSei = function(n) {
      this.emit(S.REPORT, { type: je.SEI, value: n });
    }, i.onAacPriv = function(n) {
      this.emit(S.REPORT, { type: je.AAC_PRIV, value: n });
    }, i.onPlay = function() {
      this._data.playStartTime || (this._data.playStartTime = Date.now()), this._startBeaconTimer();
    }, i.onLoadedmetadata = function() {
      this._processFirstFrame(Te.LOADEDMETADATA), this._data.metadataTime || (this._data.metadataTime = Date.now());
    }, i.onLoadeddata = function() {
      this._processFirstFrame(Te.LOADEDDATA), this._waitingEnd();
    }, i.onCanplay = function() {
      this._processFirstFrame(Te.CANPLAY), Q.safari && this._ctx.stat.coreType !== b.mse || this._waitingEnd();
    }, i.onPlaying = function() {
      var n;
      Q.ios && ((n = this._ctx.video) == null ? void 0 : n.readyState) !== 4 || (this._playing || (this._playing = !0, this._triggerEventReport(ge.PLAY)), this._playStart(), this._pauseEnd(), this._waitingEnd());
    }, i.onPause = function() {
      var n;
      (n = this._ctx.video) != null && n.seeking || !this._playing || (this._playEnd(), this._pauseStart(), this._triggerEventReport(ge.PAUSE), this._playing = !1);
    }, i.onEnded = function() {
      this._data.playToEnd++, this._playing = !1, this._playEnd(), this._pauseEnd(), this._waitingEnd(), this._sendRealtimeBeacon(ht.END), this._stopBeaconTimer(), this._triggerEventReport(ge.END);
    }, i.onWaiting = function(n) {
      this._data.playPos = Math.round(1e3 * this._ctx.currentTime), this._playing && this._firstFrame.complete && n.block && (this._waitingStart(n.bufferedSec), this._triggerEventReport(ge.BLOCK_START));
    }, i.onSeeking = function(n) {
      var o, c, d = this;
      this._data.seekRecord.push({ from: this._data.playPos, to: Math.round(1e3 * this._ctx.currentTime), time: Date.now() }), this._data.seekRecord.length > 50 && this._data.seekRecord.shift(), this._ctx.stat.isLive || n != null && n.internal || (this._data.seekStartTime = performance.now(), this._seeking ? !this._seekingThrottle && this._seeking && (this._seekingThrottle = +setTimeout(function(A) {
        var f, x;
        d._triggerEventReport(ge.SEEK_START, { paused: (f = d._ctx.video) == null ? void 0 : f.paused, seeking: (x = d._ctx.video) == null ? void 0 : x.seeking, position: A }), d._seekingThrottle = null;
      }, 500, this._data.playPos / 1e3)) : (this._triggerEventReport(ge.SEEK_START, { paused: (o = this._ctx.video) == null ? void 0 : o.paused, seeking: (c = this._ctx.video) == null ? void 0 : c.seeking, position: this._data.playPos / 1e3 }), this._seeking = !0));
    }, i.onSeekWithLoad = function() {
      this._firstFrame.complete && (this._sendRealtimeBeacon(ht.SEEK), this._resetBeaconTimer(), this._seekLoadFlag = !0);
    }, i.onSeeked = function() {
      var n = this;
      if (this._ctx.fps.getFPS(this._ctx.videoPlaybackQuality), this._data.seekStartTime) {
        this._data.seekCnt++;
        var o = Math.round(performance.now() - this._data.seekStartTime);
        this._data.seekDuration += o, this._data.seekStartTime = 0, this._seekLoadFlag && (this._data.seekLoadCnt++, this._data.seekLoadDuration += o), this._seekedDebounce && clearTimeout(this._seekedDebounce), this._seekedDebounce = +setTimeout(function() {
          var c, d, A;
          (c = n._ctx.video) != null && c.seeking || (n._seeking = !1, n._triggerEventReport(ge.SEEK_END, { paused: (d = n._ctx.video) == null ? void 0 : d.paused, seeking: (A = n._ctx.video) == null ? void 0 : A.seeking }));
        }, 500);
      }
      this._seekLoadFlag = !1, this._firstFrame.complete || this._ctx.stat.coreType === b.mse || !Q.safari && !Q.msie || this._processFirstFrame(Te.SEEKED);
    }, i.onTimeupdate = function() {
      var n, o, c = this._ctx, d = c.video;
      if (d) {
        d.loop && !c.stat.isLive && c.currentTime === 0 && Number.isFinite(d.duration) && d.duration > 0 && d.duration - this._data.playPos / 1e3 < 1 && this._data.playToEnd++;
        var A = Math.round(1e3 * c.currentTime);
        Q.msie && c.stat.coreType !== b.mse && this._data.bufferingStartMS && this._data.playPos !== A && this.onPlaying(), this._data.playPos = A, !Q.ios || typeof this._data.bufferingStartMS != "number" || ((n = this._ctx.video) == null ? void 0 : n.readyState) !== 4 || (o = this._ctx.video) != null && o.paused || this.onPlaying();
      }
    }, i.onProgress = function() {
      var n;
      Q.safari && this._ctx.stat.coreType !== b.mse && this._data.bufferingStartMS && ((n = this._ctx.video) == null ? void 0 : n.readyState) === 4 && this._waitingEnd();
    }, i.mediaCapabilities = function(n) {
      this._data.smoothBitrate = n;
    }, i.onLevelSwitching = function(n) {
      n.smooth || (this._sendRealtimeBeacon(ht.LEVEL_SWITCH), this._resetBeaconTimer());
      var o = this._ctx.lctx.current;
      o && this._triggerEventReport(ge.QUALITY_CHANGE, { quality_type: o.qualityType, trigger_mode: n.auto ? "abr" : "user", play_url: o.currentUrl, is_smooth: n.smooth ? 1 : 0 });
    }, i.onLevelSwitched = function() {
      this._triggerEventReport(ge.QUALITY_CHANGE_DATA);
    }, i.onLevelSwitchPlaying = function() {
      this._triggerEventReport(ge.QUALITY_CHANGE_RENDER);
    }, i.onAudioTrackSwitching = function() {
      this._triggerEventReport(ge.AUDIO_CHANGE);
    }, i.onAudioTrackSwitched = function() {
      this._triggerEventReport(ge.AUDIO_CHANGE);
    }, i.onRetry = function(n) {
      var o;
      n.type === I.BACKUP && (this._data.useBackup = 1), this._firstFrame.onRetry(), this._triggerEventReport(ge.RETRY, { retry_type: n.type, retry_message: n.message, error_code: n.code || 0 }), n.type === I.BACKUP && (this._realtimeBeacon && this._realtimeBeacon.setError(n.code || 0, n.message || ""), this._sendRealtimeBeacon(ht.BACKUP), this._realtimeBeacon && this._realtimeBeacon.setError(0, "")), (o = this._realtimeBeacon) == null || o.setRetry(n);
    }, i.onLiveShift = function(n) {
      this._triggerEventReport(ge.LIVE_SHIFT, { live_shift_type: this._ctx.stat.liveShiftType, live_shift_time: n != null && n.time ? n.time : -1 });
    }, i.onRefresh = function() {
      this._data.refreshCnt++;
    }, i.onMetadata = function(n) {
      n.mp4MoovSize && (this._data.mp4MoovSize = n.mp4MoovSize), typeof n.mp4FastStart == "number" && (this._data.mp4FastStart = n.mp4FastStart), typeof n.cdn_ip == "string" && (this._data.cdnIP = n.cdn_ip), this.emit(S.REPORT, { type: je.METADATA, value: n }), this._triggerEventReport(ge.METADATA_LOAD, nn({}, n));
    }, i._triggerEventReport = function(n, o) {
      this.emit(S.REPORT, { type: je.EVENT, value: u()(nn({ type: n, position: this._ctx.currentTime }, o), Qi(this._ctx, this._data)) });
    }, i.onRatechange = function() {
      var n;
      !this._ctx.video || (n = this._ctx.video) != null && n.seeking || this._triggerEventReport(ge.SPEED_CHANGE, { speed: this._ctx.video.playbackRate });
    }, i.onError = function(n, o) {
      this._data.errorCode = n, this._data.errorMessage = o, this._triggerEventReport(ge.ERROR, { error_message: o, error_type: n }), this._realtimeBeacon && this._realtimeBeacon.setError(n, o), this._playEnd(), this._pauseEnd(), this._waitingEnd();
    }, i._processFirstFrame = function(n, o) {
      o === void 0 && (o = 0), !this._firstFrame.complete && this._firstFrame.process(n, o) && this._onFirstFrame();
    }, i._playStart = function() {
      this._data.playingStartTime || (this._data.playingStartTime = Date.now()), this._data.playStartMS = this._data.playStartMS || performance.now(), this._data.actualPlayStartMS = this._data.actualPlayStartMS || performance.now();
    }, i._playEnd = function() {
      this._data.playStartMS && (this._data.playDuration += performance.now() - this._data.playStartMS), this._data.actualPlayStartMS && (this._data.actualPlayDuration += performance.now() - this._data.actualPlayStartMS), this._data.playStartMS = void 0, this._data.actualPlayStartMS = void 0;
    }, i._pauseStart = function() {
      this._data.pauseCnt++, this._data.pauseStartMS = this._data.pauseStartMS || performance.now();
    }, i._pauseEnd = function() {
      this._data.pauseStartMS && (this._data.pauseDuration += performance.now() - this._data.pauseStartMS), this._data.pauseStartMS = void 0;
    }, i._waitingStart = function(n) {
      this._data.bufferingStartMS || (this._data.blockCount++, this._data.bufferingStartMS = performance.now(), n > 0.6 && this._data.renderBlockCount++), this._data.actualPlayStartMS && (this._data.actualPlayDuration += performance.now() - this._data.actualPlayStartMS), this._data.actualPlayStartMS = void 0;
    }, i._waitingEnd = function() {
      this._data.bufferingStartMS && (this._data.bufferTime += performance.now() - this._data.bufferingStartMS, this._data.bufferingStartMS = void 0, this._triggerEventReport(ge.BLOCK_END));
    }, i._onFirstFrame = function() {
      var n, o, c, d, A, f;
      C.i("monitor", "first frame"), this._ctx.stat.firstFrameLoaded = !0;
      var x = this._data, O = this._ctx.loadRec.currentLoad;
      x.firstScreenTotalDuration = x.firstScreenTotalDuration || Math.round(this._firstFrame.duration), x.firstScreenDetails = x.firstScreenDetails || this._firstFrame.details, this._triggerEventReport(ge.FIRST_SCREEN_RENDER, { initial_rate: Math.round(((n = this._ctx.loadRec.currentLoad) == null ? void 0 : n.videoDataRate) || 0), inital_quality_type: this._data.startQualityType, fps: O == null || (o = O.mediaInfo) == null || (o = o.fps) == null ? void 0 : o.toString(), a_codec: O == null || (c = O.mediaInfo) == null ? void 0 : c.audioCodec, v_codec: O == null || (d = O.mediaInfo) == null ? void 0 : d.videoCodec, channels: O == null || (A = O.mediaInfo) == null || (A = A.channel) == null ? void 0 : A.toString(), sample_rate: O == null || (f = O.mediaInfo) == null || (f = f.audioSampleRate) == null ? void 0 : f.toString() }), x.playStartTime && this._firstFrame.complete ? x.clickToFirstFrame = x.clickToFirstFrame || Math.max(1, this._firstFrame.complete - x.playStartTime) : x.clickToFirstFrame = 1, this._realtimeBeacon && this._realtimeBeacon.setFirstScreenDuration(this._firstFrame.duration, this._firstFrame.details, x.clickToFirstFrame), this._ctx.video && !this._ctx.video.paused && this._playStart();
    }, i._startBeaconTimer = function() {
      this._beaconTimer === void 0 && (this._beaconTimer = setInterval(this._sendRealtimeBeacon, 1e4));
    }, i._stopBeaconTimer = function() {
      this._beaconTimer && (clearTimeout(this._beaconTimer), this._beaconTimer = void 0);
    }, i._resetBeaconTimer = function() {
      this._stopBeaconTimer(), this._startBeaconTimer();
    }, E()(s, [{ key: "runningStartTime", get: function() {
      return this._runningStartTime;
    } }, { key: "sid", get: function() {
      return this._data.sessionId;
    } }, { key: "snapshot", get: function() {
      var n = this._ctx.loadRec, o = this._ctx.stat;
      return u()({ streams: n.streams, live: o.isLive, liveShift: o.liveShift, demuxer: o.demuxerType, decSimd: o.wasmSimd, decThreads: o.wasmThreads, decoderType: o.wasmDecoder }, this._data);
    } }, { key: "data", get: function() {
      return this._data;
    } }, { key: "audienceStat", get: function() {
      var n, o = this._data, c = en(o), d = this._ctx.stat, A = this._ctx.loadRec, f = { play_duration: c.play, actual_play_duration: c.actualPlay, traffic: A.traffic >> 10, buffer_time: c.buffer, block_cnt: o.blockCount, render_block_cnt: o.renderBlockCount, click_to_first_frame: o.playStartTime && o.clickToFirstFrame || 0, first_screen_total_duration: Math.round(o.firstScreenTotalDuration) || 0, first_screen_details: o.firstScreenDetails || this._firstFrame.details || null, error_code: o.errorCode || 0, error_message: o.errorMessage || "", remux_process_type: (this._ctx.streamingMuxEnabled ? 1 : 0) + (d.gopRemux ? 1 : 0), hidden_start: this._hiddenStart ? 1 : 0, current_running_time: Math.round(performance.now() - o.startTime), running_time: Math.round(performance.now() - this._runningStartTime), smooth_bitrate: o.smoothBitrate, start_bitrate: o.startBitrate || 0, abr: this._ctx.config.adaptive ? 1 : 0, pause_cnt: o.pauseCnt, preload_cnt: o.preloadCount, traffic_vcodec: A.trafficGroupedByVCodecType, traffic_level: A.trafficGroupedByLevel, decoded_video_frames: o.decodedFrames || 0, dropped_video_frames: o.droppedFrames || 0, pause_duration: c.pause, seek_cnt: o.seekCnt, seek_duration: o.seekDuration, seek_load_cnt: o.seekLoadCnt, seek_load_duration: o.seekLoadDuration, start_sec: d.isLive ? 0 : Math.round(this._ctx.config.startFromSec || 0), on_line_change: o.onLineChange, visibility_change: o.visibilityChange, heartbeat_timeout: o.heartbeatTimeout, load_cnt: o.loadCnt, refresh_cnt: o.refreshCnt };
      return Q.version && (f.browser_name = Q.name || "", f.browser_major = Q.version.major || 0), d.retryInfo.hasData && (f.retry_record = d.retryInfo.mergedBeacon, f.retry_cnt = d.retryInfo.retryCount), u()(f, Xi(), qr(this._ctx, o), Qr((n = this._ctx.loadRec.currentLoad) == null ? void 0 : n.mediaInfo), Zr(this._ctx), Jr(this._ctx), Xr()), d.coreType === b.mse && this._ctx.mse && (f.mse_buffer_full = this._ctx.mse.stat.mseBufferFull, f.mse_remove = this._ctx.mse.stat.mseRemove, f.key_frame_cnt = o.keyFrame, d.box === _.mp4 && (f.mp4_moov_size = o.mp4MoovSize, o.mp4FastStart !== void 0 && (f.mp4_fast_start = o.mp4FastStart ? 0 : 1))), o.fillA && (f.fill_a = o.fillA), o.fillV && (f.fill_v = o.fillV), ke(d.box) && (f.unknown_ts_packet_count = o.unknownTSPacketCount, f.audio_non_monotonous = o.audioNonMonotonous, f.aac_overhead = o.aacOverhead), typeof o.decLibLoadDuration == "number" && (f.dec_lib_load_duration = Math.round(o.decLibLoadDuration), f.dec_lib_hit = o.decLibCacheHit ? 1 : 0), f;
    } }]), s;
  }(Er), re = "kernel", an = function() {
    function r(i, n) {
      var o, c = this;
      this._video = void 0, this._ctx = void 0, this._monitor = void 0, this._error = void 0, this._evt = new v.EventEmitter(), this._avcore = void 0, C.loadLogLevel(), C.level !== Ae.NONE && (o = et.version, Q.msie || console.log("%c kwai-player-kernel %c " + o + " %c", "background:#35495e ; padding: 1px; border-radius: 4px 0 0 4px;  color: #fff", "background:#ffa483 ; padding: 1px; border-radius: 0 4px 4px 0;  color: #fff", "background:transparent")), C.i(re, et.packName + ", " + et.version + " build: " + et.buildTime + " cors: " + (i == null ? void 0 : i.crossOrigin) + " autoplay: " + (i == null ? void 0 : i.autoplay), n), this._video = i, this._ctx = new et(n || {}, this._video), this._ctx.cOutput.setVideo(i), this._ctx.config || setTimeout(function() {
        c._onError({ type: ft.OTHER_ERROR, details: ve.CONFIG_ERROR, fatal: !0, reason: "config data error" });
      }, 0), this._monitor = this._initLogger(), this._ctx.config.src && (this._avcore = this._initAVCore()), C.i(re, "config", this._ctx.config), et.instanceCount++;
    }
    r.isSupport = function(i) {
      if (_.webrtc === (i == null ? void 0 : i.box))
        return X.isWebRTCSupported();
      if (i != null && i.nativeFirst)
        return X.isVideoBoxSupported(i == null ? void 0 : i.box);
      var n = X.isSupported();
      if (n) {
        var o = !0;
        i && (o = !(!i.isLive || i.box !== _.flv));
        var c = !o || ut.isStreamingSupported();
        return n && !!c;
      }
      return X.isVideoBoxSupported(i == null ? void 0 : i.box);
    }, r.videoCodecCapabilities = function(i) {
      return X.getVideoCodecCompatibilityByCodec(i);
    };
    var s = r.prototype;
    return s.on = function(i, n) {
      C.i(re, "call on " + i), this._evt.on(i, n);
    }, s.once = function(i, n) {
      C.i(re, "call once " + i), this._evt.once(i, n);
    }, s.removeAllListeners = function(i) {
      C.i(re, "call removeAllListeners"), this._evt.removeAllListeners(i);
    }, s.off = function(i, n) {
      C.i(re, "call off " + i), this._evt.off(i, n);
    }, s.listeners = function(i) {
      return this._evt.listeners(i);
    }, s.emit = function(i, n) {
      return this._evt.emit(i, n);
    }, s.listenerCount = function(i) {
      return this._evt.listenerCount(i);
    }, s.load = function(i, n) {
      var o, c = this;
      if (C.i(re, "call kernel load", i), i && this._ctx.setSrc(i), this._ctx.src) {
        var d, A;
        r.isSupport({ box: this._ctx.stat.box, isLive: this._ctx.stat.isLive, nativeFirst: this._ctx.stat.native }) || setTimeout(function() {
          c._onError({ type: ft.OTHER_ERROR, details: ve.UNSUPPORTED, fatal: !0, reason: "unsupported: " + c._ctx.stat.box + " live: " + c._ctx.stat.isLive + " native: " + c._ctx.stat.native });
        }, 0), typeof (n == null ? void 0 : n.startFromSec) == "number" ? this._ctx.stat.startFromSec = n.startFromSec : i && (this._ctx.stat.startFromSec = -1), this._ctx.stat.multipart && this._ctx.config.resourceBuffer && ci(this._ctx.config.resourceBufferSize), i && ((o = this._avcore) == null ? void 0 : o.type) !== ((A = this._ctx).stat.box === _.webrtc ? b.rtc : A.stat.native ? b.native : b.mse) && ((d = this._avcore) == null || d.destroy(), this._avcore = void 0), this._load();
      } else
        this._onError({ type: ft.OTHER_ERROR, details: ve.SRC_EMPTY, fatal: !0, reason: "url empty" });
    }, s.getTimeNow = function() {
      return Wt.serverNowMs;
    }, s.setAvailableAbrLevels = function(i) {
      C.i(re, "setAvailableAbrLevels", i), this._ctx.lctx.availableList = i.splice(0), this._avcore && "onAbrLevelsUpdated" in this._avcore && this._avcore.onAbrLevelsUpdated();
    }, s.preload = function(i, n) {
      C.i(re, "call preload"), this._avcore && "preload" in this._avcore && this._avcore.preload(i, n);
    }, s.isTimeinBuffered = function(i) {
      return this._ctx.stat.box !== _.webrtc && this._ctx.isTimeinBuffered(i);
    }, s.resume = function() {
      var i;
      C.i(re, "call resume"), (i = this._avcore) == null || i.resume(), this._video.paused && this._video.play();
    }, s.destroy = function() {
      var i, n;
      C.i(re, "call kernel destroy"), et.instanceCount--, performance.removeEventListener && performance.removeEventListener("resourcetimingbufferfull", vr), this._ctx.destroy(), (i = this._avcore) == null || i.destroy(), (n = this._monitor) == null || n.destroy(), this.removeAllListeners();
    }, s.refresh = function() {
      var i;
      C.i(re, "call kernel refresh"), this._monitor.onRefresh(), this._error = void 0, this._ctx.cOutput.reset(), (i = this._avcore) == null || i.refresh();
    }, s.stopLoad = function() {
      var i;
      C.i(re, "call kernel stopLoad"), (i = this._avcore) == null || i.stopLoad();
    }, s.getStreamTime = function(i) {
      var n = this._ctx.getStreamTime(i / 1e3);
      return n ? 1e3 * n : NaN;
    }, s.getAudienceStat = function() {
      return this._monitor.audienceStat;
    }, s.getMediaInfo = function() {
      var i;
      return u()({}, (i = this._ctx.loadRec.currentLoad) == null ? void 0 : i.mediaInfo);
    }, s.experiment = function(i) {
      C.i(re, "experiment", i);
    }, s.liveEnd = function() {
      C.i(re, "call liveEnd"), this._avcore && "liveEnd" in this._avcore && this._avcore.liveEnd();
    }, s.seekToNextFrame = function() {
      C.i(re, "call seekToNextFrame"), this._avcore && "seekToNextFrame" in this._avcore ? this._avcore.seekToNextFrame() : this._unsupportFrameSeek();
    }, s.seekToPrevFrame = function() {
      C.i(re, "call seekToPrevFrame"), this._avcore && "seekToPrevFrame" in this._avcore ? this._avcore.seekToPrevFrame() : this._unsupportFrameSeek();
    }, s.seekByFrameIndex = function(i) {
      if (C.i(re, "call seekByFrameIndex", i), this._avcore && "setCurretVideoFrame" in this._avcore)
        return this._avcore.setCurretVideoFrame(i);
      this._unsupportFrameSeek();
    }, s.bindVPP = function(i) {
      return C.i(re, "bind vpp. config.mainThreadRendering: " + this._ctx.stat.mainThreadRendering), this._ctx.stat.mainThreadRendering !== !1 ? (this._ctx.cOutput.bindVPP(i) && this._rendererChanged(), !0) : (C.w(re, "offscreen causes binding failure. set config.mainThreadRendering=true or bindVpp before play."), !1);
    }, s.unbindVPP = function(i) {
      this._ctx.cOutput.unbindVPP(i) && this._rendererChanged();
    }, s.jumpToLiveTime = function(i) {
      C.i(re, "call jumpToLiveTime", i), this._avcore && "jumpToLiveTime" in this._avcore && this._avcore.jumpToLiveTime(i) && this._monitor.onLiveShift(i);
    }, s._load = function(i) {
      this._error = void 0, this._avcore || (this._avcore = this._initAVCore()), this._avcore && (this._avcore.load(i), this._ctx.stat.coreType = this._avcore.type);
    }, s._initAVCore = function() {
      var i = this, n = this._ctx, o = function(c) {
        return c.stat.native ? new uo(c) : c.stat.box !== _.webrtc && Ee.a || c.stat.box === _.webrtc && Ee.a ? new Ee.a(c) : void 0;
      }(n);
      if (o)
        return n.stat.coreType = o.type, o.on(S.ERROR, function(c) {
          i._onError(c);
        }), o.on(S.MANIFEST_PARSED, function() {
          var c = { levels: n.lctx.levels.map(function(f) {
            return f.getKLevel();
          }), currentLevel: n.lctx.currentIdx, auto: n.lctx.abr };
          c.levels = n.lctx.levels.map(function(f) {
            return f.getKLevel();
          });
          var d = n.lctx.audioTracks;
          d && d.length && (c.audioTrack = n.lctx.audioIdx, c.audioTracks = d.map(function(f) {
            return { lang: f.lang, qualityLabel: f.qualityLabel, qualityType: f.qualityType, bitrate: f.bitrate, groupId: f.groupId };
          }));
          var A = n.lctx.subtitleTracks;
          A && A.length && (c.subtitleTrack = n.lctx.subtitleIdx, c.subtitleTracks = A.map(function(f) {
            return { lang: f.lang, name: f.name, groupId: f.groupId };
          })), c.currentLevel = n.lctx.currentIdx, c.auto = n.lctx.abr, c.isLive = n.stat.isLive, n.stat.stereoType !== void 0 && (c.stereoType = n.stat.stereoType), i._monitor.onManifestParsed(c), i.emit(S.MANIFEST_PARSED, c);
        }), o.on(S.LEVEL_SWITCHING, function(c) {
          i._monitor.onLevelSwitching(c), i.emit(S.LEVEL_SWITCHING, c);
        }), o.on(S.LEVEL_SWITCHED, function(c) {
          i._monitor.onLevelSwitched(), i.emit(S.LEVEL_SWITCHED, c);
        }), o.on(S.LEVEL_SWITCH_PLAYING, function(c) {
          i._monitor.onLevelSwitchPlaying(), i.emit(S.LEVEL_SWITCH_PLAYING, c);
        }), o.on(S.AUDIO_TRACK_SWITCHING, function(c) {
          i._monitor.onAudioTrackSwitching(), i.emit(S.AUDIO_TRACK_SWITCHING, c);
        }), o.on(S.AUDIO_TRACK_SWITCHED, function(c) {
          i._monitor.onAudioTrackSwitched(), i.emit(S.AUDIO_TRACK_SWITCHED, c);
        }), o.on(S.LEVEL_SWITCH_FAILED, function() {
          return i.emit(S.LEVEL_SWITCH_FAILED);
        }), o.on(S.STOP_LOAD, function() {
          return i._monitor.onStopLoad();
        }), o.on(S.LOAD_END, function() {
          return i.emit(S.LOAD_END);
        }), o.on(S.LEVEL_UPDATED, function(c) {
          i._monitor.onLevelUpdated(c), i.emit(S.LEVEL_UPDATED, c);
        }), o.on(S.AUDIO_TRACK_UPDATED, function(c) {
          i._monitor.onAudioTrackUpdated(), i.emit(S.AUDIO_TRACK_UPDATED, c);
        }), o.on(S.SUBTITLE_TRACK_SWITCHED, function(c) {
          i.emit(S.SUBTITLE_TRACK_SWITCHED, c);
        }), o.on(S.PRELOAD_COMPLETE, function() {
          i._monitor.onPreloadComplete();
        }), o.on(S.VIDEO_RENDERER_CHANGE, function(c) {
          i._rendererChanged(c);
        }), o.on(S.DEC_LIB_LOADED, function(c) {
          i._monitor.onDecLibLoaded(c);
        }), o.on(S.LOAD, function(c) {
          i._monitor.onLoad(c), c.type === M.retry && (i._error = void 0);
        }), o.on(S.PRIV_NAL, function(c) {
          return i._monitor.onPrivNal(c);
        }), o.on(S.SEI, function(c) {
          return i._monitor.onSei(c);
        }), o.on(S.AAC_PRIV, function(c) {
          return i._monitor.onAacPriv(c);
        }), o.on(S.PARSING_DATA, function(c) {
          return i._monitor.onParsingData(c);
        }), o.on(S.WAITING, function(c) {
          return i._monitor.onWaiting(c);
        }), o.on(S.LOADEDMETADATA, function() {
          return i._monitor.onLoadedmetadata();
        }), o.on(S.LOADEDDATA, function() {
          return i._monitor.onLoadeddata();
        }), o.on(S.CANPLAY, function() {
          return i._monitor.onCanplay();
        }), o.on(S.SEEKING, function(c) {
          return i._monitor.onSeeking(c);
        }), o.on(S.SEEKED, function() {
          return i._monitor.onSeeked();
        }), o.on(S.SEEK_WITH_LOAD, function() {
          return i._monitor.onSeekWithLoad();
        }), o.on(S.PLAYING, function() {
          return i._monitor.onPlaying();
        }), o.on(S.PAUSE, function() {
          return i._monitor.onPause();
        }), o.on(S.PLAY, function() {
          return i._monitor.onPlay();
        }), o.on(S.ENDED, function() {
          return i._monitor.onEnded();
        }), o.on(S.RATE_CHANGE, function() {
          return i._monitor.onRatechange();
        }), o.on(S.MEDIA_INFO, function(c) {
          return i._monitor.onMediaInfo(c);
        }), o.on(S.TIMEUPDATE, function() {
          return i._monitor.onTimeupdate();
        }), o.on(S.PROGRESS, function() {
          return i._monitor.onProgress();
        }), o.on(S.HEARTBEAT, function() {
          return i._monitor.onHeartbeat();
        }), o.on(S.LOADER_CHUNK_ARRIVAL, function(c) {
          return i._monitor.onLoaderChunkArrival(c);
        }), o.on(S.MEDIA_DEMUX, function() {
          return i._monitor.onMediaDemux();
        }), o.on(S.MEDIA_CONNECTED, function(c) {
          return i._monitor.onMediaConnected(c);
        }), o.on(S.KEY_FRAME, function(c) {
          return i._monitor.onKeyFrame(c);
        }), o.on(S.NEW_SOURCE, function(c) {
          return i._monitor.onNewSource(c);
        }), o.on(S.DISCONTINUITY, function(c) {
          return i._monitor.onDiscontinuity(c);
        }), o.on(S.METADATA, function(c) {
          return i._monitor.onMetadata(c);
        }), o.on(S.DOWNLOAD, function(c) {
          return i._monitor.onDownload(c);
        }), o.on(S.FALLBACK_H264, function(c) {
          C.i(re, "fallback h264"), n.canCodecFallback && (n.stat.fallback264 = !0, n.reProcessSrc(p.h264), i._recover(c.type, c.message, n.stat.coreType), X.playHEVCTest === void 0 && (C.i(re, "play hevc test start"), n.hevcTest.start()));
        }), o.on(S.RETRY, function(c) {
          return i._recodeRetry(c.type, c.message, n.stat.coreType, c.code);
        }), o;
    }, s._initLogger = function() {
      var i = this, n = new Fo(this._ctx);
      return n.on(S.REPORT, function(o) {
        i.emit(S.REPORT, o);
      }), n;
    }, s._recover = function(i, n, o, c) {
      var d, A;
      C.i(re, "recover: " + i + " native:" + this._ctx.stat.native), this._recodeRetry(i, n, o, c), (d = this._avcore) == null || d.destroy(), this._avcore = void 0, this._ctx.stat.native = o !== b.mse, this._load(M.retry), (A = this._video.play()) == null || A.catch(function(f) {
        return C.i(re, "recover, call play() fail.", f);
      });
    }, s._recodeRetry = function(i, n, o, c) {
      var d, A, f = { type: i, code: c, core: o, message: n, pos: Math.floor(this._video.currentTime), ts: Math.floor(performance.now()) };
      (d = this._avcore) != null && d.type && (f.change = ((A = this._avcore) == null ? void 0 : A.type) !== o), this._ctx.stat.retryInfo.append(f), this._monitor.onRetry(f);
    }, s._onError = function(i) {
      C.i(re, "on error", i);
      var n = this._ctx;
      if (i.fatal && (n.stat.coreType === b.mse || n.stat.coreType === b.native)) {
        if (!n.stat.retryInfo.hasChangeCore && !n.stat.native) {
          if (i.details === ve.DEMUX_NOT_FOUND)
            return C.i(re, "demux not found. switch to native"), void this._recover(I.REMUX, "demux not found", b.native);
          if (n.stat.box === _.mp4 && n.stat.decoder === R.buildin && (i.details === ve.SOURCEBUFFER_ERROR || i.details === ve.MEDIASOURCE_ERROR || i.details === ve.ADDSOURCEBUFFER_ERROR))
            return C.i(re, "mse error. switch to native", n.stat.box), void this._recover(I.MSE, i.reason, b.native);
        }
        if (!n.stat.retryInfo.hasChangeCore && n.stat.native && i.statusCode !== 0 && X.isMSEAvailable()) {
          var o = "box: " + n.stat.box + " native startup failed. switch to mse";
          return C.i(re, o), void this._recover(I.NATIVE, o, b.mse);
        }
        if (n.nextMediaDesc())
          return void this._recover(I.NEXT_MEDIA_DESC, "use next media description.", n.config.nativeFirst ? b.native : b.mse);
      }
      var c = u()({ code: 0 }, i);
      if (c.details === ve.MANIFEST_PARSING_ERROR)
        try {
          Wr.isSrcEmpty(this._ctx.src) && (C.i(re, "src empty", this._ctx.src), c.details = ve.SRC_EMPTY), n.src ? typeof n.src == "string" ? c.reason += "src str:" + n.src.slice(0, 1024) : n.src instanceof Blob ? c.reason += "src: blob" : c.reason += "src other:" + JSON.stringify(n.src).slice(0, 1024) : c.reason += "src:" + n.src;
        } catch (A) {
          c.reason += A.message;
        }
      if (c.fatal) {
        var d = kt(c.details, c.reason, c.statusCode || 0);
        if (this._monitor.onError(d, c.reason), this.stopLoad(), c.code = d, !this._error) {
          this._error = c.details;
          try {
            this.emit(S.ERROR, c);
          } catch (A) {
          }
        }
      }
    }, s._rendererChanged = function(i) {
      var n = this._ctx.cOutput;
      i === void 0 && (i = { enabled: !0, type: n.rendererType, canvas: n.rendererType === y.canvas && n.canvas ? n.canvas : void 0 }), C.i(re, "video renderer change", i), this.emit(S.VIDEO_RENDERER_CHANGE, i), i.canvas && this.emit(S.H265_DETECTED, { canvas: i.canvas, message: "", enabled: i.enabled, decoder: R.wasm });
    }, s._unsupportFrameSeek = function() {
      this._onError({ type: ft.MEDIA_ERROR, details: ve.CANNOT_SEEK_BY_FRAME_INDEX, fatal: !1, reason: "unsupported" });
    }, E()(r, [{ key: "liveShiftType", get: function() {
      return this._ctx.stat.liveShiftType;
    } }, { key: "liveShift", get: function() {
      return this._ctx.stat.liveShift;
    } }, { key: "currentVideoFrame", get: function() {
      return this._avcore && "getCurrentVideoFrame" in this._avcore ? this._avcore.getCurrentVideoFrame() : 0;
    }, set: function(i) {
      C.i(re, "call set currentVideoFrame", i), this._avcore && "setCurretVideoFrame" in this._avcore && this._avcore.setCurretVideoFrame(i);
    } }, { key: "totalVideoFrames", get: function() {
      return this._avcore && "getTotalVideoFrames" in this._avcore ? this._avcore.getTotalVideoFrames() : 0;
    } }, { key: "audioTrack", get: function() {
      return this._ctx.lctx.audioIdx || 0;
    }, set: function(i) {
      var n;
      C.i(re, "call set audioTrack", i), this._avcore && "setAudioTrack" in this._avcore && ((n = this._avcore) == null || n.setAudioTrack(i));
    } }, { key: "subtitleTrack", get: function() {
      return this._ctx.lctx.subtitleIdx || 0;
    }, set: function(i) {
      var n;
      C.i(re, "call set subtitleTrack", i), this._avcore && "setSubtitleTrack" in this._avcore && ((n = this._avcore) == null || n.setSubtitleTrack(i));
    } }, { key: "currentLevel", get: function() {
      return this._ctx.lctx.currentIdx || 0;
    }, set: function(i) {
      var n;
      C.i(re, "call set currentLevel", i), this._avcore && "setCurrentLevel" in this._avcore && ((n = this._avcore) == null || n.setCurrentLevel(i));
    } }, { key: "nextLevel", get: function() {
      return this._ctx.lctx.nextIdx || 0;
    }, set: function(i) {
      var n;
      C.i(re, "call set nextLevel", i), this._avcore && "setNextLevel" in this._avcore && ((n = this._avcore) == null || n.setNextLevel(i));
    } }, { key: "startLevel", get: function() {
      return this._ctx.lctx.startIdx || 0;
    }, set: function(i) {
      C.i(re, "call set startLevel", i), this._ctx.lctx.startIdx = i;
    } }, { key: "autoLevelEnabled", get: function() {
      return this._ctx.lctx.abr;
    } }, { key: "monitorData", get: function() {
      return this._monitor && this._avcore ? u()(this._monitor.snapshot, { trackBufInfo: this._avcore.getTrackBufInfo() }) : null;
    } }, { key: "currentLevelTimeInfo", get: function() {
      var i = this._ctx.lctx.current;
      if (i && i.timeInfo)
        return i.timeInfo;
    } }], [{ key: "version", get: function() {
      return et.version;
    } }, { key: "buildTime", get: function() {
      return et.buildTime;
    } }, { key: "MediaBox", get: function() {
      return _;
    } }, { key: "Events", get: function() {
      return { REPORT: S.REPORT, ERROR: S.ERROR, LEVEL_SWITCHING: S.LEVEL_SWITCHING, LEVEL_SWITCHED: S.LEVEL_SWITCHED, LEVEL_SWITCH_PLAYING: S.LEVEL_SWITCH_PLAYING, LEVEL_SWITCH_FAILED: S.LEVEL_SWITCH_FAILED, AUDIO_TRACK_SWITCHING: S.AUDIO_TRACK_SWITCHING, AUDIO_TRACK_SWITCHED: S.AUDIO_TRACK_SWITCHED, AUDIO_TRACK_UPDATED: S.AUDIO_TRACK_UPDATED, SUBTITLE_TRACK_SWITCHED: S.SUBTITLE_TRACK_SWITCHED, MANIFEST_PARSED: S.MANIFEST_PARSED, LEVEL_UPDATED: S.LEVEL_UPDATED, LOAD_END: S.LOAD_END, VIDEO_RENDERER_CHANGE: S.VIDEO_RENDERER_CHANGE };
    } }, { key: "Reports", get: function() {
      return u()({}, je);
    } }]), r;
  }();
  function Bo(r, s) {
    return Rt() ? void 0 : new an(r, s);
  }
}]);
xe === void 0 && console.error("esm-webpack-plugin: nothing exported!");
const Hs = xe.default;
xe.createKernel;
xe.CodecType;
xe.Decoder;
xe.DemuxerType;
xe.DownloadStatus;
xe.HttpRangeType;
const ot = xe.KEvents;
xe.LogLevel;
const Mt = xe.LiveShiftType;
xe.MediaBox;
xe.ReportTypes;
xe.StereoType;
xe.VideoDecBlockPolicy;
xe.VideoDropFramePolicy;
xe.VideoRendererType;
xe.WasmDecoder;
xe.EventReportTypes;
const wt = {
  "kwai-player": "_kwai-player_uxc1a_2",
  "kwai-player-video-interactive": "_kwai-player-video-interactive_uxc1a_11",
  "kwai-player-poster": "_kwai-player-poster_uxc1a_19",
  "kwai-player-video": "_kwai-player-video_uxc1a_11",
  "kwai-player-disable-scroll": "_kwai-player-disable-scroll_uxc1a_50"
};
var ta = /* @__PURE__ */ ((e) => (e[e.CTOR_ERROR = 1e4] = "CTOR_ERROR", e))(ta || {});
const Vs = "https://ntp.nc.gifshow.com/", ai = {
  local: 0,
  server: 0
};
function sr() {
  return ai.server ? performance.now() - ai.local + ai.server : Date.now();
}
const vn = "ntp";
class Gs {
  constructor() {
    F(this, "_xhr");
  }
  load() {
    this._disposeLoader();
    const t = this._xhr = new XMLHttpRequest(), a = performance.now();
    t.open("GET", Vs, !0), t.responseType = "text", t.timeout = 5e3, t.ontimeout = t.onerror = () => {
      w.i(vn, "load error");
    }, t.onload = () => {
      if (t.status < 200 || t.status > 299)
        w.i(vn, `load error: ${t.status}`);
      else {
        this._disposeLoader(), t.responseText;
        {
          ai.local = performance.now();
          const l = t.responseText.split(",");
          ai.server = parseFloat(l[0]) * 1e3 + (performance.now() - a) / 2;
        }
      }
    }, t.send();
  }
  destroy() {
    this._disposeLoader();
  }
  _disposeLoader() {
    this._xhr && (this._xhr.onreadystatechange = null, this._xhr.onprogress = null, this._xhr.onload = null, this._xhr.onerror = null, this._xhr.abort(), this._xhr = void 0);
  }
}
function Ws(e, t, a) {
  if (typeof a == "number") {
    if (e === Mt.KWAI)
      return {
        time: a
      };
    if (e === Mt.GENERAL) {
      const l = a - (sr() - t.start);
      return {
        time: l,
        urlParams: {
          offset: l.toFixed(0)
        }
      };
    }
  }
}
const mn = typeof document > "u" ? void 0 : document.createElement("video");
function Ks() {
  return !!(mn != null && mn.requestPictureInPicture);
}
function zs(e) {
  const t = Be.browser.name;
  t && ["IE", "IEMobile"].indexOf(t) === -1 && console.log(
    `%c kwai-player %c ${e} %c`,
    "background:#35495e ; padding: 1px; border-radius: 4px 0 0 4px;  color: #fff",
    "background:#ffa483 ; padding: 1px; border-radius: 0 4px 4px 0;  color: #fff",
    "background:transparent"
  );
}
const $s = "fullscreen";
let Ys = class {
  constructor(t) {
    F(this, "_evt"), F(this, "_element"), F(this, "_isFillWindow", !1), F(this, "_originStyle"), F(this, "_isSupportFullscreen", !0), F(this, "_onFullscreenChange", () => {
      w.i($s, "_onFullscreenChange", this.isFull()), this.isFull() || (this._recoverStyle(), document.body.classList.remove(wt["kwai-player-disable-scroll"])), this._isFillWindow = !1, this._evt.emit("fullChange", {
        type: At.SYSTEM,
        isFull: this.isFull()
      });
    }), this._evt = t, !(typeof document > "u") && (this._isSupportFullscreen = typeof this._getExitFullscreenFunc() < "u" && !(Be.os.name === "iOS" && Be.device.type === "mobile"), "onfullscreenchange" in document ? (document.addEventListener("fullscreenchange", this._onFullscreenChange), document.addEventListener("fullscreenerror", this._onFullscreenChange)) : "onwebkitfullscreenchange" in document && (document.addEventListener("webkitfullscreenchange", this._onFullscreenChange), document.addEventListener("webkitfullscreenerror", this._onFullscreenChange)));
  }
  destroy() {
    document.removeEventListener("fullscreenchange", this._onFullscreenChange), document.removeEventListener("fullscreenerror", this._onFullscreenChange), document.removeEventListener("webkitfullscreenchange", this._onFullscreenChange), document.removeEventListener("webkitfullscreenerror", this._onFullscreenChange);
  }
  /**
   * 全屏或网页全屏
   * @param e 需要全屏的元素 
   */
  requestFull(t, a) {
    a === At.SYSTEM ? this.requestFullscreen(t) : a === At.WINDOW ? this.requestFillWindow(t) : this._isSupportFullscreen ? this.requestFullscreen(t) : this.requestFillWindow(t);
  }
  /**
   * 退出全屏或网页全屏
   */
  exitFull(t) {
    if (t === At.SYSTEM)
      return this.exitFullscreen();
    if (t === At.WINDOW)
      return this.exitFillWindow();
    this.isFull(At.SYSTEM) ? this.exitFullscreen() : this.exitFillWindow();
  }
  /**
   * 是否是全屏或网页全屏状态
   * @returns 全屏状态
   */
  isFull(t) {
    return t === At.SYSTEM ? this.isFullScreen() : t === At.WINDOW ? this.isFillWindow() : this.isFullScreen() || this.isFillWindow();
  }
  /**
   * 全屏
   * @param element 需要全屏的元素
   * @returns 
   */
  requestFullscreen(t) {
    this._element = t, this._originStyle || this._saveOriginStyle(t), (Be.os.name === "Mac OS" || Be.browser.name === "IE" || Be.os.name === "iOS" && Be.device.type !== "mobile") && (t.style.width = "100%", t.style.height = "100%", t.style.background = "black");
    const a = t;
    let l;
    a.requestFullscreen ? l = a.requestFullscreen() : a.mozRequestFullScreen ? l = a.mozRequestFullScreen() : a.webkitRequestFullScreen ? l = a.webkitRequestFullscreen() : a.msRequestFullscreen && (l = a.msRequestFullscreen()), typeof Promise < "u" && l instanceof Promise && l.catch((u) => w.e(u));
  }
  /**
   * 退出全屏
   */
  exitFullscreen() {
    this._recoverStyle(), this._element = void 0;
    const t = document;
    t.exitFullscreen ? t.exitFullscreen() : t.webkitCancelFullScreen ? t.webkitCancelFullScreen() : t.mozCancelFullScreen ? t.mozCancelFullScreen() : t.msExitFullscreen && t.msExitFullscreen();
  }
  /**
   * 当前是否是全屏状态
   * @returns 全屏状态
   */
  isFullScreen() {
    const t = document;
    return !!(t.fullscreen || t.fullscreenElement || t.isFullScreen || t.webkitIsFullScreen || t.mozFullScreen || t.msFullscreenElement);
  }
  /**
   * 网页全屏
   * @param element 需要全屏的元素
   * @returns 
   */
  requestFillWindow(t) {
    this._element = t, this._originStyle || this._saveOriginStyle(t), t.style.width = "100%", t.style.height = "100%", t.style.background = "black", t.style.position = "fixed", t.style.left = "0", t.style.top = "0", t.style.zIndex = "99999", document.body.classList.add(wt["kwai-player-disable-scroll"]), this._isFillWindow = !0, this._evt.emit("fullChange", {
      type: "window",
      isFull: !0
    });
  }
  /**
   * 退出网页全屏
   */
  exitFillWindow() {
    this._recoverStyle(), this._isFillWindow = !1, this._element && (this._element.style.zIndex = "auto"), this._element = void 0, document.body.classList.remove(wt["kwai-player-disable-scroll"]), this._evt.emit("fullChange", {
      type: "window",
      isFull: !1
    });
  }
  /**
   * 当前是否是网页全屏状态
   * @returns 网页全屏状态
   */
  isFillWindow() {
    return this._isFillWindow;
  }
  isFullscreenAvailable(t) {
    return t !== At.WINDOW && typeof document < "u" ? !!document.body.requestFullscreen || !!document.body.webkitRequestFullscreen || !!document.body.msRequestFullscreen || !!document.body.mozRequestFullscreen : !0;
  }
  _getExitFullscreenFunc() {
    const t = document;
    return t.exitFullscreen || t.webkitCancelFullScreen || t.mozCancelFullScreen || t.msExitFullscreen;
  }
  _saveOriginStyle(t) {
    this._originStyle = {
      position: t.style.position,
      background: t.style.background,
      width: t.style.width,
      height: t.style.height,
      left: t.style.left,
      right: t.style.right
    };
  }
  _recoverStyle() {
    if (this._element)
      for (const t in this._originStyle)
        this._element.style[t] = this._originStyle[t];
    this._originStyle = void 0;
  }
};
const js = "ControlsPlugin", qs = "I18nPlugin", Xs = "LoggerPlugin", Qs = "HotkeyPlugin", Zs = "PlayInfoPlugin", Js = "MirrorPlugin", el = "RotatePlugin", tl = "PreviewPlugin", il = "MaskPlugin", rl = "VRPlugin", nl = "DanmakuPlugin";
var al = /* @__PURE__ */ ((e) => (e.DARK = "dark", e.LIGHT = "light", e))(al || {}), ol = /* @__PURE__ */ ((e) => (e.BOTTOM = "bottom", e.PLAY_BAR = "playBar", e.NONE = "none", e))(ol || {});
let ze = class extends Mi {
  static isInstanceOfPlugin(t) {
    return typeof t.beforeInstall == "function" && typeof t.afterInstall == "function" && typeof t.beforeUninstall == "function" && typeof t.afterUninstall == "function" && typeof t.getLabel == "function";
  }
  /**
   * 播放器实例化前钩子
   * @param player 播放器实例
   * @param options 实例化播放器时指定的当前插件的参数
   */
  beforeInstall(t, a) {
  }
  /**
   * 播放器实例化后钩子
   * @param player 播放器实例
   * @param options 实例化播放器时指定的当前插件的参数
   */
  afterInstall(t, a) {
  }
  /**
   * 播放器销毁前钩子
   * @param player 播放器实例
   */
  beforeUninstall(t) {
  }
  /**
   * 播放器销毁后钩子
   * @param player 播放器实例
   */
  afterUninstall(t) {
  }
};
F(ze, "label"), /**
* 版本
*/
F(ze, "version"), /**
* 当前环境是否支持
*/
F(ze, "isSupported");
const ia = class extends ze {
  /**
   * @override
   */
  getLabel() {
    return ia.label;
  }
  beforeInstall(t, a) {
  }
  afterInstall(t, a) {
  }
};
let sl = ia;
F(sl, "label", js);
const ra = class extends ze {
  /**
   * @override
   */
  getLabel() {
    return ra.label;
  }
  beforeInstall(t, a) {
  }
  afterInstall(t, a) {
  }
};
let ll = ra;
F(ll, "label", qs);
const na = class extends ze {
  /**
   * @override
   */
  getLabel() {
    return na.label;
  }
  beforeInstall(t, a) {
  }
  afterInstall(t, a) {
  }
  /**
   * 增加业务相关数据
   * @param key 上报数据key
   * @param value 上报数据
   */
  addBizLog(t, a) {
  }
  appendSummaryField(t, a) {
  }
};
let cl = na;
F(cl, "label", Xs);
const aa = class extends ze {
  /**
   * @override
   */
  getLabel() {
    return aa.label;
  }
};
let ul = aa;
F(ul, "label", Qs);
const oa = class extends ze {
  /**
   * @override
   */
  getLabel() {
    return oa.label;
  }
};
let dl = oa;
F(dl, "label", Zs);
const sa = class extends ze {
  /**
   * @override
   */
  getLabel() {
    return sa.label;
  }
};
let hl = sa;
F(hl, "label", Js);
const la = class extends ze {
  /**
   * @override
   */
  getLabel() {
    return la.label;
  }
};
let _l = la;
F(_l, "label", el);
const ca = class extends ze {
  /**
   * @override
   */
  getLabel() {
    return ca.label;
  }
};
let pl = ca;
F(pl, "label", tl);
const ua = class extends ze {
  /**
   * @override
   */
  getLabel() {
    return ua.label;
  }
};
let fl = ua;
F(fl, "label", il);
const da = class extends ze {
  /**
   * @override
   */
  getLabel() {
    return da.label;
  }
};
let vl = da;
F(vl, "label", rl);
const ha = class extends ze {
  /**
   * @override
   */
  getLabel() {
    return ha.label;
  }
};
let ml = ha;
F(ml, "label", nl);
const Ve = "pluginBase", _a = class {
  constructor() {
    F(this, "_instances", []);
  }
  static register(e) {
    w.i(Ve, "register", e.label, e.version), e.label || w.i(Ve, "register plugin label is empty.");
    const t = this._plugins.findIndex((a) => a.label === e.label);
    t >= 0 && (w.i(Ve, `register plugin label: ${e.label} exists.`), this._plugins.splice(t, 1)), this._plugins.push(e);
  }
  static deregister(e) {
    w.i(Ve, "deregister", e.label);
    const t = this._plugins.indexOf(e);
    if (t === -1) {
      w.i(e.label + "plugin unregistered");
      return;
    }
    this._plugins.splice(t, 1);
  }
  initialize(e) {
    const t = this._instances;
    for (const a of _a._plugins)
      try {
        if (e && e[a.label] === !1)
          continue;
        if (a.isSupported === !1) {
          w.i(Ve, `initialize ${a.label}, ${a.version}. The current browser does not support this plugin.`);
          continue;
        }
        w.i(Ve, "initialize", a.label, a.version, e);
        const l = new a();
        ze.isInstanceOfPlugin(l) ? t.push(l) : w.e(Ve, `plugin type error: ${l}`);
      } catch (l) {
        w.e(Ve, "plugin initialize error", l);
      }
  }
  beforeInstallPlugins(e, t) {
    for (const a of this._instances) {
      const l = a.getLabel();
      w.i(Ve, "beforeInstallPlugins", t, l);
      try {
        if (!a.beforeInstall)
          continue;
        t && typeof t[l] == "object" ? a.beforeInstall(e, t[l]) : a.beforeInstall(e);
      } catch (u) {
        w.e(Ve, "beforeInstallPlugins error", u);
      }
    }
  }
  afterInstallPlugins(e, t) {
    for (const a of this._instances) {
      const l = a.getLabel();
      w.i(Ve, "afterInstallPlugins", l, t);
      try {
        if (!a.afterInstall)
          continue;
        t && typeof t[l] == "object" ? a.afterInstall(e, t[l]) : a.afterInstall(e);
      } catch (u) {
        w.e(Ve, "afterInstallPlugins error", u);
      }
    }
  }
  beforeUninstallPlugins(e) {
    for (const t of this._instances)
      try {
        if (w.i(Ve, "beforeUninstallPlugins", t.getLabel()), !t.beforeUninstall)
          continue;
        t.beforeUninstall.call(t, e);
      } catch (a) {
        w.e(Ve, "plugin beforeUninstall error", a);
      }
  }
  afterUninstallPlugins(e) {
    for (const t of this._instances)
      try {
        if (w.i(Ve, "afterUninstallPlugins", t.getLabel()), !t.afterUninstall)
          continue;
        t.afterUninstall.call(t, e);
      } catch (a) {
        w.e(Ve, "plugin afterUninstall error", a);
      }
    this._instances = [];
  }
  getPlugin(e) {
    for (let t = 0; t < this._instances.length; t++)
      if (this._instances[t].getLabel() === e)
        return this._instances[t];
  }
};
let Ei = _a;
F(Ei, "_plugins", []);
const yl = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==", z = "native", zt = class {
  constructor(t, a) {
    F(this, "_pluginBase", new Ei()), F(this, "_eventHandlers"), F(this, "_evt"), F(this, "_mainDom"), F(this, "_video"), F(this, "_kernel"), F(this, "_error"), F(this, "_config"), F(this, "_src", ""), F(this, "_autoplay", !1), F(this, "_preload", "none"), F(this, "_poster", ""), F(this, "_controls", "default"), F(this, "_videoWidth", 0), F(this, "_videoHeight", 0), F(this, "_kernelLoaded", !1), F(this, "_livePaused", !1), F(this, "_canvas"), F(this, "_mediaInfo"), F(this, "_isLiveShift", !1), F(this, "_full"), F(this, "_subContainerNumber", 0), F(this, "_data"), F(this, "_id"), F(this, "_videoLayer"), F(this, "_videoInteractiveLayer"), F(this, "_posterLayer"), F(this, "_preprocessSrcFunc"), F(this, "_preprocessURL"), F(this, "_kernelStartTimeout", 0), F(this, "_liveTimeHelper", new Gs()), F(this, "_liveOffset", 0), F(this, "requestFullscreen", (h) => {
      w.i(z, "requestFullscreen"), this._mainDom && (this._full.isFull(h) || this._full.requestFull(this._mainDom, h));
    }), F(this, "exitFullscreen", (h) => {
      w.i(z, "exitFullscreen"), this._mainDom && this._full.isFull(h) && this._full.exitFull(h);
    }), F(this, "_onFullscreenchange", (h) => {
      this._updateCanvasSize(h.isFull), this.emit(N.FULLSCREEN_CHANGE, h);
    }), F(this, "_onMutedChange", (h) => {
      this._video && (this._video.muted = h);
    }), F(this, "_onVideoLoadstart", () => {
      this.emit(N.LOADSTART);
    }), F(this, "_onVideoProgress", () => {
      this.emit(N.PROGRESS);
    }), F(this, "_onVideoSuspend", () => {
      this.emit(N.SUSPEND);
    }), F(this, "_onVideoAbort", () => {
      this.emit(N.ABORT);
    }), F(this, "_onVideoEmptied", () => {
      this.emit(N.EMPTIED);
    }), F(this, "_onVideoStalled", () => {
      this.emit(N.STALLED);
    }), F(this, "_onVideoLoadedmetadata", () => {
      this.emit(N.LOADEDMETADATA);
    }), F(this, "_onVideoLoadeddata", () => {
      this.emit(N.LOADEDDATA);
    }), F(this, "_onVideoCanplay", () => {
      this.emit(N.CANPLAY);
    }), F(this, "_onVideoCanplaythrough", () => {
      this.emit(N.CANPLAYTHROUGH);
    }), F(this, "_onVideoPlaying", () => {
      Be.os.name !== "iOS" && Be.os.name !== "Android" && this._hidePosterDom(), this.emit(N.PLAYING);
    }), F(this, "_onVideoWaiting", () => {
      this.emit(N.WAITING);
    }), F(this, "_onVideoSeeking", () => {
      this.emit(N.SEEKING);
    }), F(this, "_onVideoSeeked", () => {
      this.emit(N.SEEKED);
    }), F(this, "_onVideoEnded", () => {
      this.emit(N.ENDED);
    }), F(this, "_onVideoDurationchange", () => {
      this.emit(N.DURATIONCHANGE);
    }), F(this, "_onVideoTimeupdate", () => {
      var h, E;
      this._posterLayer.style.display !== "none" && ((h = this._video) == null ? void 0 : h.readyState) === 4 && !((E = this._video) != null && E.paused) && this._hidePosterDom(), this.emit(N.TIMEUPDATE);
    }), F(this, "_onVideoPlay", () => {
      this.emit(N.PLAY);
    }), F(this, "_onVideoPause", () => {
      this.emit(N.PAUSE);
    }), F(this, "_onVideoRatechange", () => {
      this.emit(N.RATECHANGE);
    }), F(this, "_onVideoResize", () => {
      this.emit(N.RESIZE);
    }), F(this, "_onVideoVolumechange", () => {
      this.emit(N.VOLUMECHANGE);
    }), F(this, "_onVideoEnterpictureinpicture", () => {
      this.emit(N.ENTER_PICTURE_IN_PICTURE);
    }), F(this, "_onVideoLeavepictureinpicture", () => {
      this.emit(N.LEAVE_PICTURE_IN_PICTURE);
    });
    var l;
    if ((w.ENABLE_VERBOSE || w.ENABLE_INFO || w.ENABLE_INFO || w.ENABLE_DEBUG) && zs(zt.packVersion), w.i(z, zt.packVersion, zt.version, t.toString(), a), this._data = a || {}, typeof t == "string" ? (this._id = t, this._mainDom = document.querySelector(t)) : (this._id = `kp_${Math.random() * 1e3 | 0}`, this._mainDom = t), this._evt = new Mi(), this._evt.setMaxListeners(30), this._full = new Ys(this._evt), this._evt.on("fullChange", this._onFullscreenchange), this._eventHandlers = {
      loadstart: this._onVideoLoadstart,
      progress: this._onVideoProgress,
      suspend: this._onVideoSuspend,
      abort: this._onVideoAbort,
      emptied: this._onVideoEmptied,
      stalled: this._onVideoStalled,
      loadedmetadata: this._onVideoLoadedmetadata,
      loadeddata: this._onVideoLoadeddata,
      canplay: this._onVideoCanplay,
      canplaythrough: this._onVideoCanplaythrough,
      playing: this._onVideoPlaying,
      waiting: this._onVideoWaiting,
      seeking: this._onVideoSeeking,
      seeked: this._onVideoSeeked,
      ended: this._onVideoEnded,
      durationchange: this._onVideoDurationchange,
      timeupdate: this._onVideoTimeupdate,
      play: this._onVideoPlay,
      pause: this._onVideoPause,
      ratechange: this._onVideoRatechange,
      resize: this._onVideoResize,
      volumechange: this._onVideoVolumechange,
      enterpictureinpicture: this._onVideoEnterpictureinpicture,
      leavepictureinpicture: this._onVideoLeavepictureinpicture
    }, a && typeof a.controls < "u" && (this.controls = a.controls), this._videoLayer = document.createElement("div"), this._videoLayer.className = wt["kwai-player-video"], this._posterLayer = document.createElement("div"), this._posterLayer.className = wt["kwai-player-poster"], this._posterLayer.dataset.kpRole = "poster", this._videoLayer.appendChild(this._posterLayer), this._videoInteractiveLayer = document.createElement("div"), this._videoInteractiveLayer.className = wt["kwai-player-video-interactive"], this._video = document.createElement("video"), !this._mainDom) {
      w.i(z, `container not found.${t}`), this._setError({ code: ta.CTOR_ERROR, message: `container not found.${t}` });
      return;
    }
    this._mainDom.className = this._mainDom.className ? `${this._mainDom.className} ${wt["kwai-player"]}` : wt["kwai-player"], this._mainDom.setAttribute("role", "player"), this._mainDom.appendChild(this._videoLayer), this._mainDom.appendChild(this._videoInteractiveLayer), this._video.controls = !1, this._videoLayer.appendChild(this.video), this._bindVideo(), this._pluginBase.initialize(a == null ? void 0 : a.plugins), this._pluginBase.beforeInstallPlugins(this, a == null ? void 0 : a.plugins), a && this._parseData(a);
    const u = ((l = this._config) == null ? void 0 : l.src) || this._src;
    u && this._initKernel("", !1), this._pluginBase.afterInstallPlugins(this, a == null ? void 0 : a.plugins), u && (this._kernelStartTimeout = setTimeout(() => {
      this._clearKernelStartTimer(), this._kernelStart();
    }, 0)), w.i(z, "constructor completed.");
  }
  static get version() {
    return "1.1.0";
  }
  /**
     * 获取版本号
     */
  get version() {
    return zt.version;
  }
  /**
     * 获取包版本号
     */
  get packVersion() {
    return zt.packVersion;
  }
  /**
     * 配置
    */
  get config() {
    return w.i(z, "call get config", this._config), this._config;
  }
  set config(t) {
    w.i(z, "call set config", t), this._config = t, this._initKernel(), this.emit(N.ATTRIBUTE_CHANGE_CONFIG, t);
  }
  /**
     * 获取当前错误
     */
  get error() {
    return w.i(z, "call get error", this._error), this._error;
  }
  /**
     * videoId
     */
  get videoId() {
    var t;
    return (t = this._data) == null ? void 0 : t.videoId;
  }
  set videoId(t) {
    this._data && (this._data.videoId = t, this.emit(N.ATTRIBUTE_CHANGE_VIDEO_ID));
  }
  /**
     * 设置预览图url
     */
  get previewUrl() {
    var t;
    return (t = this._data) == null ? void 0 : t.previewUrl;
  }
  set previewUrl(t) {
    w.i(z, "call set previewUrl", t), this._data && (this._data.previewUrl = t, this.emit(N.ATTRIBUTE_CHANGE_PREVIEW_URL));
  }
  /**
     * 设置弹幕防挡url
     */
  get maskUrl() {
    var t;
    return (t = this._data) == null ? void 0 : t.maskUrl;
  }
  set maskUrl(t) {
    w.i(z, "call set maskUrl", t), this._data && (this._data.maskUrl = t, this.emit(N.ATTRIBUTE_CHANGE_MASK_URL));
  }
  /**
     * 禁用弹幕
     */
  get disableMask() {
    var t;
    return (t = this._data) == null ? void 0 : t.disableMask;
  }
  set disableMask(t) {
    w.i(z, "call set disableMask", t), this._data && (this._data.disableMask = t, this.emit(N.ATTRIBUTE_CHANGE_DISABLE_MASK));
  }
  /**
     * 获取播放地址
     */
  get src() {
    return w.v(z, "call get src", this._src), this._src;
  }
  set src(t) {
    w.i(z, "call set src", t), this._src = this._preprocessSrcFunc ? this._preprocessSrcFunc(t) : t, this.emit(N.ATTRIBUTE_CHANGE_SRC), this._initKernel();
  }
  /**
     * 获取当前是否时移回放
    */
  get isLiveShift() {
    return this._isLiveShift;
  }
  set liveShiftType(t) {
    w.i(z, "call set liveShiftType", t), this._data && (this._data.liveShiftType = t, this.emit(N.LIVE_SHIFT_TYPE_CHANGE));
  }
  /**
     * 直播时移类型
     */
  get liveShiftType() {
    var t;
    return ((t = this._data) == null ? void 0 : t.liveShiftType) || Mt.NONE;
  }
  set crossOrigin(t) {
    w.i(z, "call set crossOrigin", t), this._video && (this._video.crossOrigin = t), this.emit(N.ATTRIBUTE_CHANGE_CROSS_ORIGIN);
  }
  /**
     * 跨域配置
     */
  get crossOrigin() {
    var t;
    return w.v(z, "call get crossOrigin", (t = this._video) == null ? void 0 : t.crossOrigin), this._video ? this._video.crossOrigin : null;
  }
  /**
     * 网络状态
     */
  get networkState() {
    var t;
    return w.v(z, "call get networkState", (t = this._video) == null ? void 0 : t.networkState), this._video ? this._video.networkState : 0;
  }
  /**
     * 预加载配置
     */
  get preload() {
    return w.v(z, "call get preload", this._preload), this._preload;
  }
  set preload(t) {
    w.i(z, "call set preload", t), this._preload = t, this._video.preload = t, this.emit(N.ATTRIBUTE_CHANGE_PRELOAD);
  }
  /**
     * 获取预加载配置
     */
  get buffered() {
    var t, a;
    return w.v(z, "call get buffered", (t = this._video) == null ? void 0 : t.buffered), (a = this._video) == null ? void 0 : a.buffered;
  }
  /**
     * 获取video元素readyState
     */
  get readyState() {
    var t;
    return w.v(z, "call get readyState", (t = this._video) == null ? void 0 : t.readyState), this._video ? this._video.readyState : 0;
  }
  /**
     * 获取video元素seeking状态
     */
  get seeking() {
    var t, a;
    return w.v(z, "call get seeking", (t = this._video) == null ? void 0 : t.seeking), !!((a = this._video) != null && a.seeking);
  }
  /**
     * 获取video播放时间
     */
  get currentTime() {
    var t, a, l;
    return w.v(z, "call get currentTime", (t = this._video) == null ? void 0 : t.currentTime), ((a = this._data) == null ? void 0 : a.liveShiftType) === Mt.GENERAL && (l = this._data) != null && l.liveTime ? (sr() - this._data.liveTime.start + this._liveOffset) / 1e3 : this._video ? this._video.currentTime : 0;
  }
  set currentTime(t) {
    w.i(z, "call set currentTime", t), this._video && (this._video.currentTime = t), this.emit(N.ATTRIBUTE_CHANGE_CURRENT_TIME);
  }
  /**
     * 获取video时长
     */
  get duration() {
    var t, a, l;
    if (w.v(z, "call get duration", (t = this._video) == null ? void 0 : t.duration), ((a = this._data) == null ? void 0 : a.liveShiftType) === Mt.GENERAL && (l = this._data) != null && l.liveTime) {
      const u = sr();
      return ((this._data.liveTime.end || u) - this._data.liveTime.start) / 1e3;
    }
    return this._video ? this._video.duration : NaN;
  }
  /**
     * 获取暂停状态
     */
  get paused() {
    var t;
    return w.v(z, "call get paused", (t = this._video) == null ? void 0 : t.paused), this._video ? this._video.paused : !0;
  }
  /**
     * 获取默认倍速
     */
  get defaultPlaybackRate() {
    var t;
    return w.v(z, "call get defaultPlaybackRate", (t = this._video) == null ? void 0 : t.defaultPlaybackRate), this._video ? this._video.defaultPlaybackRate : 1;
  }
  set defaultPlaybackRate(t) {
    w.i(z, "call set defaultPlaybackRate", t), this._video && (this._video.defaultPlaybackRate = t), this.emit(N.ATTRIBUTE_CHANGE_DEFAULT_PLAYBACK_RATE);
  }
  /**
     * 获取当前倍速
     */
  get playbackRate() {
    return this._video ? this._video.playbackRate : 1;
  }
  set playbackRate(t) {
    w.i(z, "call set playbackRate", t), this._video && (this._video.playbackRate = t), this.emit(N.ATTRIBUTE_CHANGE_PLAYBACK_RATE);
  }
  /**
     * 获取是否播放
     */
  get played() {
    var t;
    return (t = this._video) == null ? void 0 : t.played;
  }
  /**
     * 获取是否可以seek
     */
  get seekable() {
    var t;
    return (t = this._video) == null ? void 0 : t.seekable;
  }
  /**
     * 获取是否播放完成
     */
  get ended() {
    return this._video ? this._video.ended : !1;
  }
  /**
     * 获取是否自动播放
     */
  get autoplay() {
    return this._autoplay;
  }
  set autoplay(t) {
    w.i(z, "call set autoplay", t), this._autoplay = t, this.emit(N.ATTRIBUTE_CHANGE_AUTOPLAY);
  }
  /**
     * 获取是否循环播放
     */
  get loop() {
    return this._video ? this._video.loop : !1;
  }
  set loop(t) {
    w.i(z, "call set loop", t), this._video && (this._video.loop = t), this.emit(N.ATTRIBUTE_CHANGE_LOOP);
  }
  /**
     * 获取是否显示控制条
     */
  get controls() {
    return this._controls;
  }
  set controls(t) {
    w.i(z, "call set controls", t), t !== this._controls && (this._controls = t), this.emit(N.ATTRIBUTE_CHANGE_CONTROLS);
  }
  /**
     * 音量
     */
  get volume() {
    return this._video ? this._video.volume : 1;
  }
  set volume(t) {
    this._video && (this._video.volume = t < 0 ? 0 : t > 1 ? 1 : t, this.emit(N.ATTRIBUTE_CHANGE_VOLUME));
  }
  /**
     * 获取静音状态
    */
  get muted() {
    return this._video ? this._video.muted : !1;
  }
  set muted(t) {
    w.i(z, `call set muted: ${t}, hasVideo: ${!!this._video}`), this._video && (this._video.muted = t, this.emit(N.ATTRIBUTE_CHANGE_MUTED));
  }
  /**
     * 获取默认静音状态
     */
  get defaultMuted() {
    return this._video ? this._video.defaultMuted : !1;
  }
  set defaultMuted(t) {
    w.i(z, "call set defaultMuted", t), this._video && (this._video.defaultMuted = t, this.emit(N.ATTRIBUTE_CHANGE_DEFAULT_MUTED));
  }
  // public set width(val: number | string) {
  //     this._width = val;
  // }
  // public set height(val: number | string) {
  //     this._height = val;
  // }
  /**
     * 获取视频宽
     */
  get videoWidth() {
    var t;
    return this._videoWidth || ((t = this._video) == null ? void 0 : t.videoWidth);
  }
  /**
     * 获取视频高
     */
  get videoHeight() {
    var t;
    return this._videoHeight || ((t = this._video) == null ? void 0 : t.videoHeight);
  }
  /**
     * 获取封面图
     */
  get poster() {
    return this._poster;
  }
  set poster(t) {
    w.i(z, "call set poster", t), this._poster = t, this._updatePosterDom(), this.emit(N.ATTRIBUTE_CHANGE_POSTER);
  }
  /**
     * 获取禁用画中画状态
     */
  get disablePictureInPicture() {
    var t;
    return !!((t = this._video) != null && t.disablePictureInPicture);
  }
  set disablePictureInPicture(t) {
    w.i(z, "call set disablePictureInPicture", t), this._video && (this._video.disablePictureInPicture = t, this.emit(N.ATTRIBUTE_CHANGE_DISABLE_PICTURE_IN_PICTURE));
  }
  /**
     * UI中是否展示下载按钮
     */
  get disableDownload() {
    var t;
    return (t = this._data) == null ? void 0 : t.disableDownload;
  }
  set disableDownload(t) {
    w.i(z, "call set disableDownload", t), this._data && (this._data.disableDownload = t, this.emit(N.ATTRIBUTE_CHANGE_DISABLE_DOWNLOAD));
  }
  /**
     * 获取是否内联（inline）播放
     */
  get playsinline() {
    var t;
    return !!((t = this._video) != null && t.hasAttribute("playsinline"));
  }
  set playsinline(t) {
    w.i(z, "call set playsinline", t), this._video && (this._video.playsinline = t, this._video.WebKitPlaysInline = t, t ? (this._video.setAttribute("playsinline", "playsinline"), this._video.setAttribute("webkit-playsinline", "webkit-playsinline"), this._video.setAttribute("x5-playsinline", "x5-playsinline")) : (this._video.removeAttribute("playsinline"), this._video.removeAttribute("webkit-playsinline"), this._video.removeAttribute("x5-playsinline")), this.emit(N.ATTRIBUTE_CHANGE_PLAYSINLINE));
  }
  /**
     * 获取自适应码率开关状态
     */
  get disableAdaptive() {
    var t;
    return (t = this._data) == null ? void 0 : t.disableAdaptive;
  }
  set disableAdaptive(t) {
    w.i(z, "call set disableAdaptive", t), this._data && (this._data.disableAdaptive = t, this.emit(N.ATTRIBUTE_CHANGE_DISABLE_ADAPTIVE));
  }
  /**
     * 获取当前视频轨id
     */
  get currentLevel() {
    var t;
    return ((t = this._kernel) == null ? void 0 : t.currentLevel) || 0;
  }
  set currentLevel(t) {
    var a, l;
    if (w.i(z, "call set currentLevel", t, !!this._kernel, this._livePaused), this._kernel) {
      const u = this._video.paused;
      this._livePaused ? ((a = this._kernel) == null || a.refresh(), this._kernel.currentLevel = t) : (this._kernel.currentLevel = t, this.emit(N.ATTRIBUTE_CHANGE_CURRENT_LEVEL)), !u && this._video.paused && (w.i(z, "set level. play"), (l = this._video) == null || l.play());
    }
  }
  /**
     * 获取即将切换的视频轨id
     */
  get nextLevel() {
    var t;
    return ((t = this._kernel) == null ? void 0 : t.nextLevel) || 0;
  }
  set nextLevel(t) {
    var a, l;
    if (w.i(z, "call set nextLevel", t), this._kernel) {
      const u = this._video.paused;
      this._livePaused ? ((a = this._kernel) == null || a.refresh(), this._kernel.currentLevel = t) : (this._kernel.nextLevel = t, this.emit(N.ATTRIBUTE_CHANGE_NEXT_LEVEL)), !u && this._video.paused && (w.i(z, "set next level. play"), (l = this._video) == null || l.play());
    }
  }
  /**
     * 获取当前播放帧数
     */
  get currentVideoFrame() {
    var t;
    return ((t = this._kernel) == null ? void 0 : t.currentVideoFrame) || 0;
  }
  set currentVideoFrame(t) {
    this._kernel && (this._kernel.currentVideoFrame = t, this.emit(N.ATTRIBUTE_CHANGE_CURRENT_FRAME));
  }
  /**
     * 获取当前视频总帧数
     */
  get totalVideoFrames() {
    var t;
    return ((t = this._kernel) == null ? void 0 : t.totalVideoFrames) || 0;
  }
  /**
     * 当前清晰度时间信息
     */
  get currentLevelTimeInfo() {
    var t;
    return (t = this._kernel) == null ? void 0 : t.currentLevelTimeInfo;
  }
  /**
     * 返回当前video
     */
  get video() {
    return this._video;
  }
  /**
     * 返回当前canvas，视频渲染在canvas时有值
     */
  get canvas() {
    return this._canvas;
  }
  /**
     * 获取当前音频轨id
     */
  get audioTrack() {
    return this._kernel ? this._kernel.audioTrack : -1;
  }
  set audioTrack(t) {
    w.i(z, "call set audioTrack", t), this._kernel && (this._kernel.audioTrack = t, this.emit(N.ATTRIBUTE_CHANGE_AUDIO_TRACK));
  }
  /**
     * 产品ID，用于上报
     */
  get productName() {
    var t;
    return (t = this._data) == null ? void 0 : t.productName;
  }
  set productName(t) {
    w.i(z, "call set productName", t), this._data && (this._data.productName = t);
  }
  /**
     * 获取当前是否开启连接预热
     */
  get prefetch() {
    var t;
    return (t = this._data) == null ? void 0 : t.prefetch;
  }
  set prefetch(t) {
    w.i(z, "call set prefetch", t), this._data && (this._data.prefetch = t, this.emit(N.ATTRIBUTE_CHANGE_PREFETCH));
  }
  /**
     * 获取是否显示进度条
     * @remarks 依赖控制条插件
     */
  get showProgress() {
    var t;
    return (t = this._data) == null ? void 0 : t.showProgress;
  }
  set showProgress(t) {
    w.i(z, "call set showProgress", t), this._data && (this._data.showProgress = t, this.emit(N.ATTRIBUTE_CHANGE_SHOW_PROGRESS));
  }
  /**
     * 是否显示时间
     * @remarks 依赖控制条插件
     */
  get showTime() {
    var t;
    return (t = this._data) == null ? void 0 : t.showTime;
  }
  set showTime(t) {
    w.i(z, "call set showTime", t), this._data && (this._data.showTime = t, this.emit(N.ATTRIBUTE_CHANGE_SHOW_TIME));
  }
  /**
     * 获取是否启用热键
     * @remarks 依赖热键插件
    */
  get disableHotkey() {
    var t;
    return (t = this._data) == null ? void 0 : t.disableHotkey;
  }
  set disableHotkey(t) {
    w.i(z, "call set disableHotkey", t), this._data && (this._data.disableHotkey = t, this.emit(N.ATTRIBUTE_CHANGE_DISABLE_HOTKEY));
  }
  /**
     * 弹幕是否可用
     */
  get disableDanmaku() {
    var t;
    return (t = this._data) == null ? void 0 : t.disableDanmaku;
  }
  set disableDanmaku(t) {
    w.i(z, "call set disableDanmaku", t), this._data && (this._data.disableDanmaku = t, this.emit(N.ATTRIBUTE_CHANGE_DISABLE_DANMAKU));
  }
  /**
     * 是否渲染弹幕
     */
  get danmakuRendering() {
    var t;
    return (t = this._data) == null ? void 0 : t.danmakuRendering;
  }
  set danmakuRendering(t) {
    w.i(z, "call set danmakuRendering", t), this._data && (this._data.danmakuRendering = t, this.emit(N.ATTRIBUTE_CHANGE_DANMAKU_RENDERING));
  }
  /**
     * 设置是否显示信息面板
     * @remarks 依赖信息面板插件
     */
  get showInfoPanel() {
    var t;
    return (t = this._data) == null ? void 0 : t.showInfoPanel;
  }
  set showInfoPanel(t) {
    w.i(z, "call set showInfoPanel", t), this._data && (this._data.showInfoPanel = t, this.emit(N.ATTRIBUTE_CHANGE_SHOW_INFO_PANEL));
  }
  /**
     * 是否显示下一个按钮，与UI相关
     */
  get showNext() {
    var t;
    return (t = this._data) == null ? void 0 : t.showNext;
  }
  set showNext(t) {
    w.i(z, "call set showNext", t), this._data && (this._data.showNext = t, this.emit(N.ATTRIBUTE_CHANGE_SHOW_NEXT));
  }
  /**
     * 是否显示上一个按钮，与UI相关
     */
  get showPrev() {
    var t;
    return (t = this._data) == null ? void 0 : t.showPrev;
  }
  set showPrev(t) {
    w.i(z, "call set showPrev", t), this._data && (this._data.showPrev = t, this.emit(N.ATTRIBUTE_CHANGE_SHOW_PREV));
  }
  /**
     * 业务参数
     */
  get bizData() {
    var t;
    return (t = this._data) == null ? void 0 : t.bizData;
  }
  set bizData(t) {
    w.i(z, "set biz data", t), this._data && (this._data.bizData = t), this.emit(N.ATTRIBUTE_CHANGE_BIZ_DATA);
  }
  /**
     * 当前场次直播时间信息，配合直播时移功能
     */
  get liveTime() {
    var t;
    return (t = this._data) != null && t.liveTime ? { start: this._data.liveTime.start, end: this._data.liveTime.end } : void 0;
  }
  set liveTime(t) {
    w.i(z, "set live time", t), this._data && (this._data.liveTime = Object.assign({}, t)), this.emit(N.ATTRIBUTE_CHANGE_LIVE_TIME);
  }
  /**
     * 返回当前的内核实例
     */
  get kernel() {
    return this._kernel;
  }
  setPreprocessURL(t) {
    this._preprocessURL = t;
  }
  setPreprocessSrcFunc(t) {
    this._preprocessSrcFunc = t;
  }
  /**
     * 加载视频
     */
  load() {
    var t;
    w.i(z, "call load"), (t = this._kernel) == null || t.load(), this._kernelLoaded = !0;
  }
  /**
     * 播放视频
     */
  play() {
    var t, a;
    return w.i(z, "call play", this._kernelLoaded, this._livePaused), this._livePaused ? (t = this._kernel) == null || t.refresh() : this._kernelLoaded || this.load(), this._video.paused ? (a = this._video) == null ? void 0 : a.play() : Promise.resolve();
  }
  /**
     * 暂停视频
     */
  pause() {
    var t, a, l;
    return w.i(z, "call pause", (t = this._mediaInfo) == null ? void 0 : t.isLive), this._kernel && (a = this._mediaInfo) != null && a.isLive && (w.i(z, "live stop load"), this._kernel.stopLoad(), this._livePaused = !0), (l = this._video) == null ? void 0 : l.pause();
  }
  /**
     * 开启画中画
     */
  requestPictureInPicture() {
    return w.i(z, "call requestPictureInPicture"), this._video && "requestPictureInPicture" in this._video ? this._video.requestPictureInPicture() : Promise.reject("not support requestPictureInPicture");
  }
  isPictureInPictureAvailable() {
    return Ks();
  }
  /**
     * 销毁播放器
     */
  destroy() {
    var t, a;
    w.i(z, "call destroy"), this._liveTimeHelper.destroy(), this._clearKernelStartTimer(), this._preprocessSrcFunc = void 0, this._pluginBase.beforeUninstallPlugins(this), this._evt.removeAllListeners(), this._destroyKernel(), this._unbindVideo(), (t = this._videoLayer.parentElement) == null || t.removeChild(this._videoLayer), (a = this._videoLayer.parentElement) == null || a.removeChild(this._videoInteractiveLayer), this.removeAllListeners(), this._pluginBase.afterUninstallPlugins(this);
  }
  /**
     * 重新加载视频
     */
  refresh() {
    var t;
    w.i(z, "call refresh"), (t = this._kernel) == null || t.refresh();
  }
  /**
     * 支持时移时回到直播状态
     */
  jumpToLiveTime(t) {
    var a, l, u;
    if (w.i(z, `call jumpToLiveTime: ${t}`), (a = this._data) != null && a.liveShiftType && this._data.liveShiftType !== Mt.NONE && (l = this._data) != null && l.liveTime) {
      const h = typeof t == "number" ? Ws(this._data.liveShiftType, this._data.liveTime, t * 1e3) : void 0;
      this._liveOffset = (h == null ? void 0 : h.time) || 0, (u = this._kernel) == null || u.jumpToLiveTime(h), this._updateIsLiveShift(!!h);
    }
  }
  /**
     * 获取流时间
     * @param val 播放时间，ms
     * @returns 播放时间对应的流时间，ms
     */
  getStreamTime(t) {
    var a;
    return ((a = this._kernel) == null ? void 0 : a.getStreamTime(t)) || 0;
  }
  /**
     * 注册播放器插件
     * @param plugin plugin需继承自PluginModule
     */
  static register(t) {
    Ei.register(t);
  }
  /**
     * 注销播放器插件
     * @param plugin plugin需继承自PluginModule
     */
  static deregister(t) {
    Ei.deregister(t);
  }
  /**
     * 根据插件名获取插件实例
     * @param label 插件名
     * @returns plugin
     */
  getPluginInstance(t) {
    return this._pluginBase.getPlugin(t);
  }
  /**
     * 创建一个子容器
     * @returns HTMLDivELement
     */
  createSubContainer(t = Ai.DEFAULT) {
    const a = document.createElement("div");
    a.id = `${this._id}-sub-${Math.round(this._subContainerNumber++)}`;
    let l = this._mainDom;
    if (t === Ai.VIDEO && (l = this._videoLayer), t === Ai.VIDEO_INTERACTIVE && (l = this._videoInteractiveLayer), l)
      l.children.length ? l.children[l.children.length - 1].insertAdjacentElement("afterend", a) : l.appendChild(a);
    else
      throw new Error("cteate sub container error. no parent found.");
    return a;
  }
  /**
     * 是否全屏
     * @returns boolean
     */
  isFullscreen(t) {
    return this._full.isFull(t);
  }
  isFullscreenAvailable(t) {
    return this._full.isFullscreenAvailable(t);
  }
  removeSubContainer(t) {
    t.parentElement && t.parentElement.removeChild(t);
  }
  /**
   * 当前画面截图
   * @returns 截图
   */
  screenshot() {
    if (this.videoWidth && this.videoHeight) {
      const t = document.createElement("canvas");
      t.width = this.videoWidth, t.height = this.videoHeight;
      const a = t.getContext("2d");
      if (this.canvas) {
        const l = this.canvas.width / this.canvas.height, u = this.videoWidth / this.videoHeight;
        let h = 0, E = 0;
        l > u ? h = (this.canvas.width - this.videoWidth * this.canvas.height / this.videoHeight) / 2 : E = (this.canvas.height - this.videoHeight * this.canvas.width / this.videoWidth) / 2, a == null || a.drawImage(this.canvas, h, E, this.canvas.width - h * 2, this.canvas.height - E * 2, 0, 0, this.videoWidth, this.videoHeight);
      } else
        a == null || a.drawImage(this.video, 0, 0, this.videoWidth, this.videoHeight);
      return t;
    }
  }
  /**
     * 获取主容器
     * @returns
     */
  get mainContainer() {
    return this._mainDom;
  }
  get videoLayer() {
    return this._videoLayer;
  }
  get videoInteractiveLayer() {
    return this._videoInteractiveLayer;
  }
  /**
     * 获取当前QOS信息
     * @returns
     */
  get audienceStat() {
    var t;
    return (t = this._kernel) == null ? void 0 : t.getAudienceStat();
  }
  _updatePosterDom() {
    Ht ? (this._video.poster = this._poster || "", this._hidePosterDom()) : this._poster ? (this._video.poster = yl, this._posterLayer.className = wt["kwai-player-poster"], this._posterLayer.style.backgroundImage = `url(${this._poster})`) : (this._video.poster = "", this._posterLayer.className = "", this._posterLayer.style.backgroundImage = "");
  }
  _hidePosterDom() {
    this._posterLayer.style.display = "none";
  }
  _setIsUseCanvas(t) {
    this._video && (this._video.style.display = t ? "none" : "block");
  }
  _setError(t) {
    this._error = t, this._error && setTimeout(() => {
      try {
        this.emit(N.ERROR, this._error);
      } catch (a) {
      }
    }, 0);
  }
  _resetPlayerStat() {
    if (this._canvas) {
      try {
        this._videoLayer.removeChild(this._canvas);
      } catch (t) {
      }
      this._canvas = void 0;
    }
    this._setError(void 0), this._setIsUseCanvas(!1), this._mediaInfo = void 0, this._isLiveShift = !1, this._liveOffset = 0;
  }
  _destroyKernel() {
    this._kernel && (this._kernelLoaded = !1, this._livePaused = !1, this.pause(), this._kernel.destroy(), this._kernel = void 0);
  }
  _bindVideo() {
    if (this._video)
      for (const t in this._eventHandlers)
        this._video.addEventListener(t, this._eventHandlers[t]);
  }
  _unbindVideo() {
    if (this._video)
      for (const t in this._eventHandlers)
        this._video.removeEventListener(t, this._eventHandlers[t]);
  }
  _parseData(t) {
    w.i(z, "parse data.", t), t.src && (this._src = this._preprocessSrcFunc ? this._preprocessSrcFunc(t.src) : t.src), t.config && (this._config = t.config), t.crossOrigin && (this.crossOrigin = t.crossOrigin), typeof t.preload < "u" && (this.preload = t.preload), typeof t.defaultPlaybackRate == "number" && (this.defaultPlaybackRate = t.defaultPlaybackRate), typeof t.playbackRate == "number" && (this.playbackRate = t.playbackRate), typeof t.autoplay < "u" && (this.autoplay = t.autoplay), typeof t.loop < "u" && (this.loop = t.loop), typeof t.controls < "u" && (this.controls = t.controls), typeof t.volume == "number" && (this.volume = t.volume), typeof t.muted < "u" && (this.muted = t.muted), typeof t.defaultMuted < "u" && (this.defaultMuted = t.defaultMuted), typeof t.disablePictureInPicture < "u" && (this.disablePictureInPicture = t.disablePictureInPicture), typeof t.disableAdaptive < "u" && (this.disableAdaptive = t.disableAdaptive), typeof t.playsinline < "u" && (this.playsinline = t.playsinline), typeof t.liveShiftType < "u" && (this.liveShiftType = t.liveShiftType), this.poster = t.poster || "";
  }
  _initKernel(t, a = !0) {
    var l, u, h;
    if (!this._video)
      return;
    if (this._posterLayer.style.display = Ht ? "none" : "block", this._destroyKernel(), !this._src && !((l = this._config) != null && l.src) && !t) {
      this._video.src = "", this._resetPlayerStat();
      return;
    }
    this._config || (this._config = {});
    const E = Object.assign({}, this._config, {
      adaptive: ((u = this._data) == null ? void 0 : u.disableAdaptive) === !1,
      liveShiftType: (h = this._data) == null ? void 0 : h.liveShiftType,
      ntp: !1
    });
    t ? E.src = t : this._src && (E.src = this._src), this._preprocessURL && (E.preprocessUrl = this._preprocessURL), typeof E.nativeFirst > "u" && Ht && (E.nativeFirst = !0), this._resetPlayerStat(), w.i(z, "init kernel");
    const v = this._kernel = new Hs(this._video, E);
    v.on(ot.VIDEO_RENDERER_CHANGE, (p) => {
      const D = this._videoLayer;
      if (p.type === "canvas" && (this._setIsUseCanvas(!0), this._canvas = p.canvas, D.insertAdjacentElement("afterbegin", p.canvas), this._updateCanvasSize()), p.type === "video") {
        this._setIsUseCanvas(!1);
        try {
          this._canvas && D.removeChild(this._canvas);
        } catch (y) {
        }
        this._canvas = void 0;
      }
      this.emit(N.VIDEO_RENDERER_CHANGE, p);
    }), v.on(ot.MANIFEST_PARSED, (p) => {
      w.i(z, ot.MANIFEST_PARSED, p), this.emit(N.MANIFEST_PARSED, p);
    }), v.on(ot.LEVEL_SWITCHING, (p) => {
      this.emit(N.LEVEL_SWITCHING, p);
    }), v.on(ot.LEVEL_SWITCHED, (p) => {
      this.emit(N.LEVEL_SWITCHED, p);
    }), v.on(ot.LEVEL_SWITCH_PLAYING, (p) => {
      this.emit(N.LEVEL_SWITCH_PLAYING, p);
    }), v.on(ot.LEVEL_SWITCH_FAILED, () => {
      this.emit(N.LEVEL_SWITCH_FAILED);
    }), v.on(ot.LEVEL_UPDATED, (p) => {
      this.emit(N.LEVEL_UPDATED, p);
    }), v.on(ot.AUDIO_TRACK_SWITCHING, (p) => {
      this.emit(N.AUDIO_TRACKS_SWITCHING, p);
    }), v.on(ot.AUDIO_TRACK_SWITCHED, (p) => {
      this.emit(N.AUDIO_TRACKS_SWITCHED, p);
    }), v.on(ot.ERROR, (p) => {
      this._setError({ code: p.code, message: p.reason });
    }), v.on(ot.REPORT, (p) => {
      p.type === "mediaInfo" && (this._videoWidth = p.value.width || 0, this._videoHeight = p.value.height || 0, this._mediaInfo = p.value, this._updateCanvasSize(), this._data && (p.value.liveShiftType && (this.liveShiftType = p.value.liveShiftType), this._data.liveShiftType && this._data.liveShiftType !== Mt.NONE && this._liveTimeHelper.load())), this.emit(N.REPORT, p);
    }), a && (this._clearKernelStartTimer(), this._kernelStart());
  }
  _clearKernelStartTimer() {
    this._kernelStartTimeout && (clearTimeout(this._kernelStartTimeout), this._kernelStartTimeout = 0);
  }
  _kernelStart() {
    if (!(!this._kernel || !this._video) && (this._autoplay || this._preload === "" || this._preload === "auto" || this._preload === "metadata") && (this._kernel.load(), this._kernelLoaded = !0, this.autoplay)) {
      const t = this._video.play();
      t instanceof Promise && t.catch(() => {
        var a;
        w.i(z, "autoplay fail, retry."), this._onMutedChange(!0), (a = this._video) == null || a.play().catch(() => {
        });
      });
    }
  }
  _updateCanvasSize(t) {
    w.i(z, "updateCanvas", t || this._full.isFull(), this._videoWidth, this._videoHeight), typeof t > "u" && (t = this._full.isFull()), this._canvas && this._videoWidth && this._videoHeight && (this._canvas.style.width = t ? "100%" : `${this._videoWidth}px`, this._canvas.style.height = t ? "100%" : `${this._videoHeight}px`);
  }
  _updateIsLiveShift(t) {
    t !== this._isLiveShift && (this._isLiveShift = t, this.emit(N.LIVE_SHIFT_CHANGE));
  }
  on(t, a) {
    this._evt.on(t, a);
  }
  once(t, a) {
    this._evt.once(t, a);
  }
  removeAllListeners(t) {
    w.i(z, "call removeAllListeners"), this._evt.removeAllListeners(t);
  }
  off(t, a) {
    this._evt.off(t, a);
  }
  listeners(t) {
    return this._evt.listeners(t);
  }
  emit(t, a) {
    return this._evt.emit(t, a);
  }
  listenerCount(t) {
    return this._evt.listenerCount(t);
  }
};
let qt = zt;
F(qt, "packVersion", "1.1.0");
(function() {
  try {
    if (typeof document != "undefined") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("")), document.head.appendChild(e);
    }
  } catch (t) {
    console.error("vite-plugin-css-injected-by-js", t);
  }
})();
const le = "vue2", Al = [
  N.LOADSTART,
  N.PROGRESS,
  N.SUSPEND,
  N.ABORT,
  N.ERROR,
  N.EMPTIED,
  N.STALLED,
  N.LOADEDMETADATA,
  N.LOADEDDATA,
  N.CANPLAY,
  N.CANPLAYTHROUGH,
  N.PLAYING,
  N.WAITING,
  N.SEEKING,
  N.SEEKED,
  N.ENDED,
  N.DURATIONCHANGE,
  N.TIMEUPDATE,
  N.PLAY,
  N.PAUSE,
  N.RATECHANGE,
  N.RESIZE,
  N.VOLUMECHANGE,
  N.MANIFEST_PARSED,
  N.LEVEL_SWITCHING,
  N.LEVEL_SWITCHED,
  N.LEVEL_SWITCH_PLAYING,
  N.LEVEL_SWITCH_FAILED,
  N.AUDIO_TRACKS_SWITCHING,
  N.AUDIO_TRACKS_SWITCHED,
  N.FULLSCREEN_CHANGE,
  N.LEVEL_UPDATED,
  N.CLICK_NEXT,
  N.CLICK_PREV,
  N.CLICK_REGISTER,
  N.CLICK_LOGIN,
  N.CLICK_VIP,
  N.REPORT
], El = {
  name: "KwaiPlayerVue2",
  props: {
    id: {
      type: String,
      default: ""
    },
    config: {
      type: Object,
      default() {
        return {};
      }
    },
    plugins: {
      type: Object,
      default() {
        return {};
      }
    },
    src: {
      type: [Object, String],
      default: ""
    },
    controls: {
      type: [Boolean, String],
      default: !0
    },
    videoId: {
      type: [String],
      default: ""
    },
    autoplay: {
      type: [Boolean],
      default: !1
    },
    crossOrigin: {
      type: [String, null],
      default: null
    },
    defaultMuted: {
      type: [Boolean],
      default: !1
    },
    defaultPlaybackRate: {
      type: [Number],
      default: 1
    },
    loop: {
      type: [Boolean],
      default: !1
    },
    muted: {
      type: [Boolean],
      default: !1
    },
    preload: {
      type: [String, void 0],
      default: void 0
    },
    poster: {
      type: [String],
      default: ""
    },
    currentTime: {
      type: [Number]
    },
    playbackRate: {
      type: [Number],
      default: 1
    },
    volume: {
      type: [Number],
      default: 1
    },
    disablePictureInPicture: {
      type: [Boolean],
      default: !1
    },
    playsinline: {
      type: [Boolean],
      default: !1
    },
    disableDownload: {
      type: [Boolean],
      default: !0
    },
    disableAdaptive: {
      type: [Boolean],
      default: !0
    },
    disableHotkey: {
      type: [Boolean],
      default: !1
    },
    disableMask: {
      type: [Boolean],
      default: !1
    },
    currentLevel: {
      type: [Number],
      default: 0
    },
    nextLevel: {
      type: [Number],
      default: 0
    },
    audioTrack: {
      type: [Number],
      default: 0
    },
    currentVideoFrame: {
      type: [Number],
      default: 0
    },
    showProgress: {
      type: [Boolean],
      default: void 0
    },
    showTime: {
      type: [Boolean],
      default: void 0
    },
    prefetch: {
      type: [Boolean],
      default: !0
    },
    showInfoPanel: {
      type: [Boolean],
      default: !1
    },
    productName: {
      type: [String],
      default: ""
    },
    previewUrl: {
      type: [String],
      default: ""
    },
    maskUrl: {
      type: [String],
      default: ""
    },
    disableDanmaku: {
      type: [Boolean]
    },
    danmakuRendering: {
      type: [Boolean],
      default: !0
    },
    bizData: {
      type: [Object]
    }
  },
  data() {
    return {
      player: void 0,
      cid: 0
    };
  },
  watch: {
    config: function(e) {
      w.i(le, "call set config", e), this.player && (this.player.config = e);
    },
    controls: function(e) {
      w.i(le, "call set controls", e), this.player && (this.player.controls = e);
    },
    videoId: function(e) {
      w.i(le, "call set videoId", e), this.player && (this.player.videoId = e);
    },
    src: function(e) {
      w.i(le, "call set src", e), this.player && (this.player.src = e);
    },
    autoplay: function(e) {
      w.i(le, "call set autoplay", e), this.player && (this.player.autoplay = e);
    },
    crossOrigin: function(e) {
      w.i(le, "call set crossOrigin", e), this.player && (this.player.crossOrigin = e);
    },
    defaultMuted: function(e) {
      w.i(le, "call set defaultMuted", e), this.player && (this.player.defaultMuted = e);
    },
    defaultPlaybackRate: function(e) {
      w.i(le, "call set defaultPlaybackRate", e), this.player && (this.player.defaultPlaybackRate = e);
    },
    loop: function(e) {
      w.i(le, "call set loop", e), this.player && (this.player.loop = e);
    },
    muted: function(e) {
      w.i(le, "call set muted", e), this.player && (this.player.muted = e);
    },
    preload: function(e) {
      w.i(le, "call set preload", e), this.player && (this.player.preload = e);
    },
    poster: function(e) {
      w.i(le, "call set poster", e), this.player && (this.player.poster = e);
    },
    currentTime: function(e) {
      w.i(le, "call set currentTime", e), this.player && (this.player.currentTime = e);
    },
    playbackRate: function(e) {
      w.i(le, "call set playbackRate", e), this.player && (this.player.playbackRate = e);
    },
    volume: function(e) {
      w.i(le, "call set volume", e), this.player && (this.player.volume = e);
    },
    disablePictureInPicture: function(e) {
      w.i(le, "call set disablePictureInPicture", e), this.player && (this.player.disablePictureInPicture = e);
    },
    playsinline: function(e) {
      w.i(le, "call set playsinline", e), this.player && (this.player.playsinline = e);
    },
    disableDownload: function(e) {
      w.i(le, "call set disableDownload", e), this.player && (this.player.disableDownload = e);
    },
    disableAdaptive: function(e) {
      w.i(le, "call set disableAdaptive", e), this.player && (this.player.disableAdaptive = e);
    },
    disableHotkey: function(e) {
      w.i(le, "call set disableHotkey", e), this.player && (this.player.disableHotkey = e);
    },
    disableMask: function(e) {
      w.i(le, "call set disableMask", e), this.player && (this.player.disableMask = e);
    },
    currentLevel: function(e) {
      w.i(le, "call set currentLevel", e), this.player && (this.player.currentLevel = e);
    },
    nextLevel: function(e) {
      w.i(le, "call set nextLevel", e), this.player && (this.player.nextLevel = e);
    },
    audioTrack: function(e) {
      w.i(le, "call set audioTrack", e), this.player && (this.player.audioTrack = e);
    },
    currentVideoFrame: function(e) {
      w.i(le, "call set currentVideoFrame", e), this.player && (this.player.currentVideoFrame = e);
    },
    showProgress: function(e) {
      w.i(le, "call set showProgress", e), this.player && (this.player.showProgress = e);
    },
    showTime: function(e) {
      w.i(le, "call set showTime", e), this.player && (this.player.showTime = e);
    },
    prefetch: function(e) {
      w.i(le, "call set prefetch", e), this.player && (this.player.prefetch = e);
    },
    showInfoPanel: function(e) {
      w.i(le, "call set showInfoPanel", e), this.player && (this.player.showInfoPanel = e);
    },
    previewUrl: function(e) {
      w.i(le, "call set previewUrl", e), this.player && (this.player.previewUrl = e);
    },
    maskUrl: function(e) {
      w.i(le, "call set maskUrl", e), this.player && (this.player.maskUrl = e);
    },
    disableDanmaku: function(e) {
      w.i(le, "call set disableDanmaku", e), this.player && (this.player.disableDanmaku = e);
    },
    danmakuRendering: function(e) {
      w.i(le, "call set danmakuRendering", e), this.player && (this.player.danmakuRendering = e);
    },
    bizData: function(e) {
      this.player && (this.player.bizData = e);
    }
  },
  methods: {
    load() {
      var e;
      (e = this.player) == null || e.load();
    },
    play() {
      var e;
      return (e = this.player) == null ? void 0 : e.play();
    },
    pause() {
      var e;
      (e = this.player) == null || e.pause();
    },
    destroy() {
      var e;
      (e = this.player) == null || e.destroy();
    },
    requestPictureInPicture() {
      var e;
      return (e = this.player) == null ? void 0 : e.requestPictureInPicture();
    },
    isFullscreen(e) {
      var t;
      return (t = this.player) == null ? void 0 : t.isFullscreen(e);
    },
    requestFullscreen(e) {
      var t;
      (t = this.player) == null || t.requestFullscreen(e);
    },
    exitFullscreen(e) {
      var t;
      (t = this.player) == null || t.exitFullscreen(e);
    },
    isFullscreenAvailable(e) {
      var t;
      return (t = this.player) == null ? void 0 : t.isFullscreenAvailable(e);
    },
    screenshot() {
      var e;
      return (e = this.player) == null ? void 0 : e.screenshot();
    },
    // readonly
    getError() {
      var e;
      return (e = this.player) == null ? void 0 : e.error;
    },
    getNetworkState() {
      var e;
      return ((e = this.player) == null ? void 0 : e.networkState) || 0;
    },
    getBuffered() {
      var e;
      return (e = this.player) == null ? void 0 : e.buffered;
    },
    getReadyState() {
      var e;
      return ((e = this.player) == null ? void 0 : e.readyState) || 0;
    },
    getSeeking() {
      var e;
      return ((e = this.player) == null ? void 0 : e.seeking) || !1;
    },
    getDuration() {
      var e;
      return ((e = this.player) == null ? void 0 : e.duration) || 0;
    },
    getPaused() {
      var e;
      return ((e = this.player) == null ? void 0 : e.paused) || !1;
    },
    getSeekable() {
      var e;
      return (e = this.player) == null ? void 0 : e.seekable;
    },
    getEnded() {
      var e;
      return ((e = this.player) == null ? void 0 : e.ended) || !1;
    },
    getVideoWidth() {
      var e;
      return (e = this.player) == null ? void 0 : e.videoWidth;
    },
    getVideoHeight() {
      var e;
      return (e = this.player) == null ? void 0 : e.videoHeight;
    },
    getTotalVideoFrames() {
      var e;
      return ((e = this.player) == null ? void 0 : e.totalVideoFrames) || 0;
    },
    //
    setSrc(e) {
      this.player && (this.player.src = e);
    },
    getSrc() {
      var e;
      return (e = this.player) == null ? void 0 : e.src;
    },
    setConfig(e) {
      this.player && (this.player.config = e);
    },
    getConfig() {
      var e;
      return (e = this.player) == null ? void 0 : e.config;
    },
    setCrossOrigin(e) {
      this.player && (this.player.crossOrigin = e);
    },
    getCrossOrigin() {
      var e;
      return ((e = this.player) == null ? void 0 : e.crossOrigin) || null;
    },
    setPreload(e) {
      this.player && (this.preload = e);
    },
    getPreload() {
      var e;
      return ((e = this.player) == null ? void 0 : e.preload) || "";
    },
    setCurrentTime(e) {
      this.player && (this.player.currentTime = e);
    },
    getCurrentTime() {
      var e;
      return ((e = this.player) == null ? void 0 : e.currentTime) || 0;
    },
    setDefaultPlaybackRate(e) {
      this.player && (this.player.defaultPlaybackRate = e);
    },
    getDefaultPlaybackRate() {
      var e;
      return (e = this.player) == null ? void 0 : e.defaultPlaybackRate;
    },
    setPlaybackRate(e) {
      this.player && (this.player.playbackRate = e);
    },
    getPlaybackRate() {
      var e;
      return ((e = this.player) == null ? void 0 : e.playbackRate) || 1;
    },
    setAutoplay(e) {
      this.player && (this.player.autoplay = e);
    },
    getAutoplay() {
      var e;
      return ((e = this.player) == null ? void 0 : e.autoplay) || !1;
    },
    setLoop(e) {
      this.player && (this.player.loop = e);
    },
    getLoop() {
      var e;
      return ((e = this.player) == null ? void 0 : e.loop) || !1;
    },
    setControls(e) {
      this.player && (this.player.controls = e);
    },
    getControls() {
      var e;
      return ((e = this.player) == null ? void 0 : e.controls) || !1;
    },
    setVideoId(e) {
      this.player && (this.player.videoId = e);
    },
    getVideoId() {
      var e;
      return ((e = this.player) == null ? void 0 : e.videoId) || !1;
    },
    setVolume(e) {
      this.player && (this.player.volume = e);
    },
    getVolume() {
      var e;
      return ((e = this.player) == null ? void 0 : e.volume) || 0;
    },
    setMuted(e) {
      this.player && (this.player.muted = e);
    },
    getMuted() {
      var e;
      return ((e = this.player) == null ? void 0 : e.muted) || !1;
    },
    setDefaultMuted(e) {
      player && (this.player.defaultMuted = e);
    },
    getDefaultMuted() {
      var e;
      return ((e = this.player) == null ? void 0 : e.defaultMuted) || !1;
    },
    setPoster(e) {
      this.player && (this.player.poster = e);
    },
    getPoster() {
      var e;
      return ((e = this.player) == null ? void 0 : e.poster) || "";
    },
    setDisablePictureInPicture(e) {
      player && (this.player.disablePictureInPicture = e);
    },
    getDisablePictureInPicture() {
      var e;
      return ((e = this.player) == null ? void 0 : e.disablePictureInPicture) || !1;
    },
    setPlaysinline(e) {
      this.player && (this.player.playsinline = e);
    },
    getPlaysinline() {
      var e;
      return ((e = this.player) == null ? void 0 : e.playsinline) || !1;
    },
    setDisableDownload(e) {
      this.player && (this.player.disableDownload = e);
    },
    getDisableDownload() {
      var e;
      return (e = this.player) == null ? void 0 : e.disableDownload;
    },
    setDisableAdaptive(e) {
      this.player && (this.player.disableAdaptive = e);
    },
    getDisableAdaptive() {
      var e;
      return (e = this.player) == null ? void 0 : e.disableAdaptive;
    },
    setDisableHotkey(e) {
      this.player && (this.player.disableHotkey = e);
    },
    getDisableHotkey() {
      var e;
      return (e = this.player) == null ? void 0 : e.disableHotkey;
    },
    setDisableMask(e) {
      this.player && (this.player.disableMask = e);
    },
    getDisableMask() {
      var e;
      return (e = this.player) == null ? void 0 : e.disableMask;
    },
    setCurrentLevel(e) {
      this.player && (this.player.currentLevel = e);
    },
    getCurrentLevel() {
      var e;
      return ((e = this.player) == null ? void 0 : e.currentLevel) || 0;
    },
    setNextLevel(e) {
      this.player && (this.player.nextLevel = e);
    },
    getNextLevel() {
      var e;
      return ((e = this.player) == null ? void 0 : e.nextLevel) || 0;
    },
    setAudioTrack(e) {
      this.player && (this.player.audioTrack = e);
    },
    getAudioTrack() {
      var e;
      return ((e = this.player) == null ? void 0 : e.audioTrack) || 0;
    },
    setCurrentVideoFrame(e) {
      this.player && (this.player.currentVideoFrame = e);
    },
    getCurrentVideoFrame() {
      var e;
      return ((e = this.player) == null ? void 0 : e.currentVideoFrame) || 0;
    },
    setShowProgress(e) {
      this.player && (this.player.showProgress = e);
    },
    getShowProgress() {
      var e;
      return (e = this.player) == null ? void 0 : e.showProgress;
    },
    setShowTime(e) {
      this.player && (this.player.showTime = e);
    },
    getShowTime() {
      var e;
      return (e = this.player) == null ? void 0 : e.showTime;
    },
    setPrefetch(e) {
      this.player && (this.player.prefetch = e);
    },
    getPrefetch() {
      var e;
      return (e = this.player) == null ? void 0 : e.prefetch;
    },
    setShowInfoPanel(e) {
      this.player && (this.player.showInfoPanel = e);
    },
    getShowInfoPanel() {
      var e;
      return (e = this.player) == null ? void 0 : e.showInfoPanel;
    },
    setProductName(e) {
      this.player && (this.player.productName = e);
    },
    getProductName() {
      var e;
      return (e = this.player) == null ? void 0 : e.productName;
    },
    setPreviewUrl(e) {
      this.player && (this.player.previewUrl = e);
    },
    getPreviewUrl() {
      var e;
      return (e = this.player) == null ? void 0 : e.previewUrl;
    },
    setMaskUrl(e) {
      this.player && (this.player.maskUrl = e);
    },
    getMaskUrl() {
      var e;
      return (e = this.player) == null ? void 0 : e.maskUrl;
    },
    setDisableDanmaku(e) {
      this.player && (this.player.disableDanmaku = e);
    },
    getDisableDanmaku() {
      var e;
      return (e = this.player) == null ? void 0 : e.disableDanmaku;
    },
    setDanmakuRendering(e) {
      this.player && (this.player.danmakuRendering = e);
    },
    getDanmakuRendering() {
      var e;
      return (e = this.player) == null ? void 0 : e.danmakuRendering;
    },
    getAudienceStat() {
      var e;
      return (e = this.player) == null ? void 0 : e.audienceStat;
    },
    getStreamTime(e) {
      var t;
      return ((t = this.player) == null ? void 0 : t.getStreamTime(e)) || 0;
    },
    getVersion() {
      return qt.version;
    },
    getPluginInstance(e) {
      var t;
      return (t = this.player) == null ? void 0 : t.getPluginInstance(e);
    }
  },
  created() {
    this.cid = this.id || Os();
  },
  mounted() {
    w.i(le, "mounted");
    const e = this.player = new qt(`#${this.cid}`, {
      config: this.config,
      src: this.src,
      crossOrigin: this.crossOrigin,
      preload: this.preload,
      defaultPlaybackRate: this.defaultPlaybackRate,
      playbackRate: this.playbackRate,
      autoplay: this.autoplay,
      loop: this.loop,
      controls: this.controls,
      videoId: this.videoId,
      volume: this.volume,
      muted: this.muted,
      defaultMuted: this.defaultMuted,
      poster: this.poster,
      disablePictureInPicture: this.disablePictureInPicture,
      disableDownload: this.disableDownload,
      disableAdaptive: this.disableAdaptive,
      disableHotkey: this.disableHotkey,
      disableMask: this.disableMask,
      playsinline: this.playsinline,
      showProgress: this.showProgress,
      showTime: this.showTime,
      prefetch: this.prefetch,
      showInfoPanel: this.showInfoPanel,
      productName: this.productName,
      previewUrl: this.previewUrl,
      maskUrl: this.maskUrl,
      disableDanmaku: this.disableDanmaku,
      danmakuRendering: this.danmakuRendering,
      plugins: this.plugins,
      bizData: this.bizData
    });
    Al.forEach((t) => {
      e.on(t, (a) => {
        this.$emit(t, a);
      });
    });
  },
  beforeUnmount() {
    this.player.destroy();
  }
};
var gl = function() {
  var e = this, t = e.$createElement, a = e._self._c || t;
  return a("div", {
    attrs: {
      id: e.cid
    }
  }, [e._t("watermark")], 2);
}, Tl = [];
function bl(e, t, a, l, u, h, E, v) {
  var p = typeof e == "function" ? e.options : e;
  t && (p.render = t, p.staticRenderFns = a, p._compiled = !0), l && (p.functional = !0), h && (p._scopeId = "data-v-" + h);
  var D;
  if (E ? (D = function(g) {
    g = g || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !g && typeof __VUE_SSR_CONTEXT__ < "u" && (g = __VUE_SSR_CONTEXT__), u && u.call(this, g), g && g._registeredComponents && g._registeredComponents.add(E);
  }, p._ssrRegister = D) : u && (D = v ? function() {
    u.call(
      this,
      (p.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : u), D)
    if (p.functional) {
      p._injectStyles = D;
      var y = p.render;
      p.render = function(g, _) {
        return D.call(_), y(g, _);
      };
    } else {
      var R = p.beforeCreate;
      p.beforeCreate = R ? [].concat(R, D) : [D];
    }
  return {
    exports: e,
    options: p
  };
}
const yn = {};
var Rl = /* @__PURE__ */ bl(
  El,
  gl,
  Tl,
  !1,
  Sl,
  null,
  null,
  null
);
function Sl(e) {
  for (let t in yn)
    this[t] = yn[t];
}
const vu = /* @__PURE__ */ function() {
  return Rl.exports;
}();
var Ll = Object.defineProperty, wl = (e, t, a) => t in e ? Ll(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a, he = (e, t, a) => (wl(e, typeof t != "symbol" ? t + "" : t, a), a);
const An = {
  development: "./misc2",
  production: "https://log-sdk.ksapisrv.com/rest/wd/common/log/collect/misc2",
  oversea: "https://logsdk.kwai-pro.com/rest/wd/common/log/collect/misc2",
  "logger-oversea": "https://data-track-sgp.corp.kuaishou.com/rest/wd/common/log/collect/misc2"
}, Il = 5e3;
var Yt = /* @__PURE__ */ ((e) => (e.SUMMARY = "KP_WEB_SUMMARY", e.REALTIME = "KP_WEB_REALTIME", e.DOWNLOAD = "KP_WEB_DOWNLOAD", e.EVENT = "KP_WEB_EVENT", e))(Yt || {});
const Cl = {
  summary: "KP_WEB_SUMMARY",
  realtimeBeacon: "KP_WEB_REALTIME",
  download: "KP_WEB_DOWNLOAD",
  event: "KP_WEB_EVENT"
  /* EVENT */
}, pa = "production", kl = "streamlake", En = [
  "summary",
  "realtimeBeacon",
  "download",
  "event"
  /* EVENT */
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("")), document.head.appendChild(e);
    }
  } catch (t) {
    console.error("vite-plugin-css-injected-by-js", t);
  }
})();
var Dl = Object.defineProperty, xl = (e, t, a) => t in e ? Dl(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a, qe = (e, t, a) => (xl(e, typeof t != "symbol" ? t + "" : t, a), a);
const Nl = "ControlsPlugin", Ol = "I18nPlugin", Pl = "LoggerPlugin", Ul = "HotkeyPlugin", Ml = "PlayInfoPlugin", Fl = "MirrorPlugin", Bl = "RotatePlugin", Hl = "PreviewPlugin", Vl = "MaskPlugin", Gl = "VRPlugin", Wl = "DanmakuPlugin";
class Xe extends Mi {
  static isInstanceOfPlugin(t) {
    return typeof t.beforeInstall == "function" && typeof t.afterInstall == "function" && typeof t.beforeUninstall == "function" && typeof t.afterUninstall == "function" && typeof t.getLabel == "function";
  }
  /**
   * 播放器实例化前钩子
   * @param player 播放器实例
   * @param options 实例化播放器时指定的当前插件的参数
   */
  beforeInstall(t, a) {
  }
  /**
   * 播放器实例化后钩子
   * @param player 播放器实例
   * @param options 实例化播放器时指定的当前插件的参数
   */
  afterInstall(t, a) {
  }
  /**
   * 播放器销毁前钩子
   * @param player 播放器实例
   */
  beforeUninstall(t) {
  }
  /**
   * 播放器销毁后钩子
   * @param player 播放器实例
   */
  afterUninstall(t) {
  }
}
qe(Xe, "label"), /**
* 版本
*/
qe(Xe, "version"), /**
* 当前环境是否支持
*/
qe(Xe, "isSupported");
const fa = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return fa.label;
  }
  beforeInstall(e, t) {
  }
  afterInstall(e, t) {
  }
};
let Kl = fa;
qe(Kl, "label", Nl);
const va = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return va.label;
  }
  beforeInstall(e, t) {
  }
  afterInstall(e, t) {
  }
};
let zl = va;
qe(zl, "label", Ol);
const ma = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return ma.label;
  }
  beforeInstall(t, a) {
  }
  afterInstall(t, a) {
  }
  /**
   * 增加业务相关数据
   * @param key 上报数据key
   * @param value 上报数据
   */
  addBizLog(t, a) {
  }
  appendSummaryField(t, a) {
  }
};
let ya = ma;
qe(ya, "label", Pl);
const Aa = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return Aa.label;
  }
};
let $l = Aa;
qe($l, "label", Ul);
const Ea = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return Ea.label;
  }
};
let Yl = Ea;
qe(Yl, "label", Ml);
const ga = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return ga.label;
  }
};
let jl = ga;
qe(jl, "label", Fl);
const Ta = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return Ta.label;
  }
};
let ql = Ta;
qe(ql, "label", Bl);
const ba = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return ba.label;
  }
};
let Xl = ba;
qe(Xl, "label", Hl);
const Ra = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return Ra.label;
  }
};
let Ql = Ra;
qe(Ql, "label", Vl);
const Sa = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return Sa.label;
  }
};
let Zl = Sa;
qe(Zl, "label", Gl);
const La = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return La.label;
  }
};
let Jl = La;
qe(Jl, "label", Wl);
var Ot = /* @__PURE__ */ ((e) => (e.ERROR = "error", e.MANIFEST_PARSED = "manifestparsed", e.LEVEL_SWITCHING = "levelswitching", e.LEVEL_SWITCHED = "levelswitched", e.LEVEL_SWITCH_PLAYING = "levelswitchplaying", e.LEVEL_SWITCH_FAILED = "levelswitchfailed", e.LEVEL_UPDATED = "levelupdated", e.AUDIO_TRACKS_SWITCHING = "audiotrackswitching", e.AUDIO_TRACKS_SWITCHED = "audiotrackswitched", e.LOADSTART = "loadstart", e.PROGRESS = "progress", e.SUSPEND = "suspend", e.ABORT = "abort", e.EMPTIED = "emptied", e.STALLED = "stalled", e.LOADEDMETADATA = "loadedmetadata", e.LOADEDDATA = "loadeddata", e.CANPLAY = "canplay", e.CANPLAYTHROUGH = "canplaythrough", e.PLAYING = "playing", e.WAITING = "waiting", e.SEEKING = "seeking", e.SEEKED = "seeked", e.ENDED = "ended", e.DURATIONCHANGE = "durationchange", e.TIMEUPDATE = "timeupdate", e.PLAY = "play", e.PAUSE = "pause", e.RATECHANGE = "ratechange", e.RESIZE = "resize", e.VOLUMECHANGE = "volumechange", e.ENTER_PICTURE_IN_PICTURE = "enterpictureinpicture", e.LEAVE_PICTURE_IN_PICTURE = "leavepictureinpicture", e.REPORT = "report", e.VIDEO_RENDERER_CHANGE = "videorendererchange", e.FULLSCREEN_CHANGE = "fullscreenchange", e.LIVE_SHIFT_CHANGE = "liveshiftchange", e.LIVE_SHIFT_TYPE_CHANGE = "liveshifttypechange", e.ATTRIBUTE_CHANGE_CONFIG = "attribute:change:config", e.ATTRIBUTE_CHANGE_SRC = "attribute:change:src", e.ATTRIBUTE_CHANGE_VIDEO_ID = "attribute:change:videoid", e.ATTRIBUTE_CHANGE_PREVIEW_URL = "attribute:change:previewurl", e.ATTRIBUTE_CHANGE_MASK_URL = "attribute:change:maskurl", e.ATTRIBUTE_CHANGE_CROSS_ORIGIN = "attribute:change:crossorigin", e.ATTRIBUTE_CHANGE_PRELOAD = "attribute:change:preload", e.ATTRIBUTE_CHANGE_CURRENT_TIME = "attribute:change:currenttime", e.ATTRIBUTE_CHANGE_DEFAULT_PLAYBACK_RATE = "attribute:change:defaultplaybackrate", e.ATTRIBUTE_CHANGE_PLAYBACK_RATE = "attribute:change:playbackrate", e.ATTRIBUTE_CHANGE_AUTOPLAY = "attribute:change:autoplay", e.ATTRIBUTE_CHANGE_LOOP = "attribute:change:loop", e.ATTRIBUTE_CHANGE_CONTROLS = "attribute:change:controls", e.ATTRIBUTE_CHANGE_VOLUME = "attribute:change:volume", e.ATTRIBUTE_CHANGE_MUTED = "attribute:change:muted", e.ATTRIBUTE_CHANGE_DEFAULT_MUTED = "attribute:change:defaultmuted", e.ATTRIBUTE_CHANGE_POSTER = "attribute:change:poster", e.ATTRIBUTE_CHANGE_DISABLE_PICTURE_IN_PICTURE = "attribute:change:disablepictureinpicture", e.ATTRIBUTE_CHANGE_PLAYSINLINE = "attribute:change:playsinline", e.ATTRIBUTE_CHANGE_DISABLE_ADAPTIVE = "attribute:change:disableadaptive", e.ATTRIBUTE_CHANGE_DISABLE_DOWNLOAD = "attribute:change:disabledownload", e.ATTRIBUTE_CHANGE_DISABLE_MASK = "attribute:change:disablemask", e.ATTRIBUTE_CHANGE_DISABLE_HOTKEY = "attribute:change:disablehotkey", e.ATTRIBUTE_CHANGE_DISABLE_DANMAKU = "attribute:change:disabledanmaku", e.ATTRIBUTE_CHANGE_DANMAKU_RENDERING = "attribute:change:danmakurendering", e.ATTRIBUTE_CHANGE_DANMAKU_CONTROLS_POS = "attribute:change:danmakucontrolspos", e.ATTRIBUTE_CHANGE_DANMAKU_CONTROLS_POS_FULLSCREEN = "attribute:change:danmakucontrolsposfullscreen", e.ATTRIBUTE_CHANGE_CURRENT_LEVEL = "attribute:change:currentlevel", e.ATTRIBUTE_CHANGE_NEXT_LEVEL = "attribute:change:nextlevel", e.ATTRIBUTE_CHANGE_CURRENT_FRAME = "attribute:change:currentframe", e.ATTRIBUTE_CHANGE_AUDIO_TRACK = "attribute:change:audiotrack", e.ATTRIBUTE_CHANGE_PREFETCH = "attribute:change:prefetch", e.ATTRIBUTE_CHANGE_SHOW_PROGRESS = "attribute:change:showprogress", e.ATTRIBUTE_CHANGE_SHOW_TIME = "attribute:change:showtime", e.ATTRIBUTE_CHANGE_SHOW_NEXT = "attribute:change:shownext", e.ATTRIBUTE_CHANGE_SHOW_PREV = "attribute:change:showprev", e.ATTRIBUTE_CHANGE_BIZ_DATA = "attribute:change:bizdata", e.ATTRIBUTE_CHANGE_LIVE_TIME = "attribute:change:livetime", e.ATTRIBUTE_CHANGE_SHOW_INFO_PANEL = "attribute:change:showinfopanel", e.CLICK_NEXT = "clicknext", e.CLICK_PREV = "clickprev", e.CLICK_LOGIN = "clicklogin", e.CLICK_REGISTER = "clickregister", e.CLICK_SEND_DANMAKU = "clicksenddanmaku", e.CLICK_VIP = "clickvip", e))(Ot || {}), vi, ec = new Uint8Array(16);
function tc() {
  if (!vi && (vi = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !vi))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return vi(ec);
}
const ic = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function rc(e) {
  return typeof e == "string" && ic.test(e);
}
var Me = [];
for (var Ji = 0; Ji < 256; ++Ji)
  Me.push((Ji + 256).toString(16).substr(1));
function nc(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a = (Me[e[t + 0]] + Me[e[t + 1]] + Me[e[t + 2]] + Me[e[t + 3]] + "-" + Me[e[t + 4]] + Me[e[t + 5]] + "-" + Me[e[t + 6]] + Me[e[t + 7]] + "-" + Me[e[t + 8]] + Me[e[t + 9]] + "-" + Me[e[t + 10]] + Me[e[t + 11]] + Me[e[t + 12]] + Me[e[t + 13]] + Me[e[t + 14]] + Me[e[t + 15]]).toLowerCase();
  if (!rc(a))
    throw TypeError("Stringified UUID is invalid");
  return a;
}
function wa(e, t, a) {
  e = e || {};
  var l = e.random || (e.rng || tc)();
  if (l[6] = l[6] & 15 | 64, l[8] = l[8] & 63 | 128, t) {
    a = a || 0;
    for (var u = 0; u < 16; ++u)
      t[a + u] = l[u];
    return t;
  }
  return nc(l);
}
let ac = class {
  constructor() {
    he(this, "_env", pa), he(this, "_reportTypes", []), he(this, "_player"), he(this, "_logBaseInfo", this._getDefaultLogBaseInfo()), he(this, "_biz", {}), he(this, "_extraSummaryFields", {}), he(this, "_forceSendBeacon", !1);
  }
  setBaseInfo(t, a, l) {
    this._player = t, this._logBaseInfo.env = this._env = a, this._reportTypes = l;
  }
  setBizData(t) {
    if (!t) {
      this._logBaseInfo = this._getDefaultLogBaseInfo();
      return;
    }
    const a = this._logBaseInfo, l = Object.keys(a);
    typeof (t == null ? void 0 : t.resourceId) < "u" && (t.resourceId = this._id2String(t == null ? void 0 : t.resourceId)), typeof (t == null ? void 0 : t.userId) < "u" && (t.userId = this._id2String(t == null ? void 0 : t.userId)), Object.keys(t).forEach((u) => {
      const h = this._underscoreToCamelCase(u);
      l.indexOf(h) >= 0 && (a[h] = t[u]), this._biz[u] = t[u];
    });
  }
  preprocessingLog(t, a, l) {
    var u, h;
    if (a)
      return a = Object.assign(a, {
        player_version: ((u = this._player) == null ? void 0 : u.version) || "",
        pack_version: ((h = this._player) == null ? void 0 : h.packVersion) || "",
        biz: this._biz
      }), t === Yt.SUMMARY && (l ? a.extra = Object.assign({}, this._extraSummaryFields, l) : a.extra = this._extraSummaryFields), a;
  }
  clearExtraSummary() {
    this._extraSummaryFields = {};
  }
  appendSummaryField(t, a) {
    this._extraSummaryFields[t] = a;
  }
  get reportTypes() {
    return this._reportTypes;
  }
  get logBaseInfo() {
    var t;
    return (t = this._player) != null && t.productName && (this._logBaseInfo.productName = this._player.productName), this._logBaseInfo;
  }
  get player() {
    return this._player;
  }
  set forceSendBeacon(t) {
    this._forceSendBeacon = t;
  }
  get forceSendBeacon() {
    return this._forceSendBeacon;
  }
  _getDefaultLogBaseInfo() {
    let t = 10;
    return Be.os.name === "iOS" ? t = 9 : Be.os.name === "Android" && (t = 8), {
      env: this._env,
      productName: kl,
      sessionId: wa(),
      platform: t,
      deviceId: localStorage.getItem("kwai_player_device_id") || this._nanoId(),
      userId: "",
      globalId: "",
      networkType: "",
      packageName: "",
      versionName: "",
      channel: ""
    };
  }
  _nanoId() {
    const t = Math.random() * 1e9 >>> 0, a = [], l = "0123456789ABCDEF";
    for (let u = 0; u < 7; u++)
      a.push(l.charAt(Math.random() * 16));
    return `web_${t}${a.join("")}`;
  }
  _underscoreToCamelCase(t) {
    return t.replace(/_([a-z])/g, (a, l) => l.toUpperCase());
  }
  _id2String(t) {
    return typeof t == "number" ? t.toString() : t || "";
  }
};
const er = "kwai-player-web-log-temp", oc = 3 * 24 * 3600 * 1e3, sc = 5 * 1e3, gn = 1, xt = "log-reissue";
let lc = class {
  constructor(t, a) {
    he(this, "_ctx"), he(this, "_logger"), he(this, "_active", !1), he(this, "_processingTs", 0), he(this, "_lc", new _r()), he(this, "_timer", 0), he(this, "_checkMissing", !1), he(this, "_tick", () => {
      if (!this._active || !this._ctx.player)
        return;
      this._checkMissing && (this._checkMissing = !1, this._checkMissingLog());
      const l = performance.now();
      if (l - this._processingTs >= sc) {
        this._processingTs = l;
        const u = this._ctx.preprocessingLog(Yt.SUMMARY, this._ctx.player.audienceStat, { reissue_log: 1 });
        u && (w.v(xt, "write temp"), this._writeTemp(this._logger.generateFormData(this._ctx.logBaseInfo, [{ key: Yt.SUMMARY, value: u }])));
      }
    }), he(this, "_startTimer", () => {
      this._timer || (this._timer = setInterval(this._tick, 1e3));
    }), he(this, "_stopTimer", () => {
      clearInterval(this._timer), this._timer = 0;
    }), this._ctx = t, this._logger = a, this._lc.timeout = oc;
  }
  start() {
    w.i(xt, "start"), this._active || (this._active = !0, this._processingTs = performance.now(), this._checkMissing = !0, this._startTimer());
  }
  stop() {
    w.i(xt, "stop"), this._active = !1, this._clear(), this._stopTimer();
  }
  _checkMissingLog() {
    const t = this._readTemp();
    this._clear(), t ? (w.i(xt, "send missing log"), this._logger.send(this._ctx.logBaseInfo.env, Yt.SUMMARY, t.value)) : w.i(xt, "no missing log");
  }
  _clear() {
    localStorage.removeItem(er);
  }
  _writeTemp(t) {
    if (!t)
      return;
    const a = {
      version: gn,
      value: t,
      checkSum: this._fletcher16(t)
    };
    this._lc.write(er, btoa(JSON.stringify(a)));
  }
  _readTemp() {
    const t = this._lc.read(er, !0);
    if (t)
      try {
        const a = JSON.parse(atob(t));
        if (a.version === gn && typeof a.value == "string" && a.checkSum === this._fletcher16(a.value))
          return w.i(xt, "read success"), a;
        w.i(xt, "read failed", a);
      } catch (a) {
      }
  }
  _fletcher16(t) {
    let a = 0, l = 0;
    for (let u = 0; u < t.length; u++)
      a = (a + t.charCodeAt(u)) % 255, l = (l + a) % 255;
    return l << 8 | a;
  }
};
const Tn = {
  unknown: 0,
  none: 1,
  wifi: 2,
  "4g": 3,
  "3g": 4,
  "2g": 5,
  "5g": 7,
  "slow-2g": 5
}, tr = (/* @__PURE__ */ new Date()).toString().match(/GMT\+\d+/);
let ir = "";
const ii = "web-logger", Pt = class {
  constructor() {
    he(this, "_waitingQueue", []), he(this, "_nextTickTimer");
  }
  sendLog(t, a, l, u = !1, h) {
    w.i(ii, "sendLog", t, a, l, `forceSendBeacon: ${u} immediately: ${h}`), l && (this._waitingQueue.push({ key: a, value: l }), h ? (this.send(t.env, t.productName, this.generateFormData(t, this._waitingQueue), u), this._waitingQueue.splice(0)) : this._nextTickTimer || (this._nextTickTimer = setTimeout(() => {
      this._nextTickTimer = 0, this.send(t.env, t.productName, this.generateFormData(t, this._waitingQueue), u), this._waitingQueue.splice(0);
    }, 0)));
  }
  send(t, a, l, u = !1) {
    if (w.i(ii, "send", t, a, !!l, `forceSendBeacon: ${u}`), !l)
      return;
    let h = An[t] || An.production;
    Pt._clientIncrementId++, localStorage.kwai_player_client_increment_id = Pt._clientIncrementId;
    const E = new _n(h, !0);
    if (E.query.v = "3.10.24", E.query.kpn = a, h = E.toString(), w.i(ii, "send", t, a, !!l, h), u && navigator.sendBeacon) {
      const v = navigator.sendBeacon(h, l);
      w.i(ii, "send data use sendBeacon.", v), v || this._sendByXhr(h, l);
    } else
      this._sendByXhr(h, l);
  }
  _sendByXhr(t, a) {
    w.i(ii, "send data use xhr.");
    const l = new XMLHttpRequest();
    l.open("POST", t), l.setRequestHeader("Content-Type", "text/plain;charset=UTF-8"), l.onerror = l.ontimeout = () => {
      w.i("sendLog error"), l.onerror = l.ontimeout = l.onload = null;
    }, l.onload = () => {
      l.onerror = l.ontimeout = l.onload = null;
    }, l.timeout = Il, l.send(a);
  }
  generateFormData(t, a) {
    const l = {
      common: Pt._buildCommon(
        t,
        {
          service_name: "KwaiPlayerWeb"
        }
      ),
      logs: a.map((u) => Pt._buildEvent(t, u.key, u.value))
    };
    return l.logs.length ? JSON.stringify(l) : "";
  }
  static _buildEvent(t, a, l) {
    ir || (ir = wa());
    const u = {
      identity: ir,
      page: location.href,
      hostname: location.hostname,
      page_type: 2
    };
    return u.params = new _n(location.href, !0).query, {
      client_timestamp: Date.now(),
      client_increment_id: Pt._clientIncrementId,
      session_id: t.sessionId,
      time_zone: Pt._timeZone,
      stat_package: {
        custom_stat_event: {
          key: a,
          value: JSON.stringify(Object.assign({}, l, { url_package: u }))
        }
      }
    };
  }
  static _buildCommon(t, a) {
    return localStorage.kwai_player_device_id || (localStorage.kwai_player_device_id = t.deviceId), ln({
      identity_package: {
        device_id: t.deviceId,
        global_id: t.globalId,
        user_id: t.userId
      },
      app_package: {
        language: navigator.language,
        platform: t.platform,
        container: t.platform === 10 ? "WEB" : "H5",
        package_name: t.packageName,
        product_name: t.productName,
        version_name: t.versionName,
        channel: t.channel
      },
      device_package: {
        os_version: Be.os.version,
        model: Be.os.name,
        ua: navigator.userAgent
      },
      need_encrypt: !1,
      sdk_version: "",
      h5_extra_attr: this._getH5ExtraAttr(t),
      global_attr: "{}",
      network_package: {
        type: this._getNetworkType(t.networkType)
      }
    }, a);
  }
  static _getNetworkType(t) {
    var a;
    const l = t || ((a = (navigator == null ? void 0 : navigator.connection) || (navigator == null ? void 0 : navigator.mozConnection) || (navigator == null ? void 0 : navigator.webkitConnection)) == null ? void 0 : a.effectiveType);
    return l && Tn[l] || Tn.unknown;
  }
  static _getH5ExtraAttr(t) {
    const a = parseFloat(devicePixelRatio.toFixed(3)) || 1;
    return JSON.stringify({
      sdk_name: "",
      sdk_version: "",
      sdk_bundle: "",
      app_version_name: t.versionName,
      resolution: `${Math.floor(screen.width * a)}x${Math.floor(screen.height * a)}`,
      screen_width: Math.floor(screen.width),
      screen_height: Math.floor(screen.height),
      device_pixel_ratio: a,
      domain: location.origin,
      fromIframe: self !== top
    });
  }
};
let lr = Pt;
he(lr, "_clientIncrementId", parseInt(typeof localStorage < "u" && localStorage != null && localStorage.getItem("kwai_player_client_increment_id") || "") || 0), he(lr, "_timeZone", tr && tr[0] ? tr[0] : "");
const ri = "logger-plugin";
let cc = class extends ya {
  constructor() {
    super(...arguments), he(this, "_summaryAlreadySend", !1), he(this, "_logger", new lr()), he(this, "_ctx", new ac()), he(this, "_logReissue"), he(this, "_parseBizData", () => {
      var t;
      w.i(ri, "parse biz data"), this._ctx.setBizData((t = this._ctx.player) == null ? void 0 : t.bizData);
    }), he(this, "_onReport", (t) => {
      if (this._ctx.reportTypes.indexOf(t.type) !== -1) {
        const a = Cl[t.type];
        a ? (w.i(ri, "sendLog", this._ctx.logBaseInfo.productName, a), this._send(a, t.value)) : w.i(ri, "unknown weblogger key.");
      }
    }), he(this, "_onSrcChange", () => {
      var t;
      this._sendSummary(), this._summaryAlreadySend = !1, (t = this._logReissue) == null || t.start();
    }), he(this, "_sendSummary", () => {
      var t;
      !this._ctx.player || this._summaryAlreadySend || !this._ctx.player.audienceStat || ((t = this._logReissue) == null || t.stop(), this._summaryAlreadySend = !0, w.i(ri, "send summary"), this._send(Yt.SUMMARY, this._ctx.player.audienceStat, !0));
    }), he(this, "_onBeforeunload", () => {
      this._sendSummary();
    });
  }
  beforeInstall(t, a) {
    let l;
    a && a.reportTypes && Array.isArray(a.reportTypes) && (l = a.reportTypes.filter((u) => En.indexOf(u) >= 0)), a != null && a.productName && (t.productName = a.productName), typeof (a == null ? void 0 : a.forceSendBeacon) < "u" && (this._ctx.forceSendBeacon = a.forceSendBeacon), this._ctx.setBaseInfo(t, (a == null ? void 0 : a.env) || pa, l || En), this._logReissue = new lc(this._ctx, this._logger), t.on(Ot.REPORT, this._onReport), t.on(Ot.ATTRIBUTE_CHANGE_SRC, this._onSrcChange), t.on(Ot.ATTRIBUTE_CHANGE_BIZ_DATA, this._parseBizData), window.addEventListener("beforeunload", this._onBeforeunload), Be && Be.device.type === "mobile" && window.addEventListener("unload", this._onBeforeunload), this._parseBizData();
  }
  beforeUninstall() {
    this._sendSummary();
  }
  afterUninstall() {
    var t, a, l;
    (t = this._ctx.player) == null || t.off(Ot.REPORT, this._onReport), (a = this._ctx.player) == null || a.off(Ot.ATTRIBUTE_CHANGE_SRC, this._onSrcChange), (l = this._ctx.player) == null || l.off(Ot.ATTRIBUTE_CHANGE_BIZ_DATA, this._parseBizData), window.removeEventListener("beforeunload", this._onBeforeunload), window.removeEventListener("unload", this._onBeforeunload);
  }
  appendSummaryField(t, a) {
    w.i(ri, "add summary field", t, a), this._ctx.appendSummaryField(t, a);
  }
  _send(t, a, l) {
    a && this._logger.sendLog(this._ctx.logBaseInfo, t, this._ctx.preprocessingLog(t, a), this._ctx.forceSendBeacon, l);
  }
};
(function() {
  try {
    if (typeof document != "undefined") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._container_afsrn_1{background-color:rgba(0,0,0,.5);border-radius:.375em;position:relative;color:#fff;font-size:12px;font-family:Arial,Roboto,Noto,sans-serif;box-sizing:border-box;padding:2em .625em .625em;overflow:auto;word-break:break-all;white-space:normal;max-width:500px;max-height:calc(100% - 10px);line-height:1.5;margin:.3125em}._container-h5_afsrn_19{background-color:rgba(0,0,0,.5);border-radius:.375em;position:relative;color:#fff;font-size:12px;font-family:Arial,Roboto,Noto,sans-serif;box-sizing:border-box;padding:2em .625em .625em;overflow:auto;word-break:break-all;white-space:normal;font-size:14px;width:100%;height:100%}._close-btn_afsrn_36{position:absolute;right:0;top:0;cursor:pointer;word-break:keep-all;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding:.625em}._btn-tip_afsrn_49{background-color:rgba(0,0,0,.5);border-radius:.375em;position:absolute;left:50%;transform:translate(-50%);bottom:2.1875em;white-space:nowrap;padding:.5em}._actions_afsrn_60{display:flex;justify-content:flex-end;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding:0}._actions_afsrn_60 ._copy-btn_afsrn_69{word-break:keep-all;cursor:pointer;padding:.625em 0 0 .625em}._info-item_afsrn_75{display:flex}._info-item-name_afsrn_79{width:20%;min-width:7.5em;text-align:right;margin-right:.625em;flex-shrink:0}._info-item-value_afsrn_87{flex-grow:1;text-align:left}._item-svg_afsrn_92{display:inline-block;width:60%;height:1em;margin-right:.625em;background:rgba(255,255,255,.2)}._item-value_afsrn_100{display:inline-block}@media (hover: hover){._close-btn_afsrn_36:hover,._copy-btn_afsrn_69:hover{color:#ccc}}")), document.head.appendChild(e);
    }
  } catch (t) {
    console.error("vite-plugin-css-injected-by-js", t);
  }
})();
var uc = Object.defineProperty, dc = (e, t, a) => t in e ? uc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a, ni = (e, t, a) => (dc(e, typeof t != "symbol" ? t + "" : t, a), a);
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("")), document.head.appendChild(e);
    }
  } catch (t) {
    console.error("vite-plugin-css-injected-by-js", t);
  }
})();
var hc = Object.defineProperty, _c = (e, t, a) => t in e ? hc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a, Qe = (e, t, a) => (_c(e, typeof t != "symbol" ? t + "" : t, a), a);
const pc = "ControlsPlugin", fc = "I18nPlugin", vc = "LoggerPlugin", mc = "HotkeyPlugin", yc = "PlayInfoPlugin", Ac = "MirrorPlugin", Ec = "RotatePlugin", gc = "PreviewPlugin", Tc = "MaskPlugin", bc = "VRPlugin", Rc = "DanmakuPlugin";
let Ze = class extends Mi {
  static isInstanceOfPlugin(e) {
    return typeof e.beforeInstall == "function" && typeof e.afterInstall == "function" && typeof e.beforeUninstall == "function" && typeof e.afterUninstall == "function" && typeof e.getLabel == "function";
  }
  /**
   * 播放器实例化前钩子
   * @param player 播放器实例
   * @param options 实例化播放器时指定的当前插件的参数
   */
  beforeInstall(e, t) {
  }
  /**
   * 播放器实例化后钩子
   * @param player 播放器实例
   * @param options 实例化播放器时指定的当前插件的参数
   */
  afterInstall(e, t) {
  }
  /**
   * 播放器销毁前钩子
   * @param player 播放器实例
   */
  beforeUninstall(e) {
  }
  /**
   * 播放器销毁后钩子
   * @param player 播放器实例
   */
  afterUninstall(e) {
  }
};
Qe(Ze, "label"), /**
* 版本
*/
Qe(Ze, "version"), /**
* 当前环境是否支持
*/
Qe(Ze, "isSupported");
const Ia = class extends Ze {
  /**
   * @override
   */
  getLabel() {
    return Ia.label;
  }
  beforeInstall(e, t) {
  }
  afterInstall(e, t) {
  }
};
let Sc = Ia;
Qe(Sc, "label", pc);
const Ca = class extends Ze {
  /**
   * @override
   */
  getLabel() {
    return Ca.label;
  }
  beforeInstall(e, t) {
  }
  afterInstall(e, t) {
  }
};
let Lc = Ca;
Qe(Lc, "label", fc);
const ka = class extends Ze {
  /**
   * @override
   */
  getLabel() {
    return ka.label;
  }
  beforeInstall(e, t) {
  }
  afterInstall(e, t) {
  }
  /**
   * 增加业务相关数据
   * @param key 上报数据key
   * @param value 上报数据
   */
  addBizLog(e, t) {
  }
  appendSummaryField(e, t) {
  }
};
let wc = ka;
Qe(wc, "label", vc);
const Da = class extends Ze {
  /**
   * @override
   */
  getLabel() {
    return Da.label;
  }
};
let Ic = Da;
Qe(Ic, "label", mc);
const xa = class extends Ze {
  /**
   * @override
   */
  getLabel() {
    return xa.label;
  }
};
let Na = xa;
Qe(Na, "label", yc);
const Oa = class extends Ze {
  /**
   * @override
   */
  getLabel() {
    return Oa.label;
  }
};
let Cc = Oa;
Qe(Cc, "label", Ac);
const Pa = class extends Ze {
  /**
   * @override
   */
  getLabel() {
    return Pa.label;
  }
};
let kc = Pa;
Qe(kc, "label", Ec);
const Ua = class extends Ze {
  /**
   * @override
   */
  getLabel() {
    return Ua.label;
  }
};
let Dc = Ua;
Qe(Dc, "label", gc);
const Ma = class extends Ze {
  /**
   * @override
   */
  getLabel() {
    return Ma.label;
  }
};
let xc = Ma;
Qe(xc, "label", Tc);
const Fa = class extends Ze {
  /**
   * @override
   */
  getLabel() {
    return Fa.label;
  }
};
let Nc = Fa;
Qe(Nc, "label", bc);
const Ba = class extends Ze {
  /**
   * @override
   */
  getLabel() {
    return Ba.label;
  }
};
let Oc = Ba;
Qe(Oc, "label", Rc);
var Bt = /* @__PURE__ */ ((e) => (e.ERROR = "error", e.MANIFEST_PARSED = "manifestparsed", e.LEVEL_SWITCHING = "levelswitching", e.LEVEL_SWITCHED = "levelswitched", e.LEVEL_SWITCH_PLAYING = "levelswitchplaying", e.LEVEL_SWITCH_FAILED = "levelswitchfailed", e.LEVEL_UPDATED = "levelupdated", e.AUDIO_TRACKS_SWITCHING = "audiotrackswitching", e.AUDIO_TRACKS_SWITCHED = "audiotrackswitched", e.LOADSTART = "loadstart", e.PROGRESS = "progress", e.SUSPEND = "suspend", e.ABORT = "abort", e.EMPTIED = "emptied", e.STALLED = "stalled", e.LOADEDMETADATA = "loadedmetadata", e.LOADEDDATA = "loadeddata", e.CANPLAY = "canplay", e.CANPLAYTHROUGH = "canplaythrough", e.PLAYING = "playing", e.WAITING = "waiting", e.SEEKING = "seeking", e.SEEKED = "seeked", e.ENDED = "ended", e.DURATIONCHANGE = "durationchange", e.TIMEUPDATE = "timeupdate", e.PLAY = "play", e.PAUSE = "pause", e.RATECHANGE = "ratechange", e.RESIZE = "resize", e.VOLUMECHANGE = "volumechange", e.ENTER_PICTURE_IN_PICTURE = "enterpictureinpicture", e.LEAVE_PICTURE_IN_PICTURE = "leavepictureinpicture", e.REPORT = "report", e.VIDEO_RENDERER_CHANGE = "videorendererchange", e.FULLSCREEN_CHANGE = "fullscreenchange", e.LIVE_SHIFT_CHANGE = "liveshiftchange", e.LIVE_SHIFT_TYPE_CHANGE = "liveshifttypechange", e.ATTRIBUTE_CHANGE_CONFIG = "attribute:change:config", e.ATTRIBUTE_CHANGE_SRC = "attribute:change:src", e.ATTRIBUTE_CHANGE_VIDEO_ID = "attribute:change:videoid", e.ATTRIBUTE_CHANGE_PREVIEW_URL = "attribute:change:previewurl", e.ATTRIBUTE_CHANGE_MASK_URL = "attribute:change:maskurl", e.ATTRIBUTE_CHANGE_CROSS_ORIGIN = "attribute:change:crossorigin", e.ATTRIBUTE_CHANGE_PRELOAD = "attribute:change:preload", e.ATTRIBUTE_CHANGE_CURRENT_TIME = "attribute:change:currenttime", e.ATTRIBUTE_CHANGE_DEFAULT_PLAYBACK_RATE = "attribute:change:defaultplaybackrate", e.ATTRIBUTE_CHANGE_PLAYBACK_RATE = "attribute:change:playbackrate", e.ATTRIBUTE_CHANGE_AUTOPLAY = "attribute:change:autoplay", e.ATTRIBUTE_CHANGE_LOOP = "attribute:change:loop", e.ATTRIBUTE_CHANGE_CONTROLS = "attribute:change:controls", e.ATTRIBUTE_CHANGE_VOLUME = "attribute:change:volume", e.ATTRIBUTE_CHANGE_MUTED = "attribute:change:muted", e.ATTRIBUTE_CHANGE_DEFAULT_MUTED = "attribute:change:defaultmuted", e.ATTRIBUTE_CHANGE_POSTER = "attribute:change:poster", e.ATTRIBUTE_CHANGE_DISABLE_PICTURE_IN_PICTURE = "attribute:change:disablepictureinpicture", e.ATTRIBUTE_CHANGE_PLAYSINLINE = "attribute:change:playsinline", e.ATTRIBUTE_CHANGE_DISABLE_ADAPTIVE = "attribute:change:disableadaptive", e.ATTRIBUTE_CHANGE_DISABLE_DOWNLOAD = "attribute:change:disabledownload", e.ATTRIBUTE_CHANGE_DISABLE_MASK = "attribute:change:disablemask", e.ATTRIBUTE_CHANGE_DISABLE_HOTKEY = "attribute:change:disablehotkey", e.ATTRIBUTE_CHANGE_DISABLE_DANMAKU = "attribute:change:disabledanmaku", e.ATTRIBUTE_CHANGE_DANMAKU_RENDERING = "attribute:change:danmakurendering", e.ATTRIBUTE_CHANGE_DANMAKU_CONTROLS_POS = "attribute:change:danmakucontrolspos", e.ATTRIBUTE_CHANGE_DANMAKU_CONTROLS_POS_FULLSCREEN = "attribute:change:danmakucontrolsposfullscreen", e.ATTRIBUTE_CHANGE_CURRENT_LEVEL = "attribute:change:currentlevel", e.ATTRIBUTE_CHANGE_NEXT_LEVEL = "attribute:change:nextlevel", e.ATTRIBUTE_CHANGE_CURRENT_FRAME = "attribute:change:currentframe", e.ATTRIBUTE_CHANGE_AUDIO_TRACK = "attribute:change:audiotrack", e.ATTRIBUTE_CHANGE_PREFETCH = "attribute:change:prefetch", e.ATTRIBUTE_CHANGE_SHOW_PROGRESS = "attribute:change:showprogress", e.ATTRIBUTE_CHANGE_SHOW_TIME = "attribute:change:showtime", e.ATTRIBUTE_CHANGE_SHOW_NEXT = "attribute:change:shownext", e.ATTRIBUTE_CHANGE_SHOW_PREV = "attribute:change:showprev", e.ATTRIBUTE_CHANGE_BIZ_DATA = "attribute:change:bizdata", e.ATTRIBUTE_CHANGE_LIVE_TIME = "attribute:change:livetime", e.ATTRIBUTE_CHANGE_SHOW_INFO_PANEL = "attribute:change:showinfopanel", e.CLICK_NEXT = "clicknext", e.CLICK_PREV = "clickprev", e.CLICK_LOGIN = "clicklogin", e.CLICK_REGISTER = "clickregister", e.CLICK_SEND_DANMAKU = "clicksenddanmaku", e.CLICK_VIP = "clickvip", e))(Bt || {}), Fi, J, Ha, Ft, bn, Va, cr, Di = {}, Ga = [], Pc = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function Ct(e, t) {
  for (var a in t)
    e[a] = t[a];
  return e;
}
function Wa(e) {
  var t = e.parentNode;
  t && t.removeChild(e);
}
function Uc(e, t, a) {
  var l, u, h, E = {};
  for (h in t)
    h == "key" ? l = t[h] : h == "ref" ? u = t[h] : E[h] = t[h];
  if (arguments.length > 2 && (E.children = arguments.length > 3 ? Fi.call(arguments, 2) : a), typeof e == "function" && e.defaultProps != null)
    for (h in e.defaultProps)
      E[h] === void 0 && (E[h] = e.defaultProps[h]);
  return gi(e, E, l, u, null);
}
function gi(e, t, a, l, u) {
  var h = { type: e, props: t, key: a, ref: l, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: u != null ? u : ++Ha };
  return u == null && J.vnode != null && J.vnode(h), h;
}
function Bi(e) {
  return e.children;
}
function Ti(e, t) {
  this.props = e, this.context = t;
}
function oi(e, t) {
  if (t == null)
    return e.__ ? oi(e.__, e.__.__k.indexOf(e) + 1) : null;
  for (var a; t < e.__k.length; t++)
    if ((a = e.__k[t]) != null && a.__e != null)
      return a.__e;
  return typeof e.type == "function" ? oi(e) : null;
}
function Ka(e) {
  var t, a;
  if ((e = e.__) != null && e.__c != null) {
    for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)
      if ((a = e.__k[t]) != null && a.__e != null) {
        e.__e = e.__c.base = a.__e;
        break;
      }
    return Ka(e);
  }
}
function Rn(e) {
  (!e.__d && (e.__d = !0) && Ft.push(e) && !xi.__r++ || bn !== J.debounceRendering) && ((bn = J.debounceRendering) || Va)(xi);
}
function xi() {
  var e, t, a, l, u, h, E, v;
  for (Ft.sort(cr); e = Ft.shift(); )
    e.__d && (t = Ft.length, l = void 0, u = void 0, E = (h = (a = e).__v).__e, (v = a.__P) && (l = [], (u = Ct({}, h)).__v = h.__v + 1, pr(v, h, u, a.__n, v.ownerSVGElement !== void 0, h.__h != null ? [E] : null, l, E != null ? E : oi(h), h.__h), qa(l, h), h.__e != E && Ka(h)), Ft.length > t && Ft.sort(cr));
  xi.__r = 0;
}
function za(e, t, a, l, u, h, E, v, p, D) {
  var y, R, g, _, I, k, P, K = l && l.__k || Ga, m = K.length;
  for (a.__k = [], y = 0; y < t.length; y++)
    if ((_ = a.__k[y] = (_ = t[y]) == null || typeof _ == "boolean" || typeof _ == "function" ? null : typeof _ == "string" || typeof _ == "number" || typeof _ == "bigint" ? gi(null, _, null, null, _) : Array.isArray(_) ? gi(Bi, { children: _ }, null, null, null) : _.__b > 0 ? gi(_.type, _.props, _.key, _.ref ? _.ref : null, _.__v) : _) != null) {
      if (_.__ = a, _.__b = a.__b + 1, (g = K[y]) === null || g && _.key == g.key && _.type === g.type)
        K[y] = void 0;
      else
        for (R = 0; R < m; R++) {
          if ((g = K[R]) && _.key == g.key && _.type === g.type) {
            K[R] = void 0;
            break;
          }
          g = null;
        }
      pr(e, _, g = g || Di, u, h, E, v, p, D), I = _.__e, (R = _.ref) && g.ref != R && (P || (P = []), g.ref && P.push(g.ref, null, _), P.push(R, _.__c || I, _)), I != null ? (k == null && (k = I), typeof _.type == "function" && _.__k === g.__k ? _.__d = p = $a(_, p, e) : p = Ya(e, _, g, K, I, p), typeof a.type == "function" && (a.__d = p)) : p && g.__e == p && p.parentNode != e && (p = oi(g));
    }
  for (a.__e = k, y = m; y--; )
    K[y] != null && (typeof a.type == "function" && K[y].__e != null && K[y].__e == a.__d && (a.__d = ja(l).nextSibling), Qa(K[y], K[y]));
  if (P)
    for (y = 0; y < P.length; y++)
      Xa(P[y], P[++y], P[++y]);
}
function $a(e, t, a) {
  for (var l, u = e.__k, h = 0; u && h < u.length; h++)
    (l = u[h]) && (l.__ = e, t = typeof l.type == "function" ? $a(l, t, a) : Ya(a, l, l, u, l.__e, t));
  return t;
}
function Ya(e, t, a, l, u, h) {
  var E, v, p;
  if (t.__d !== void 0)
    E = t.__d, t.__d = void 0;
  else if (a == null || u != h || u.parentNode == null)
    e:
      if (h == null || h.parentNode !== e)
        e.appendChild(u), E = null;
      else {
        for (v = h, p = 0; (v = v.nextSibling) && p < l.length; p += 1)
          if (v == u)
            break e;
        e.insertBefore(u, h), E = h;
      }
  return E !== void 0 ? E : u.nextSibling;
}
function ja(e) {
  var t, a, l;
  if (e.type == null || typeof e.type == "string")
    return e.__e;
  if (e.__k) {
    for (t = e.__k.length - 1; t >= 0; t--)
      if ((a = e.__k[t]) && (l = ja(a)))
        return l;
  }
  return null;
}
function Mc(e, t, a, l, u) {
  var h;
  for (h in a)
    h === "children" || h === "key" || h in t || Ni(e, h, null, a[h], l);
  for (h in t)
    u && typeof t[h] != "function" || h === "children" || h === "key" || h === "value" || h === "checked" || a[h] === t[h] || Ni(e, h, t[h], a[h], l);
}
function Sn(e, t, a) {
  t[0] === "-" ? e.setProperty(t, a != null ? a : "") : e[t] = a == null ? "" : typeof a != "number" || Pc.test(t) ? a : a + "px";
}
function Ni(e, t, a, l, u) {
  var h;
  e:
    if (t === "style")
      if (typeof a == "string")
        e.style.cssText = a;
      else {
        if (typeof l == "string" && (e.style.cssText = l = ""), l)
          for (t in l)
            a && t in a || Sn(e.style, t, "");
        if (a)
          for (t in a)
            l && a[t] === l[t] || Sn(e.style, t, a[t]);
      }
    else if (t[0] === "o" && t[1] === "n")
      h = t !== (t = t.replace(/Capture$/, "")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + h] = a, a ? l || e.addEventListener(t, h ? wn : Ln, h) : e.removeEventListener(t, h ? wn : Ln, h);
    else if (t !== "dangerouslySetInnerHTML") {
      if (u)
        t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if (t !== "width" && t !== "height" && t !== "href" && t !== "list" && t !== "form" && t !== "tabIndex" && t !== "download" && t in e)
        try {
          e[t] = a != null ? a : "";
          break e;
        } catch (E) {
        }
      typeof a == "function" || (a == null || a === !1 && t[4] !== "-" ? e.removeAttribute(t) : e.setAttribute(t, a));
    }
}
function Ln(e) {
  return this.l[e.type + !1](J.event ? J.event(e) : e);
}
function wn(e) {
  return this.l[e.type + !0](J.event ? J.event(e) : e);
}
function pr(e, t, a, l, u, h, E, v, p) {
  var D, y, R, g, _, I, k, P, K, m, T, b, L, M, U, B = t.type;
  if (t.constructor !== void 0)
    return null;
  a.__h != null && (p = a.__h, v = t.__e = a.__e, t.__h = null, h = [v]), (D = J.__b) && D(t);
  try {
    e:
      if (typeof B == "function") {
        if (P = t.props, K = (D = B.contextType) && l[D.__c], m = D ? K ? K.props.value : D.__ : l, a.__c ? k = (y = t.__c = a.__c).__ = y.__E : ("prototype" in B && B.prototype.render ? t.__c = y = new B(P, m) : (t.__c = y = new Ti(P, m), y.constructor = B, y.render = Bc), K && K.sub(y), y.props = P, y.state || (y.state = {}), y.context = m, y.__n = l, R = y.__d = !0, y.__h = [], y._sb = []), y.__s == null && (y.__s = y.state), B.getDerivedStateFromProps != null && (y.__s == y.state && (y.__s = Ct({}, y.__s)), Ct(y.__s, B.getDerivedStateFromProps(P, y.__s))), g = y.props, _ = y.state, y.__v = t, R)
          B.getDerivedStateFromProps == null && y.componentWillMount != null && y.componentWillMount(), y.componentDidMount != null && y.__h.push(y.componentDidMount);
        else {
          if (B.getDerivedStateFromProps == null && P !== g && y.componentWillReceiveProps != null && y.componentWillReceiveProps(P, m), !y.__e && y.shouldComponentUpdate != null && y.shouldComponentUpdate(P, y.__s, m) === !1 || t.__v === a.__v) {
            for (t.__v !== a.__v && (y.props = P, y.state = y.__s, y.__d = !1), y.__e = !1, t.__e = a.__e, t.__k = a.__k, t.__k.forEach(function(H) {
              H && (H.__ = t);
            }), T = 0; T < y._sb.length; T++)
              y.__h.push(y._sb[T]);
            y._sb = [], y.__h.length && E.push(y);
            break e;
          }
          y.componentWillUpdate != null && y.componentWillUpdate(P, y.__s, m), y.componentDidUpdate != null && y.__h.push(function() {
            y.componentDidUpdate(g, _, I);
          });
        }
        if (y.context = m, y.props = P, y.__P = e, b = J.__r, L = 0, "prototype" in B && B.prototype.render) {
          for (y.state = y.__s, y.__d = !1, b && b(t), D = y.render(y.props, y.state, y.context), M = 0; M < y._sb.length; M++)
            y.__h.push(y._sb[M]);
          y._sb = [];
        } else
          do
            y.__d = !1, b && b(t), D = y.render(y.props, y.state, y.context), y.state = y.__s;
          while (y.__d && ++L < 25);
        y.state = y.__s, y.getChildContext != null && (l = Ct(Ct({}, l), y.getChildContext())), R || y.getSnapshotBeforeUpdate == null || (I = y.getSnapshotBeforeUpdate(g, _)), U = D != null && D.type === Bi && D.key == null ? D.props.children : D, za(e, Array.isArray(U) ? U : [U], t, a, l, u, h, E, v, p), y.base = t.__e, t.__h = null, y.__h.length && E.push(y), k && (y.__E = y.__ = null), y.__e = !1;
      } else
        h == null && t.__v === a.__v ? (t.__k = a.__k, t.__e = a.__e) : t.__e = Fc(a.__e, t, a, l, u, h, E, p);
    (D = J.diffed) && D(t);
  } catch (H) {
    t.__v = null, (p || h != null) && (t.__e = v, t.__h = !!p, h[h.indexOf(v)] = null), J.__e(H, t, a);
  }
}
function qa(e, t) {
  J.__c && J.__c(t, e), e.some(function(a) {
    try {
      e = a.__h, a.__h = [], e.some(function(l) {
        l.call(a);
      });
    } catch (l) {
      J.__e(l, a.__v);
    }
  });
}
function Fc(e, t, a, l, u, h, E, v) {
  var p, D, y, R = a.props, g = t.props, _ = t.type, I = 0;
  if (_ === "svg" && (u = !0), h != null) {
    for (; I < h.length; I++)
      if ((p = h[I]) && "setAttribute" in p == !!_ && (_ ? p.localName === _ : p.nodeType === 3)) {
        e = p, h[I] = null;
        break;
      }
  }
  if (e == null) {
    if (_ === null)
      return document.createTextNode(g);
    e = u ? document.createElementNS("http://www.w3.org/2000/svg", _) : document.createElement(_, g.is && g), h = null, v = !1;
  }
  if (_ === null)
    R === g || v && e.data === g || (e.data = g);
  else {
    if (h = h && Fi.call(e.childNodes), D = (R = a.props || Di).dangerouslySetInnerHTML, y = g.dangerouslySetInnerHTML, !v) {
      if (h != null)
        for (R = {}, I = 0; I < e.attributes.length; I++)
          R[e.attributes[I].name] = e.attributes[I].value;
      (y || D) && (y && (D && y.__html == D.__html || y.__html === e.innerHTML) || (e.innerHTML = y && y.__html || ""));
    }
    if (Mc(e, g, R, u, v), y)
      t.__k = [];
    else if (I = t.props.children, za(e, Array.isArray(I) ? I : [I], t, a, l, u && _ !== "foreignObject", h, E, h ? h[0] : a.__k && oi(a, 0), v), h != null)
      for (I = h.length; I--; )
        h[I] != null && Wa(h[I]);
    v || ("value" in g && (I = g.value) !== void 0 && (I !== e.value || _ === "progress" && !I || _ === "option" && I !== R.value) && Ni(e, "value", I, R.value, !1), "checked" in g && (I = g.checked) !== void 0 && I !== e.checked && Ni(e, "checked", I, R.checked, !1));
  }
  return e;
}
function Xa(e, t, a) {
  try {
    typeof e == "function" ? e(t) : e.current = t;
  } catch (l) {
    J.__e(l, a);
  }
}
function Qa(e, t, a) {
  var l, u;
  if (J.unmount && J.unmount(e), (l = e.ref) && (l.current && l.current !== e.__e || Xa(l, null, t)), (l = e.__c) != null) {
    if (l.componentWillUnmount)
      try {
        l.componentWillUnmount();
      } catch (h) {
        J.__e(h, t);
      }
    l.base = l.__P = null, e.__c = void 0;
  }
  if (l = e.__k)
    for (u = 0; u < l.length; u++)
      l[u] && Qa(l[u], t, a || typeof e.type != "function");
  a || e.__e == null || Wa(e.__e), e.__ = e.__e = e.__d = void 0;
}
function Bc(e, t, a) {
  return this.constructor(e, a);
}
function Hc(e, t, a) {
  var l, u, h;
  J.__ && J.__(e, t), u = (l = typeof a == "function") ? null : a && a.__k || t.__k, h = [], pr(t, e = (!l && a || t).__k = Uc(Bi, null, [e]), u || Di, Di, t.ownerSVGElement !== void 0, !l && a ? [a] : u ? null : t.firstChild ? Fi.call(t.childNodes) : null, h, !l && a ? a : u ? u.__e : t.firstChild, l), qa(h, e);
}
Fi = Ga.slice, J = { __e: function(e, t, a, l) {
  for (var u, h, E; t = t.__; )
    if ((u = t.__c) && !u.__)
      try {
        if ((h = u.constructor) && h.getDerivedStateFromError != null && (u.setState(h.getDerivedStateFromError(e)), E = u.__d), u.componentDidCatch != null && (u.componentDidCatch(e, l || {}), E = u.__d), E)
          return u.__E = u;
      } catch (v) {
        e = v;
      }
  throw e;
} }, Ha = 0, Ti.prototype.setState = function(e, t) {
  var a;
  a = this.__s != null && this.__s !== this.state ? this.__s : this.__s = Ct({}, this.state), typeof e == "function" && (e = e(Ct({}, a), this.props)), e && Ct(a, e), e != null && this.__v && (t && this._sb.push(t), Rn(this));
}, Ti.prototype.forceUpdate = function(e) {
  this.__v && (this.__e = !0, e && this.__h.push(e), Rn(this));
}, Ti.prototype.render = Bi, Ft = [], Va = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, cr = function(e, t) {
  return e.__v.__b - t.__v.__b;
}, xi.__r = 0;
var Vc = function() {
  var e = document.getSelection();
  if (!e.rangeCount)
    return function() {
    };
  for (var t = document.activeElement, a = [], l = 0; l < e.rangeCount; l++)
    a.push(e.getRangeAt(l));
  switch (t.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      t.blur();
      break;
    default:
      t = null;
      break;
  }
  return e.removeAllRanges(), function() {
    e.type === "Caret" && e.removeAllRanges(), e.rangeCount || a.forEach(function(u) {
      e.addRange(u);
    }), t && t.focus();
  };
}, Gc = Vc, In = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, Wc = "Copy to clipboard: #{key}, Enter";
function Kc(e) {
  var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return e.replace(/#{\s*key\s*}/g, t);
}
function zc(e, t) {
  var a, l, u, h, E, v, p = !1;
  t || (t = {}), a = t.debug || !1;
  try {
    u = Gc(), h = document.createRange(), E = document.getSelection(), v = document.createElement("span"), v.textContent = e, v.ariaHidden = "true", v.style.all = "unset", v.style.position = "fixed", v.style.top = 0, v.style.clip = "rect(0, 0, 0, 0)", v.style.whiteSpace = "pre", v.style.webkitUserSelect = "text", v.style.MozUserSelect = "text", v.style.msUserSelect = "text", v.style.userSelect = "text", v.addEventListener("copy", function(y) {
      if (y.stopPropagation(), t.format)
        if (y.preventDefault(), typeof y.clipboardData > "u") {
          a && console.warn("unable to use e.clipboardData"), a && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var R = In[t.format] || In.default;
          window.clipboardData.setData(R, e);
        } else
          y.clipboardData.clearData(), y.clipboardData.setData(t.format, e);
      t.onCopy && (y.preventDefault(), t.onCopy(y.clipboardData));
    }), document.body.appendChild(v), h.selectNodeContents(v), E.addRange(h);
    var D = document.execCommand("copy");
    if (!D)
      throw new Error("copy command was unsuccessful");
    p = !0;
  } catch (y) {
    a && console.error("unable to copy using execCommand: ", y), a && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), p = !0;
    } catch (R) {
      a && console.error("unable to copy using clipboardData: ", R), a && console.error("falling back to prompt"), l = Kc("message" in t ? t.message : Wc), window.prompt(l, e);
    }
  } finally {
    E && (typeof E.removeRange == "function" ? E.removeRange(h) : E.removeAllRanges()), v && document.body.removeChild(v), u();
  }
  return p;
}
var $c = zc, li, Se, rr, Cn, si = 0, Za = [], bi = [], kn = J.__b, Dn = J.__r, xn = J.diffed, Nn = J.__c, On = J.unmount;
function Hi(e, t) {
  J.__h && J.__h(Se, e, si || t), si = 0;
  var a = Se.__H || (Se.__H = { __: [], __h: [] });
  return e >= a.__.length && a.__.push({ __V: bi }), a.__[e];
}
function Fe(e) {
  return si = 1, Yc(to, e);
}
function Yc(e, t, a) {
  var l = Hi(li++, 2);
  if (l.t = e, !l.__c && (l.__ = [a ? a(t) : to(void 0, t), function(v) {
    var p = l.__N ? l.__N[0] : l.__[0], D = l.t(p, v);
    p !== D && (l.__N = [D, l.__[1]], l.__c.setState({}));
  }], l.__c = Se, !Se.u)) {
    var u = function(v, p, D) {
      if (!l.__c.__H)
        return !0;
      var y = l.__c.__H.__.filter(function(g) {
        return g.__c;
      });
      if (y.every(function(g) {
        return !g.__N;
      }))
        return !h || h.call(this, v, p, D);
      var R = !1;
      return y.forEach(function(g) {
        if (g.__N) {
          var _ = g.__[0];
          g.__ = g.__N, g.__N = void 0, _ !== g.__[0] && (R = !0);
        }
      }), !(!R && l.__c.props === v) && (!h || h.call(this, v, p, D));
    };
    Se.u = !0;
    var h = Se.shouldComponentUpdate, E = Se.componentWillUpdate;
    Se.componentWillUpdate = function(v, p, D) {
      if (this.__e) {
        var y = h;
        h = void 0, u(v, p, D), h = y;
      }
      E && E.call(this, v, p, D);
    }, Se.shouldComponentUpdate = u;
  }
  return l.__N || l.__;
}
function Ja(e, t) {
  var a = Hi(li++, 3);
  !J.__s && fr(a.__H, t) && (a.__ = e, a.i = t, Se.__H.__h.push(a));
}
function jc(e, t) {
  var a = Hi(li++, 4);
  !J.__s && fr(a.__H, t) && (a.__ = e, a.i = t, Se.__h.push(a));
}
function Ri(e) {
  return si = 5, eo(function() {
    return { current: e };
  }, []);
}
function eo(e, t) {
  var a = Hi(li++, 7);
  return fr(a.__H, t) ? (a.__V = e(), a.i = t, a.__h = e, a.__V) : a.__;
}
function Kt(e, t) {
  return si = 8, eo(function() {
    return e;
  }, t);
}
function qc() {
  for (var e; e = Za.shift(); )
    if (e.__P && e.__H)
      try {
        e.__H.__h.forEach(Si), e.__H.__h.forEach(ur), e.__H.__h = [];
      } catch (t) {
        e.__H.__h = [], J.__e(t, e.__v);
      }
}
J.__b = function(e) {
  Se = null, kn && kn(e);
}, J.__r = function(e) {
  Dn && Dn(e), li = 0;
  var t = (Se = e.__c).__H;
  t && (rr === Se ? (t.__h = [], Se.__h = [], t.__.forEach(function(a) {
    a.__N && (a.__ = a.__N), a.__V = bi, a.__N = a.i = void 0;
  })) : (t.__h.forEach(Si), t.__h.forEach(ur), t.__h = [])), rr = Se;
}, J.diffed = function(e) {
  xn && xn(e);
  var t = e.__c;
  t && t.__H && (t.__H.__h.length && (Za.push(t) !== 1 && Cn === J.requestAnimationFrame || ((Cn = J.requestAnimationFrame) || Xc)(qc)), t.__H.__.forEach(function(a) {
    a.i && (a.__H = a.i), a.__V !== bi && (a.__ = a.__V), a.i = void 0, a.__V = bi;
  })), rr = Se = null;
}, J.__c = function(e, t) {
  t.some(function(a) {
    try {
      a.__h.forEach(Si), a.__h = a.__h.filter(function(l) {
        return !l.__ || ur(l);
      });
    } catch (l) {
      t.some(function(u) {
        u.__h && (u.__h = []);
      }), t = [], J.__e(l, a.__v);
    }
  }), Nn && Nn(e, t);
}, J.unmount = function(e) {
  On && On(e);
  var t, a = e.__c;
  a && a.__H && (a.__H.__.forEach(function(l) {
    try {
      Si(l);
    } catch (u) {
      t = u;
    }
  }), a.__H = void 0, t && J.__e(t, a.__v));
};
var Pn = typeof requestAnimationFrame == "function";
function Xc(e) {
  var t, a = function() {
    clearTimeout(l), Pn && cancelAnimationFrame(t), setTimeout(e);
  }, l = setTimeout(a, 100);
  Pn && (t = requestAnimationFrame(a));
}
function Si(e) {
  var t = Se, a = e.__c;
  typeof a == "function" && (e.__c = void 0, a()), Se = t;
}
function ur(e) {
  var t = Se;
  e.__c = e.__(), Se = t;
}
function fr(e, t) {
  return !e || e.length !== t.length || t.some(function(a, l) {
    return a !== e[l];
  });
}
function to(e, t) {
  return typeof t == "function" ? t(e) : t;
}
const Qc = "_container_afsrn_1", Zc = "_actions_afsrn_60", Ge = {
  container: Qc,
  "container-h5": "_container-h5_afsrn_19",
  "close-btn": "_close-btn_afsrn_36",
  "btn-tip": "_btn-tip_afsrn_49",
  actions: Zc,
  "copy-btn": "_copy-btn_afsrn_69",
  "info-item": "_info-item_afsrn_75",
  "info-item-name": "_info-item-name_afsrn_79",
  "info-item-value": "_info-item-value_afsrn_87",
  "item-svg": "_item-svg_afsrn_92",
  "item-value": "_item-value_afsrn_100"
};
var Jc = 0;
function ue(e, t, a, l, u, h) {
  var E, v, p = {};
  for (v in t)
    v == "ref" ? E = t[v] : p[v] = t[v];
  var D = { type: e, props: p, key: a, ref: E, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: --Jc, __source: u, __self: h };
  if (typeof e == "function" && (E = e.defaultProps))
    for (v in E)
      p[v] === void 0 && (p[v] = E[v]);
  return J.vnode && J.vnode(D), D;
}
function _t(e) {
  const {
    title: t,
    value: a
  } = e;
  return ue("div", {
    className: Ge["info-item"],
    children: [ue("div", {
      className: Ge["info-item-name"],
      children: [t, ":"]
    }), ue("div", {
      className: Ge["info-item-value"],
      children: a
    })]
  });
}
function eu(e) {
  const {
    dataArray: t
  } = e, a = Ri(null), [l, u] = Fe("");
  return Ja(() => {
    if (a != null && a.current) {
      const {
        width: h,
        height: E
      } = a.current.getBoundingClientRect(), v = Math.max(...t) || 1, p = E - 2, D = h / t.length;
      let y = `M0 ${p * (v - t[0]) / v + 1}`;
      for (let R = 1; R < t.length; R++)
        y += ` L${R * D} ${p * (v - t[R]) / v + 1}`;
      u(y);
    }
  }, [t]), ue("svg", {
    ref: a,
    height: "100%",
    width: "100%",
    style: "display:block",
    children: ue("path", {
      fill: "none",
      stroke: "#fff",
      "stroke-width": "1",
      d: l
    })
  });
}
function mi(e) {
  const {
    title: t,
    suffix: a,
    value: l
  } = e, [u, h] = Fe(0);
  return Ja(() => {
    h(l[l.length - 1] || 0);
  }, [l]), ue("div", {
    className: Ge["info-item"],
    children: [ue("div", {
      className: Ge["info-item-name"],
      children: [t, ":"]
    }), ue("div", {
      className: Ge["info-item-value"],
      children: [ue("div", {
        className: Ge["item-svg"],
        children: ue(eu, {
          dataArray: l
        })
      }), ue("div", {
        className: Ge["item-value"],
        children: a(u)
      })]
    })]
  });
}
const Un = 100, tu = "info-panel";
function iu(e) {
  const {
    player: t,
    onChangeShowEventLog: a,
    DID: l,
    playerVersion: u
  } = e, [h, E] = Fe(""), [v, p] = Fe(""), [D, y] = Fe(""), [R, g] = Fe(""), [_, I] = Fe(""), [k, P] = Fe(0), [K, m] = Fe(""), [T, b] = Fe(""), [L, M] = Fe([]), [U, B] = Fe([]), [H, q] = Fe([]), [Ie, Ae] = Fe([]), [W, C] = Fe(""), st = Ri(void 0), $e = Ri([]);
  jc(() => {
    const Z = () => {
      E(""), p(""), y(""), g(""), I(""), P(0), m(""), Ie.splice(0, U.length), U.splice(0, U.length), H.splice(0, H.length), L.splice(0, L.length), $e.current = [];
    }, fe = (Y) => {
      if (Y && Y.type === "mediaInfo") {
        st.current = Y.value, E(Y.value.streamHost), p(Y.value.colorSpace), m(Y.value.sid), b(Y.value.gpu);
        const Ee = [];
        Y.value.coreType && Ee.push(Y.value.coreType), Y.value.box && (Y.value.enhancedFlv ? Ee.push("enhanced-flv") : Ee.push(Y.value.box)), Y.value.videoCodecType && Ee.push(Y.value.videoCodecType), Y.value.videoDecoder && Ee.push(Y.value.videoDecoder), Y.value.width && Y.value.height && Ee.push(`${Y.value.width}x${Y.value.height}`), Y.value.sar && Ee.push(`[SAR ${Y.value.sar.width}:${Y.value.sar.height}]`), Y.value.fps && Ee.push(`@${Y.value.fps.toFixed(2)}`), y(Ee.join(" "));
        const rt = [];
        Y.value.videoCodec && rt.push(Y.value.videoCodec), Y.value.audioCodec && rt.push(Y.value.audioCodec), g(rt.join(","));
      } else
        Y && Y.value && Y.type === "event" && $e.current.push(Y.value);
      Y && Y.type === "heartbeat" && (Y.value.decodedFrames && I(`${Y.value.decodedFPS || 0}/${Y.value.droppedFPS || 0} ${Y.value.decodedFrames || 0}/${Y.value.droppedFrames || 0}`), typeof Y.value.totalReceive == "number" && P(Y.value.totalReceive), ke(Y.value.videoBuffered, U, B), ke(Y.value.audioBuffered, H, q), !U.length && !H.length && ke(Y.value.buffered, Ie, Ae), ke(Y.value.speed, L, M), C((/* @__PURE__ */ new Date()).toString()));
    };
    return t.on(Bt.ATTRIBUTE_CHANGE_SRC, Z), t.on(Bt.REPORT, fe), () => {
      t.off(Bt.ATTRIBUTE_CHANGE_SRC, Z), t.off(Bt.REPORT, fe), We.current && clearTimeout(We.current);
    };
  }, []);
  const [Ce, He] = Fe(""), [Le, Oe] = Fe(!1), We = Ri(0), ke = Kt((Z, fe, Y) => {
    typeof Z == "number" && !isNaN(Z) && (fe.push(Z), fe.length > Un ? fe.shift() : fe.length === 1 && (fe.unshift(...new Array(Un - 1)), fe.forEach((Ee, rt) => {
      typeof Ee != "number" && (fe[rt] = 0);
    })), Y([...fe]));
  }, []), lt = Kt(() => {
    w.i(tu, "click copy");
    const Z = {
      date: W
    };
    l && (Z.did = l), u && (Z.playerVersion = u), K && (Z.sessionId = K), h && (Z.streamHost = h), v && (Z.colorSpace = v), D && (Z.res = D), R && (Z.codec = R), T && (Z.gpu = T), U.length && (Z.vBuffer = U[U.length - 1]), H.length && (Z.aBuffer = H[H.length - 1]), Ie.length && (Z.buffer = Ie[Ie.length - 1]), L.length && (Z.speed = L[L.length - 1]), st.current && (Z.mediainfo = st.current), Z.userAgent = navigator.userAgent, Z.summary = t.audienceStat, Z.events = $e.current;
    const fe = $c(JSON.stringify(Z));
    He(fe ? "已复制" : "复制失败"), Oe(!0), We.current && clearTimeout(We.current), We.current = +setTimeout(() => {
      Oe(!1), We.current = 0;
    }, 1e3);
  }, []), Q = Kt((Z) => Z > 1e9 ? `${(Z / 1e9).toFixed(2)} GB` : Z > 1e6 ? `${(Z / 1e6).toFixed(2)} MB` : `${(Z / 1e3).toFixed(2)} KB`, []), ct = Kt((Z) => Z > 1e7 ? `${(Z / 1e6).toFixed(2)} MB/s` : `${(Z / 1e3).toFixed(2)} KB/s`, []), pt = Kt((Z) => Z > 1e3 ? `${(Z / 1e3).toFixed(2)} s` : `${Z} ms`, []), Tt = Kt((Z) => {
    Z.stopPropagation();
  }, []);
  return ue("div", {
    className: Ht ? Ge["container-h5"] : Ge.container,
    onContextMenu: Tt,
    children: [l && ue(_t, {
      title: "DeviceId",
      value: l
    }), u && ue(_t, {
      title: "PlayerVersion",
      value: u
    }), K && ue(_t, {
      title: "SessionId",
      value: K
    }), h && ue(_t, {
      title: "StreamHost",
      value: h
    }), D && ue(_t, {
      title: "Res",
      value: D
    }), v && ue(_t, {
      title: "Color",
      value: v
    }), R && ue(_t, {
      title: "Codec",
      value: R
    }), _ && ue(_t, {
      title: "Frames",
      value: _
    }), !!Ie.length && ue(mi, {
      title: "Buffered",
      value: Ie,
      suffix: pt
    }), !!U.length && ue(mi, {
      title: "VideoBuffered",
      value: U,
      suffix: pt
    }), !!H.length && ue(mi, {
      title: "AudioBuffered",
      value: H,
      suffix: pt
    }), !!L.length && ue(mi, {
      title: "Speed",
      value: L,
      suffix: ct
    }), k > 0 && ue(_t, {
      title: "TotalReceive",
      value: Q(k)
    }), T && ue(_t, {
      title: "GPU",
      value: T
    }), ue(_t, {
      title: "Date",
      value: W
    }), ue("div", {
      className: [Ht ? Ge["h5-btn"] : "", Ge["close-btn"]].join(" "),
      onClick: a,
      children: "[X]"
    }), ue("div", {
      className: Ge.actions,
      children: ue("div", {
        className: [Ht ? Ge["h5-btn"] : "", Ge["copy-btn"]].join(" "),
        onClick: lt,
        children: [Le && ue("div", {
          className: Ge["btn-tip"],
          children: Ce
        }), ue("div", {
          children: "[Copy]"
        })]
      })
    })]
  });
}
const io = class extends Na {
  constructor() {
    super(...arguments), ni(this, "_player"), ni(this, "_container"), ni(this, "_onChangeShowEventLog", () => {
      this._container && (this.isShow = !this.isShow);
    }), ni(this, "_onShowInfoPanelChange", () => {
      var e;
      this.isShow = !!((e = this._player) != null && e.showInfoPanel);
    });
  }
  afterInstall(e) {
    if (this._player = e, !this._player)
      return;
    this._container || (this._container = this._player.createSubContainer(), this._container.style.display = "none", this._container.style.position = "absolute", this._container.style.maxHeight = "100%", this._container.style.overflowY = "auto", Ht && (this._container.style.width = "100%"));
    let t = localStorage.getItem("kwai_player_device_id");
    Hc(ue(iu, {
      player: e,
      DID: t || "",
      playerVersion: `${this._player.packVersion}(${this._player.version})`,
      onChangeShowEventLog: this._onChangeShowEventLog
    }), this._container), this.isShow = !!e.showInfoPanel, e.on(Bt.ATTRIBUTE_CHANGE_SHOW_INFO_PANEL, this._onShowInfoPanelChange);
  }
  afterUninstall(e) {
    this._container && e.removeSubContainer(this._container), this._player = void 0, e.off(Bt.ATTRIBUTE_CHANGE_SHOW_INFO_PANEL, this._onShowInfoPanelChange), this.removeAllListeners();
  }
  set isShow(e) {
    this._container && (this._container.style.display = e ? "block" : "none", this.emit(
      "attribute:change"
      /* ATTRIBUTE_CHANGE */
    ));
  }
  get isShow() {
    var e;
    return ((e = this._container) == null ? void 0 : e.style.display) === "block";
  }
  getLabel() {
    return io.label;
  }
};
let ro = io;
ni(ro, "version", "1.1.0-alpha.0");
qt.register(cc);
qt.register(ro);
qt.packVersion = "1.1.7-alpha.2.vue2-mini";
export {
  js as ControlsPluginLabel,
  sl as ControlsPluginModule,
  ol as DanmakuControlsPos,
  al as DanmakuPluginDomStyle,
  nl as DanmakuPluginLabel,
  ml as DanmakuPluginModule,
  At as FullscreenType,
  Qs as HotkeyPluginLabel,
  ul as HotkeyPluginModule,
  qs as I18nPluginLabel,
  ll as I18nPluginModule,
  qt as KwaiPlayer,
  N as KwaiPlayerEvent,
  Ai as KwaiPlayerLayer,
  Bs as LiveShiftType,
  Xs as LoggerPluginLabel,
  cl as LoggerPluginModule,
  il as MaskPluginLabel,
  fl as MaskPluginModule,
  Js as MirrorPluginLabel,
  hl as MirrorPluginModule,
  Zs as PlayInfoPluginLabel,
  dl as PlayInfoPluginModule,
  ze as PluginModule,
  tl as PreviewPluginLabel,
  pl as PreviewPluginModule,
  el as RotatePluginLabel,
  _l as RotatePluginModule,
  rl as VRPluginLabel,
  vl as VRPluginModule,
  vu as default
};
